// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./sense-triangle-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1.5L6 6.5L11 1.5%27 stroke=%27%236c757d%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27%236b7280%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27%238888a4%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:root {
    --bg-primary: #f8f9fa;
    --bg-secondary: #ffffff;
    --bg-tertiary: #f1f3f5;
    --bg-card: #ffffff;
    --accent-orange: #FF6B4A;
    --accent-red: #E94B6C;
    --accent-purple: #8E3A9A;
    --accent-gradient: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
    --text-primary: #1a1a1a;
    --text-secondary: #6c757d;
    --text-tertiary: #adb5bd;
    --border-color: rgba(0, 0, 0, 0.08);
    --success: #2ecc71;
    --warning: #f39c12;
    --danger: #e74c3c;
}

body {
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    background: var(--bg-primary);
    color: var(--text-primary);
    overflow-x: hidden;
}

/* Enhanced Background with Brand Colors */
.bg-gradient {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 0.05;
    background: 
        radial-gradient(circle at 20% 30%, var(--accent-orange) 0%, transparent 50%),
        radial-gradient(circle at 80% 70%, var(--accent-purple) 0%, transparent 50%),
        radial-gradient(circle at 50% 50%, var(--accent-red) 0%, transparent 60%);
    animation: gradientShift 20s ease infinite;
}

@keyframes gradientShift {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(50px, 30px) scale(1.1); }
}

/* Decorative Elements */
.bg-orbs {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
}

.orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.08;
    animation: floatOrb 20s ease-in-out infinite;
}

.orb-1 {
    width: 300px;
    height: 300px;
    background: var(--accent-orange);
    top: 10%;
    left: 5%;
    animation-delay: 0s;
}

.orb-2 {
    width: 400px;
    height: 400px;
    background: var(--accent-purple);
    bottom: 10%;
    right: 10%;
    animation-delay: 5s;
}

.orb-3 {
    width: 250px;
    height: 250px;
    background: var(--accent-red);
    top: 50%;
    right: 20%;
    animation-delay: 10s;
}

@keyframes floatOrb {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(50px, -30px) scale(1.1); }
    66% { transform: translate(-30px, 50px) scale(0.9); }
}

/* Layout */
.app-container {
    display: flex;
    min-height: 100vh;
    position: relative;
    z-index: 1;
}

/* Sidebar with Brand Accent */
.sidebar {
    width: 280px;
    background: #fafbfc;
    border-right: 1px solid var(--border-color);
    padding: 28px 24px 0;
    display: flex;
    flex-direction: column;
    position: fixed;
    height: 100vh;
    overflow: hidden;
    z-index: 100;
}

.sidebar-nav-scroll {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: -24px;
    padding-right: 24px;
    padding-bottom: 8px;
    position: relative;
    z-index: 1;
}

.sidebar::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0.6;
}

.logo {
    margin-bottom: 32px;
    animation: fadeInDown 0.6s ease;
    position: relative;
}

.logo img {
    width: 200px;
    height: auto;
    filter: drop-shadow(0 8px 24px rgba(255, 107, 74, 0.4));
    transition: transform 0.3s ease;
}

.logo:hover img {
    transform: scale(1.05);
}

.nav-section {
    margin-bottom: 32px;
    animation: fadeInLeft 0.6s ease;
    animation-fill-mode: both;
}

.nav-section:nth-child(2) { animation-delay: 0.1s; }
.nav-section:nth-child(3) { animation-delay: 0.2s; }
.nav-section:nth-child(4) { animation-delay: 0.3s; }

.nav-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--text-tertiary);
    margin-bottom: 12px;
    padding-left: 16px;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    color: var(--text-secondary);
    text-decoration: none;
    border-radius: 10px;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
}

.nav-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: var(--accent-gradient);
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.nav-item::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.nav-item:hover::after {
    opacity: 0.05;
}

.nav-item:hover,
.nav-item.active {
    background: #f8f9fa;
    color: var(--text-primary);
}

.nav-item.active::before {
    transform: translateX(0);
}

.nav-item-icon {
    width: 20px;
    height: 20px;
    opacity: 0.7;
    position: relative;
    z-index: 1;
}

.nav-item.active .nav-item-icon {
    opacity: 1;
}

.nav-item span {
    position: relative;
    z-index: 1;
}

/* Sidebar User Menu */
.sidebar-user {
    flex-shrink: 0;
    padding: 20px 0 24px;
    border-top: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.sidebar-user-info {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.sidebar-user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    flex-shrink: 0;
}

.sidebar-user-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.sidebar-user-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sidebar-user-email {
    font-size: 11px;
    color: var(--text-tertiary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sidebar-logout-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.sidebar-logout-btn svg {
    width: 18px;
    height: 18px;
    stroke: var(--text-tertiary);
    transition: stroke 0.2s ease;
}

.sidebar-logout-btn:hover {
    background: var(--bg-tertiary);
}

.sidebar-logout-btn:hover svg {
    stroke: var(--accent-red);
}

/* Main Content */
.main-content {
    flex: 1 1;
    min-width: 0;   /* flex item must shrink to the viewport, not grow to its widest child
                       (without this ANY wide content horizontally overflows the whole page) */
    margin-left: 280px;
    padding: 32px 48px;
}

/* Header with Gradient Accent */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;
    animation: fadeInDown 0.6s ease;
    position: relative;
    padding-bottom: 24px;
}

.header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 120px;
    height: 3px;
    background: var(--accent-gradient);
    border-radius: 2px;
}

.header-title h1 {
    font-family: 'DM Sans', sans-serif;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 8px;
    letter-spacing: -0.5px;
    color: var(--text-primary);
}

.header-subtitle {
    color: var(--text-secondary);
    font-size: 15px;
}

.header-actions {
    display: flex;
    gap: 16px;
    align-items: center;
}

.btn {
    padding: 14px 28px;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    position: relative;
    overflow: hidden;
}

.btn::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
}

.btn:hover::before {
    width: 300px;
    height: 300px;
}

.btn-primary {
    background: var(--accent-gradient);
    color: white;
    box-shadow: 0 8px 24px rgba(255, 107, 74, 0.4);
    position: relative;
    z-index: 1;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(255, 107, 74, 0.5);
}

.btn-secondary {
    background: var(--bg-card);
    color: var(--text-primary);
    border: 1px solid #e9ecef;
}

.btn-secondary:hover {
    background: #f8f9fa;
    border-color: var(--accent-orange);
}

/* Sense Max — premium dark sibling of New Campaign, with a gradient MAX pill */
.btn-max {
    background: #1b1430;
    color: #fff;
    position: relative;
    z-index: 1;
    box-shadow: 0 8px 24px rgba(142, 58, 154, 0.35);
}
.btn-max:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(142, 58, 154, 0.5);
}
.btn-max svg { color: #fff; }
.btn-max-badge {
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.5px;
    line-height: 1;
    padding: 3px 6px;
    border-radius: 6px;
    background: var(--accent-gradient);
    color: #fff;
    margin-left: 4px;
}

/* Stats Grid with Brand Accents */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 36px;
    animation: fadeInUp 0.6s ease 0.2s;
    animation-fill-mode: both;
}

.stat-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    padding: 28px;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}

.stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.stat-card::after {
    content: '';
    position: absolute;
    top: -100%;
    right: -50px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255, 107, 74, 0.15) 0%, transparent 70%);
    border-radius: 50%;
    transition: top 0.6s ease;
}

.stat-card:hover {
    transform: translateY(-6px);
    border-color: rgba(255, 107, 74, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card:hover::before {
    opacity: 1;
}

.stat-card:hover::after {
    top: -50px;
}

.stat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
}

.stat-label {
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
}

.stat-badge.positive {
    background: rgba(46, 204, 113, 0.15);
    color: var(--success);
}

.stat-badge.negative {
    background: rgba(231, 76, 60, 0.15);
    color: var(--danger);
}

.stat-value {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1;
    color: var(--text-primary);
    position: relative;
    z-index: 1;
}

.stat-comparison {
    font-size: 13px;
    color: var(--text-tertiary);
    position: relative;
    z-index: 1;
}

/* Campaign Cards with Enhanced Styling */
.campaigns-section {
    margin-bottom: 48px;
    animation: fadeInUp 0.6s ease 0.3s;
    animation-fill-mode: both;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
}

.section-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 28px;
    font-weight: 700;
    position: relative;
    display: inline-block;
}

.section-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 60px;
    height: 3px;
    background: var(--accent-gradient);
    border-radius: 2px;
}

.campaign-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.campaign-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    padding: 32px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

/* Sense Max (cross-platform) campaign — strongly distinct: 2px brand-gradient border,
   a bright gradient wash, a heavier shadow, and a big faint brand triangle watermark in
   the bottom-right. No element sits ABOVE the title. */
/* NOTE: must out-specify \`.campaigns-cards .campaign-card\` (background:white)
   which is declared later in this file — hence the \`.campaigns-cards\` prefix. */
.campaigns-cards .campaign-card.sense-max {
    border: 2px solid transparent;
    /* Normal cards end with the pacing (card-ai) block, which the grid stretches
       to give the bottom breathing room. Max cards end with the thin "Running on"
       row instead, so when a Max card is ALONE (grid row not stretched by a taller
       sibling) that row jams against the bottom edge and looks cut off. Reserve the
       bottom room explicitly so it reads the same whether alone or in a full grid. */
    padding-bottom: 40px;
    /* Signature: a large brand-gradient triangle wedge bleeding off the
       bottom-right corner, a soft gradient tint, and the gradient border.
       All are background layers, so the card's rounded corners clip them
       automatically (no pseudo-element cutting the corners). */
    background:
        /* The real Sense logo (public/sense-triangle-bg.png, pre-faded to ~8%
           alpha) as a LARGE brand watermark bleeding off the bottom-right corner.
           A background layer, so the card's rounded corners clip it automatically. */
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right -60px bottom -170px / 150% auto,
        /* OPAQUE, near-white tint — keeps the interior light so all the text and
           metric boxes stay fully readable; brand colour lives in the border only */
        linear-gradient(155deg, #FFFBFA 0%, #FEF7F9 55%, #FCF9FD 100%) padding-box,
        linear-gradient(120deg, #FF6B4A, #E94B6C, #8E3A9A) border-box;
    box-shadow: 0 10px 30px rgba(142,58,154,0.14);
    /* Darken the muted text tiers (default tertiary #adb5bd is too light to read
       over the tinted/watermarked bg). Descendants using these vars — metric &
       cost labels, subtitle, "No data" — all get darker at once. */
    --text-tertiary: #6b6b77;
    --text-secondary: #4c4c58;
}
/* KZT/currency prefix is styled in another file; darken it here too */
.campaigns-cards .campaign-card.sense-max .currency-symbol { color: #7a7a86; }
/* Solid white metric/cost boxes on Max cards — the default #f8f9fa is nearly the
   same value as the tinted card, so boxes must go white to read as distinct. */
.campaigns-cards .campaign-card.sense-max .metric-box,
.campaigns-cards .campaign-card.sense-max .cost-box {
    background: #fff;
    border: 1px solid rgba(142,58,154,0.10);
}
/* keep the gradient border crisp on hover (base card sets a solid border-color) */
.campaigns-cards .campaign-card.sense-max:hover { border-color: transparent; }

/* Max identity chip — same shape/slot as the type-indicator on regular cards */
.type-indicator.sense-max-m {
    background: #17171d;
    color: #fff;
    font-weight: 800;
    font-size: 15px;
    line-height: 1;
    letter-spacing: -0.5px;
}

/* "Running on <platform logos>" block — replaces the pacing block on Max cards */
.card-platforms {
    display: flex;
    align-items: center;
    gap: 12px;
    /* inset 20px each side so "Running on" + the divider line up with the
       card body text (metrics/budget sit at card-padding 32 + 20) */
    margin: 16px 20px 0;
    padding-top: 15px;
    border-top: 1px solid rgba(142,58,154,0.12);
    position: relative;
    z-index: 1;
}
.card-platforms-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #a29aad;
}
.card-platforms-logos { display: flex; align-items: center; gap: 8px; }
/* Launched on a now-disconnected cabinet — greyed (still runs there, can't be managed). */
.plat-disconnected { opacity: .32; filter: grayscale(1); display: inline-flex; }
/* Partial launch: a platform whose tool FAILED to launch — red "!" badge on its logo. */
.card-plat { position: relative; display: inline-flex; }
.card-plat.plat-failed { opacity: .5; filter: grayscale(.6); }
.plat-failed-mark {
  position: absolute; top: -5px; right: -6px;
  width: 15px; height: 15px; border-radius: 50%;
  background: #e5484d; color: #fff;
  font-size: 10px; font-weight: 800; line-height: 15px; text-align: center;
  box-shadow: 0 0 0 2px #fff;
}
.plat-tile {
    width: 30px; height: 30px;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(20,10,40,0.10);
    transition: transform .15s ease, box-shadow .15s ease;
    flex: 0 0 auto;
}
.plat-tile:hover { transform: translateY(-2px); box-shadow: 0 6px 15px rgba(20,10,40,0.20); }
.plat-tile-white  { background: #fff; border: 1px solid #ececf2; }
.plat-tile-yandex { background: #FC3F1D; }
.plat-tile-sense  { background: linear-gradient(135deg, #FF6B4A, #E94B6C 55%, #8E3A9A); }
.plat-svg { width: 18px; height: 18px; display: block; }
.plat-letter { color: #fff; font-weight: 800; font-size: 15px; line-height: 1; }
.plat-tile-yandex .plat-letter { font-size: 16px; }
/* platform count in the subtitle (replaces "N ad groups" for Max) */
.sense-max-platforms { font-weight: 600; color: #8E3A9A; }

/* full precision, compact only when it would overflow (measured live) */
.fit-currency { display: block; max-width: 100%; overflow: hidden; white-space: nowrap; }

/* Max card budget — one compact row (Sense / Commission / External / From balance),
   aligned to the metric boxes (20px insets); external muted when it's stats-only. */
.sm-budget-strip { display: flex; align-items: flex-start; gap: 10px; padding: 6px 20px 4px; }
.sm-bs-item { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.sm-bs-label { font-size: 10px; font-weight: 700; letter-spacing: .3px; text-transform: uppercase; color: #a09aac; white-space: nowrap; }
.sm-bs-val { font-size: 14px; font-weight: 700; color: #22222c; white-space: nowrap; }
.sm-bs-val.muted { color: #b0b0ba; }
.sm-bs-item.total { align-items: flex-end; text-align: right; padding-left: 12px; border-left: 1px solid rgba(142,58,154,0.16); flex: 0 0 auto; min-width: 120px; }
.sm-bs-item.total .sm-bs-label { color: #8E3A9A; }
.sm-bs-item.total .sm-bs-val { font-size: 15px; font-weight: 800; color: #1a1a22; }

.campaign-card::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, rgba(142, 58, 154, 0.12) 0%, transparent 70%);
    pointer-events: none;
    transform: translate(50%, -50%);
    transition: all 0.4s ease;
}

.campaign-card:hover {
    transform: translateY(-6px);
    border-color: rgba(142, 58, 154, 0.3);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.campaign-card:hover::after {
    transform: translate(40%, -40%) scale(1.2);
}

.campaign-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 28px;
    position: relative;
    z-index: 1;
}

.campaign-info h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
    color: var(--text-primary);
}

.campaign-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: var(--text-secondary);
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    animation: pulse 2s ease infinite;
    box-shadow: 0 0 0 0 currentColor;
}

.status-dot.live {
    background: var(--success);
    box-shadow: 0 0 12px var(--success);
}

.status-dot.paused {
    background: var(--warning);
    box-shadow: 0 0 8px var(--warning);
}

.status-dot.ended {
    background: var(--text-tertiary);
}

@keyframes pulse {
    0%, 100% { 
        opacity: 1;
        box-shadow: 0 0 0 0 currentColor;
    }
    50% { 
        opacity: 0.7;
        box-shadow: 0 0 12px 4px transparent;
    }
}

.campaign-budget {
    text-align: right;
    position: relative;
    z-index: 1;
}

.budget-label {
    font-size: 12px;
    color: var(--text-tertiary);
    margin-bottom: 6px;
}

.budget-value {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.budget-bar {
    width: 100px;
    height: 6px;
    background: #f8f9fa;
    border-radius: 3px;
    margin-top: 10px;
    overflow: hidden;
    margin-left: auto;
}

.budget-fill {
    height: 100%;
    background: var(--accent-gradient);
    border-radius: 3px;
    transition: width 0.8s ease;
    box-shadow: 0 0 12px rgba(255, 107, 74, 0.6);
}

.campaign-metrics {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    position: relative;
    z-index: 1;
}

.metric {
    text-align: center;
}

.metric-value {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 6px;
    color: var(--text-primary);
}

.metric-label {
    font-size: 11px;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Analytics Chart with Gradient */
.analytics-section {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    padding: 36px;
    margin-bottom: 48px;
    animation: fadeInUp 0.6s ease 0.4s;
    animation-fill-mode: both;
    position: relative;
    overflow: visible;
}

.analytics-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 80% 20%, rgba(255, 107, 74, 0.05) 0%, transparent 50%);
    pointer-events: none;
    border-radius: 16px;
}

.analytics-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;
    position: relative;
    z-index: 1;
}

.chart-tabs {
    display: flex;
    gap: 12px;
}

.chart-tab {
    padding: 10px 20px;
    background: transparent;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.chart-tab::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.chart-tab:hover::before {
    opacity: 0.1;
}

.chart-tab.active {
    background: #f8f9fa;
    border-color: transparent;
    color: var(--text-primary);
    position: relative;
}

.chart-tab.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--accent-gradient);
}

/* Chart tab labels - full on desktop, short on mobile */
.chart-tab-full {
    display: inline;
}

.chart-tab-short {
    display: none;
}

.chart-container {
    height: 320px;
    position: relative;
    background: 
        linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%);
    border-radius: 12px;
    padding: 20px;
}

#reportChart {
    width: 100%;
    height: 100%;
}

.chart-tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.chart-tooltip.show {
    opacity: 1;
}

.tooltip-date {
    font-weight: 700;
    margin-bottom: 6px;
    color: #FF6B4A;
}

.tooltip-value {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
}

.tooltip-label {
    font-size: 11px;
    color: #aaa;
}

/* Audience Intelligence */
.audience-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
    animation: fadeInUp 0.6s ease 0.5s;
    animation-fill-mode: both;
}

.audience-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    padding: 32px;
    position: relative;
    overflow: hidden;
}

.audience-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 90% 10%, rgba(233, 75, 108, 0.05) 0%, transparent 60%);
    pointer-events: none;
}

.audience-card h3 {
    font-family: 'DM Sans', sans-serif;
    font-size: 20px;
    margin-bottom: 28px;
    position: relative;
    display: inline-block;
}

.audience-card h3::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 50px;
    height: 2px;
    background: var(--accent-gradient);
    border-radius: 1px;
}

.segment-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    position: relative;
    z-index: 1;
}

.segment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid transparent;
}

.segment-item:hover {
    background: #fafbfc;
    transform: translateX(6px);
    border-color: rgba(255, 107, 74, 0.2);
}

.segment-info {
    display: flex;
    align-items: center;
    gap: 14px;
}

.segment-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: var(--accent-gradient);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.segment-details h4 {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 6px;
}

.segment-details p {
    font-size: 12px;
    color: var(--text-tertiary);
}

.segment-count {
    text-align: right;
}

.segment-count-value {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 4px;
    color: var(--text-primary);
}

.segment-count-label {
    font-size: 11px;
    color: var(--text-tertiary);
}

/* Top Creatives */
.creative-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    z-index: 1;
}

.creative-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid transparent;
}

.creative-item:hover {
    background: #fafbfc;
    border-color: rgba(142, 58, 154, 0.2);
}

.creative-rank {
    font-size: 20px;
    font-weight: 700;
    width: 40px;
    text-align: center;
    color: var(--text-primary);
}

.creative-preview {
    width: 64px;
    height: 64px;
    border-radius: 10px;
    background: var(--accent-gradient);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    box-shadow: 0 4px 12px rgba(142, 58, 154, 0.3);
}

.creative-details {
    flex: 1 1;
}

.creative-details h4 {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 8px;
}

.creative-stats {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: var(--text-tertiary);
}

.creative-ctr {
    font-size: 18px;
    font-weight: 700;
    color: var(--success);
}

/* Animations */
@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInLeft {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/* Responsive */
@media (max-width: 1400px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .campaign-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 1024px) {
    .sidebar {
        width: 240px;
    }
    
    .main-content {
        margin-left: 240px;
        padding: 24px 32px;
    }

    .audience-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .sidebar {
        transform: translateX(-100%);
    }
    
    .main-content {
        margin-left: 0;
        padding: 16px;
    }

    .stats-grid {
        grid-template-columns: 1fr;
    }

    .campaign-metrics {
        grid-template-columns: repeat(2, 1fr);
    }
}
    


/* Variant 6: Segmented Control */
.type-segmented {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 4px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 4px;
}

.type-segment {
    padding: 12px 8px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    position: relative;
}

.type-segment svg {
    width: 20px;
    height: 20px;
    color: var(--text-secondary);
    transition: all 0.3s ease;
}

.type-segment-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-secondary);
    transition: all 0.3s ease;
}

.type-segment:hover {
    background: rgba(255, 107, 74, 0.08);
}

.type-segment:hover svg,
.type-segment:hover .type-segment-label {
    color: var(--accent-orange);
}

.type-segment.active {
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.type-segment.active svg,
.type-segment.active .type-segment-label {
    color: var(--accent-orange);
}

/* Reports Layout */
.reports-layout {
    display: grid;
    grid-template-columns: 380px minmax(0, 1fr);
    gap: 24px;
    align-items: start;
}

/* Filters Panel */
.filters-panel {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 28px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    position: sticky;
    top: 24px;
}

.filter-section {
    margin-bottom: 36px;
}

.filter-section:last-child {
    margin-bottom: 0;
}

/* Section Headings - same as dashboard section-title */
.section-heading {
    font-size: 12px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 20px;
    display: block;
}

/* Type Buttons - same as chart-tab */
.type-buttons {
    display: grid;
    gap: 10px;
}

.type-button {
    padding: 12px 16px;
    background: transparent;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 10px;
}

.type-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.type-button:hover::before {
    opacity: 0.1;
}

.type-button.active {
    background: #f8f9fa;
    border-color: transparent;
    color: var(--text-primary);
}

.type-button.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--accent-gradient);
}

.type-button svg {
    width: 18px;
    height: 18px;
    position: relative;
    z-index: 1;
}

/* Form Fields */
.form-field {
    margin-bottom: 16px;
}

.field-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
}

.field-select {
    width: 100%;
    padding: 13px 40px 13px 16px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    font-family: inherit;
    background: white;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: right 16px center;
}

.field-select:hover {
    border-color: #adb5bd;
}

.field-select:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);
}

/* Campaign Info */
.info-box {
    padding: 16px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.06), rgba(233, 75, 108, 0.06));
    border-radius: 8px;
    border-left: 3px solid var(--accent-orange);
    font-size: 14px;
    line-height: 1.7;
    color: #495057;
}

.info-box div {
    margin-bottom: 4px;
}

.info-box div:last-child {
    margin-bottom: 0;
}

.info-box strong {
    color: var(--text-primary);
    font-weight: 600;
}

/* Period Buttons */
.period-buttons {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 16px;
}

.period-button {
    padding: 12px;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #495057;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;
}

.period-button:hover {
    border-color: #adb5bd;
}

.period-button.active {
    background: var(--accent-gradient);
    border-color: transparent;
    color: white;
}

/* Date Inputs */
.date-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.date-input {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    color: var(--text-primary);
    transition: all 0.2s;
}

.date-input:hover {
    border-color: #adb5bd;
}

.date-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.06);
}

/* Action Buttons (Reports page specific) */
.action-buttons {
    display: grid;
    gap: 10px;
}

.action-buttons .btn-primary {
    width: 100%;
    padding: 15px 24px;
    background: var(--accent-gradient);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.action-buttons .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 74, 0.4);
}

.action-buttons .btn-secondary {
    width: 100%;
    padding: 15px 24px;
    background: white;
    color: #495057;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.action-buttons .btn-secondary:hover {
    border-color: #adb5bd;
    background: #f8f9fa;
}

.action-buttons .btn-primary svg,
.action-buttons .btn-secondary svg {
    width: 18px;
    height: 18px;
}


/* Chart Section */
.chart-section {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 28px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    margin-bottom: 24px;
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.chart-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.chart-tabs {
    display: flex;
    gap: 12px;
}

.chart-tab {
    padding: 10px 20px;
    background: transparent;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.chart-tab::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.chart-tab:hover::before {
    opacity: 0.1;
}

.chart-tab.active {
    background: #f8f9fa;
    border-color: transparent;
    color: var(--text-primary);
    position: relative;
}

.chart-tab.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--accent-gradient);
}

.chart-container {
    height: 320px;
    position: relative;
    background: 
        linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%);
    border-radius: 12px;
    padding: 20px;
}

#reportChart {
    width: 100%;
    height: 100%;
}

.chart-tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.chart-tooltip.show {
    opacity: 1;
}

.tooltip-date {
    font-weight: 700;
    margin-bottom: 6px;
    color: #FF6B4A;
}

.tooltip-value {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
}

.tooltip-label {
    font-size: 11px;
    color: #aaa;
}

/* Results */
.results-area {
    display: none;
    /* Grid item, so min-width defaults to auto and it takes its content's width,
       overflowing its own track — minmax(0, 1fr) on .reports-layout sizes the
       TRACK but does not make the item shrink. Without this the summary grid
       claimed the width it wanted and pushed the whole document sideways
       (measured 1719px against a 1250px viewport), which no overflow container
       further down can undo: nothing is ever too narrow, so nothing scrolls. */
    min-width: 0;
}

.results-area.visible {
    display: block;
}

/* Report Card */
.report-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    min-width: 0;   /* same reason as .results-area above */
}

.report-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
}

.report-title {
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
    position: relative;
    padding-bottom: 12px;
}

.report-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background: var(--accent-gradient);
    border-radius: 2px;
}

.report-period {
    font-size: 14px;
    color: var(--text-secondary);
}

/* Table */
/* The money columns pushed the table past its card. It scrolls sideways inside
   its own box now rather than widening the page. */
.report-table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.report-table {
    width: 100%;
    border-collapse: collapse;
}

/* A figure like "₸ 1 293,81" was breaking after the symbol once the column got
   tight — with the scroll in place the cells can keep their natural width. */
.report-table th,
.report-table td {
    white-space: nowrap;
}

/* The one column that may be long and IS safe to clip: it sets its own width. */
.report-table td.val-wrap {
    white-space: normal;
}

.report-table thead {
    background: #f8f9fa;
}

.report-table th {
    padding: 18px;
    text-align: left;
    font-size: 13px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    border-bottom: 2px solid #e9ecef;
}

.report-table td {
    padding: 20px 18px;
    font-size: 16px;
    color: #495057;
    border-bottom: 1px solid #f1f3f5;
}

.report-table tbody tr:hover {
    background: #f8f9fa;
}

.report-table tbody tr:last-child td {
    border-bottom: none;
}

.val-big {
    font-weight: 600;
    color: var(--text-primary);
    font-size: 17px;
}

.val-positive {
    color: var(--success);
    font-weight: 600;
}

.val-negative {
    color: var(--danger);
    font-weight: 600;
}

@media (max-width: 1200px) {
    .reports-layout {
        grid-template-columns: 1fr;
    }

    .filters-panel {
        position: static;
    }
}

/* Pagination Arrows */
.pagination-arrow {
    position: relative;
    overflow: hidden;
}

.pagination-arrow::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.pagination-arrow:not(:disabled):hover {
    border-color: var(--accent-orange) !important;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.2);
}

.pagination-arrow:not(:disabled):hover::before {
    opacity: 0.1;
}

.pagination-arrow:not(:disabled):hover svg {
    stroke: var(--accent-purple) !important;
}

.pagination-arrow:not(:disabled):active {
    transform: scale(0.95);
}

/* Sortable Table Headers */
.report-table th[style*="cursor: pointer"] {
    transition: all 0.2s ease;
    position: relative;
}

.report-table th[style*="cursor: pointer"]:hover {
    color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.05);
}

.report-table th[style*="cursor: pointer"]:hover span {
    opacity: 1 !important;
    color: var(--accent-orange);
}

/* ========================================
   MOBILE RESPONSIVE STYLES
   ======================================== */

/* Mobile Header */
.mobile-header {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: var(--bg-card);
    border-bottom: 1px solid var(--border-color);
    z-index: 100;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.mobile-header-logo {
    display: flex;
    align-items: center;
}

.mobile-header-logo img {
    height: 32px;
    width: auto;
}

.mobile-header-logo .mobile-logo-icon {
    height: 36px;
    width: 36px;
    border-radius: 8px;
}

/* Mobile Menu Button */
.mobile-menu-btn {
    display: none;
    width: 40px;
    height: 40px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.mobile-menu-btn:hover {
    background: var(--bg-tertiary);
}

.mobile-menu-btn svg {
    width: 22px;
    height: 22px;
    color: var(--text-primary);
}

/* Sidebar Overlay */
.sidebar-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
}

.sidebar-overlay.visible {
    opacity: 1;
    visibility: visible;
}

/* ========================================
   TABLET (iPad) - 768px to 1024px
   ======================================== */
@media (max-width: 1024px) {
    /* Prevent horizontal scroll */
    html, body {
        overflow-x: hidden;
        max-width: 100vw;
    }

    /* Mobile header */
    .mobile-header {
        display: flex;
        z-index: 101;
    }

    .mobile-menu-btn {
        display: flex;
    }

    /* Overlay */
    .sidebar-overlay {
        display: block;
        z-index: 100;
    }

    /* Sidebar as drawer */
    .sidebar {
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: 280px;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
        z-index: 102;
        background: #fafbfc;
        padding-top: 70px;
    }

    /* Скрыть логотип в сайдбаре - он есть в хедере */
    .sidebar .logo {
        display: none;
    }

    .sidebar.open {
        transform: translateX(0);
    }

    .main-content {
        margin-left: 0;
        padding: 76px 20px 20px 20px;
        max-width: 100%;
        box-sizing: border-box;
    }

    .reports-layout {
        grid-template-columns: 1fr;
        gap: 20px;
        max-width: 100%;
    }

    .filters-panel {
        position: static;
        padding: 20px;
        max-width: 100%;
        box-sizing: border-box;
    }

    .type-segmented {
        grid-template-columns: repeat(5, 1fr);
    }

    /* Results area */
    .results-area {
        max-width: 100%;
    }

    /* Report card */
    .report-card {
        max-width: 100%;
        box-sizing: border-box;
    }

    /* Таблица - скролл внутри карточки */
    .report-table {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    /* Таблицы на планшете - на всю ширину */
    .report-card {
        width: 100%;
    }

    .report-table {
        width: 100% !important;
        min-width: 100%;
        display: table;
    }

    .report-table th {
        padding: 16px 14px;
        font-size: 13px;
    }

    .report-table td {
        padding: 18px 14px;
        font-size: 17px;
    }

    .val-big {
        font-size: 18px;
    }

    .val-big {
        font-size: 15px;
    }
}

/* ========================================
   TABLET ONLY - 769px to 1024px
   Form fields in 2 columns
   ======================================== */
@media (min-width: 769px) and (max-width: 1024px) {
    /* All filter sections use flexbox for potential 2-column layout */
    .filter-section {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: flex-end;
    }

    /* Section headings take full width */
    .filter-section > .section-heading,
    .filter-section > h3 {
        width: 100%;
        flex-basis: 100%;
    }

    /* Form fields - 2 per row when there are multiple */
    .filter-section > .form-field {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 6px);
        min-width: calc(50% - 6px);
        max-width: calc(50% - 6px);
        margin-bottom: 0 !important;
        margin-top: 0 !important;
    }

    /* Single form-field takes full width */
    .filter-section > .form-field:only-of-type {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
    }

    /* Period buttons and date fields take full width */
    .filter-section > .period-buttons,
    .filter-section > .date-fields,
    .filter-section > .type-segmented,
    .filter-section > .action-buttons {
        width: 100%;
        flex-basis: 100%;
    }

    /* Date fields - ensure they stay in a row */
    .date-fields {
        grid-template-columns: 1fr 1fr;
    }
}

/* ========================================
   MOBILE - max 768px
   ======================================== */
@media (max-width: 768px) {
    /* Main content */
    .main-content {
        padding: 72px 12px 12px 12px;
        max-width: 100%;
        box-sizing: border-box;
    }

    /* Report card */
    .report-card {
        max-width: 100%;
        box-sizing: border-box;
    }

    /* Header adjustments */
    .header {
        margin-bottom: 16px;
        padding-bottom: 12px;
    }

    .header-title h1 {
        font-size: 22px;
    }

    .header-subtitle {
        font-size: 13px;
    }

    /* Reports layout */
    .reports-layout {
        gap: 16px;
    }

    /* Filters panel - компактнее */
    .filters-panel {
        padding: 16px;
        border-radius: 10px;
    }

    .filter-section {
        margin-bottom: 20px;
    }

    .section-heading {
        font-size: 11px;
        margin-bottom: 12px;
    }

    /* Type segmented - компактный с подписями */
    .type-segmented {
        grid-template-columns: repeat(5, 1fr);
        padding: 4px;
        gap: 4px;
        background: var(--bg-tertiary);
        border-radius: 10px;
    }

    .type-segment {
        padding: 10px 4px;
        gap: 4px;
        border-radius: 8px;
        background: transparent;
        border: none;
    }

    .type-segment.active {
        background: white;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }

    .type-segment svg {
        width: 16px;
        height: 16px;
    }

    .type-segment-label {
        font-size: 9px;
    }

    /* Period buttons - в ряд */
    .period-buttons {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
    }

    .period-button {
        padding: 10px 8px;
        font-size: 12px;
    }

    /* Date fields */
    .date-fields {
        gap: 8px;
    }

    .date-input {
        padding: 10px 12px;
        font-size: 14px;
    }

    .field-select {
        padding: 10px 32px 10px 12px;
        font-size: 14px;
    }

    .field-label {
        font-size: 12px;
        margin-bottom: 6px;
    }

    /* Action buttons - в ряд */
    .action-buttons {
        gap: 8px;
        display: flex;
        flex-direction: row;
    }

    .action-buttons .btn-primary,
    .action-buttons .btn-secondary {
        flex: 1 1;
        padding: 12px 10px;
        font-size: 13px;
    }

    /* Report card */
    .report-card {
        padding: 16px;
        border-radius: 10px;
    }

    .report-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        margin-bottom: 16px;
    }

    .report-title {
        font-size: 18px;
        padding-bottom: 8px;
    }

    .report-period {
        font-size: 13px;
    }

    /* Summary stats - компактные 3 в ряд */
    .report-card > div[style*="grid-template-columns: repeat(3"] {
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 6px !important;
        margin-bottom: 14px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div {
        padding: 10px 6px !important;
        border-radius: 8px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div > div:first-child {
        font-size: 16px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div > div:last-child {
        font-size: 9px !important;
    }

    /* Chart section */
    .chart-section {
        padding: 12px;
        margin-bottom: 16px;
    }

    .chart-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 16px;
    }

    .chart-title {
        font-size: 15px;
    }

    /* Chart tabs - segmented control стиль */
    .chart-tabs {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 4px;
        background: var(--bg-tertiary);
        border-radius: 8px;
        padding: 4px;
    }

    .chart-tab {
        padding: 10px 8px;
        font-size: 12px;
        text-align: center;
        border: none;
        background: transparent;
        border-radius: 6px;
        color: var(--text-secondary);
    }

    .chart-tab::before,
    .chart-tab::after {
        display: none !important;
    }

    .chart-tab.active {
        background: white;
        color: var(--accent-orange);
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }

    .chart-tab.active::after {
        display: none !important;
    }

    /* Короткие названия на мобильных */
    .chart-tab-full {
        display: none;
    }

    .chart-tab-short {
        display: inline;
    }

    .chart-container {
        height: 160px;
        padding: 4px;
    }

    /* Report card - contain overflow */
    .report-card {
        max-width: 100%;
        overflow: hidden;
    }

    /* Table - компактная и читаемая */
    .report-table {
        display: table;
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
    }

    .report-table thead {
        background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%);
    }

    .report-table th {
        padding: 10px 6px;
        font-size: 9px;
        white-space: nowrap;
        letter-spacing: 0.5px;
        border-bottom: 2px solid #e9ecef;
    }

    .report-table td {
        padding: 12px 6px;
        font-size: 13px;
        white-space: nowrap;
    }

    /* Zebra striping для лучшей читаемости */
    .report-table tbody tr:nth-child(even) {
        background: rgba(0,0,0,0.02);
    }

    .report-table tbody tr:hover {
        background: rgba(255, 107, 74, 0.05);
    }

    /* Первая колонка (дата) - акцент */
    .report-table td:first-child {
        font-weight: 600;
        color: #2c3e50;
    }

    .val-big {
        font-size: 13px;
        font-weight: 600;
    }

    /* CTR положительный - зелёный */
    .val-positive {
        color: #27ae60;
        font-weight: 600;
    }

    /* Pagination */
    .report-card > div[style*="justify-content: space-between"] {
        flex-direction: column !important;
        gap: 12px !important;
        align-items: center !important;
    }
}

/* ========================================
   SMALL MOBILE - max 480px
   ======================================== */
@media (max-width: 480px) {
    .main-content {
        padding: 70px 12px 12px 12px;
    }

    .header-title h1 {
        font-size: 20px;
    }

    .header-subtitle {
        font-size: 12px;
    }

    /* Filters более компактные */
    .filters-panel {
        padding: 12px;
    }

    .filter-section {
        margin-bottom: 16px;
    }

    /* Type segmented - компактный с подписями */
    .type-segmented {
        grid-template-columns: repeat(5, 1fr);
        gap: 3px;
        padding: 3px;
    }

    .type-segment {
        padding: 8px 2px;
        gap: 3px;
    }

    .type-segment svg {
        width: 14px;
        height: 14px;
    }

    .type-segment-label {
        font-size: 8px;
    }

    /* Period buttons */
    .period-buttons {
        gap: 4px;
    }

    .period-button {
        padding: 8px 6px;
        font-size: 11px;
    }

    /* Date fields - в колонку */
    .date-fields {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    /* Inputs */
    .field-select,
    .date-input {
        padding: 10px 12px;
        font-size: 14px;
    }

    /* Buttons */
    .btn-primary,
    .btn-secondary {
        padding: 10px 14px;
        font-size: 13px;
    }

    /* Report card */
    .report-card {
        padding: 12px;
    }

    /* Summary stats - ещё компактнее */
    .report-card > div[style*="grid-template-columns: repeat(3"] {
        gap: 4px !important;
        margin-bottom: 12px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div {
        padding: 8px 4px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div > div:first-child {
        font-size: 14px !important;
    }

    .report-card > div[style*="grid-template-columns: repeat(3"] > div > div:last-child {
        font-size: 8px !important;
    }

    /* Chart - segmented control на 480px */
    .chart-tabs {
        grid-template-columns: repeat(4, 1fr);
        gap: 3px;
        padding: 3px;
    }

    .chart-tab {
        padding: 8px 4px;
        font-size: 10px;
    }

    .chart-tab::before,
    .chart-tab::after,
    .chart-tab.active::after {
        display: none !important;
    }

    .chart-container {
        height: 140px;
    }

    /* Table - ещё компактнее */
    .report-table th {
        padding: 8px 3px;
        font-size: 8px;
    }

    .report-table td {
        padding: 10px 3px;
        font-size: 12px;
    }

    .val-big {
        font-size: 12px;
    }

    /* Pagination buttons */
    .pagination-arrow,
    .report-card button[style*="width: 36px"] {
        width: 34px !important;
        height: 34px !important;
    }
}

/* ========================================
   CAMPAIGN SEARCH AUTOCOMPLETE
   ======================================== */

.campaign-search-container {
    position: relative;
    width: 100%;
}

.campaign-search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.campaign-search-input-wrapper .search-icon {
    position: absolute;
    left: 14px;
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
    pointer-events: none;
    transition: color 0.2s;
}

.campaign-search-input {
    width: 100%;
    padding: 13px 40px 13px 42px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    font-family: inherit;
    background: white;
    color: var(--text-primary);
    transition: all 0.2s;
}

.campaign-search-input::placeholder {
    color: var(--text-tertiary);
}

.campaign-search-input:hover {
    border-color: #adb5bd;
}

.campaign-search-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);
}

.campaign-search-input:focus + .search-icon,
.campaign-search-input-wrapper:focus-within .search-icon {
    color: var(--accent-orange);
}

/* Loading spinner */
.search-spinner {
    position: absolute;
    right: 14px;
    width: 18px;
    height: 18px;
    border: 2px solid #e9ecef;
    border-top-color: var(--accent-orange);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Clear button */
.search-clear-btn {
    position: absolute;
    right: 10px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f3f5;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 0;
    transition: all 0.2s;
}

.search-clear-btn:hover {
    background: #e9ecef;
}

.search-clear-btn svg {
    width: 14px;
    height: 14px;
    color: var(--text-secondary);
}

.search-clear-btn:hover svg {
    color: var(--text-primary);
}

/* Dropdown */
.campaign-search-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    max-height: 320px;
    overflow-y: auto;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    animation: dropdownSlide 0.2s ease;
}

@keyframes dropdownSlide {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Dropdown items */
.campaign-search-item {
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s;
    border-bottom: 1px solid #f1f3f5;
}

.campaign-search-item:last-child {
    border-bottom: none;
}

.campaign-search-item:hover {
    background: #f8f9fa;
}

.campaign-search-item.selected {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.08));
}

.campaign-search-item.selected:hover {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12), rgba(233, 75, 108, 0.12));
}

.campaign-search-item-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 4px;
    line-height: 1.3;
}

.archived-label {
    font-size: 12px;
    font-weight: 400;
    color: #9ca3af;
    margin-left: 6px;
}

.campaign-search-item-advertiser {
    font-size: 13px;
    color: var(--text-secondary);
}

/* Empty state */
.campaign-search-empty {
    padding: 20px 16px;
    text-align: center;
    color: var(--text-secondary);
    font-size: 14px;
}

/* Mobile adjustments */
@media (max-width: 768px) {
    .campaign-search-input {
        padding: 10px 36px 10px 38px;
        font-size: 14px;
    }

    .campaign-search-input-wrapper .search-icon {
        left: 12px;
        width: 16px;
        height: 16px;
    }

    .search-clear-btn {
        right: 8px;
        width: 22px;
        height: 22px;
    }

    .search-clear-btn svg {
        width: 12px;
        height: 12px;
    }

    .campaign-search-dropdown {
        max-height: 280px;
    }

    .campaign-search-item {
        padding: 12px 14px;
    }

    .campaign-search-item-name {
        font-size: 14px;
    }

    .campaign-search-item-advertiser {
        font-size: 12px;
    }
}

/* ========================================
   CAMPAIGNS PAGE STYLES
   ======================================== */

/* Filters Bar */
.filters-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    gap: 20px;
}

.filters-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.filters-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Status Filter Dropdown */
.status-filter-select {
    height: 40px;
    padding: 0 32px 0 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat right 10px center;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    min-width: 140px;
}

.status-filter-select:hover {
    border-color: #d1d5db;
}

.status-filter-select:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

/* Status Segmented Control */
.status-segmented {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 4px;
    display: inline-flex;
    gap: 4px;
}

.status-segment {
    padding: 10px 20px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary);
    font-family: inherit;
}

.status-segment:hover {
    background: rgba(255, 107, 74, 0.08);
}

.status-segment.active {
    background: white;
    color: var(--text-primary);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.segment-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 11px;
    font-size: 11px;
    font-weight: 700;
}

.status-segment.active .segment-count {
    background: var(--accent-gradient);
    color: white;
}

/* View Toggle */
.view-toggle {
    display: flex;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 4px;
}

.view-btn {
    padding: 8px 12px;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.view-btn svg {
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
}

.view-btn:hover svg {
    color: var(--text-secondary);
}

.view-btn.active {
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.view-btn.active svg {
    color: var(--accent-orange);
}

/* Search Box */
.search-box {
    position: relative;
    width: 280px;
}

.search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
    pointer-events: none;
}

.search-input {
    width: 100%;
    padding: 12px 14px 12px 44px;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    color: var(--text-primary);
    background: white;
    transition: all 0.2s;
}

.search-input::placeholder {
    color: var(--text-tertiary);
}

.search-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);
}

/* Period Select */
.period-select {
    padding: 10px 36px 10px 14px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    background: white;
    color: var(--text-primary);
    cursor: pointer;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    transition: all 0.2s;
}

.period-select:hover {
    border-color: #adb5bd;
}

.period-select:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);
}

/* Campaigns Table Card */
.campaigns-table-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    overflow: visible;
    animation: fadeInUp 0.4s ease;
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

/* ============ CARD VIEW ============ */
.campaigns-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
    gap: 24px;
    animation: fadeInUp 0.4s ease;
}

.campaigns-cards .campaign-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 10px;
    transition: all 0.3s ease;
    position: relative;
    overflow: visible;
    display: flex;
    flex-direction: column;
}

.campaigns-cards .campaign-card .card-ai {
    margin-top: auto;
}

.campaigns-cards .campaign-card::after {
    display: none;
}

.campaigns-cards .campaign-card:hover,
.campaigns-cards .campaign-card.menu-active {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
}

/* Card with unpublished changes */
.campaigns-cards .campaign-card.has-unpublished {
    overflow: hidden;
    border-color: rgba(255, 107, 74, 0.5);
    box-shadow: 0 0 0 1px rgba(255, 107, 74, 0.2);
}

.campaigns-cards .campaign-card.has-unpublished:hover {
    border-color: rgba(255, 107, 74, 0.7);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(255, 107, 74, 0.3);
}

.campaigns-cards .campaign-card:hover::after {
    display: none;
}

.campaigns-cards .campaign-card.action-loading {
    pointer-events: none;
}

.card-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    z-index: 100;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary);
}

.card-loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f1f3f5;
    border-top-color: var(--brand-orange);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px 12px 0;
    /* keeps a long campaign name from butting against the status badge */
    gap: 10px;
}

.campaign-name-card {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    /* Campaign names are often long underscore-joined strings with no break
       opportunity. Without min-width:0 the flex item refuses to shrink below
       its content and the name runs under the status badge. */
    flex: 1 1;
    min-width: 0;
}

.campaign-name-card .campaign-name-text {
    min-width: 0;
}

.card-title {
    font-size: 15px;
    font-weight: 800;
    color: var(--text-primary);
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.card-subtitle {
    font-size: 12px;
    color: var(--text-tertiary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.card-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    position: relative;
    z-index: 10;
    /* the badge and the menu keep their size; only the name shrinks */
    flex-shrink: 0;
}

.card-actions .actions-dropdown {
    position: relative;
}

.card-actions .actions-btn {
    pointer-events: auto;
}

/* Status Badge */
.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
}

.status-badge.live {
    background: rgba(46, 204, 113, 0.1);
    color: var(--success);
}

.status-badge.paused {
    background: rgba(108, 117, 125, 0.1);
    color: var(--text-secondary);
}

.status-badge-icon {
    width: 12px;
    height: 12px;
}

.status-badge.ended {
    background: rgba(108, 117, 125, 0.1);
    color: var(--text-secondary);
}

.status-badge .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.status-badge .status-dot.live {
    background: var(--success);
    box-shadow: 0 0 8px var(--success);
    animation: statusPulse 2s ease infinite;
}

/* Corner Ribbon for Unpublished Changes */
.corner-ribbon {
    position: absolute;
    top: 18px;
    left: -40px;
    width: 150px;
    padding: 5px 0;
    background: linear-gradient(135deg, #ff6b4a 0%, #e94b6c 100%);
    color: white;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
    transform: rotate(-45deg);
    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.35);
    z-index: 15;
    pointer-events: none;
}

/* Card Dates Row */
.card-dates-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 12px 8px;
}

.card-dates {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-secondary);
}

.card-dates svg {
    color: var(--text-tertiary);
}

/* Demographics Link */
.demographics-link {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.demographics-link:hover {
    color: var(--text-primary);
    background: var(--bg-tertiary);
}

.demographics-link svg {
    color: inherit;
}

/* Demographics Content */
.demographics-content {
    padding: 8px 20px 0;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.demographics-loading,
.demographics-empty,
.demographics-no-data {
    text-align: center;
    color: var(--text-secondary);
    padding: 40px 20px;
    font-size: 13px;
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.demographics-no-data-small {
    text-align: center;
    color: var(--text-secondary);
    padding: 20px 10px;
    font-size: 12px;
    opacity: 0.7;
}

.demographics-charts {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: flex-end;
}

.demographics-chart-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1;
    align-self: flex-start;
    position: relative;
}

.demographics-chart-title.age-title {
    position: absolute;
    top: 0;
    left: 130px;
    transform: translateX(-50%);
}

.demographics-chart-section.gender-section {
    flex: 0 0 auto;
    align-items: center;
}

.demographics-chart-title {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

.demographics-bars {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.demographics-bar-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.demographics-bar-label {
    width: 70px;
    font-size: 12px;
    color: var(--text-secondary);
    flex-shrink: 0;
}

.demographics-bar-track {
    flex: 1 1;
    height: 20px;
    background: var(--bg-tertiary);
    border-radius: 4px;
    overflow: hidden;
}

.demographics-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease;
}

.demographics-bar-fill.age {
    background: linear-gradient(90deg, #FF6B4A 0%, #E94B6C 100%);
}

.demographics-bar-fill.gender {
    background: linear-gradient(90deg, #8E3A9A 0%, #6B5CE7 100%);
}

/* Age Pie Chart */
.age-pie-container {
    position: relative;
    height: 290px;
    margin-top: 22px;
}

.age-pie-chart {
    position: absolute;
    top: 0;
    left: 0;
}

.age-pie-tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    z-index: 100;
    transform: translate(-50%, -100%);
}

.age-pie-segment {
    transition: opacity 0.2s ease;
    cursor: pointer;
}

.age-pie-segment:hover {
    opacity: 0.8;
}

.age-pie-label {
    font-size: 14px;
    font-weight: 600;
    fill: white;
    pointer-events: none;
}

.age-pie-legend {
    position: absolute;
    bottom: 10px;
    left: 250px;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.age-legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
}

.age-legend-color {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

.age-legend-label {
    color: var(--text-secondary);
}

/* Gender Single Bar */
.gender-single-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
}

.gender-label {
    font-size: 12px;
    color: var(--text-secondary);
    flex-shrink: 0;
}

.gender-bar-track {
    flex: 1 1;
    height: 32px;
    background: var(--bg-tertiary);
    border-radius: 4px;
    display: flex;
    position: relative;
}

.gender-bar-female {
    height: 100%;
    background: linear-gradient(90deg, #E94B6C 0%, #FFAA80 100%);
    transition: width 0.3s ease;
    border-right: 2px solid white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 8px;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
}

.gender-bar-male {
    height: 100%;
    background: linear-gradient(90deg, #C77DFF 0%, #6B2D78 100%);
    transition: width 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 8px;
    cursor: pointer;
    border-radius: 0 4px 4px 0;
}

.gender-bar-tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    pointer-events: none;
    z-index: 100;
}

.gender-bar-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.85);
}

.gender-bar-tooltip.female-tooltip {
    left: 25%;
    transform: translateX(-50%);
}

.gender-bar-tooltip.male-tooltip {
    right: 25%;
    left: auto;
    transform: translateX(50%);
}

.gender-bar-female:hover ~ .gender-bar-tooltip.female-tooltip,
.gender-bar-male:hover ~ .gender-bar-tooltip.male-tooltip {
    opacity: 1;
    visibility: visible;
}

.gender-bar-text {
    font-size: 11px;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
    white-space: nowrap;
}

/* Gender Vertical Bar */
.gender-vertical-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.gender-bar-track-vertical {
    width: 44px;
    height: 265px;
    background: var(--bg-tertiary);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: visible;
}

.gender-bar-female-v {
    width: 100%;
    background: linear-gradient(180deg, #E94B6C 0%, #FFAA80 100%);
    transition: height 0.3s ease, opacity 0.2s ease;
    border-bottom: 2px solid white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 25%;
    cursor: pointer;
    border-radius: 4px 4px 0 0;
    position: relative;
}

.gender-bar-male-v {
    width: 100%;
    background: linear-gradient(180deg, #C77DFF 0%, #6B2D78 100%);
    transition: height 0.3s ease, opacity 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 25%;
    cursor: pointer;
    border-radius: 0 0 4px 4px;
    position: relative;
}

.gender-bar-text-v {
    font-size: 11px;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.gender-bar-tooltip-v {
    position: absolute;
    right: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    pointer-events: none;
    z-index: 100;
}

.gender-bar-female-v:hover,
.gender-bar-male-v:hover {
    opacity: 0.8;
}

.gender-bar-female-v:hover .gender-bar-tooltip-v,
.gender-bar-male-v:hover .gender-bar-tooltip-v {
    opacity: 1;
    visibility: visible;
}

/* When only one gender is shown - full rounded corners */
.gender-bar-only {
    border-radius: 4px !important;
}

.gender-label-v {
    font-size: 11px;
    color: var(--text-secondary);
    text-align: center;
}

.demographics-bar-value {
    width: 50px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-primary);
    text-align: right;
    flex-shrink: 0;
}

.demographics-total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid var(--border-color);
    font-size: 12px;
    color: var(--text-secondary);
    text-align: center;
}

/* Card Chart */
.card-chart {
    padding: 0 20px;
    margin: 8px 0;
    position: relative;
    height: 100px;
    overflow: visible;
}

.card-chart-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: crosshair;
}

.card-sparkline-svg {
    width: 100%;
    height: 100%;
    overflow: visible;
    display: block;
}

/* Chart dots (HTML elements for campaign cards) */
.card-chart-wrapper .chart-dot {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 5;
}

.card-chart-wrapper .chart-dot.hover-dot {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-chart-wrapper .chart-dot-inner {
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
}

.card-chart-wrapper .chart-dot.end-dot {
    width: 10px;
    height: 10px;
}

/* Chart Tooltip */
.chart-tooltip {
    position: absolute;
    background: rgba(26, 26, 26, 0.95);
    color: white;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 11px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 100;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    transform: translateX(-50%);
}

.chart-tooltip.show {
    opacity: 1;
}

.chart-tooltip-date {
    font-weight: 700;
    color: #FF6B4A;
    margin-bottom: 4px;
}

.chart-tooltip-value {
    font-size: 13px;
    font-weight: 600;
}

.chart-tooltip-change {
    font-size: 10px;
    margin-top: 2px;
}

.chart-tooltip-change.positive { color: var(--success); }
.chart-tooltip-change.negative { color: var(--danger); }

.card-chart-empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
    font-size: 13px;
}

/* Card Metrics Grid */
.card-metrics-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 16px 20px;
}

.metric-box {
    text-align: center;
    padding: 12px 8px;
    background: #f8f9fa;
    border-radius: 8px;
    /* Grid items default to min-width:auto, so a long conversion-goal name would
       blow the track out and distort the whole 4-column metrics grid (squishing
       Impressions/Clicks/Spend). Pin to 0 so every track keeps its 1fr share and
       the name ellipsizes instead. */
    min-width: 0;
}

.metric-box .metric-label {
    font-size: 10px;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
}

.metric-big {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 4px;
}

/* Top-2 conversion goals under the Conversions metric */
.metric-top-conv {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 4px;
}
.top-conv-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    font-size: 11px;
}
.top-conv-name {
    color: var(--text-secondary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* Allow the flex item to shrink below its content width so ellipsis engages. */
    min-width: 0;
}
.top-conv-count {
    font-weight: 700;
    color: var(--text-primary);
    flex-shrink: 0;
    font-variant-numeric: tabular-nums;
}

.metric-change {
    font-size: 11px;
    font-weight: 600;
}

.metric-change.positive {
    color: var(--success);
}

.metric-change.negative {
    color: var(--danger);
}

.metric-change.neutral {
    color: #6c757d;
}

.metric-box.clickable {
    cursor: pointer;
    transition: all 0.2s ease;
}

.metric-box.clickable:hover {
    background: #eef0f2;
}

.metric-box.clickable.selected {
    box-shadow: inset 0 -2px 0 var(--accent-orange);
}

/* Card Costs */
.card-costs {
    display: flex;
    gap: 8px;
    padding: 0 20px 16px;
}

.cost-box {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    background: #f8f9fa;
    border-radius: 6px;
    font-size: 12px;
}

.cost-box .cost-label {
    color: var(--text-tertiary);
}

.cost-box .cost-value {
    font-weight: 600;
    color: var(--text-primary);
}

/* CPC/CPM drive the card chart, same as the metric boxes above. */
.cost-box.clickable {
    cursor: pointer;
    transition: all 0.2s ease;
}

.cost-box.clickable:hover {
    background: #eef0f2;
}

.cost-box.clickable.selected {
    box-shadow: inset 0 -2px 0 var(--accent-orange);
}

.cost-box.highlight {
    background: linear-gradient(135deg, rgba(46, 204, 113, 0.1), rgba(46, 204, 113, 0.05));
    border: 1px solid rgba(46, 204, 113, 0.2);
}

.cost-box.highlight.warning {
    background: linear-gradient(135deg, rgba(243, 156, 18, 0.1), rgba(243, 156, 18, 0.05));
    border: 1px solid rgba(243, 156, 18, 0.2);
}

/* Card Budget */
.card-budget {
    padding: 0 20px 16px;
}

.card-budget .budget-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
    font-size: 13px;
}

.card-budget .budget-label {
    color: var(--text-secondary);
}

.card-budget .budget-amount {
    font-weight: 600;
}

.card-budget .budget-bar {
    width: 100%;
    height: 6px;
    background: #f1f3f5;
    border-radius: 3px;
    overflow: hidden;
    margin-top: 0;
}

.card-budget .budget-progress {
    height: 100%;
    background: var(--accent-gradient);
    border-radius: 3px;
}

.card-budget .budget-progress.warning {
    background: var(--danger);
}

/* Card AI - Pacing Alerts */
.card-ai {
    padding: 16px 30px;
    background: linear-gradient(135deg, rgba(142, 58, 154, 0.06), rgba(142, 58, 154, 0.02));
    border-top: 1px solid rgba(142, 58, 154, 0.1);
    border-radius: 0 0 12px 12px;
    margin: 0 -10px -10px -10px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.card-ai.warning {
    background: linear-gradient(135deg, rgba(243, 156, 18, 0.08), rgba(243, 156, 18, 0.02));
    border-top-color: rgba(243, 156, 18, 0.15);
}

.ai-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    color: var(--accent-purple);
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.card-ai.warning .ai-badge {
    color: var(--warning);
}

.ai-badge svg {
    flex-shrink: 0;
}

.ai-recommendation {
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-secondary);
    margin: 0;
}

.card-ai:hover {
    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));
}

.card-ai.warning:hover {
    background: linear-gradient(135deg, rgba(243, 156, 18, 0.12), rgba(243, 156, 18, 0.04));
}

.ai-action {
    display: inline-block;
    margin-left: 8px;
    color: var(--accent-purple);
    font-weight: 600;
}

.card-ai.warning .ai-action {
    color: var(--warning);
}

.card-ai.danger {
    background: linear-gradient(135deg, rgba(231, 76, 60, 0.15), rgba(192, 57, 43, 0.08));
    border-top: 2px solid rgba(231, 76, 60, 0.5);
}

.card-ai.danger .ai-badge {
    color: #c0392b;
    font-weight: 600;
    background: #fff;
    padding: 4px 10px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.card-ai.danger:hover {
    background: linear-gradient(135deg, rgba(231, 76, 60, 0.2), rgba(192, 57, 43, 0.12));
}

.card-ai.danger .ai-action {
    color: #c0392b;
    font-weight: 600;
}

.card-ai.danger .ai-recommendation {
    color: #1a1a1a;
}

/* Paused style - purple/neutral */
.card-ai.paused {
    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));
    border-top: 2px solid rgba(142, 58, 154, 0.3);
}

.card-ai.paused .ai-badge {
    color: #8E3A9A;
    font-weight: 600;
    background: #fff;
    padding: 4px 10px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.card-ai.paused:hover {
    background: linear-gradient(135deg, rgba(142, 58, 154, 0.15), rgba(142, 58, 154, 0.08));
}

.card-ai.paused .ai-action {
    color: #8E3A9A;
    font-weight: 600;
}

.card-ai.paused .ai-recommendation {
    color: #1a1a1a;
}

/* OK style - neutral gray */
.card-ai.ok {
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
}

.card-ai.ok .ai-badge {
    color: #6c757d;
    font-weight: 600;
    background: #fff;
    padding: 4px 10px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.card-ai.ok:hover {
    background: #f1f3f5;
}

.card-ai.ok .ai-recommendation {
    color: #495057;
}

.card-ai.ok .ai-action {
    display: none;
}

/* Campaigns Table */
.campaigns-table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 16px;
    overflow: hidden;
    table-layout: fixed;
}

/* Fixed column widths */
.campaigns-table th:nth-child(1),
.campaigns-table td:nth-child(1) { width: 28%; } /* Campaign */
.campaigns-table th:nth-child(2),
.campaigns-table td:nth-child(2) { width: 10%; } /* Period */
.campaigns-table th:nth-child(3),
.campaigns-table td:nth-child(3) { width: 12%; } /* Trend */
.campaigns-table th:nth-child(4),
.campaigns-table td:nth-child(4) { width: 14%; } /* Metrics */
.campaigns-table th:nth-child(5),
.campaigns-table td:nth-child(5) { width: 8%; } /* CPM */
.campaigns-table th:nth-child(6),
.campaigns-table td:nth-child(6) { width: 8%; } /* CPC */
.campaigns-table th:nth-child(7),
.campaigns-table td:nth-child(7) { width: 14%; } /* Budget */
.campaigns-table th:nth-child(8),
.campaigns-table td:nth-child(8) { width: 6%; } /* Actions */

.campaigns-table thead {
    background: #f8f9fa;
}

.campaigns-table thead tr:first-child th:first-child {
    border-top-left-radius: 16px;
}

.campaigns-table thead tr:first-child th:last-child {
    border-top-right-radius: 16px;
}

.campaigns-table tbody tr:last-child td:first-child {
    border-bottom-left-radius: 16px;
}

.campaigns-table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 16px;
}

.campaigns-table th {
    padding: 14px 12px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    border-bottom: 1px solid #e9ecef;
    white-space: nowrap;
}

.campaigns-table td {
    padding: 12px;
    border-bottom: 1px solid #f1f3f5;
    vertical-align: middle;
}

.campaigns-table tbody tr {
    transition: background 0.2s;
}

.campaigns-table tbody tr:hover {
    background: #fafbfc;
}

.campaigns-table tbody tr:last-child td {
    border-bottom: none;
}

.campaigns-table tbody tr.row-loading {
    opacity: 0.5;
    pointer-events: none;
    position: relative;
}

.campaigns-table tbody tr.row-loading td:first-child::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border: 2px solid #f1f3f5;
    border-top-color: var(--brand-orange);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* Campaign Name Cell */
.campaign-name-cell {
    display: flex;
    gap: 10px;
    align-items: center;
    min-width: 250px;
}

.campaign-name-cell .status-dot {
    margin-right: -2px;
}

.campaign-name-cell .campaign-info {
    flex: 1 1;
    min-width: 0;
}

.campaign-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.campaign-subtitle {
    font-size: 11px;
    color: var(--text-tertiary);
}

/* Status Indicator (Table view) */
.status-indicator {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
}

.status-indicator .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.status-indicator .status-dot.live {
    background: var(--success, #2ecc71);
    box-shadow: 0 0 8px var(--success, #2ecc71);
    animation: statusPulse 2s ease infinite;
}

@keyframes statusPulse {
    0%, 100% {
        opacity: 1;
        box-shadow: 0 0 8px var(--success);
    }
    50% {
        opacity: 0.6;
        box-shadow: 0 0 12px 2px var(--success);
    }
}

/* Pause Icon */
.status-pause-icon {
    width: 14px;
    height: 14px;
    color: var(--text-tertiary, #adb5bd);
}

/* Ended Icon (hourglass) */
.status-ended-icon {
    width: 14px;
    height: 14px;
    color: var(--text-tertiary, #adb5bd);
}

/* Type Indicator */
.type-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    flex-shrink: 0;
}

.type-indicator svg {
    width: 14px;
    height: 14px;
}

.type-indicator.display {
    background: rgba(52, 152, 219, 0.1);
    color: #3498db;
}

.type-indicator.video {
    background: rgba(155, 89, 182, 0.1);
    color: #9b59b6;
}

.type-indicator.audio {
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
}

/* Date Range */
.date-range {
    font-size: 12px;
    white-space: nowrap;
}

.date-start {
    color: var(--text-primary);
    font-weight: 600;
    margin-bottom: 2px;
}

.date-end {
    color: var(--text-tertiary);
}

/* Chart Cell (Sparkline) */
.chart-cell {
    position: relative;
    width: 120px;
    height: 40px;
}

.chart-cell.empty {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
    font-size: 12px;
}

.mini-chart {
    width: 100%;
    height: 100%;
    cursor: crosshair;
}

.chart-tooltip {
    position: absolute;
    background: rgba(26, 26, 26, 0.95);
    color: white;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 11px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 100;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: translateX(-50%);
}

.chart-tooltip.show {
    opacity: 1;
}

.chart-tooltip-date {
    font-weight: 700;
    color: var(--accent-orange);
    margin-bottom: 2px;
}

.chart-tooltip-value {
    font-size: 12px;
    font-weight: 600;
}

.chart-tooltip-change {
    font-size: 10px;
    margin-top: 2px;
}

.chart-tooltip-change.positive {
    color: #2ecc71;
}

.chart-tooltip-change.negative {
    color: #e74c3c;
}

/* Metrics Cell - Campaigns Table */
.metrics-cell {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 90px;
}

.metrics-cell .metric-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    line-height: 1.3;
}

.metrics-cell .metric-label {
    font-size: 10px;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.metrics-cell .metric-value {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    text-align: right;
}

/* CPA/CPM/CPC Cell */
.campaigns-table th:nth-child(5),
.campaigns-table th:nth-child(6) {
    text-align: center;
}

.cpa-cell {
    text-align: center;
}

.cpa-value {
    font-size: 15px;
    font-weight: 700;
    color: var(--text-primary);
}

.cpa-trend {
    font-size: 11px;
    font-weight: 600;
    margin-top: 2px;
}

.cpa-trend.positive {
    color: var(--success);
}

.cpa-trend.negative {
    color: var(--danger);
}

/* Budget Info (Table view) */
.budget-info {
    min-width: 130px;
}

.budget-info .budget-values {
    display: flex;
    gap: 4px;
    font-size: 12px;
    margin-bottom: 6px;
}

.budget-info .budget-spent {
    font-weight: 700;
    color: var(--text-primary);
}

.budget-info .budget-total {
    color: var(--text-tertiary);
}

.budget-info .budget-bar {
    width: 100%;
    height: 5px;
    background: #f1f3f5;
    border-radius: 3px;
    overflow: hidden;
}

.budget-info .budget-progress {
    height: 100%;
    background: var(--accent-gradient);
    border-radius: 3px;
}

.budget-info .budget-progress.warning {
    background: var(--danger);
}

.budget-warning-icon {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    color: var(--danger);
}

.budget-warning-icon svg {
    width: 14px;
    height: 14px;
}

.card-budget .budget-warning-icon {
    margin-left: 0;
    margin-right: 6px;
    vertical-align: middle;
    position: relative;
    top: -1px;
}

.budget-info.warning .budget-spent {
    color: var(--danger);
}

/* Performance Metrics */
.perf-metrics {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.perf-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
}

.perf-label {
    color: var(--text-tertiary);
    font-size: 10px;
    text-transform: uppercase;
}

.perf-value {
    font-weight: 600;
    color: var(--text-primary);
}

/* Spend Cell */
.spend-cell {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

/* Actions Dropdown */
.actions-dropdown {
    position: relative;
}

.actions-btn {
    width: 32px;
    height: 32px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.actions-btn svg {
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
}

.actions-btn:hover {
    background: #f8f9fa;
    border-color: #e9ecef;
}

.actions-btn:hover svg {
    color: var(--text-secondary);
}

.actions-menu {
    position: absolute;
    right: 0;
    top: 100%;
    margin-top: 4px;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    min-width: 180px;
    z-index: 100;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-8px);
    transition: all 0.2s ease;
}

.actions-dropdown.open .actions-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    z-index: 1000;
}

.action-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: none;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    transition: background 0.15s;
    text-align: left;
}

.action-item:first-child {
    border-radius: 10px 10px 0 0;
}

.action-item:last-child {
    border-radius: 0 0 10px 10px;
}

.action-item:hover {
    background: #f8f9fa;
}

.action-item svg {
    width: 16px;
    height: 16px;
    color: var(--text-secondary);
}

.action-item.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.action-item.disabled:hover {
    background: none;
}

.action-item.danger {
    color: var(--danger);
}

.action-item.danger svg {
    color: var(--danger);
}

.action-item.resume svg {
    color: var(--success);
}

.action-item.publish {
    background: linear-gradient(135deg, #ff6b4a 0%, #e94b6c 100%);
    color: #ffffff;
    font-weight: 500;
}

.action-item.publish svg {
    color: #ffffff;
}

.action-item.publish:hover {
    background: linear-gradient(135deg, #ff5a3a 0%, #d83a5c 100%);
}

.action-item.delete {
    color: #dc3545;
}

.action-item.delete svg {
    color: #dc3545;
}

.action-item.loading {
    opacity: 0.7;
    cursor: wait;
}

.action-item.loading:hover {
    background: none;
}

.action-divider {
    height: 1px;
    background: #f1f3f5;
    margin: 4px 0;
}

/* Campaign Dates */
.campaign-dates {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-secondary);
}

.date-separator {
    color: #dee2e6;
}

/* Metric Cell */
.metric-cell {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.metric-cell.spend {
    color: var(--accent-purple);
}

/* Campaign Action Button */
.campaign-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    color: var(--text-secondary);
    background: transparent;
    border: 1px solid transparent;
    transition: all 0.2s;
}

.campaign-action-btn:hover {
    background: #f8f9fa;
    border-color: #e9ecef;
    color: var(--accent-orange);
}

/* Loading & Error States */
.loading-state,
.error-message,
.empty-state {
    padding: 48px 24px;
    text-align: center;
    color: var(--text-secondary);
    font-size: 15px;
}

.error-message {
    background: rgba(231, 76, 60, 0.08);
    color: #c0392b;
    border-radius: 8px;
    margin-bottom: 24px;
}

.empty-state {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 12px;
}

/* Mobile Responsive for Campaigns */
@media (max-width: 1024px) {
    .filters-bar {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
    }

    .filters-left {
        width: 100%;
    }

    .filters-right {
        width: 100%;
    }

    .status-segmented {
        width: 100%;
        justify-content: flex-start;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
    }

    .status-segmented::-webkit-scrollbar {
        display: none;
    }

    .search-box {
        width: 100%;
    }

    .period-select {
        width: 100%;
    }

    .campaigns-table-card {
        overflow-x: auto;
    }

    .campaigns-table {
        min-width: 700px;
    }

    .campaigns-cards {
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: 12px;
    }

    /* Modal on tablet */
    .modal-container {
        width: 100%;
        max-width: 100%;
        border-radius: 0;
    }
}

@media (max-width: 768px) {
    /* Filters Bar - compact */
    .filters-bar {
        gap: 10px;
        padding: 12px 0;
    }

    .status-segmented {
        background: var(--bg-tertiary);
        border-radius: 8px;
        padding: 4px;
        gap: 4px;
    }

    .status-segment {
        padding: 10px 12px;
        font-size: 12px;
        border-radius: 6px;
        white-space: nowrap;
        flex-shrink: 0;
        border: none;
        background: transparent;
    }

    .status-segment.active {
        background: white;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }

    .segment-count {
        min-width: 18px;
        height: 18px;
        font-size: 10px;
    }

    .search-box {
        height: 44px;
    }

    .search-input {
        font-size: 14px;
    }

    /* Campaign Cards - compact */
    .campaigns-cards {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .campaigns-cards .campaign-card {
        padding: 0;
        border-radius: 10px;
    }

    .card-header {
        padding: 12px 12px 0;
    }

    .campaign-name-card {
        gap: 8px;
        flex: 1 1;
        min-width: 0;
    }

    .type-indicator {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
    }

    .type-indicator svg {
        width: 14px;
        height: 14px;
    }

    .card-title {
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 180px;
    }

    .card-subtitle {
        font-size: 11px;
    }

    .card-actions {
        gap: 6px;
    }

    .status-badge {
        padding: 4px 8px;
        font-size: 10px;
        gap: 4px;
    }

    .status-badge-icon {
        width: 10px;
        height: 10px;
    }

    .actions-btn {
        width: 32px;
        height: 32px;
    }

    /* Card Dates Row - compact */
    .card-dates-row {
        padding: 10px 12px 6px;
    }

    .card-dates {
        font-size: 11px;
        gap: 4px;
    }

    .card-dates svg {
        width: 12px;
        height: 12px;
    }

    .demographics-link {
        font-size: 11px;
        padding: 4px 8px;
    }

    .demographics-link svg {
        width: 12px;
        height: 12px;
    }

    /* Card Chart - smaller on mobile */
    .card-chart {
        padding: 0 12px;
        margin: 4px 0;
        height: 60px;
    }

    /* wrapper and svg inherit height: 100% from parent */

    /* Metrics Grid - 4 in row, compact */
    .card-metrics-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 4px;
        margin: 8px 12px;
        padding: 10px;
        background: var(--bg-tertiary);
        border-radius: 8px;
    }

    .metric-box {
        padding: 0;
        text-align: center;
        background: transparent;
        border: none;
    }

    .metric-box.clickable {
        border-radius: 6px;
        padding: 6px 4px;
    }

    .metric-box.clickable.selected {
        background: white;
        box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    }

    .metric-label {
        font-size: 9px;
        margin-bottom: 2px;
    }

    .metric-big {
        font-size: 13px;
    }

    .metric-change {
        font-size: 9px;
        padding: 1px 4px;
        margin-top: 2px;
    }

    /* Card Costs - compact row */
    .card-costs {
        margin: 0 12px;
        padding: 8px 0;
        gap: 6px;
        flex-wrap: nowrap;
    }

    .cost-box {
        flex: 1 1;
        padding: 6px 8px;
        min-width: 0;
    }

    .cost-label {
        font-size: 9px;
    }

    .cost-value {
        font-size: 12px;
    }

    /* Card Budget - compact */
    .card-budget {
        margin: 0 12px 12px;
        padding: 10px;
    }

    .card-budget .budget-header {
        margin-bottom: 6px;
    }

    .card-budget .budget-label {
        font-size: 10px;
    }

    .card-budget .budget-amount {
        font-size: 11px;
    }

    .card-budget .budget-bar {
        height: 4px;
    }

    /* Card AI - mobile */
    .card-ai {
        margin: 0;
        padding: 12px;
        border-radius: 0 0 10px 10px;
    }

    .card-ai .ai-badge {
        font-size: 10px;
    }

    .card-ai .ai-recommendation {
        font-size: 12px;
    }

    /* Demographics - mobile layout */
    .demographics-content {
        padding: 10px 12px;
        min-height: unset;
        justify-content: flex-start;
    }

    .demographics-charts {
        display: grid;
        grid-template-columns: 1fr 70px;
        gap: 8px;
        align-items: start;
    }

    .demographics-chart-section {
        min-width: 0;
    }

    .demographics-chart-section.gender-section {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .demographics-chart-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: var(--text-secondary);
        margin-bottom: 8px;
        text-align: center;
    }

    /* Age chart - compact mobile */
    .age-pie-container {
        position: relative;
        height: 200px;
        margin-top: 0;
        overflow: visible;
    }

    .age-pie-chart {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%) scale(0.68);
        transform-origin: top center;
    }

    .age-pie-legend {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 3px 10px;
        justify-content: center;
        padding: 0 4px;
    }

    .age-legend-item {
        font-size: 9px;
        gap: 3px;
    }

    .age-legend-color {
        width: 7px;
        height: 7px;
        border-radius: 1px;
    }

    /* Gender - fixed height, no overflow */
    .demographics-chart-section.gender-section {
        max-height: 200px;
        overflow: hidden;
    }

    .gender-vertical-bar {
        height: auto;
        max-height: 170px;
        min-height: unset;
    }

    .gender-bar-track-vertical {
        height: 100px !important;
        flex-shrink: 0;
        border-radius: 6px;
    }

    .gender-bar-text-v {
        font-size: 10px;
    }

    .gender-label-v {
        font-size: 9px;
        margin: 2px 0;
    }

    /* Modal - full screen on mobile */
    .modal-container {
        width: 100%;
        max-width: 100%;
        border-radius: 0;
    }

    .modal-header {
        padding: 16px;
    }

    .modal-title {
        font-size: 18px;
    }

    .modal-subtitle {
        font-size: 12px;
    }

    .modal-content {
        padding: 0;
    }

    /* Ad Groups Table - horizontal scroll */
    .ad-groups-table {
        font-size: 12px;
    }

    .ad-groups-table th,
    .ad-groups-table td {
        padding: 10px 8px;
    }

    .ad-group-title {
        font-size: 13px;
    }

    .ad-group-subtitle {
        font-size: 10px;
    }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
    .card-title {
        font-size: 13px;
        max-width: 140px;
    }

    .card-subtitle {
        font-size: 10px;
    }

    .type-indicator {
        width: 24px;
        height: 24px;
    }

    .type-indicator svg {
        width: 12px;
        height: 12px;
    }

    .status-badge {
        padding: 3px 6px;
        font-size: 9px;
    }

    .card-dates {
        font-size: 10px;
    }

    .card-chart {
        height: 50px;
    }

    .card-metrics-grid {
        padding: 8px;
    }

    .metric-label {
        font-size: 8px;
    }

    .metric-big {
        font-size: 11px;
    }

    .metric-change {
        font-size: 8px;
    }

    .cost-label {
        font-size: 8px;
    }

    .cost-value {
        font-size: 11px;
    }

    .card-budget {
        padding: 8px;
    }

    .card-budget .budget-label,
    .card-budget .budget-amount {
        font-size: 10px;
    }

    /* Hide demographics pie chart on very small screens, show simplified */
    .age-pie-container {
        transform: scale(0.7);
    }

    .modal-header {
        padding: 12px;
    }

    .modal-close {
        width: 36px;
        height: 36px;
    }
}

/* ============ AD GROUPS SLIDE PANEL ============ */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(2px);
    z-index: 10000;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
}

.modal-overlay.active {
    opacity: 1;
    visibility: visible;
}

.modal-container {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    background: white;
    border-radius: 20px 0 0 20px;
    width: 1000px;
    max-width: 90%;
    overflow: hidden;
    box-shadow: -8px 0 40px rgba(0, 0, 0, 0.15);
    transform: translateX(100%);
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-overlay.active .modal-container {
    transform: translateX(0);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 1px solid var(--border-color);
    background: #fafbfc;
}

.modal-title-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
}

.modal-subtitle {
    font-size: 14px;
    color: var(--text-secondary);
}

.modal-close {
    width: 40px;
    height: 40px;
    border: none;
    background: transparent;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.modal-close svg {
    width: 24px;
    height: 24px;
    color: var(--text-tertiary);
}

.modal-close:hover {
    background: #f1f3f5;
}

.modal-close:hover svg {
    color: var(--text-primary);
}

.modal-content {
    padding: 24px 32px;
    overflow-y: auto;
    height: calc(100vh - 90px);
    position: relative;
}

.modal-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.modal-loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f1f3f5;
    border-top-color: var(--brand-gradient-start, #FF6B4A);
    border-radius: 50%;
    animation: modal-spin 0.8s linear infinite;
}

@keyframes modal-spin {
    to { transform: rotate(360deg); }
}

/* Ad Groups Table */
.ad-groups-table {
    width: 100%;
    border-collapse: collapse;
}

.ad-groups-table thead {
    background: #f8f9fa;
}

.ad-groups-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    border-bottom: 1px solid #e9ecef;
    white-space: nowrap;
}

.ad-groups-table td {
    padding: 16px;
    border-bottom: 1px solid #f1f3f5;
    vertical-align: middle;
}

.ad-groups-table tbody tr {
    transition: background 0.2s;
}

.ad-groups-table tbody tr:hover {
    background: #fafbfc;
}

.ad-groups-table tbody tr:last-child td {
    border-bottom: none;
}

.ad-groups-table tbody tr.inactive > td:not(:last-child) {
    opacity: 0.5;
}

.ad-groups-table tbody tr.inactive > td:last-child {
    opacity: 1;
}

/* Ad Group Name Cell */
.ad-group-name-cell {
    display: flex;
    gap: 12px;
    align-items: center;
    min-width: 220px;
}

.ad-group-info {
    flex: 1 1;
    min-width: 0;
}

.ad-group-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ad-group-subtitle {
    font-size: 11px;
    color: var(--text-tertiary);
}

/* Ad Groups Loading/Empty States */
.ad-groups-loading,
.ad-groups-empty {
    padding: 60px 20px;
    text-align: center;
    color: var(--text-secondary);
    font-size: 14px;
}

/* Metric Cell */
.ad-groups-table .metric-cell {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
}

/* Metrics Cell (combined Impr, Clicks, CTR) */
.metrics-cell {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 80px;
}

.metrics-cell .metric-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    line-height: 1.4;
}

.metrics-cell .metric-label {
    font-size: 10px;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.metrics-cell .metric-value {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 0;
}

/* No Budget */
.no-budget {
    color: var(--text-tertiary);
}

/* Clickable Subtitle */
.clickable-subtitle {
    cursor: pointer;
    transition: color 0.2s ease;
}

.clickable-subtitle:hover {
    color: var(--accent-orange);
}

/* Status Indicator for Ad Groups */
.ad-group-name-cell .status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.ad-group-name-cell .status-indicator .status-dot {
    width: 8px;
    height: 8px;
}

.ad-group-name-cell .status-icon {
    width: 16px;
    height: 16px;
}

.ad-group-name-cell .status-icon.paused {
    color: var(--text-tertiary);
}

.ad-group-name-cell .status-icon.ended {
    color: var(--text-tertiary);
}

.ad-group-name-cell .status-icon.scheduled {
    color: #f59e0b;
}

/* ============ EDIT CAMPAIGN PAGE ============ */

/* Back Link */
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--text-tertiary);
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    transition: color 0.2s;
    margin-bottom: 8px;
}

.back-link svg {
    width: 18px;
    height: 18px;
}

.back-link:hover {
    color: var(--accent-orange);
}

/* Edit Header */
.edit-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;
    position: relative;
    padding-bottom: 24px;
}

.edit-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 120px;
    height: 3px;
    background: var(--accent-gradient);
    border-radius: 2px;
}

.edit-header .header-title h1 {
    font-family: 'DM Sans', sans-serif;
    font-size: 36px;
    font-weight: 700;
    margin: 0 0 8px 0;
    letter-spacing: -0.5px;
    color: var(--text-primary);
}

.edit-header .header-subtitle {
    color: var(--text-secondary);
    font-size: 15px;
    margin: 0;
}

/* Edit Layout */
.edit-layout {
    display: flex;
    gap: 24px;
    align-items: flex-start;
    --text-primary: #111111;
    --text-secondary: #555555;
    --text-tertiary: #888888;
}

/* Left Panel - Campaign */
.campaign-panel {
    width: 340px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.panel-section {
    background: white;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.section-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 20px;
}

.section-header .section-title {
    margin-bottom: 0;
}

/* Form Fields */
.form-field {
    margin-bottom: 16px;
}

.form-field:last-child {
    margin-bottom: 0;
}

.field-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-input {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    color: var(--text-primary);
    background: white;
    transition: all 0.2s;
    box-sizing: border-box;
}

.field-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.field-input:disabled,
.field-input.disabled {
    background: #f5f5f7;
    color: var(--text-tertiary);
    cursor: not-allowed;
    border-color: #e5e5e8;
}

/* Required empty field - red border */
.field-input.required-empty,
.field-select.required-empty {
    border-color: #e53935;
}

.field-input.required-empty:focus {
    border-color: #e53935;
    box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);
}

/* Input with prefix - required empty */
.input-with-prefix:has(.field-input.required-empty) {
    border-color: #e53935;
}

.input-wrapper {
    display: block;
    width: 100%;
}

.field-select {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    color: var(--text-primary);
    background: white;
    cursor: pointer;
    transition: all 0.2s;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 36px;
}

.field-select:focus {
    outline: none;
    border-color: var(--accent-orange);
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
}

.form-row.form-row-3 {
    grid-template-columns: 1fr 1.5fr 1fr;
}

/* Conversion Goals Selector for CPA optimization */
.conversion-goals-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);
    border-radius: 10px;
    border: 1px solid rgba(255, 107, 74, 0.12);
    margin-bottom: 16px;
    position: relative;
}

.conversion-goals-row .goals-label {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.conversion-goals-row .goals-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1 1;
}

.conversion-goals-row .goal-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    font-size: 13px;
    color: #444;
    cursor: pointer;
    transition: all 0.15s ease;
    -webkit-user-select: none;
            user-select: none;
}

.conversion-goals-row .goal-chip:hover {
    border-color: #FF6B4A;
    background: rgba(255, 107, 74, 0.05);
}

.conversion-goals-row .goal-chip.selected {
    background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
    border-color: transparent;
    color: #fff;
    font-weight: 500;
}

.conversion-goals-row .goal-chip .goal-check {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1.5px solid currentColor;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.conversion-goals-row .goal-chip.selected .goal-check {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.6);
}

.conversion-goals-row .goal-chip.selected .goal-check::after {
    content: '';
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: 50%;
}

.conversion-goals-row.error {
    border: 2px solid #d32f2f;
    background: #fff5f5;
    box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.15);
}

.conversion-goals-row.error .goals-label {
    color: #d32f2f;
    font-weight: 700;
}

.conversion-goals-row.error .goals-label::before {
    content: '⚠ ';
}

.conversion-goals-row.error::after {
    content: 'Select at least one goal';
    position: absolute;
    right: 16px;
    font-size: 12px;
    color: #d32f2f;
    font-weight: 500;
}

.form-row-flex {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    align-items: flex-end;
}

.form-row-flex .form-field {
    margin-bottom: 0;
}

.form-field-auto {
    flex-shrink: 0;
}

.form-field-grow {
    flex: 1 1;
    min-width: 0;
}

.form-row .form-field {
    margin-bottom: 0;
    min-width: 0;   /* grid items must shrink to fit the panel, not overflow it */
}

/* Frequency Input */
.frequency-input {
    display: flex;
    align-items: center;
    gap: 8px;
}

.frequency-count {
    width: 70px;
    text-align: center;
}

.frequency-text {
    font-size: 13px;
    color: var(--text-tertiary);
    white-space: nowrap;
}

.frequency-period {
    width: auto;
    min-width: 100px;
}

/* Status Dots in Edit Page */
.edit-layout .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.edit-layout .status-dot.live {
    background: var(--success);
    box-shadow: 0 0 8px var(--success);
    animation: editStatusPulse 2s ease infinite;
}

@keyframes editStatusPulse {
    0%, 100% {
        opacity: 1;
        box-shadow: 0 0 8px var(--success);
    }
    50% {
        opacity: 0.6;
        box-shadow: 0 0 12px 2px var(--success);
    }
}

.edit-layout .status-dot.paused {
    background: var(--warning);
}

/* Status Toggle */
.status-toggle {
    display: flex;
    gap: 8px;
}

.status-btn {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s;
}

.status-btn svg {
    width: 14px;
    height: 14px;
}

.status-btn:hover {
    border-color: var(--text-tertiary);
}

.status-btn.active {
    background: linear-gradient(135deg, rgba(255,107,74,0.1), rgba(233,75,108,0.1));
    border-color: var(--accent-orange);
    color: var(--accent-orange);
}

.status-btn.ended {
    background: var(--bg-secondary);
    border-color: var(--border-color);
    color: var(--text-tertiary);
    cursor: default;
}

.status-btn.ended:hover {
    border-color: var(--border-color);
}

/* Line Item Type Toggle */
.line-item-type-toggle {
    display: flex;
    gap: 8px;
}

.line-item-type-btn {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s;
}

.line-item-type-btn svg {
    width: 20px;
    height: 20px;
}

.line-item-type-btn:hover {
    border-color: var(--text-tertiary);
    background: var(--bg-secondary);
}

.line-item-type-btn.active {
    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));
    border-color: var(--accent-orange);
    color: var(--accent-red);
}

.line-item-type-btn.active svg {
    stroke: var(--accent-orange);
}

.line-item-type-toggle.disabled .line-item-type-btn {
    cursor: not-allowed;
    opacity: 0.5;
}

.line-item-type-toggle.disabled .line-item-type-btn.active {
    opacity: 1;
}

.line-item-type-toggle.disabled .line-item-type-btn:hover {
    border-color: var(--border-color);
    background: white;
}

.line-item-type-toggle.disabled .line-item-type-btn.active:hover {
    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));
    border-color: var(--accent-orange);
}

.line-item-type-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));
    border: 1px solid rgba(255,107,74,0.2);
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
}

.line-item-type-badge svg {
    width: 18px;
    height: 18px;
    stroke: var(--accent-orange);
}

/* Ad Groups List in Edit Page */
.edit-layout .ad-groups-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    max-height: 470px;
}

.edit-layout .ad-group-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    background: #fafbfc;
    border: 1px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
}

.edit-layout .ad-group-item:hover {
    background: #f5f5fa;
}

.edit-layout .ad-group-item.active {
    background: white;
    border-color: var(--accent-orange);
    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.1);
}

.edit-layout .ad-group-item.paused {
    opacity: 0.6;
}

.edit-layout .ad-group-item.ended {
    opacity: 0.5;
}

.edit-layout .ad-group-item.scheduled {
    background: rgba(245, 158, 11, 0.05);
    border-color: rgba(245, 158, 11, 0.2);
}

.edit-layout .ad-group-info {
    flex: 1 1;
    min-width: 0;
}

.edit-layout .ad-group-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.edit-layout .ad-group-meta {
    font-size: 12px;
    color: var(--text-tertiary);
    margin-top: 2px;
}

.edit-layout .chevron {
    width: 20px;
    height: 20px;
    color: var(--text-tertiary);
    flex-shrink: 0;
    transition: transform 0.2s;
}

.edit-layout .ad-group-item.active .chevron {
    color: var(--accent-orange);
}

.edit-layout .status-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

.edit-layout .status-icon.paused {
    color: var(--text-secondary);
}

.edit-layout .status-icon.ended {
    color: var(--text-tertiary);
}

.edit-layout .status-icon.scheduled {
    color: #f59e0b;
}

/* Sense Max constructor — the page itself never scrolls horizontally (top-level guarantee) */
.sense-max-page { overflow-x: clip; }
.sense-max-page .edit-layout { min-width: 0; max-width: 100%; }

/* Right Panel - Ad Group Form */
.adgroup-panel {
    flex: 1 1;
    min-width: 0;        /* shrink below content's intrinsic width (flexbox default is auto) */
    overflow-x: clip;    /* hard guarantee vs horizontal page-break; keeps dropdowns (vertical) visible */
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.adgroup-form {
    padding: 24px;
    min-width: 0;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--border-color);
}

.form-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.edit-layout .form-actions {
    display: flex;
    gap: 8px;
}

/* Form Sections */
.form-section {
    margin-bottom: 28px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--border-color);
}

.form-section:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.form-section-title {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Collapsible form section */
.form-section-collapsible {
    padding-top: 0;
}

.form-section-collapsible .form-section-title {
    margin-bottom: 0;
}

.form-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    padding-bottom: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
}

.form-section-header:hover .form-section-title {
    color: var(--brand-orange);
}

.form-section-chevron {
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
    transition: transform 0.2s ease;
}

.form-section-chevron.expanded {
    transform: rotate(180deg);
}

/* Inventory Section Styles */
.inventory-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-top: 8px;
}

.inventory-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.inventory-column-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary);
}

.inventory-icon {
    width: 18px;
    height: 18px;
}

.inventory-icon-whitelist {
    color: #22c55e;
}

.inventory-icon-blacklist {
    color: #ef4444;
}

.inventory-list-selector {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
}

.inventory-list-selector select {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    background: white;
    font-size: 13px;
    color: var(--text-secondary);
    cursor: pointer;
}

.inventory-list-selector select:focus {
    outline: none;
    border-color: var(--brand-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.btn-new-list {
    padding: 8px 12px;
    background: linear-gradient(135deg, var(--brand-orange) 0%, var(--brand-red) 100%);
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
}

.btn-new-list:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.3);
}

.inventory-urls-container {
    position: relative;
}

.inventory-urls-input {
    width: 100%;
    padding: 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 12px;
    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
    line-height: 1.5;
    resize: vertical;
    min-height: 120px;
    background: white;
    color: var(--text-primary);
}

.inventory-urls-input:focus {
    outline: none;
    border-color: var(--brand-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.inventory-urls-input::placeholder {
    color: var(--text-tertiary);
    font-style: italic;
}

.inventory-urls-count {
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: 11px;
    color: var(--text-tertiary);
    background: rgba(255, 255, 255, 0.9);
    padding: 2px 6px;
    border-radius: 4px;
}

/* Inventory chips (like Proximity) */
.inventory-saved-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
}

.inventory-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.15s ease;
}

.inventory-chip-whitelist {
    background: rgba(34, 197, 94, 0.1);
    color: #15803d;
}

.inventory-chip-whitelist:hover,
.inventory-chip-whitelist.active {
    background: rgba(34, 197, 94, 0.25);
}

.inventory-chip-blacklist {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.inventory-chip-blacklist:hover,
.inventory-chip-blacklist.active {
    background: rgba(239, 68, 68, 0.25);
}

.inventory-chip-new {
    background: rgba(255, 107, 74, 0.1);
    color: var(--brand-orange);
}

.inventory-chip-new:hover {
    background: rgba(255, 107, 74, 0.2);
}

.inventory-chip-count {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 8px;
    font-weight: 600;
}

.inventory-chip-whitelist .inventory-chip-count {
    background: rgba(34, 197, 94, 0.2);
}

.inventory-chip-blacklist .inventory-chip-count {
    background: rgba(239, 68, 68, 0.2);
}

.inventory-chip-remove {
    font-size: 14px;
    line-height: 1;
    opacity: 0.5;
    margin-left: 2px;
}

.inventory-chip-remove:hover {
    opacity: 1;
}

/* Inventory editor */
.inventory-editor {
    margin-top: 8px;
}

.inventory-textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 12px;
    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
    line-height: 1.5;
    resize: vertical;
    min-height: 100px;
    background: white;
    color: var(--text-primary);
    margin-top: 6px;
}

.inventory-textarea:focus {
    outline: none;
    border-color: var(--brand-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.inventory-textarea::placeholder {
    color: var(--text-tertiary);
}

.inventory-hint {
    display: block;
    font-size: 11px;
    color: var(--text-tertiary);
    margin-top: 4px;
}

.form-placeholder {
    color: var(--text-tertiary);
    font-size: 14px;
    font-style: italic;
}

/* Targeting Styles */
.targeting-group {
    margin-bottom: 16px;
}

.targeting-group:last-child {
    margin-bottom: 0;
}

.targeting-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 10px;
}

.targeting-row:last-child {
    margin-bottom: 0;
}

.targeting-row-separated {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid var(--border-light);
}

.targeting-label {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    min-width: 70px;
    padding-top: 4px;
}

.sm-blacklist {
    flex: 1 1;
    min-height: 62px;
    padding: 8px 10px;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-family: inherit;
    font-size: 13px;
    line-height: 1.4;
    resize: vertical;
}

.targeting-hint {
    font-size: 12px;
    line-height: 1.45;
    color: var(--text-secondary);
    opacity: .8;
    margin: 6px 0 0 78px;   /* clears the label column so it reads as a footnote */
    max-width: 560px;
}

.targeting-expand-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    background: transparent;
    border: 1px dashed var(--border-color);
    border-radius: 12px;
    font-size: 12px;
    color: var(--text-tertiary);
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.targeting-expand-btn:hover {
    color: var(--text-secondary);
    border-color: var(--text-tertiary);
    background: var(--bg-tertiary);
}

.targeting-expand-btn.active {
    color: var(--text-tertiary);
    border-color: var(--border-color);
    background: transparent;
}

.targeting-expand-btn svg {
    width: 14px;
    height: 14px;
}

.targeting-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1 1;
}

.targeting-tags-wrap {
    max-height: 120px;
    overflow-y: auto;
}

.targeting-tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.1) 100%);
    border: 1px solid rgba(255, 107, 74, 0.2);
    border-radius: 12px;
    font-size: 12px;
    color: var(--text-primary);
    white-space: nowrap;
}

.targeting-tag-more {
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-secondary);
    cursor: pointer;
}

.targeting-tag-more:hover {
    background: var(--bg-hover);
}

.targeting-empty {
    font-size: 13px;
    color: var(--text-tertiary);
    font-style: italic;
}

/* Toggle tags (Age, Gender, Devices) */
.targeting-tag-toggle {
    cursor: pointer;
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-tertiary);
    transition: all 0.15s ease;
}

.targeting-tag-toggle:hover {
    background: var(--bg-hover);
    color: var(--text-secondary);
}

.targeting-tag-toggle.active {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.15) 0%, rgba(233, 75, 108, 0.15) 100%);
    border-color: rgba(255, 107, 74, 0.3);
    color: var(--text-primary);
}

/* Exclude tags (Content Labels, Sensitive Categories) */
.targeting-tag-exclude {
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-tertiary);
}

.targeting-tag-exclude.excluded {
    background: rgba(220, 53, 69, 0.1);
    border-color: rgba(220, 53, 69, 0.3);
    color: #dc3545;
}

.targeting-tag-exclude:hover {
    background: rgba(220, 53, 69, 0.05);
    border-color: rgba(220, 53, 69, 0.2);
    color: var(--text-secondary);
}

/* Exclude tag active state (uses .active not .excluded for consistency) */
.targeting-tag-exclude.active {
    background: rgba(220, 53, 69, 0.12);
    border-color: rgba(220, 53, 69, 0.4);
    color: #dc3545;
}

/* Disabled tag (when included can't exclude, vice versa) */
.targeting-tag.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

/* Inventory column header with toggle */
.inventory-column-header-with-toggle {
    display: flex;
    align-items: center;
    gap: 12px;
}

.inventory-column-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Align remarketing columns - both headers same height */
.inventory-columns .inventory-column-header {
    min-height: 32px;
    display: flex;
    align-items: center;
}

/* Remarketing OR/AND toggle switch */
.remarketing-toggle {
    display: inline-flex;
    background: var(--bg-tertiary);
    border-radius: 6px;
    padding: 2px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.remarketing-toggle-option {
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-tertiary);
    border-radius: 4px;
    transition: all 0.15s ease;
}

.remarketing-toggle-option.active {
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
}

/* Look-Alike (Optimized Targeting) section */
.lookalike-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-light);
}

.lookalike-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.lookalike-toggle {
    display: inline-flex;
    background: var(--bg-tertiary);
    border-radius: 6px;
    padding: 2px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.lookalike-toggle-option {
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-tertiary);
    border-radius: 4px;
    transition: all 0.15s ease;
}

.lookalike-toggle-option.active-off {
    background: var(--bg-secondary);
    color: var(--text-secondary);
}

.lookalike-toggle-option.active-on {
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
}

.lookalike-hint {
    margin: 8px 0 0 0;
    font-size: 11px;
    color: var(--text-tertiary);
    line-height: 1.4;
}

/* Unavailable state */
.lookalike-unavailable .lookalike-row,
.lookalike-unavailable .lookalike-hint {
    opacity: 0.4;
    pointer-events: none;
}

.lookalike-warning {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 10px;
}

.lookalike-warning-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: var(--accent-orange);
}

.lookalike-warning span {
    font-size: 12px;
    line-height: 1.5;
    color: var(--text-secondary);
}

.lookalike-warning-highlight {
    color: var(--accent-orange);
    font-weight: 600;
}

/* Exclude chip styles */
.proximity-chip-exclude:hover {
    border-color: #dc3545;
    background: rgba(220, 53, 69, 0.04);
}

.proximity-chip-exclude.selected {
    border-color: #dc3545;
    background: linear-gradient(135deg, #dc3545, #b33d4a);
    color: white;
}

.chip-checkbox-exclude:hover {
    border-color: #dc3545;
}

.chip-checkbox-exclude.checked {
    background: #dc3545;
    border-color: #dc3545;
    color: white;
}

/* Clickable chip (for remarketing - whole area is clickable) */
.proximity-chip-clickable {
    cursor: pointer;
}

/* Disabled chip (already selected in other column) */
.disabled-chip {
    opacity: 0.35;
    pointer-events: none;
}

/* Targeting empty state */
.targeting-empty {
    padding: 20px;
    text-align: center;
    color: var(--text-tertiary);
    font-size: 13px;
}

/* Removable tags (Locations) */
.targeting-tag-removable {
    padding-right: 6px;
    gap: 4px;
}

.targeting-tag-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    background: transparent;
    color: var(--text-tertiary);
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.15s ease;
}

.targeting-tag-remove:hover {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
}

/* Language dropdown */
.targeting-dropdown-container {
    position: relative;
    flex: 1 1;
}

.targeting-row:has(.targeting-dropdown-container) {
    align-items: center;
}

.targeting-dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 280px;
    padding: 8px 12px;
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.15s ease;
}

.targeting-dropdown-trigger:hover {
    border-color: var(--accent-orange);
}

.dropdown-trigger-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown-chevron {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    transition: transform 0.2s ease;
}

.dropdown-chevron.expanded {
    transform: rotate(180deg);
}

.targeting-dropdown-panel {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-width: 280px;
    margin-top: 4px;
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 100;
    overflow: hidden;
}

.dropdown-search-wrapper {
    padding: 8px;
    border-bottom: 1px solid var(--border-light);
}

.dropdown-search-input {
    width: 100%;
    padding: 8px 10px;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 13px;
    color: var(--text-primary);
    outline: none;
}

.dropdown-search-input:focus {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 2px rgba(255, 107, 74, 0.15);
}

.dropdown-search-input::placeholder {
    color: var(--text-tertiary);
}

.dropdown-options-list {
    max-height: 240px;
    overflow-y: auto;
    padding: 4px 0;
}

.dropdown-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    transition: background 0.1s ease;
}

.dropdown-option:hover {
    background: var(--bg-hover);
}

.dropdown-option input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: var(--accent-orange);
    cursor: pointer;
}

.dropdown-option .option-label {
    font-size: 13px;
    color: var(--text-primary);
}

.dropdown-no-results {
    padding: 16px;
    text-align: center;
    font-size: 13px;
    color: var(--text-tertiary);
}

.targeting-selected-tags {
    margin-top: 8px;
}

.tag-remove-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    padding: 0;
    margin-left: 2px;
    border: none;
    background: transparent;
    color: var(--text-tertiary);
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.15s ease;
}

.tag-remove-btn svg {
    width: 10px;
    height: 10px;
}

.tag-remove-btn:hover {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
}

/* Add button */
.targeting-add-btn {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: transparent;
    border: 1px dashed var(--border-color);
    border-radius: 12px;
    font-size: 12px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.15s ease;
}

.targeting-add-btn:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.05);
}

/* Geo input */
.targeting-input-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.targeting-input {
    padding: 4px 8px;
    border: 1px solid var(--accent-orange);
    border-radius: 8px;
    font-size: 12px;
    width: 180px;
    outline: none;
    background: var(--bg-primary);
    color: var(--text-primary);
}

.targeting-input:focus {
    box-shadow: 0 0 0 2px rgba(255, 107, 74, 0.2);
}

.targeting-input-cancel {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: none;
    background: var(--bg-tertiary);
    color: var(--text-secondary);
    font-size: 14px;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.15s ease;
}

.targeting-input-cancel:hover {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
}

/* Geo autocomplete */
.targeting-autocomplete-container {
    position: relative;
    display: inline-block;
}

.targeting-input-loading {
    font-size: 12px;
    color: var(--text-secondary);
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}

.targeting-autocomplete-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 240px;
    overflow-y: auto;
    z-index: 100;
    min-width: 250px;
}

.targeting-autocomplete-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    transition: background 0.15s ease;
}

.targeting-autocomplete-item:hover {
    background: rgba(255, 107, 74, 0.1);
}

.targeting-autocomplete-item:first-child {
    border-radius: 8px 8px 0 0;
}

.targeting-autocomplete-item:last-child {
    border-radius: 0 0 8px 8px;
}

.targeting-autocomplete-item:only-child {
    border-radius: 8px;
}

.targeting-autocomplete-item .geo-name {
    font-size: 13px;
    color: var(--text-primary);
}

.targeting-autocomplete-item .geo-type {
    font-size: 11px;
    color: var(--text-secondary);
    background: var(--bg-tertiary);
    padding: 2px 6px;
    border-radius: 4px;
}

.targeting-autocomplete-empty {
    padding: 12px;
    text-align: center;
    color: var(--text-secondary);
    font-size: 12px;
}

/* Geo Grouped Display */
.targeting-row-vertical {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
}

.targeting-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.targeting-count {
    font-size: 12px;
    color: var(--text-secondary);
}

.geo-groups-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: var(--bg-secondary);
    border-radius: 8px;
    padding: 12px;
}

.geo-type-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.geo-type-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--border-color);
}

.geo-type-name {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--text-secondary);
    letter-spacing: 0.5px;
}

.geo-type-count {
    font-size: 11px;
    color: var(--text-muted);
}

.geo-type-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.geo-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    border-radius: 6px;
    transition: background 0.15s ease;
}

.geo-list-item:hover {
    background: var(--bg-primary);
}

.geo-item-name {
    font-size: 13px;
    color: var(--text-primary);
}

.geo-item-remove {
    display: none;
    width: 18px;
    height: 18px;
    border: none;
    background: transparent;
    color: var(--text-muted);
    font-size: 14px;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.15s ease;
    align-items: center;
    justify-content: center;
}

.geo-list-item:hover .geo-item-remove {
    display: flex;
}

.geo-item-remove:hover {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
}

.geo-empty {
    text-align: center;
    color: var(--text-secondary);
    font-size: 13px;
    padding: 16px;
}

.geo-add-section {
    padding-top: 8px;
    border-top: 1px solid var(--border-color);
}

.geo-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: 1px dashed var(--border-color);
    background: transparent;
    color: var(--text-secondary);
    font-size: 12px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
}

.geo-add-btn:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.05);
}

.geo-search-input {
    width: 100%;
    max-width: 300px;
}

/* Geo Two-Column Layout */
.geo-columns {
    display: flex;
    gap: 24px;
}

.geo-column {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.geo-column .targeting-label {
    margin-bottom: 0;
}

/* Geo Locations List */
.geo-email-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.geo-email-list {
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 12px 12px 0 0;
}

.geo-email-item:first-child {
    border-radius: 12px 12px 0 0;
}

.geo-email-list::-webkit-scrollbar {
    width: 6px;
}

.geo-email-list::-webkit-scrollbar-track {
    background: transparent;
}

.geo-email-list::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));
    border-radius: 3px;
}

.geo-email-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    position: relative;
}

.geo-email-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));
    opacity: 0;
    transition: opacity 0.2s ease;
}

.geo-email-item:hover::before {
    opacity: 1;
}

.geo-email-item:last-child {
    border-bottom: none;
}

.geo-email-item:hover {
    background: linear-gradient(90deg, rgba(255, 107, 74, 0.04), transparent);
}

.geo-email-name {
    font-size: 14px;
    color: #212529;
    flex: 1 1;
    font-weight: 500;
}

.geo-name-secondary {
    font-size: 12px;
    color: #868e96;
    font-weight: 400;
}

.geo-email-remove {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: #adb5bd;
    font-size: 20px;
    font-weight: 300;
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.geo-email-item:hover .geo-email-remove {
    opacity: 1;
}

.geo-email-remove:hover {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.15), rgba(233, 75, 108, 0.15));
    color: var(--accent-red);
}

.geo-email-search {
    position: relative;
    padding: 8px 12px;
}

.geo-email-container > .geo-email-search:first-child {
    padding-top: 12px;
}

.geo-email-search-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px 12px;
    background: white;
    transition: border-color 0.2s;
}

.geo-email-search-wrapper:focus-within {
    border-color: #999;
}

.geo-email-search-icon {
    display: none;
}

.geo-email-input {
    flex: 1 1;
    border: none;
    background: transparent;
    font-size: 13px;
    color: #212529;
    outline: none;
    font-family: inherit;
}

.geo-email-input::placeholder {
    color: #aaa;
}

.geo-email-loading {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 107, 74, 0.2);
    border-top-color: var(--accent-orange);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.geo-email-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    max-height: 240px;
    overflow-y: auto;
    z-index: 100;
}

.geo-email-dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.15s ease;
    gap: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.geo-email-dropdown-item:last-child {
    border-bottom: none;
    border-radius: 0 0 12px 12px;
}

.geo-email-dropdown-item:hover {
    background: linear-gradient(90deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.04));
}

.geo-dropdown-name {
    font-size: 14px;
    color: #212529;
    flex: 1 1;
    font-weight: 500;
}

.geo-dropdown-type {
    font-size: 11px;
    color: white;
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    padding: 4px 10px;
    border-radius: 12px;
    font-weight: 600;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.geo-email-dropdown-empty {
    padding: 20px;
    text-align: center;
    color: #868e96;
    font-size: 13px;
}

/* Excluded Locations Styling */
.targeting-label-excluded {
    display: flex;
    align-items: center;
    gap: 6px;
}

.excluded-icon {
    width: 16px;
    height: 16px;
    stroke: var(--accent-red);
}

.geo-excluded-container .geo-email-item::before {
    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));
}

.geo-excluded-container .geo-email-item:hover {
    background: linear-gradient(90deg, rgba(255, 107, 74, 0.04), transparent);
}

/* Geo Mode Header */
.geo-mode-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}

.geo-mode-header .targeting-label {
    margin-bottom: 0;
}

/* Geo Mode Toggle */
.geo-mode-toggle {
    display: flex;
    gap: 8px;
}

.geo-mode-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    background: white;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.geo-mode-btn svg {
    width: 18px;
    height: 18px;
}

.geo-mode-btn:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
}

.geo-mode-btn.active {
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    border-color: transparent;
    color: white;
}

.geo-mode-btn.active svg {
    stroke: white;
}

/* Proximity Container */
.proximity-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* Proximity Saved Row - Chips */
.proximity-saved-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.proximity-saved-label {
    font-size: 13px;
    color: var(--text-tertiary);
    margin-right: 4px;
}

.proximity-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid var(--border-color);
    border-radius: 20px;
    background: white;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-chip:hover {
    border-color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.04);
}

.proximity-chip.active {
    border-color: var(--accent-orange);
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
}

.proximity-chip-count {
    background: rgba(0, 0, 0, 0.1);
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 11px;
    margin-left: 6px;
}

.proximity-chip.active .proximity-chip-count {
    background: rgba(255, 255, 255, 0.25);
}

.proximity-chip-new {
    border-style: dashed;
    color: var(--accent-orange);
}

.proximity-chip-new:hover {
    background: rgba(255, 107, 74, 0.08);
}

/* Chip checkbox for multi-select */
.chip-checkbox {
    width: 16px;
    height: 16px;
    border: 1.5px solid var(--border-color);
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: transparent;
    background: white;
    transition: all 0.15s ease;
    cursor: pointer;
    flex-shrink: 0;
}

.chip-checkbox:hover {
    border-color: var(--accent-orange);
}

.chip-checkbox.checked {
    background: var(--accent-orange);
    border-color: var(--accent-orange);
    color: white;
}

.chip-label {
    cursor: pointer;
}

.proximity-chip.selected {
    border-color: var(--accent-orange);
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
}

.proximity-chip.selected .chip-checkbox {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    color: white;
}

.proximity-chip.selected .proximity-chip-count {
    background: rgba(255, 255, 255, 0.25);
}

/* Editor Grid */
.proximity-editor-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: stretch;
}

/* Proximity Editor */
.proximity-editor {
    background: white;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.proximity-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.proximity-name-editable {
    font-weight: 600;
    font-size: 14px;
    color: #1a1a2e;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.15s;
}

.proximity-name-editable:hover {
    background: #f0f0f5;
}

.proximity-name-input {
    font-weight: 600;
    font-size: 14px;
    color: #1a1a2e;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    outline: none;
    width: 200px;
}

.proximity-name-input:focus {
    border-color: #FF6B4A;
}

.proximity-delete-btn {
    background: none;
    border: none;
    color: #999;
    font-size: 18px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.15s;
}

.proximity-delete-btn:hover {
    background: #fee2e2;
    color: #dc2626;
}

.proximity-editor-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--border-color);
}

.proximity-editing-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.proximity-back-btn {
    padding: 6px 12px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--text-secondary);
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-back-btn:hover {
    background: #f0f0f0;
    color: var(--text-primary);
}

.proximity-textarea {
    width: 100%;
    min-height: 140px;
    padding: 14px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-family: 'SF Mono', Monaco, monospace;
    font-size: 13px;
    line-height: 1.6;
    resize: vertical;
    transition: all 0.2s ease;
}

.proximity-textarea:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.proximity-textarea::placeholder {
    color: var(--text-tertiary);
    font-family: 'SF Mono', Monaco, monospace;
}

.proximity-textarea.has-error {
    border-color: #e53e3e;
    background: rgba(229, 62, 62, 0.03);
}

.proximity-textarea.has-error:focus {
    border-color: #e53e3e;
    box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.15);
}

.proximity-validation-error {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 8px;
    padding: 10px 12px;
    background: rgba(229, 62, 62, 0.08);
    border: 1px solid rgba(229, 62, 62, 0.2);
    border-radius: 8px;
    color: #c53030;
    font-size: 13px;
    line-height: 1.4;
}

.proximity-validation-error svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 1px;
    stroke: #c53030;
}

.proximity-options {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 16px;
    gap: 16px;
}

.proximity-radius-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.proximity-radius-row > label {
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 500;
}

.proximity-radius-control {
    display: flex;
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
}

.proximity-radius-btn {
    width: 32px;
    height: 36px;
    border: none;
    background: var(--bg-secondary);
    color: var(--text-secondary);
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proximity-radius-btn:hover {
    background: var(--border-color);
    color: var(--text-primary);
}

.proximity-radius-btn:active {
    background: var(--accent-orange);
    color: white;
}

.proximity-radius-input {
    width: 60px;
    padding: 8px 4px;
    border: none;
    border-left: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    font-size: 14px;
    text-align: center;
}

.proximity-radius-input:focus {
    outline: none;
}

/* Hide number input spinners */
.proximity-radius-input::-webkit-outer-spin-button,
.proximity-radius-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.proximity-radius-input[type=number] {
    -moz-appearance: textfield;
}

.proximity-radius-unit {
    font-size: 13px;
    color: var(--text-tertiary);
}

.proximity-actions {
    display: flex;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color);
}

.proximity-save-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-save-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.proximity-save-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.proximity-save-btn.saving {
    pointer-events: none;
}

/* Button spinner */
.btn-spinner {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-right: 6px;
    vertical-align: middle;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Name edit input for lists */
.proximity-name-edit {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.proximity-name-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.proximity-name-edit-btn {
    padding: 4px 8px;
    border: none;
    background: transparent;
    color: var(--text-muted);
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease;
    opacity: 0.5;
}

.proximity-name-edit-btn:hover {
    opacity: 1;
    background: var(--bg-hover);
    color: var(--accent-orange);
}

.proximity-delete-btn {
    padding: 6px 12px;
    border: 1px solid #dc3545;
    background: transparent;
    color: #dc3545;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;
    margin-left: auto;
}

.proximity-delete-btn:hover {
    background: #dc3545;
    color: white;
}

.proximity-delete-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Confirmation Modal */
.modal-overlay:has(.confirm-modal) {
    opacity: 1;
    visibility: visible;
    display: flex;
    align-items: center;
    justify-content: center;
}

.confirm-modal {
    background: white;
    border-radius: 16px;
    padding: 32px;
    width: 100%;
    max-width: 400px;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.confirm-modal-icon {
    font-size: 48px;
    margin-bottom: 16px;
}

.confirm-modal h3 {
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
}

.confirm-modal p {
    margin: 0 0 24px 0;
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.5;
}

.confirm-modal p strong {
    color: var(--text-primary);
}

.confirm-modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.confirm-modal-actions .btn-secondary {
    padding: 10px 24px;
    border: 1px solid var(--border-color);
    background: white;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.confirm-modal-actions .btn-secondary:hover {
    background: var(--bg-hover);
}

.confirm-modal-actions .btn-danger {
    padding: 10px 24px;
    border: none;
    background: #dc3545;
    color: white;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
}

.confirm-modal-actions .btn-danger:hover {
    background: #c82333;
}

.confirm-modal-actions .btn-danger:disabled,
.confirm-modal-actions .btn-secondary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Message Modal - Info/Notice variant */
.message-modal {
    background: white;
    border-radius: 16px;
    padding: 32px;
    width: 100%;
    max-width: 420px;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: modalSlideIn 0.25s ease-out;
}

.message-modal-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

.message-modal-icon.info {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.1) 100%);
    color: var(--accent-orange);
}

.message-modal-icon.error {
    background: linear-gradient(135deg, rgba(251, 191, 36, 0.15) 0%, rgba(245, 158, 11, 0.15) 100%);
    color: #d97706;
    position: relative;
}

.message-modal-icon.error::before {
    content: '';
    position: absolute;
    inset: -3px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%);
    animation: error-pulse 2s ease-in-out infinite;
}

@keyframes error-pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.08); opacity: 0.7; }
}

.message-modal h3 {
    margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
}

.message-modal p {
    margin: 0 0 24px 0;
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.6;
}

.message-modal-btn {
    padding: 11px 32px;
    border: none;
    background: var(--accent-orange);
    color: white;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.message-modal-btn:hover {
    background: #e55a3a;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.message-modal-btn:active {
    transform: translateY(0);
    box-shadow: none;
}

.message-modal-btn.warning {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.message-modal-btn.warning:hover {
    background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
    box-shadow: 0 4px 12px rgba(217, 119, 6, 0.3);
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.message-modal-icon.delete {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
}

.message-modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.message-modal-btn-secondary {
    padding: 11px 24px;
    border: 1px solid var(--border-color);
    background: white;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.message-modal-btn-secondary:hover {
    background: var(--bg-hover);
    border-color: #ccc;
}

.message-modal-btn-secondary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.message-modal-btn-danger {
    padding: 11px 24px;
    border: none;
    background: #dc3545;
    color: white;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.message-modal-btn-danger:hover {
    background: #c82333;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.message-modal-btn-danger:active {
    transform: translateY(0);
    box-shadow: none;
}

.message-modal-btn-danger:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.proximity-name-input {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid transparent;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    background: transparent;
    transition: all 0.2s ease;
}

.proximity-name-input:hover {
    background: var(--bg-hover);
}

.proximity-name-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    background: white;
}

.proximity-name-input:disabled {
    opacity: 0.7;
}

.proximity-save-new-btn {
    padding: 10px 20px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    background: white;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-save-new-btn:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
}

/* Proximity Modal */
.proximity-modal {
    background: white;
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.proximity-modal h3 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
}

.proximity-modal-input {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-size: 14px;
    transition: all 0.2s ease;
}

.proximity-modal-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.proximity-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
}

.proximity-modal-cancel {
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    background: #f0f0f0;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-modal-cancel:hover {
    background: #e0e0e0;
}

.proximity-modal-save {
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.proximity-modal-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.proximity-modal-save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Proximity Hint */
.proximity-hint {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: var(--text-tertiary);
}

/* Proximity Inline Save */
.proximity-inline-save {
    display: flex;
    align-items: center;
    gap: 8px;
}

.proximity-inline-input {
    padding: 8px 12px;
    border: 1px solid var(--accent-orange);
    border-radius: 8px;
    font-size: 14px;
    width: 180px;
    transition: all 0.2s ease;
}

.proximity-inline-input:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);
}

.proximity-inline-confirm {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proximity-inline-confirm:hover:not(:disabled) {
    transform: scale(1.05);
}

.proximity-inline-confirm:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.proximity-inline-cancel {
    width: 32px;
    height: 32px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    background: white;
    color: var(--text-tertiary);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proximity-inline-cancel:hover {
    border-color: var(--text-tertiary);
    color: var(--text-secondary);
}

/* Proximity Map */
.proximity-map {
    position: relative;
    background: #f8f9fa;
    border-radius: 12px;
    overflow: hidden;
    min-height: 300px;
    height: 100%;
}

.proximity-map-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 300px;
    color: var(--text-tertiary);
    gap: 12px;
}

.proximity-map-empty svg {
    width: 48px;
    height: 48px;
    opacity: 0.4;
}

.proximity-map-empty span {
    font-size: 13px;
}

.proximity-map-container {
    width: 100%;
    height: 100%;
    min-height: 300px;
    border-radius: 12px;
}

.proximity-map-container .leaflet-control-attribution {
    font-size: 10px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px 0 0 0;
}

.proximity-map-overlay {
    position: absolute;
    top: 12px;
    right: 12px;
    background: white;
    padding: 6px 12px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
}

.proximity-map-count {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
}

/* Input with prefix */
.input-with-prefix {
    display: flex;
    align-items: stretch;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.2s;
}

.input-with-prefix:focus-within {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.input-prefix {
    padding: 12px 14px;
    background: #f8f9fa;
    color: var(--text-tertiary);
    font-size: 14px;
    font-weight: 500;
    border-right: 1px solid var(--border-color);
}

.input-with-prefix .field-input {
    border: none;
    border-radius: 0;
}

.input-with-prefix .field-input:focus {
    box-shadow: none;
}

/* Input with prefix - required empty state */
.input-with-prefix.required-empty {
    border-color: #e53935;
}

.input-with-prefix.required-empty:focus-within {
    border-color: #e53935;
    box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);
}

/* Input with suffix */
.input-with-suffix {
    display: flex;
    align-items: stretch;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.2s;
}

.input-with-suffix:focus-within {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.input-suffix {
    padding: 12px 14px;
    background: #f8f9fa;
    color: var(--text-tertiary);
    font-size: 13px;
    font-weight: 500;
    border-left: 1px solid var(--border-color);
    white-space: nowrap;
}

.input-with-suffix .field-input {
    border: none;
    border-radius: 0;
    flex: 1 1;
}

.input-with-suffix .field-input:focus {
    box-shadow: none;
}

/* Input with inline select */
.input-with-select {
    display: flex;
    align-items: stretch;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.2s;
}

.input-with-select:focus-within {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.input-with-select .field-input {
    border: none;
    border-radius: 0;
    flex: 1 1;
}

.input-with-select .field-input:focus {
    box-shadow: none;
}

.input-with-select .field-select-inline {
    border: none;
    border-left: 1px solid var(--border-color);
    border-radius: 0;
    background: #f8f9fa;
    padding: 12px 14px;
    font-size: 13px;
    color: var(--text-secondary);
    cursor: pointer;
    flex-shrink: 0;
    width: auto;
}

.input-with-select .field-select-inline:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

/* Creatives Grid */
.creatives-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
}

.creative-thumb {
    aspect-ratio: 1;
    background: #f8f9fa;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.creative-placeholder {
    font-size: 11px;
    color: var(--text-tertiary);
    font-weight: 500;
}

.creative-add {
    aspect-ratio: 1;
    background: transparent;
    border: 2px dashed var(--border-color);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.2s;
}

.creative-add svg {
    width: 24px;
    height: 24px;
    color: var(--text-tertiary);
}

.creative-add span {
    font-size: 11px;
    color: var(--text-tertiary);
    font-weight: 500;
}

.creative-add:hover {
    border-color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.02);
}

.creative-add:hover svg,
.creative-add:hover span {
    color: var(--accent-orange);
}

/* Buttons */
.btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    background: transparent;
    color: var(--accent-orange);
    border: 1px dashed var(--accent-orange);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-add svg {
    width: 16px;
    height: 16px;
}

.btn-add:hover {
    background: rgba(255, 107, 74, 0.05);
}

.btn-icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-icon svg {
    width: 18px;
    height: 18px;
    color: var(--text-tertiary);
}

.btn-icon:hover {
    background: #f5f5fa;
}

.btn-icon:hover svg {
    color: var(--text-primary);
}

.btn-icon.danger:hover {
    background: #fef2f2;
    border-color: #fecaca;
}

.btn-icon.danger:hover svg {
    color: var(--danger);
}

/* Publish All Button */
.btn-publish-all {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 9px 14px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}

.btn-publish-all svg {
    width: 14px;
    height: 14px;
}

.btn-publish-all:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}

.btn-publish-all:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.btn-publish-all .btn-loading {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* Publish buttons when campaign is not published - ghost outline style */
.btn-publish.campaign-not-published,
.btn-publish-all.campaign-not-published {
    background: transparent;
    color: #9ca3af;
    border: 1.5px dashed #d1d5db;
    box-shadow: none;
    cursor: not-allowed;
}

.btn-publish.campaign-not-published svg,
.btn-publish-all.campaign-not-published svg {
    opacity: 0.5;
}

.btn-publish.campaign-not-published:hover,
.btn-publish-all.campaign-not-published:hover {
    transform: none;
    box-shadow: none;
    background: rgba(0, 0, 0, 0.02);
}

.btn-publish-all.fields-missing {
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    box-shadow: none;
}

.btn-publish-all.fields-missing:hover {
    transform: none;
}

/* Custom Tooltip */
.tooltip-wrapper {
    position: relative;
    display: inline-flex;
}

.tooltip-wrapper.has-tooltip::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%) translateY(4px);
    padding: 8px 12px;
    background: #1f2937;
    color: #f9fafb;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 1000;
    pointer-events: none;
}

.tooltip-wrapper.has-tooltip::before {
    content: '';
    position: absolute;
    bottom: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #1f2937;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 1000;
}

.tooltip-wrapper.has-tooltip:hover::after {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
}

.tooltip-wrapper.has-tooltip:hover::before {
    opacity: 1;
    visibility: visible;
}

/* Form Actions Bottom */
.form-actions-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color);
}

.form-actions-bottom .btn-secondary-sm {
    padding: 9px 14px;
}

.form-actions-bottom .btn-primary-sm {
    padding: 9px 16px;
    min-width: auto;
}

.btn-primary-sm {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    background: var(--accent-gradient);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-primary-sm:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);
}

.btn-primary-sm:disabled {
    opacity: 0.85;
    cursor: default;
    transform: none;
}

/* Save Campaign Button States */
.save-campaign-btn {
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.save-campaign-btn.saving {
    background: linear-gradient(135deg, #a0a0a8 0%, #8888a4 100%);
}

.save-campaign-btn.saved {
    background: linear-gradient(135deg, #34c759 0%, #30b350 100%);
    box-shadow: 0 2px 8px rgba(52, 199, 89, 0.3);
}

.save-campaign-btn.inactive {
    opacity: 0.45;
    cursor: default;
}

.save-campaign-btn.inactive:hover {
    transform: none;
    box-shadow: none;
}

/* Campaign Details Section - Saving State */
.campaign-details-section {
    position: relative;
    transition: opacity 0.2s;
}

.campaign-details-section.saving {
    pointer-events: none;
}

.campaign-details-section.saving::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: inherit;
    z-index: 10;
}

.campaign-details-section.saving .form-field,
.campaign-details-section.saving .form-row,
.campaign-details-section.saving .status-toggle,
.campaign-details-section.saving .btn-secondary-sm {
    opacity: 0.5;
}

/* Keep save button visible */
.campaign-details-section.saving .save-campaign-btn {
    opacity: 1;
    position: relative;
    z-index: 11;
    pointer-events: auto;
}

/* Ad Group Form - Saving State */
.adgroup-form {
    position: relative;
    transition: opacity 0.2s;
}

.adgroup-form.saving {
    pointer-events: none;
}

.adgroup-form.saving::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: inherit;
    z-index: 10;
}

.adgroup-form.saving .form-field,
.adgroup-form.saving .form-row,
.adgroup-form.saving .form-section,
.adgroup-form.saving .btn-secondary-sm {
    opacity: 0.5;
}

/* Keep save button visible */
.adgroup-form.saving .save-campaign-btn {
    opacity: 1;
    position: relative;
    z-index: 11;
    pointer-events: auto;
}

.btn-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: btn-spin 0.8s linear infinite;
}

@keyframes btn-spin {
    to { transform: rotate(360deg); }
}

.btn-check {
    width: 16px;
    height: 16px;
    stroke-linecap: round;
    stroke-linejoin: round;
    animation: btn-check-pop 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes btn-check-pop {
    0% { transform: scale(0); opacity: 0; }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); opacity: 1; }
}

.btn-secondary-sm {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    background: white;
    color: var(--text-secondary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-secondary-sm:hover {
    border-color: var(--text-tertiary);
    color: var(--text-primary);
}

/* Empty State - Ad Group Panel */
.adgroup-panel-empty {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    min-height: 400px;
}

.adgroup-panel-empty .empty-state {
    text-align: center;
    padding: 40px;
    background: transparent;
    border: none;
    border-radius: 0;
}

.adgroup-panel-empty .empty-state-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    color: var(--text-tertiary);
    opacity: 0.5;
    display: block;
}

.adgroup-panel-empty .empty-state-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 8px;
}

.adgroup-panel-empty .empty-state-text {
    font-size: 14px;
    color: var(--text-tertiary);
}

/* Loading/Error States */
.loading-state,
.error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    color: var(--text-secondary);
    font-size: 14px;
}

.empty-list-message {
    padding: 20px;
    text-align: center;
    color: var(--text-tertiary);
    font-size: 14px;
}

/* ==================== Day & Time Grid ==================== */

.day-time-section {
    padding: 16px 0;
}

.day-time-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
}

.day-time-timezone {
    display: flex;
    align-items: center;
    gap: 8px;
}

.day-time-timezone-label {
    font-size: 13px;
    color: var(--text-secondary);
}

.day-time-timezone-select {
    padding: 6px 10px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 13px;
    color: var(--text-primary);
    background: white;
    cursor: pointer;
}

.day-time-timezone-select:focus {
    outline: none;
    border-color: var(--accent-orange);
}

.day-time-actions {
    display: flex;
    gap: 16px;
}

.day-time-action-link {
    font-size: 13px;
    color: var(--text-secondary);
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    margin: -4px -8px;
    border-radius: 4px;
    text-decoration: none;
    transition: all 0.15s;
}

.day-time-action-link:hover {
    color: var(--text-primary);
    background: rgba(0, 0, 0, 0.05);
}

.day-time-grid {
    display: flex;
    flex-direction: column;
    gap: 2px;
    background: var(--border-color);
    border-radius: 8px;
    padding: 2px;
    overflow: hidden;
    -webkit-user-select: none;
            user-select: none;
}

.day-time-row {
    display: flex;
    gap: 2px;
}

.day-time-header-row {
    background: transparent;
}

.day-time-day-label {
    width: 40px;
    min-width: 40px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-secondary);
    background: var(--bg-tertiary);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: all 0.15s;
}

.day-time-day-label:hover {
    background: var(--accent-orange);
    color: white;
}

.day-time-header-row .day-time-day-label {
    background: transparent;
}

.day-time-header-row .day-time-day-label:hover {
    background: transparent;
    color: var(--text-secondary);
}

.day-time-hour-label {
    flex: 1 1;
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: var(--text-tertiary);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: all 0.15s;
}

.day-time-hour-label:hover {
    color: var(--accent-orange);
    font-weight: 600;
}

.day-time-cell {
    flex: 1 1;
    min-width: 20px;
    height: 24px;
    background: white;
    cursor: pointer;
    transition: all 0.1s;
}

.day-time-cell:hover {
    background: rgba(255, 107, 74, 0.2);
}

.day-time-cell.selected {
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
}

.day-time-cell.selected:hover {
    background: linear-gradient(135deg, var(--accent-red), var(--accent-purple));
}

.day-time-legend {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--border-color);
}

.day-time-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-secondary);
}

.day-time-legend-box {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    background: white;
    border: 1px solid var(--border-color);
}

.day-time-legend-box.selected {
    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));
    border: none;
}

.day-time-hint {
    margin-left: auto;
    font-size: 11px;
    color: var(--text-tertiary);
    font-style: italic;
}

/* Weekend styling for Day & Time grid */
.day-time-row.weekend .day-time-day-label {
    color: var(--accent-red);
}

.day-time-row.weekend .day-time-cell.selected {
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);
}

.day-time-row.weekend .day-time-cell.selected:hover {
    background: linear-gradient(135deg, var(--accent-red) 0%, #6B2D7B 100%);
}

/* Inactive rows/columns (no cells selected) - only labels fade */
.day-time-row.inactive .day-time-day-label {
    opacity: 0.4;
}

.day-time-hour-label.inactive {
    opacity: 0.4;
}

/* ========================================
   Campaign Card Skeleton Loading Styles
   ======================================== */

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.campaign-card.skeleton {
  pointer-events: none;
}

.campaign-card.skeleton .skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite ease-in-out;
  border-radius: 6px;
}

.campaign-card.skeleton .skeleton-type {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  margin-right: 12px;
}

.campaign-card.skeleton .skeleton-title {
  width: 180px;
  height: 18px;
  margin-bottom: 6px;
}

.campaign-card.skeleton .skeleton-subtitle {
  width: 120px;
  height: 14px;
}

.campaign-card.skeleton .skeleton-badge {
  width: 70px;
  height: 28px;
  border-radius: 20px;
}

.campaign-card.skeleton .skeleton-dates {
  width: 200px;
  height: 16px;
  margin: 16px 0;
}

.campaign-card.skeleton .skeleton-chart {
  width: 100%;
  height: 80px;
  margin-bottom: 16px;
}

.campaign-card.skeleton .metric-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.campaign-card.skeleton .skeleton-metric-label {
  width: 70px;
  height: 12px;
}

.campaign-card.skeleton .skeleton-metric-value {
  width: 50px;
  height: 24px;
}

.campaign-card.skeleton .skeleton-costs {
  width: 100%;
  height: 36px;
  margin: 12px 0;
}

.campaign-card.skeleton .skeleton-budget {
  width: 100%;
  height: 48px;
}

/* ============================================
   Edit Campaign Page - Mobile Responsive
   ============================================ */

@media (max-width: 768px) {
    /* Prevent overflow */
    .edit-layout {
        flex-direction: column;
        gap: 12px;
        max-width: 100%;
        overflow-x: hidden;
    }

    .edit-layout * {
        box-sizing: border-box;
    }

    /* Campaign panel */
    .campaign-panel {
        width: 100%;
        max-width: 100%;
        gap: 12px;
    }

    .edit-layout .panel-section {
        padding: 14px;
        border-radius: 10px;
        max-width: 100%;
    }

    .edit-layout .section-header {
        margin-bottom: 12px;
    }

    .edit-layout .section-title {
        font-size: 14px;
        margin-bottom: 12px;
    }

    /* Ad group panel */
    .adgroup-panel {
        border-radius: 10px;
        max-width: 100%;
        overflow: hidden;
    }

    .adgroup-panel .adgroup-form {
        padding: 14px;
    }

    .adgroup-panel .form-header {
        margin-bottom: 14px;
        padding-bottom: 14px;
        gap: 8px;
    }

    .adgroup-panel .form-title {
        font-size: 15px;
    }

    .adgroup-panel .form-section {
        margin-bottom: 16px;
        padding-bottom: 16px;
    }

    .adgroup-panel .form-section-title {
        font-size: 11px;
        margin-bottom: 10px;
    }

    /* Form fields - simpler approach */
    .edit-layout .form-field {
        margin-bottom: 14px;
    }

    .edit-layout .field-label {
        font-size: 11px;
        margin-bottom: 5px;
    }

    .edit-layout .field-input,
    .edit-layout .field-select {
        width: 100%;
        padding: 10px 12px;
        font-size: 15px;
        border-radius: 8px;
    }

    /* Form rows */
    .edit-layout .form-row,
    .edit-layout .form-row-3 {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .edit-layout .form-row .form-field,
    .edit-layout .form-row-3 .form-field {
        margin-bottom: 0;
    }

    .edit-layout .form-row-flex {
        flex-direction: column;
        gap: 14px;
        align-items: stretch;
    }

    .edit-layout .form-row-flex .form-field {
        width: 100%;
        margin-bottom: 0 !important;
    }

    .edit-layout .form-row-flex .form-field .field-label {
        text-align: left;
    }

    .edit-layout .form-field-auto,
    .edit-layout .form-field-grow {
        width: 100%;
        flex: none;
    }

    /* Buttons - simple consistent style */
    .edit-layout .status-toggle,
    .edit-layout .line-item-type-toggle {
        display: flex;
        gap: 8px;
        width: 100%;
    }

    .edit-layout .status-btn,
    .edit-layout .line-item-type-btn {
        flex: 1 1;
        padding: 10px 12px;
        font-size: 13px;
        border-radius: 8px;
    }

    .edit-layout .status-btn svg,
    .edit-layout .line-item-type-btn svg {
        width: 16px;
        height: 16px;
    }

    /* Frequency - full width row layout */
    .edit-layout .frequency-input {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
        align-items: center;
        width: 100%;
    }

    .edit-layout .frequency-count {
        width: 70px !important;
        min-width: 70px;
        flex-shrink: 0;
        text-align: center;
    }

    .edit-layout .frequency-text {
        font-size: 12px;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .edit-layout .frequency-period {
        flex: 1 1;
        min-width: 80px;
    }

    /* Input with prefix/suffix - proper border handling */
    .edit-layout .input-with-prefix,
    .edit-layout .input-with-suffix {
        display: flex;
        width: 100%;
        border: 1px solid var(--border-color);
        border-radius: 8px;
        overflow: hidden;
    }

    .edit-layout .input-with-prefix .field-input,
    .edit-layout .input-with-suffix .field-input {
        border: none !important;
        border-radius: 0;
        flex: 1 1;
        min-width: 0;
    }

    .edit-layout .input-prefix,
    .edit-layout .input-suffix {
        font-size: 12px;
        padding: 10px 10px;
        white-space: nowrap;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    /* Action buttons */
    .edit-layout .btn-icon {
        width: 36px;
        height: 36px;
        padding: 0;
    }

    .edit-layout .form-actions-bottom {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 16px;
        justify-content: flex-end;
    }

    .edit-layout .form-actions-bottom .btn-secondary-sm {
        padding: 10px 14px;
        font-size: 13px;
        margin-right: auto;
    }

    .edit-layout .form-actions-bottom .btn-primary-sm,
    .edit-layout .form-actions-bottom .btn-publish {
        padding: 10px 14px;
        font-size: 13px;
    }

    /* Ad groups list */
    .edit-layout .ad-groups-list {
        gap: 6px;
    }

    .edit-layout .ad-group-item {
        padding: 10px;
        gap: 8px;
        border-radius: 8px;
    }

    .edit-layout .ad-group-name {
        font-size: 13px;
    }

    .edit-layout .ad-group-meta {
        font-size: 11px;
    }

    .edit-layout .btn-add {
        padding: 6px 10px;
        font-size: 12px;
    }

    .edit-layout .btn-add svg {
        width: 14px;
        height: 14px;
    }

    /* Targeting */
    .edit-layout .targeting-group {
        margin-bottom: 14px;
    }

    .edit-layout .targeting-row {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .edit-layout .targeting-label {
        font-size: 12px;
        font-weight: 500;
    }

    .edit-layout .targeting-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .edit-layout .targeting-tag {
        padding: 8px 10px;
        font-size: 12px;
        border-radius: 6px;
    }

    /* Header */
    .back-link {
        font-size: 13px;
        margin-bottom: 10px;
    }

    .edit-header {
        margin-bottom: 12px;
    }

    .edit-header h1 {
        font-size: 18px;
    }

    .edit-header .header-subtitle {
        font-size: 13px;
    }

    /* Empty state */
    .adgroup-panel-empty {
        min-height: 150px;
        border-radius: 10px;
    }

    .adgroup-panel-empty .empty-state {
        padding: 16px;
    }

    .adgroup-panel-empty .empty-state-icon {
        width: 36px;
        height: 36px;
    }
}

/* Edit Campaign - Advanced Sections (768px) */
@media (max-width: 768px) {
    /* Inventory */
    .inventory-columns {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .inventory-column-header {
        font-size: 13px;
    }

    .inventory-list-selector {
        flex-direction: column;
        gap: 6px;
    }

    .inventory-list-selector select {
        width: 100%;
    }

    .inventory-urls-input {
        font-size: 13px;
        min-height: 80px;
        padding: 10px;
    }

    /* Geo */
    .geo-columns {
        flex-direction: column;
        gap: 16px;
    }

    .geo-column {
        width: 100%;
    }

    .geo-email-item {
        padding: 10px;
    }

    .geo-email-name {
        font-size: 13px;
    }

    .geo-email-input {
        font-size: 15px;
    }

    .geo-mode-tabs {
        width: 100%;
    }

    .geo-mode-tab {
        flex: 1 1;
        padding: 10px 6px;
        font-size: 12px;
    }

    /* Proximity */
    .proximity-editor-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .proximity-saved-row {
        flex-wrap: wrap;
        gap: 6px;
    }

    .proximity-chip {
        font-size: 12px;
        padding: 6px 10px;
    }

    .proximity-textarea {
        font-size: 13px;
        min-height: 80px;
    }

    .proximity-actions {
        flex-direction: column;
        gap: 6px;
    }

    .proximity-actions button {
        width: 100%;
    }

    .proximity-map,
    .proximity-map-container {
        min-height: 180px;
    }

    /* Day & Time - horizontal scroll */
    .day-time-section {
        padding: 12px 0;
    }

    .day-time-header {
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .day-time-actions {
        display: flex;
        gap: 10px;
    }

    .day-time-action-link {
        font-size: 12px;
    }

    .day-time-grid {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 0 -14px;
        padding: 0 14px 8px 14px;
    }

    .day-time-row {
        min-width: 520px;
    }

    .day-time-day-label {
        width: 36px;
        min-width: 36px;
        height: 26px;
        font-size: 10px;
    }

    .day-time-hour-label {
        min-width: 18px;
        height: 20px;
        font-size: 9px;
    }

    .day-time-cell {
        min-width: 18px;
        height: 26px;
    }

    .day-time-legend {
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 8px;
        font-size: 11px;
    }

    /* Collapsible */
    .form-section-header {
        padding: 10px 0;
    }

    /* Language */
    .language-dropdown {
        max-height: 180px;
    }

    /* Creatives */
    .creatives-grid {
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
        gap: 8px;
    }

    .creative-item {
        padding: 8px;
        font-size: 11px;
    }
}

/* ============================================
   Category Tree Styles - Refined Design
   ============================================ */

.category-trigger.has-selection {
    border-color: var(--accent-orange);
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);
}

.category-trigger.active {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.category-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
    color: white;
    font-size: 11px;
    font-weight: 600;
    border-radius: 10px;
    margin-right: 6px;
}

.category-tree-panel {
    min-width: 340px;
    max-width: 420px;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);
    z-index: 1000;
    background: white;
}

/* Navigation Header */
.category-nav-header {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 14px;
    background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.category-home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    cursor: pointer;
    color: var(--text-secondary);
    transition: all 0.15s ease;
}

.category-home-btn:hover {
    background: white;
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    transform: scale(1.05);
}

.category-home-btn.current {
    background: var(--accent-orange);
    border-color: var(--accent-orange);
    color: white;
}

.category-home-btn svg {
    width: 14px;
    height: 14px;
}

.category-nav-chevron {
    width: 14px;
    height: 14px;
    color: var(--text-tertiary);
    flex-shrink: 0;
}

.category-nav-item {
    background: none;
    border: none;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.15s ease;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.category-nav-item:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text-primary);
}

.category-nav-item.current {
    background: white;
    color: var(--text-primary);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* Search */
.category-search-wrapper {
    position: relative;
    padding: 10px 14px;
    background: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.category-search-icon {
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    color: var(--text-tertiary);
    pointer-events: none;
}

.category-search-input {
    width: 100%;
    padding: 10px 36px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: 13px;
    background: var(--bg-primary);
    transition: all 0.15s ease;
}

.category-search-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    background: white;
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.category-search-input::placeholder {
    color: var(--text-tertiary);
}

.category-search-clear {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--text-tertiary);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: white;
    transition: all 0.15s ease;
}

.category-search-clear:hover {
    background: var(--text-secondary);
    transform: translateY(-50%) scale(1.1);
}

.category-search-clear svg {
    width: 12px;
    height: 12px;
}

/* Category List */
.category-tree-list {
    max-height: 320px;
    overflow-y: auto;
    padding: 6px 0;
    background: white;
}

.category-tree-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    margin: 2px 8px;
    border-radius: 8px;
    cursor: default;
    transition: all 0.15s ease;
    animation: categoryFadeIn 0.2s ease forwards;
    opacity: 0;
}

@keyframes categoryFadeIn {
    from {
        opacity: 0;
        transform: translateX(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.category-tree-item:hover {
    background: rgba(0, 0, 0, 0.03);
}

.category-tree-item.selected {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(233, 75, 108, 0.06) 100%);
}

.category-tree-item.selected:hover {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.1) 100%);
}

/* Custom Checkbox */
.category-checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.category-checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.category-checkbox-custom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    background: white;
    transition: all 0.15s ease;
}

.category-checkbox-custom svg {
    width: 12px;
    height: 12px;
    color: white;
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.15s ease;
}

.category-checkbox-wrapper:hover .category-checkbox-custom {
    border-color: var(--accent-orange);
}

.category-checkbox-input:checked + .category-checkbox-custom {
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
    border-color: transparent;
}

.category-checkbox-input:checked + .category-checkbox-custom svg {
    opacity: 1;
    transform: scale(1);
}

.category-checkbox-input:focus + .category-checkbox-custom {
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.2);
}

/* Category Name */
.category-tree-item .category-name {
    flex: 1 1;
    font-size: 13px;
    font-weight: 450;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.category-tree-item.selected .category-name {
    color: var(--accent-orange);
    font-weight: 500;
}

/* Clickable row for categories with children */
.category-tree-item.has-children {
    cursor: pointer;
}

.category-tree-item.has-children:hover {
    background: linear-gradient(90deg, rgba(255, 107, 74, 0.06) 0%, rgba(255, 107, 74, 0.02) 100%);
}

.category-tree-item.has-children.selected:hover {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.14) 0%, rgba(233, 75, 108, 0.1) 100%);
}

/* Drill Down Icon */
.category-drill-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: var(--text-tertiary);
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.category-drill-icon svg {
    width: 16px;
    height: 16px;
}

.category-tree-item.has-children:hover .category-drill-icon {
    color: var(--accent-orange);
    transform: translateX(3px);
}

/* Empty State */
.category-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    color: var(--text-tertiary);
    gap: 8px;
}

.category-empty svg {
    width: 32px;
    height: 32px;
    opacity: 0.5;
}

.category-empty span {
    font-size: 13px;
}

/* Loading State */
.category-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    gap: 12px;
    color: var(--text-secondary);
    font-size: 13px;
}

.category-loading-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid rgba(255, 107, 74, 0.2);
    border-top-color: var(--accent-orange);
    border-radius: 50%;
    animation: categorySpinner 0.8s linear infinite;
}

@keyframes categorySpinner {
    to { transform: rotate(360deg); }
}

/* Selected Tags */
.category-selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.category-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px 6px 12px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.08) 100%);
    border: 1px solid rgba(255, 107, 74, 0.2);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: var(--accent-orange);
    animation: tagFadeIn 0.2s ease forwards;
    opacity: 0;
}

@keyframes tagFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.category-tag-text {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.category-tag-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: rgba(255, 107, 74, 0.15);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: var(--accent-orange);
    transition: all 0.15s ease;
}

.category-tag-remove:hover {
    background: var(--accent-orange);
    color: white;
    transform: scale(1.1);
}

.category-tag-remove svg {
    width: 10px;
    height: 10px;
}

.category-clear-all {
    padding: 6px 12px;
    background: none;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    font-size: 12px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.15s ease;
}

.category-clear-all:hover {
    border-color: var(--accent-red);
    color: var(--accent-red);
    background: rgba(233, 75, 108, 0.05);
}

/* ============================================
   Language Dropdown Styles - Refined Design
   ============================================ */

.language-trigger.has-selection {
    border-color: var(--accent-orange);
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);
}

.language-trigger.active {
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.language-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
    color: white;
    font-size: 11px;
    font-weight: 600;
    border-radius: 10px;
    margin-right: 6px;
}

.language-panel {
    min-width: 280px;
    max-width: 320px;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);
    z-index: 1000;
    background: white;
    overflow: hidden;
}

/* Search */
.language-search-wrapper {
    position: relative;
    padding: 12px 14px;
    background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.language-search-icon {
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    color: var(--text-tertiary);
    pointer-events: none;
}

.language-search-input {
    width: 100%;
    padding: 10px 36px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: 13px;
    background: white;
    transition: all 0.15s ease;
}

.language-search-input:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.language-search-input::placeholder {
    color: var(--text-tertiary);
}

.language-search-clear {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--text-tertiary);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: white;
    transition: all 0.15s ease;
}

.language-search-clear:hover {
    background: var(--text-secondary);
    transform: translateY(-50%) scale(1.1);
}

.language-search-clear svg {
    width: 12px;
    height: 12px;
}

/* Language List */
.language-list {
    max-height: 280px;
    overflow-y: auto;
    padding: 6px 0;
    background: white;
}

.language-item {
    display: flex;
    align-items: center;
    padding: 2px 8px;
    margin: 0 6px;
    border-radius: 6px;
    transition: all 0.15s ease;
    animation: languageFadeIn 0.2s ease forwards;
    opacity: 0;
}

@keyframes languageFadeIn {
    from {
        opacity: 0;
        transform: translateX(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.language-item:hover {
    background: rgba(0, 0, 0, 0.03);
}

.language-item.selected {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(233, 75, 108, 0.06) 100%);
}

.language-item.selected:hover {
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.1) 100%);
}

/* Checkbox */
.language-checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    padding: 8px 6px;
    flex: 1 1;
}

.language-checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.language-checkbox-custom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    background: white;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.language-checkbox-custom svg {
    width: 12px;
    height: 12px;
    color: white;
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.15s ease;
}

.language-checkbox-wrapper:hover .language-checkbox-custom {
    border-color: var(--accent-orange);
}

.language-checkbox-input:checked + .language-checkbox-custom {
    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
    border-color: transparent;
}

.language-checkbox-input:checked + .language-checkbox-custom svg {
    opacity: 1;
    transform: scale(1);
}

.language-name {
    font-size: 13px;
    font-weight: 450;
    color: var(--text-primary);
}

.language-item.selected .language-name {
    color: var(--accent-orange);
    font-weight: 500;
}

/* Empty State */
.language-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    color: var(--text-tertiary);
    gap: 8px;
}

.language-empty svg {
    width: 32px;
    height: 32px;
    opacity: 0.5;
}

.language-empty span {
    font-size: 13px;
}

/* Selected Tags */
.language-selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.language-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px 6px 12px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.08) 100%);
    border: 1px solid rgba(255, 107, 74, 0.2);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: var(--accent-orange);
    animation: languageTagFadeIn 0.2s ease forwards;
    opacity: 0;
}

@keyframes languageTagFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.language-tag-text {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.language-tag-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: rgba(255, 107, 74, 0.15);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: var(--accent-orange);
    transition: all 0.15s ease;
}

.language-tag-remove:hover {
    background: var(--accent-orange);
    color: white;
    transform: scale(1.1);
}

.language-tag-remove svg {
    width: 10px;
    height: 10px;
}

.language-clear-all {
    padding: 6px 12px;
    background: none;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    font-size: 12px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.15s ease;
}

.language-clear-all:hover {
    border-color: var(--accent-red);
    color: var(--accent-red);
    background: rgba(233, 75, 108, 0.05);
}

/* ============================================================
   Advanced Targeting Component - Clean 3-Column Layout
   ============================================================ */

.at-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    width: 100%;
    padding: 16px 0;
}

@media (max-width: 1400px) {
    .at-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 900px) {
    .at-container {
        grid-template-columns: 1fr;
    }
}

/* Category Block */
.at-category-block {
    border: 1px solid #e8e8eb;
    border-radius: 12px;
    background: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.at-category-block:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* Category Color Variations */
.at-category-demographics {
    border-color: rgba(255, 107, 74, 0.2);
}
.at-category-demographics:hover {
    border-color: rgba(255, 107, 74, 0.4);
}
.at-category-demographics .at-category-icon {
    background: rgba(255, 107, 74, 0.1);
}
.at-category-demographics .at-category-icon svg {
    stroke: #FF6B4A;
}
.at-category-demographics .at-category-count {
    color: #FF6B4A;
    background: rgba(255, 107, 74, 0.1);
}
.at-category-demographics .at-selector-trigger:hover,
.at-category-demographics .at-selector-trigger.open {
    border-color: #FF6B4A;
}
.at-category-demographics .at-selector-trigger:hover {
    background: rgba(255, 107, 74, 0.03);
    color: #FF6B4A;
}
.at-category-demographics .at-selector-trigger:hover .at-selector-chevron,
.at-category-demographics .at-selector-trigger.open .at-selector-chevron {
    color: #FF6B4A;
}
.at-category-demographics .at-breadcrumb-root {
    color: #FF6B4A;
}
.at-category-demographics .at-breadcrumb-item:hover {
    background: rgba(255, 107, 74, 0.1);
    color: #FF6B4A;
}
.at-category-demographics .at-list-folder.has-selected {
    background: rgba(255, 107, 74, 0.06);
    border-left-color: #FF6B4A;
}
.at-category-demographics .at-list-folder.has-selected:hover {
    background: rgba(255, 107, 74, 0.1);
}
.at-category-demographics .at-item-badge {
    color: #FF6B4A;
    background: rgba(255, 107, 74, 0.12);
}
.at-category-demographics .at-list-leaf.selected {
    background: rgba(255, 107, 74, 0.08);
}
.at-category-demographics .at-list-leaf.selected:hover {
    background: rgba(255, 107, 74, 0.12);
}
.at-category-demographics .at-list-leaf:hover .at-checkbox:not(.checked) {
    border-color: #FF6B4A;
}
.at-category-demographics .at-checkbox.checked {
    background: #FF6B4A;
    border-color: #FF6B4A;
}
.at-category-demographics .at-list-folder:hover .at-item-arrow {
    color: #FF6B4A;
}
.at-category-demographics .at-tag {
    background: rgba(255, 107, 74, 0.08);
    border-color: rgba(255, 107, 74, 0.2);
}
.at-category-demographics .at-tag-remove:hover {
    background: #FF6B4A;
}

.at-category-intentions {
    border-color: rgba(233, 75, 108, 0.2);
}
.at-category-intentions:hover {
    border-color: rgba(233, 75, 108, 0.4);
}
.at-category-intentions .at-category-icon {
    background: rgba(233, 75, 108, 0.1);
}
.at-category-intentions .at-category-icon svg {
    stroke: #E94B6C;
}
.at-category-intentions .at-category-count {
    color: #E94B6C;
    background: rgba(233, 75, 108, 0.1);
}
.at-category-intentions .at-selector-trigger:hover,
.at-category-intentions .at-selector-trigger.open {
    border-color: #E94B6C;
}
.at-category-intentions .at-selector-trigger:hover {
    background: rgba(233, 75, 108, 0.03);
    color: #E94B6C;
}
.at-category-intentions .at-selector-trigger:hover .at-selector-chevron,
.at-category-intentions .at-selector-trigger.open .at-selector-chevron {
    color: #E94B6C;
}
.at-category-intentions .at-breadcrumb-root {
    color: #E94B6C;
}
.at-category-intentions .at-breadcrumb-item:hover {
    background: rgba(233, 75, 108, 0.1);
    color: #E94B6C;
}
.at-category-intentions .at-list-folder.has-selected {
    background: rgba(233, 75, 108, 0.06);
    border-left-color: #E94B6C;
}
.at-category-intentions .at-list-folder.has-selected:hover {
    background: rgba(233, 75, 108, 0.1);
}
.at-category-intentions .at-item-badge {
    color: #E94B6C;
    background: rgba(233, 75, 108, 0.12);
}
.at-category-intentions .at-list-leaf.selected {
    background: rgba(233, 75, 108, 0.08);
}
.at-category-intentions .at-list-leaf.selected:hover {
    background: rgba(233, 75, 108, 0.12);
}
.at-category-intentions .at-list-leaf:hover .at-checkbox:not(.checked) {
    border-color: #E94B6C;
}
.at-category-intentions .at-checkbox.checked {
    background: #E94B6C;
    border-color: #E94B6C;
}
.at-category-intentions .at-list-folder:hover .at-item-arrow {
    color: #E94B6C;
}
.at-category-intentions .at-tag {
    background: rgba(233, 75, 108, 0.08);
    border-color: rgba(233, 75, 108, 0.2);
}
.at-category-intentions .at-tag-remove:hover {
    background: #E94B6C;
}

.at-category-preferences {
    border-color: rgba(142, 58, 154, 0.2);
}
.at-category-preferences:hover {
    border-color: rgba(142, 58, 154, 0.4);
}
.at-category-preferences .at-category-icon {
    background: rgba(142, 58, 154, 0.1);
}
.at-category-preferences .at-category-icon svg {
    stroke: #8E3A9A;
}
.at-category-preferences .at-category-count {
    color: #8E3A9A;
    background: rgba(142, 58, 154, 0.1);
}
.at-category-preferences .at-selector-trigger:hover,
.at-category-preferences .at-selector-trigger.open {
    border-color: #8E3A9A;
}
.at-category-preferences .at-selector-trigger:hover {
    background: rgba(142, 58, 154, 0.03);
    color: #8E3A9A;
}
.at-category-preferences .at-selector-trigger:hover .at-selector-chevron,
.at-category-preferences .at-selector-trigger.open .at-selector-chevron {
    color: #8E3A9A;
}
.at-category-preferences .at-breadcrumb-root {
    color: #8E3A9A;
}
.at-category-preferences .at-breadcrumb-item:hover {
    background: rgba(142, 58, 154, 0.1);
    color: #8E3A9A;
}
.at-category-preferences .at-list-folder.has-selected {
    background: rgba(142, 58, 154, 0.06);
    border-left-color: #8E3A9A;
}
.at-category-preferences .at-list-folder.has-selected:hover {
    background: rgba(142, 58, 154, 0.1);
}
.at-category-preferences .at-item-badge {
    color: #8E3A9A;
    background: rgba(142, 58, 154, 0.12);
}
.at-category-preferences .at-list-leaf.selected {
    background: rgba(142, 58, 154, 0.08);
}
.at-category-preferences .at-list-leaf.selected:hover {
    background: rgba(142, 58, 154, 0.12);
}
.at-category-preferences .at-list-leaf:hover .at-checkbox:not(.checked) {
    border-color: #8E3A9A;
}
.at-category-preferences .at-checkbox.checked {
    background: #8E3A9A;
    border-color: #8E3A9A;
}
.at-category-preferences .at-list-folder:hover .at-item-arrow {
    color: #8E3A9A;
}
.at-category-preferences .at-tag {
    background: rgba(142, 58, 154, 0.08);
    border-color: rgba(142, 58, 154, 0.2);
}
.at-category-preferences .at-tag-remove:hover {
    background: #8E3A9A;
}

/* Category Header */
.at-category-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.at-category-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    flex-shrink: 0;
}

.at-category-icon svg {
    width: 20px;
    height: 20px;
}

.at-category-info {
    flex: 1 1;
    min-width: 0;
}

.at-category-label {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.3;
}

.at-category-desc {
    display: block;
    font-size: 12px;
    color: #9ca3af;
    line-height: 1.3;
    margin-top: 2px;
}

.at-category-count {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 12px;
    flex-shrink: 0;
}

/* Selector */
.at-selector-wrap {
    position: relative;
}

.at-selector-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
    background: #fafbfc;
    font-size: 13px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.2s ease;
}

.at-selector-trigger:hover {
    border-color: #E94B6C;
    border-style: solid;
    background: rgba(233, 75, 108, 0.03);
    color: #E94B6C;
}

.at-selector-trigger.open {
    border-color: #E94B6C;
    border-style: solid;
    background: #fff;
    color: #374151;
}

.at-selector-trigger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.at-selector-chevron {
    width: 16px;
    height: 16px;
    color: #9ca3af;
    transition: transform 0.2s ease;
}

.at-selector-trigger:hover .at-selector-chevron {
    color: #E94B6C;
}

.at-selector-trigger.open .at-selector-chevron {
    transform: rotate(180deg);
    color: #E94B6C;
}

/* Dropdown */
.at-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e8e8eb;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    z-index: 100;
    max-height: 340px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Breadcrumb */
.at-breadcrumb {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 14px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04), rgba(142, 58, 154, 0.04));
    border-bottom: 1px solid #f0f0f2;
    flex-wrap: wrap;
    min-height: 40px;
}

.at-breadcrumb-item {
    padding: 3px 8px;
    border: none;
    background: none;
    font-size: 12px;
    color: #6b7280;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.15s ease;
}

.at-breadcrumb-item:hover {
    background: rgba(233, 75, 108, 0.1);
    color: #E94B6C;
}

.at-breadcrumb-item.current {
    color: #1f2937;
    font-weight: 500;
}

.at-breadcrumb-root {
    font-weight: 500;
    color: #E94B6C;
}

.at-breadcrumb-sep {
    color: #d1d5db;
    font-size: 11px;
}

/* Search */
.at-search {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-bottom: 1px solid #e5e7eb;
}

.at-search svg {
    width: 14px;
    height: 14px;
    color: #9ca3af;
    flex-shrink: 0;
}

.at-search input {
    flex: 1 1;
    border: none;
    background: none;
    font-size: 13px;
    color: #374151;
    outline: none;
}

.at-search input::placeholder {
    color: #9ca3af;
}

.at-search-clear {
    width: 18px;
    height: 18px;
    border: none;
    background: #e5e7eb;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: all 0.15s ease;
}

.at-search-clear svg {
    width: 10px;
    height: 10px;
    color: #6b7280;
}

.at-search-clear:hover {
    background: #E94B6C;
}

.at-search-clear:hover svg {
    color: #fff;
}

/* List */
.at-list {
    flex: 1 1;
    overflow-y: auto;
    padding: 6px 0;
}

.at-list-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    transition: background 0.15s ease;
}

.at-list-item:hover {
    background: #f9fafb;
}

.at-list-folder {
    color: #374151;
}

.at-list-folder.has-selected {
    background: rgba(233, 75, 108, 0.06);
    border-left: 3px solid #E94B6C;
    padding-left: 11px;
}

.at-list-folder.has-selected:hover {
    background: rgba(233, 75, 108, 0.1);
}

.at-list-leaf {
    color: #374151;
}

.at-list-leaf.selected {
    background: rgba(233, 75, 108, 0.08);
}

.at-list-leaf.selected:hover {
    background: rgba(233, 75, 108, 0.12);
}

.at-item-name {
    flex: 1 1;
    font-size: 13px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.at-item-path {
    font-size: 11px;
    color: #9ca3af;
    margin-left: 8px;
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
}

.at-item-badge {
    font-size: 11px;
    font-weight: 600;
    color: #E94B6C;
    background: rgba(233, 75, 108, 0.12);
    padding: 2px 8px;
    border-radius: 10px;
    flex-shrink: 0;
}

.at-item-total {
    font-size: 11px;
    color: #9ca3af;
    flex-shrink: 0;
}

.at-item-arrow {
    width: 14px;
    height: 14px;
    color: #d1d5db;
    flex-shrink: 0;
    transition: transform 0.15s ease, color 0.15s ease;
}

.at-list-folder:hover .at-item-arrow {
    transform: translateX(3px);
    color: #E94B6C;
}

/* Checkbox */
.at-checkbox {
    width: 16px;
    height: 16px;
    border: 1.5px solid #d1d5db;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #fff;
    transition: all 0.15s ease;
}

.at-checkbox svg {
    width: 10px;
    height: 10px;
    color: #fff;
}

.at-checkbox.checked {
    background: linear-gradient(135deg, #FF6B4A, #E94B6C);
    border-color: #E94B6C;
}

.at-list-leaf:hover .at-checkbox:not(.checked) {
    border-color: #E94B6C;
}

/* Loading & Empty */
.at-loading,
.at-empty {
    padding: 24px 12px;
    text-align: center;
    font-size: 13px;
    color: #9ca3af;
}

/* Selected Tags */
.at-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
}

.at-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.08));
    border: 1px solid rgba(233, 75, 108, 0.2);
    border-radius: 6px;
    font-size: 12px;
    color: #374151;
}

.at-tag-text {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.at-tag-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.at-tag-remove svg {
    width: 10px;
    height: 10px;
    color: #9ca3af;
}

.at-tag-remove:hover {
    background: #E94B6C;
}

.at-tag-remove:hover svg {
    color: #fff;
}

.at-tag-remove:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}


/* ============================================
   Create Campaign & Groups Styles
   ============================================ */

/* Header Actions */
.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Draft Badge */
.draft-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    padding: 3px 8px;
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.15), rgba(255, 152, 0, 0.15));
    border: 1px solid rgba(255, 152, 0, 0.3);
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #f59e0b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Pacing Badge */
.pacing-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(243, 156, 18, 0.15);
    color: #f39c12;
}

.pacing-badge.paused {
    background: rgba(142, 58, 154, 0.15);
    color: var(--accent-purple, #8e3a9a);
}

.pacing-badge.warning {
    background: rgba(243, 156, 18, 0.15);
    color: #f39c12;
}

.pacing-badge.info {
    background: rgba(59, 130, 246, 0.15);
    color: #3b82f6;
}

/* Pacing Alert Row */
.ad-groups-table tr.alert-row td {
    padding: 0;
    background: transparent !important;
    border: none;
}

.ad-groups-table tr.alert-row:hover td {
    background: transparent !important;
}

.ad-groups-table tr.has-alert td {
    padding-bottom: 0;
    border-bottom: none;
}

.pacing-alert-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    border-radius: 0;
    border: none;
    border-top: 1px solid #e9ecef;
}

/* Danger style - behind pace (red) */
.pacing-alert-card.danger {
    background: linear-gradient(135deg, rgba(231, 76, 60, 0.12), rgba(231, 76, 60, 0.06));
    border-top: 2px solid rgba(231, 76, 60, 0.4);
}

/* Paused style - ahead/paused (purple) */
.pacing-alert-card.paused {
    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));
    border-top: 2px solid rgba(142, 58, 154, 0.3);
}

.pacing-alert-card .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #6c757d;
}

.pacing-alert-card.danger .alert-icon {
    color: #c0392b;
}

.pacing-alert-card.paused .alert-icon {
    color: var(--accent-purple, #8e3a9a);
}

.pacing-alert-card .alert-content {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1 1;
}

.pacing-alert-card .alert-message {
    font-size: 13px;
    color: #1a1a1a;
    line-height: 1.4;
}

.pacing-alert-card.danger .alert-message {
    color: #1a1a1a;
}

.pacing-alert-card.paused .alert-message {
    color: #1a1a1a;
}

.pacing-alert-card .alert-action-btn {
    padding: 6px 14px;
    background: #c0392b;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
}

.pacing-alert-card .alert-action-btn:hover:not(:disabled) {
    background: #a93226;
}

.pacing-alert-card .alert-action-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Campaign Alert Badge */
.campaign-alert-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    background: rgba(59, 130, 246, 0.12);
    color: #3b82f6;
    border: 1px solid rgba(59, 130, 246, 0.2);
}

.campaign-alert-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.campaign-alert-badge.warning {
    background: rgba(243, 156, 18, 0.12);
    color: #f39c12;
    border-color: rgba(243, 156, 18, 0.25);
}

.campaign-alert-badge.warning:hover {
    box-shadow: 0 2px 8px rgba(243, 156, 18, 0.2);
}

.campaign-alert-badge.paused {
    background: rgba(142, 58, 154, 0.12);
    color: var(--accent-purple, #8e3a9a);
    border-color: rgba(142, 58, 154, 0.25);
}

.campaign-alert-badge.paused:hover {
    box-shadow: 0 2px 8px rgba(142, 58, 154, 0.2);
}

.campaign-alert-badge.danger {
    background: rgba(231, 76, 60, 0.12);
    color: var(--danger, #e74c3c);
    border-color: rgba(231, 76, 60, 0.25);
}

.campaign-alert-badge.danger:hover {
    box-shadow: 0 2px 8px rgba(231, 76, 60, 0.2);
}

.campaign-alert-badge.throttle {
    background: rgba(255, 159, 67, 0.12);
    color: #ff9f43;
    border-color: rgba(255, 159, 67, 0.25);
    cursor: default;
}

.campaign-alert-badge.throttle:hover {
    box-shadow: 0 2px 8px rgba(255, 159, 67, 0.2);
    transform: none;
}

/* Publish Button - filled gradient style */
.btn-publish {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 9px 14px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}

.btn-publish:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}

.btn-publish:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.btn-publish.fields-missing {
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    box-shadow: none;
}

.btn-publish.fields-missing:hover {
    transform: none;
}

.btn-publish.publishing {
    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
}

.btn-publish.success {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.btn-publish svg {
    width: 14px;
    height: 14px;
}

/* Targeting Pending Indicator */
.targeting-pending-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    background: #f3f4f6;
    border-radius: 6px;
    color: #9ca3af;
}

.targeting-pending-indicator .pending-clock-icon {
    width: 16px;
    height: 16px;
    animation: pulse-pending 1.5s ease-in-out infinite;
}

@keyframes pulse-pending {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
}

/* Create Mode Notice */
.create-mode-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.05), rgba(139, 92, 246, 0.05));
    border: 1px solid rgba(99, 102, 241, 0.15);
    border-radius: 8px;
}

.create-mode-notice .notice-icon {
    width: 20px;
    height: 20px;
    color: #6366f1;
    flex-shrink: 0;
    margin-top: 2px;
}

.create-mode-notice .notice-text {
    flex: 1 1;
}

.create-mode-notice .notice-title {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;
}

.create-mode-notice .notice-description {
    font-size: 12px;
    color: #6b7280;
}

/* Create Group Notice */
.create-group-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    margin-top: 24px;
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.05), rgba(251, 191, 36, 0.05));
    border: 1px solid rgba(245, 158, 11, 0.2);
    border-radius: 8px;
}

.create-group-notice .notice-icon {
    width: 18px;
    height: 18px;
    color: #f59e0b;
    flex-shrink: 0;
    margin-top: 1px;
}

.create-group-notice .notice-text {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.5;
}

/* Draft Campaign Card */
.draft-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
    min-height: 200px;
}

.draft-notice {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px;
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.06), rgba(251, 191, 36, 0.06));
    border: 1px solid rgba(245, 158, 11, 0.15);
    border-radius: 12px;
    margin-bottom: 20px;
    width: 100%;
}

.draft-notice .draft-icon {
    width: 24px;
    height: 24px;
    color: #f59e0b;
    flex-shrink: 0;
    margin-top: 2px;
}

.draft-notice .draft-text {
    flex: 1 1;
}

.draft-notice .draft-title {
    font-size: 14px;
    font-weight: 600;
    color: #92400e;
    margin-bottom: 4px;
}

.draft-notice .draft-description {
    font-size: 13px;
    color: #a16207;
    line-height: 1.5;
}

.draft-actions {
    display: flex;
    gap: 10px;
    margin-top: 8px;
}

.btn-edit-draft {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 18px;
    background: #fff;
    color: var(--text-secondary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-edit-draft:hover {
    border-color: var(--text-tertiary);
    color: var(--text-primary);
}

.btn-edit-draft svg {
    width: 14px;
    height: 14px;
}

.btn-publish-draft {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 18px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}

.btn-publish-draft:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}

.btn-publish-draft:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.btn-publish-draft svg {
    width: 14px;
    height: 14px;
}

/* Draft badge - inline badge next to group name */
.draft-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 6px;
    margin-left: 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(251, 191, 36, 0.15));
    color: #b45309;
    border: 1px solid rgba(245, 158, 11, 0.3);
}

.edit-layout .ad-group-name .draft-badge {
    font-size: 9px;
    padding: 1px 5px;
    margin-left: 6px;
}

.field-label .draft-badge {
    font-size: 9px;
    padding: 2px 6px;
    vertical-align: middle;
}

/* ============================================
   CREATIVES PAGE STYLES
   ============================================ */

/* Header Select (for dropdowns in page headers) */
.header-select {
    padding: 10px 14px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    min-width: 180px;
    background: white;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.header-select:hover {
    border-color: #adb5bd;
}

.header-select:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);
}

/* Creatives Grid */
.creatives-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    animation: fadeInUp 0.5s ease;
}

/* Creative Card */
.creative-card {
    background: var(--bg-card);
    border: 1px solid #e9ecef;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    position: relative;
}

.creative-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--accent-gradient);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.creative-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
    border-color: rgba(142, 58, 154, 0.2);
}

.creative-card:hover::before {
    opacity: 1;
}

/* Creative Preview */
.creative-preview {
    height: 180px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}

.creative-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.creative-card:hover .creative-preview img {
    transform: scale(1.05);
}

.creative-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--text-tertiary);
}

.creative-placeholder svg {
    width: 48px;
    height: 48px;
    opacity: 0.5;
}

.creative-placeholder.video svg {
    color: var(--accent-red);
    opacity: 0.7;
}

.creative-placeholder.html5 svg {
    color: var(--accent-purple);
    opacity: 0.7;
}

.creative-placeholder span {
    font-size: 13px;
    font-weight: 500;
}

/* Creative Content */
.creative-content {
    padding: 20px;
}

.creative-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.creative-name {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
    line-height: 1.3;
    flex: 1 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 8px;
}

.creative-actions-dropdown .actions-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: var(--text-tertiary);
}

.creative-actions-dropdown .actions-btn:hover {
    background: var(--bg-tertiary);
    color: var(--text-primary);
}

.creative-actions-dropdown .actions-btn svg {
    width: 18px;
    height: 18px;
}

/* Creative Badges */
.creative-badges {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.creative-type-badge {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1.5px solid currentColor;
    background: transparent;
}

.creative-badge {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 6px;
}

.creative-badge.status-draft {
    background: rgba(108, 117, 125, 0.1);
    color: #6c757d;
}

.creative-badge.status-pending {
    background: rgba(245, 158, 11, 0.1);
    color: #d97706;
}

.creative-badge.status-approved {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
}

.creative-badge.status-rejected {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.creative-badge.status-unknown {
    background: rgba(107, 114, 128, 0.1);
    color: #6b7280;
}

/* Creative Meta */
.creative-meta {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.creative-meta .meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-tertiary);
}

.creative-meta .meta-item svg {
    opacity: 0.6;
}

/* Creative Actions */
.creative-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
}

.creative-actions .btn {
    flex: 1 1;
    min-width: 80px;
}

/* Empty State Card */
.empty-state-card {
    background: var(--bg-card);
    border: 2px dashed #e0e0e0;
    border-radius: 20px;
    padding: 80px 40px;
    text-align: center;
    animation: fadeInUp 0.5s ease;
}

.empty-state-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 24px;
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1), rgba(142, 58, 154, 0.1));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-state-icon svg {
    width: 40px;
    height: 40px;
    color: var(--accent-purple);
}

.empty-state-card h3 {
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 8px;
}

.empty-state-card p {
    font-size: 14px;
    color: var(--text-secondary);
    margin: 0 0 24px;
}

/* Loading State */
.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    text-align: center;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e9ecef;
    border-top-color: var(--accent-orange);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.loading-state p {
    color: var(--text-secondary);
    font-size: 14px;
    margin: 0;
}

/* Alert Banner */
.alert {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    border-radius: 12px;
    margin-bottom: 24px;
    animation: slideDown 0.3s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.alert-error {
    background: rgba(239, 68, 68, 0.08);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #dc2626;
}

.alert-error svg {
    flex-shrink: 0;
}

.alert span {
    flex: 1 1;
    font-size: 14px;
}

.alert-close {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: currentColor;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: background 0.2s ease;
    opacity: 0.6;
}

.alert-close:hover {
    background: rgba(0, 0, 0, 0.1);
    opacity: 1;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.modal {
    background: var(--bg-card);
    border-radius: 20px;
    width: 100%;
    max-width: 520px;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: modalSlideUp 0.3s ease;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    border-bottom: 1px solid #f0f0f0;
}

.modal-header h2 {
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
}

.modal-close {
    width: 36px;
    height: 36px;
    border: none;
    background: var(--bg-tertiary);
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: var(--text-secondary);
}

.modal-close:hover {
    background: #e9ecef;
    color: var(--text-primary);
}

.modal-close svg {
    width: 20px;
    height: 20px;
}

.modal-body {
    padding: 28px;
    overflow-y: auto;
    flex: 1 1;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 28px;
    border-top: 1px solid #f0f0f0;
    background: #fafbfc;
}

/* Form Styles */
.form-group {
    margin-bottom: 24px;
}

.form-group:last-child {
    margin-bottom: 0;
}

.form-group label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
}

.form-group label .optional {
    font-weight: 400;
    color: var(--text-tertiary);
}

.form-input,
.form-textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1.5px solid #e9ecef;
    border-radius: 10px;
    font-size: 14px;
    color: var(--text-primary);
    background: var(--bg-card);
    transition: all 0.2s ease;
}

.form-input:hover,
.form-textarea:hover {
    border-color: #d1d5db;
}

.form-input:focus,
.form-textarea:focus {
    outline: none;
    border-color: var(--accent-orange);
    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.form-input::placeholder,
.form-textarea::placeholder {
    color: var(--text-tertiary);
}

.form-textarea {
    resize: vertical;
    min-height: 100px;
    font-family: inherit;
}

.form-hint {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: var(--text-tertiary);
}

/* Type Selector */
.type-selector {
    display: flex;
    gap: 12px;
}

.type-option {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 20px 16px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    background: var(--bg-card);
    cursor: pointer;
    transition: all 0.2s ease;
    color: var(--text-secondary);
}

.type-option:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
}

.type-option.active {
    border-color: var(--accent-orange);
    background: linear-gradient(135deg, rgba(255, 107, 74, 0.05), rgba(142, 58, 154, 0.05));
    color: var(--accent-red);
}

.type-option svg {
    width: 28px;
    height: 28px;
}

.type-option span {
    font-size: 13px;
    font-weight: 600;
}

/* File Upload */
.file-upload-area {
    position: relative;
}

.file-upload-area input[type="file"] {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.file-upload-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 32px 24px;
    border: 2px dashed #e0e0e0;
    border-radius: 12px;
    background: #fafbfc;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
}

.file-upload-area:hover .file-upload-label {
    border-color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.02);
}

.file-upload-label svg {
    width: 32px;
    height: 32px;
    color: var(--text-tertiary);
}

.file-upload-label span {
    font-size: 14px;
    color: var(--text-secondary);
}

.file-upload-label small {
    font-size: 12px;
    color: var(--accent-purple);
    font-weight: 500;
}

/* Button Variants for Creatives */
.btn-ghost {
    background: transparent;
    border: none;
}

.btn-ghost:hover {
    background: rgba(0, 0, 0, 0.05);
}

.btn-danger {
    color: #dc2626;
}

.btn-danger:hover {
    background: rgba(220, 38, 38, 0.1);
    color: #dc2626;
}

/* Creatives Responsive */
@media (max-width: 768px) {
    .creatives-grid {
        grid-template-columns: 1fr;
    }

    .advertiser-dropdown {
        width: 100%;
        margin-right: 0;
        margin-bottom: 12px;
    }

    .header-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .modal {
        margin: 16px;
        max-height: calc(100vh - 32px);
    }

    .type-selector {
        flex-direction: column;
    }

    .type-option {
        flex-direction: row;
        padding: 16px;
    }
}

/* ============================================
   CREATIVES TABLE STYLES
   ============================================ */

.creatives-table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 16px;
    overflow: hidden;
    table-layout: fixed;
}

/* Fixed column widths for creatives table */
.creatives-table th:nth-child(1),
.creatives-table td:nth-child(1) { width: 44px; } /* Checkbox */
.creatives-table th:nth-child(2),
.creatives-table td:nth-child(2) { width: 72px; } /* Preview */
.creatives-table th:nth-child(3),
.creatives-table td:nth-child(3) { width: auto; } /* Name - flexible */
.creatives-table th:nth-child(4),
.creatives-table td:nth-child(4) { width: 110px; } /* Type */
.creatives-table th:nth-child(5),
.creatives-table td:nth-child(5) { width: 100px; } /* Size */
.creatives-table th:nth-child(6),
.creatives-table td:nth-child(6) { width: 120px; text-align: left; } /* Status */
.creatives-table th:nth-child(7),
.creatives-table td:nth-child(7) { width: 55px; } /* ID */
.creatives-table th:nth-child(8),
.creatives-table td:nth-child(8) { width: 90px; } /* Created */
.creatives-table th:nth-child(9),
.creatives-table td:nth-child(9) { width: 80px; } /* Actions */

.creatives-table thead {
    background: #f8f9fa;
}

.creatives-table thead tr:first-child th:first-child {
    border-top-left-radius: 16px;
}

.creatives-table thead tr:first-child th:last-child {
    border-top-right-radius: 16px;
}

.creatives-table tbody tr:last-child td:first-child {
    border-bottom-left-radius: 16px;
}

.creatives-table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 16px;
}

.creatives-table th {
    padding: 14px 12px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    border-bottom: 1px solid #e9ecef;
    white-space: nowrap;
}

.creatives-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f3f5;
    vertical-align: middle;
}

.creatives-table tbody tr {
    transition: background 0.2s;
}

.creatives-table tbody tr:hover {
    background: #fafbfc;
}

.creatives-table tbody tr:last-child td {
    border-bottom: none;
}

/* Preview Cell */
.creative-preview-cell {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.creative-preview-cell:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.preview-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.preview-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%);
    border-radius: 8px;
}

.preview-placeholder svg {
    width: 22px;
    height: 22px;
    color: var(--text-tertiary);
    opacity: 0.6;
}

.preview-placeholder.video {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(239, 68, 68, 0.15));
}

.preview-placeholder.video svg {
    color: #ef4444;
    opacity: 0.8;
}

.preview-placeholder.html5 {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08), rgba(139, 92, 246, 0.15));
}

.preview-placeholder.html5 svg {
    color: #8b5cf6;
    opacity: 0.8;
}

/* Creative Name Cell */
.creative-name-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.creative-name-cell .name-text {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

/* Type Badge */
.type-badge {
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 4px 8px;
    border-radius: 5px;
    border: 1.5px solid currentColor;
    background: transparent;
}

/* Dim Cell (secondary info) */
.dim-cell {
    font-size: 13px;
    color: var(--text-tertiary);
    font-variant-numeric: tabular-nums;
}

/* ID Cell */
.id-cell {
    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;
    font-size: 11px;
    color: var(--text-tertiary);
    letter-spacing: -0.2px;
}

/* Date Cell */
.date-cell {
    font-size: 13px;
    color: var(--text-secondary);
    font-variant-numeric: tabular-nums;
}

/* Status badges for creatives */
.status-badge.active {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
}

.status-badge.pending {
    background: rgba(245, 158, 11, 0.1);
    color: #d97706;
}

/* Clock icon for uploading status */
.upload-clock-icon {
    width: 12px;
    height: 12px;
    margin-left: 4px;
    opacity: 0.7;
    animation: pulse-opacity 1.5s ease-in-out infinite;
}

@keyframes pulse-opacity {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
}

.status-badge.rejected {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.status-badge.partial {
    background: rgba(139, 92, 246, 0.1);
    color: #7c3aed;
}

/* Status badges container */
.status-badges {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

/* Platform upload status badges */
.platform-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
}

.platform-badge.failed {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.platform-badge svg {
    flex-shrink: 0;
}

/* Spin animation for loading indicators */
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.spin {
    animation: spin 1s linear infinite;
}

/* Actions Cell */
.actions-cell {
    display: flex;
    align-items: center;
    gap: 4px;
}

.btn-icon {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
    transition: all 0.2s ease;
}

.btn-icon:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text-primary);
}

.btn-icon svg {
    width: 18px;
    height: 18px;
}

.btn-icon-danger:hover {
    background: rgba(220, 38, 38, 0.1);
    color: #dc2626;
}

/* Hidden utility */
.hidden {
    display: none !important;
}

/* Type Badge with Icon */
.type-badge-new {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    padding: 5px 10px;
    border-radius: 6px;
    white-space: nowrap;
}

.type-badge-new svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

/* Image placeholder */
.preview-placeholder.image {
    background: linear-gradient(135deg, rgba(14, 165, 233, 0.08), rgba(14, 165, 233, 0.15));
}

.preview-placeholder.image svg {
    color: #0ea5e9;
    opacity: 0.8;
}

/* Pagination */
.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 24px;
    padding: 16px 0;
}

.pagination-btn {
    min-width: 36px;
    height: 36px;
    border: 1px solid #e9ecef;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary);
    transition: all 0.2s ease;
    padding: 0 12px;
}

.pagination-btn svg {
    width: 18px;
    height: 18px;
}

.pagination-btn:hover:not(:disabled) {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    background: rgba(255, 107, 74, 0.05);
}

.pagination-btn.active {
    background: var(--accent-gradient);
    border-color: transparent;
    color: white;
}

.pagination-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.pagination-ellipsis {
    color: var(--text-tertiary);
    padding: 0 4px;
}

.pagination-info {
    margin-left: 16px;
    font-size: 13px;
    color: var(--text-tertiary);
}

/* Responsive for creatives table */
@media (max-width: 1024px) {
    .creatives-table th:nth-child(7),
    .creatives-table td:nth-child(7) {
        display: none; /* Hide ID column */
    }
}

@media (max-width: 768px) {
    .creatives-table {
        min-width: 600px;
    }

    .creative-preview-cell {
        width: 40px;
        height: 40px;
    }
}

/* Creative Preview Popup */
.creative-preview-popup {
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    pointer-events: none;
    animation: previewFadeIn 0.15s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

@keyframes previewFadeIn {
    from {
        opacity: 0;
        transform: translateX(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.creative-preview-popup img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
}

/* Placeholder styles for Video/HTML5 in popup */
.preview-video-placeholder,
.preview-html5-placeholder,
.preview-no-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: 100%;
    padding: 24px;
}

.preview-video-placeholder {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(239, 68, 68, 0.15) 100%);
}

.preview-video-placeholder svg {
    width: 48px;
    height: 48px;
    color: #ef4444;
    opacity: 0.8;
}

.preview-video-placeholder span {
    font-size: 13px;
    color: #ef4444;
    font-weight: 500;
}

.preview-video-placeholder .duration {
    font-size: 11px;
    color: #ef4444;
    opacity: 0.7;
    background: rgba(239, 68, 68, 0.12);
    padding: 2px 8px;
    border-radius: 4px;
}

.preview-html5-placeholder {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(139, 92, 246, 0.15) 100%);
}

.preview-html5-placeholder svg {
    width: 48px;
    height: 48px;
    color: #8b5cf6;
    opacity: 0.8;
}

.preview-html5-placeholder span {
    font-size: 13px;
    color: #8b5cf6;
    font-weight: 500;
}

.preview-no-preview {
    background: linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%);
}

.preview-no-preview span {
    font-size: 13px;
    color: var(--text-tertiary);
}

/* Placeholder styles for popup */
.preview-placeholder-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    height: 100%;
    border-radius: 12px;
}

.preview-placeholder-popup svg {
    width: 48px;
    height: 48px;
    opacity: 0.7;
}

.preview-placeholder-popup .placeholder-label {
    font-size: 14px;
    font-weight: 600;
}

.preview-placeholder-popup .placeholder-dims {
    font-size: 12px;
    opacity: 0.6;
    font-variant-numeric: tabular-nums;
}

.preview-placeholder-popup.image {
    background: linear-gradient(135deg, rgba(14, 165, 233, 0.1) 0%, rgba(14, 165, 233, 0.2) 100%);
    color: #0369a1;
}

.preview-placeholder-popup.html5 {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.2) 100%);
    color: #7c3aed;
}

.preview-placeholder-popup.video {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.2) 100%);
    color: #dc2626;
}

/* ===== Checkbox Selection for Creatives List ===== */

.checkbox-cell {
  width: 44px !important;
  text-align: center;
  padding: 0 !important;
}

.creative-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--primary);
  border-radius: 4px;
}

.creatives-table tr.selected-row {
  background: rgba(255, 107, 74, 0.06);
}

.creatives-table tr.selected-row:hover {
  background: rgba(255, 107, 74, 0.1);
}

/* Selection count in header */
.selection-count {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  padding: 8px 16px;
  background: rgba(255, 107, 74, 0.08);
  border-radius: 8px;
}

/* Danger outline button */
.btn-danger-outline {
  border-color: rgba(220, 38, 38, 0.3) !important;
  color: #dc2626 !important;
}

.btn-danger-outline:hover {
  background: rgba(220, 38, 38, 0.08) !important;
  border-color: rgba(220, 38, 38, 0.5) !important;
}

/* ===== Planning Help Tooltip ===== */
.planning-help-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;
}

.planning-help-icon svg {
  opacity: 0.5;
  transition: opacity 0.2s;
}

.planning-help-icon:hover svg {
  opacity: 0.8;
}

.planning-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  width: 280px;
  padding: 12px 14px;
  background: #1a1a2e;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 1000;
  pointer-events: none;
}

.planning-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1a1a2e;
}

.planning-help-icon:hover .planning-tooltip {
  opacity: 1;
  visibility: visible;
}

.planning-tooltip-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.planning-tooltip-item + .planning-tooltip-item {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.planning-tooltip-item strong {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.planning-tooltip-item span {
  font-size: 11px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
}

/* ============================================
   User Dropdown Menu (Sidebar)
   ============================================ */

.sidebar-user {
  position: relative;
}

.sidebar-user-dropdown {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  right: 0;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 100;
  animation: dropdownFadeIn 0.15s ease;
}

@keyframes dropdownFadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.sidebar-user-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.sidebar-user-dropdown-item svg {
  width: 16px;
  height: 16px;
  stroke: var(--text-secondary);
  flex-shrink: 0;
}

.sidebar-user-dropdown-item:hover {
  background: var(--bg-tertiary);
}

.sidebar-user-dropdown-item:hover svg {
  stroke: var(--text-primary);
}

.sidebar-user-dropdown-logout:hover {
  color: var(--accent-red);
}

.sidebar-user-dropdown-logout:hover svg {
  stroke: var(--accent-red);
}

/* ============================================
   Settings Page
   ============================================ */

.settings-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.settings-nav-item svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.settings-nav-item:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--text-primary);
}

.settings-nav-item.active {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1), rgba(142, 58, 154, 0.1));
  color: var(--accent-orange);
}

.settings-nav-item.active svg {
  stroke: var(--accent-orange);
}

.settings-content {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.settings-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 28px;
}

.settings-card-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 24px;
}


/* Interface language — a segmented control rather than a dropdown: with a
   handful of languages the whole choice is visible at once, and it does not
   stretch the width of the card the way a full-bleed <select> does. */
.lang-seg {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #f1f3f5;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}

.lang-seg-item {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 16px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
}

.lang-seg-item:hover {
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.7);
}

.lang-seg-item:focus-visible {
  outline: 2px solid var(--accent-orange);
  outline-offset: 2px;
}

/* The code carries the brand colour on the selected item, so the control reads
   as chosen at a glance without painting the whole pill. */
.lang-seg-item .lang-seg-code {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 3px 6px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  color: var(--text-tertiary);
  transition: background 0.18s, color 0.18s;
}

.lang-seg-item.active {
  background: #fff;
  color: var(--text-primary);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 4px 12px -6px rgba(0, 0, 0, 0.18);
}

.lang-seg-item.active .lang-seg-code {
  background: var(--accent-gradient);
  color: #fff;
}

/* Fallback picker, once there are too many languages to lay out as pills. */
.lang-select {
  max-width: 280px;
}

@media (max-width: 560px) {
  .lang-seg { flex-wrap: wrap; }
  .lang-seg-item { flex: 1 1 auto; justify-content: center; }
}

.settings-profile-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.settings-avatar {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 600;
  text-transform: uppercase;
  flex-shrink: 0;
}

.settings-avatar-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.settings-avatar-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.settings-avatar-role {
  font-size: 12px;
  color: var(--text-tertiary);
  text-transform: capitalize;
}

.settings-input {
  width: 100%;
  padding: 11px 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-card);
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.settings-input::placeholder {
  color: var(--text-tertiary);
}

.settings-input:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.settings-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.settings-form-group {
  margin-bottom: 18px;
}

.settings-form-group .field-label {
  margin-bottom: 6px;
}

.settings-message {
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 12px;
}

.settings-message-success {
  background: rgba(46, 204, 113, 0.1);
  color: #27ae60;
  border: 1px solid rgba(46, 204, 113, 0.2);
}

.settings-message-error {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

/* 2FA */
.tfa-status-row {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.tfa-status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tfa-enabled {
  background: rgba(46, 204, 113, 0.1);
  color: #27ae60;
  border: 1px solid rgba(46, 204, 113, 0.2);
}

.tfa-disabled {
  background: rgba(0, 0, 0, 0.04);
  color: var(--text-tertiary);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.tfa-description {
  margin-top: 10px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.tfa-setup-block {
  margin-top: 8px;
}

.tfa-instruction {
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 16px;
  font-weight: 500;
}

.tfa-qr-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: 16px;
}

.tfa-qr-image {
  width: 200px;
  height: 200px;
  border-radius: 4px;
}

.tfa-manual-key {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.tfa-manual-label {
  font-size: 12px;
  color: var(--text-tertiary);
}

.tfa-secret-code {
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 14px;
  color: var(--text-primary);
  background: rgba(0, 0, 0, 0.04);
  padding: 10px 14px;
  border-radius: 8px;
  letter-spacing: 2px;
  word-break: break-all;
  -webkit-user-select: all;
          user-select: all;
}

.tfa-code-input {
  max-width: 200px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 20px;
  letter-spacing: 8px;
  text-align: center;
}

.tfa-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.tfa-actions .add-list-btn {
  width: auto;
  flex: none;
  padding: 10px 20px;
}

.tfa-disable-btn {
  background: rgba(231, 76, 60, 0.08) !important;
  color: #e74c3c !important;
  border-color: rgba(231, 76, 60, 0.15) !important;
}

.tfa-disable-btn:hover {
  background: rgba(231, 76, 60, 0.15) !important;
}

.tfa-cancel-btn {
  background: rgba(0, 0, 0, 0.04) !important;
  color: var(--text-secondary) !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.tfa-cancel-btn:hover {
  background: rgba(0, 0, 0, 0.08) !important;
}

/* Sense Max — Save-and-Launch confirmation modal */
.sm-confirm-overlay { position: fixed; inset: 0; background: rgba(20,16,40,0.45); display: flex; align-items: center; justify-content: center; z-index: 3000; padding: 20px; }
.sm-confirm { background: #fff; border-radius: 16px; max-width: 460px; width: 100%; padding: 26px 26px 22px; box-shadow: 0 24px 60px rgba(20,10,40,0.28); }
.sm-confirm-title { margin: 0 0 10px; font-size: 20px; font-weight: 800; color: #17171d; }
.sm-confirm-text { margin: 0 0 20px; font-size: 14px; line-height: 1.6; color: #5a5a66; }
.sm-confirm-text strong { color: #17171d; }
.sm-confirm-actions { display: flex; justify-content: flex-end; gap: 10px; }

/* Sense Max — live budget split preview (stacked bar + legend) */
.budget-preview { width: 100%; box-sizing: border-box; margin: 14px 0 28px; padding: 16px 18px; border: 1px solid #ececf2; border-radius: 12px; background: #fafafc; overflow: hidden; }
.budget-preview-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #9a9aa6; margin-bottom: 10px; }
.bp-stack { display: flex; width: 100%; height: 12px; border-radius: 6px; overflow: hidden; background: #ececf2; }
.bp-seg { height: 100%; min-width: 2px; transition: width .3s ease; }
.bp-legend { display: flex; flex-wrap: wrap; gap: 8px 18px; margin-top: 12px; }
.bp-leg { display: flex; align-items: center; gap: 7px; font-size: 12.5px; min-width: 0; }
.bp-dot { width: 9px; height: 9px; border-radius: 3px; flex: 0 0 auto; }
.bp-leg-name { color: #3a3a44; font-weight: 600; }
.bp-leg-pct { color: #3a3a44; font-weight: 700; font-variant-numeric: tabular-nums; }
.bp-leg-amt { color: #9a9aa6; font-variant-numeric: tabular-nums; }
.bp-excluded { margin-top: 12px; padding-top: 10px; border-top: 1px dashed #e3e3ea; display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.bp-excl-row { display: flex; align-items: flex-start; gap: 8px; font-size: 12.5px; color: #7a6a56; line-height: 1.45; min-width: 0; }
.bp-excl-row > span:last-child { min-width: 0; overflow-wrap: anywhere; }   /* let the long reason WRAP, never force width */
.bp-excl-dot { width: 7px; height: 7px; border-radius: 50%; background: #E9A23B; margin-top: 5px; flex: 0 0 auto; }
.bp-excl-row strong { color: #b8791f; }

/* Draggable split bar: boundaries between segments are grab handles that redistribute budget. */
.bp-stack-drag { position: relative; height: 16px; border-radius: 8px; overflow: visible; touch-action: none; }
.bp-stack-drag .bp-seg { transition: width .12s ease; }
.bp-stack-drag.bp-dragging .bp-seg { transition: none; }   /* track the pointer 1:1 while dragging */
.bp-stack-drag .bp-seg:first-child { border-top-left-radius: 8px; border-bottom-left-radius: 8px; }
.bp-stack-drag .bp-seg:last-child { border-top-right-radius: 8px; border-bottom-right-radius: 8px; }
.bp-handle { position: absolute; top: 50%; width: 18px; height: 26px; transform: translate(-50%, -50%);
  display: flex; align-items: center; justify-content: center; cursor: ew-resize; z-index: 2; touch-action: none; }
.bp-handle-grip { width: 4px; height: 22px; border-radius: 3px; background: #fff;
  box-shadow: 0 0 0 1px rgba(20,20,30,.18), 0 2px 5px rgba(20,20,30,.22); transition: transform .12s ease, box-shadow .12s ease; }
.bp-handle:hover .bp-handle-grip, .bp-dragging .bp-handle-grip { transform: scaleY(1.12); box-shadow: 0 0 0 1px rgba(20,20,30,.28), 0 3px 8px rgba(20,20,30,.3); }
.bp-reset { margin-top: 12px; background: none; border: none; padding: 0; cursor: pointer;
  font-size: 12px; font-weight: 600; color: #8E3A9A; }
.bp-reset:hover { text-decoration: underline; }

/* Sense Max card: while the budget breakdown loads, the summed metrics aren't known yet.
   Skeleton the number elements so they don't flash the Sense-only value then jump to the total. */
.campaign-card.metrics-loading .metric-big,
.campaign-card.metrics-loading .cost-value,
.campaign-card.metrics-loading .budget-amount,
.campaign-card.metrics-loading .budget-spent,
.campaign-card.metrics-loading .budget-total,
.campaign-card.metrics-loading .sm-bs-val {
  color: transparent !important;
  border-radius: 6px;
  background: linear-gradient(90deg, #efedf3 25%, #e6e2ec 37%, #efedf3 63%);
  background-size: 400% 100%;
  animation: smx-shimmer 1.2s ease-in-out infinite;
}
.campaign-card.metrics-loading .metric-big *,
.campaign-card.metrics-loading .cost-value *,
.campaign-card.metrics-loading .sm-bs-val * { color: transparent !important; }
@keyframes smx-shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }

/* Sense Max — blacklist picker. Chips and the inline editor reuse the campaign
   editor's classes so the two screens look the same; only the layout differs. */
.sm-bl-picker { display: flex; flex-direction: column; gap: 8px; flex: 1 1; min-width: 0; }
.sm-bl-picker .proximity-saved-row { flex-wrap: wrap; }
.sm-bl-picker .proximity-editor { display: flex; flex-direction: column; gap: 8px; }
.sm-bl-actions { display: flex; align-items: center; gap: 8px; }
.sm-bl-err { color: #c0392b; }


/* ---------------------------------------------------------------------------
   Targeting templates — a saved arrangement of targeting, offered from the
   Targeting header because it acts on the whole block.
   --------------------------------------------------------------------------- */
.form-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.tpl-bar { display: flex; align-items: center; gap: 8px; }
.tpl-picker { position: relative; }

.tpl-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 11px;
  border: 1px solid #e5e8eb;
  border-radius: 8px;
  background: #fff;
  color: #495057;
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.tpl-btn:hover:not(:disabled) { border-color: #ced4da; background: #fafbfc; color: #1a1a1a; }
.tpl-btn:disabled { opacity: 0.55; cursor: default; }
.tpl-btn svg { width: 14px; height: 14px; color: #adb5bd; }
.tpl-btn .tpl-chevron { width: 13px; height: 13px; margin-left: -1px; }

/* Click-away layer, so the menu closes on the next click anywhere. */
.tpl-backdrop { position: fixed; inset: 0; z-index: 60; }

.tpl-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 61;
  width: 320px;
  background: #fff;
  border: 1px solid #e5e8eb;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(16, 24, 40, 0.14);
  overflow: hidden;
}

.tpl-menu-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 13px;
  border-bottom: 1px solid #f1f3f5;
  font-size: 12px;
  color: #868e96;
}

.tpl-menu-save {
  border: none;
  background: none;
  padding: 0;
  color: #4c6ef5;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.tpl-menu-save:hover:not(:disabled) { text-decoration: underline; }
.tpl-menu-save:disabled { opacity: 0.55; cursor: default; }

.tpl-empty {
  padding: 18px 14px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #868e96;
  text-align: center;
}

.tpl-list { max-height: 300px; overflow-y: auto; padding: 4px; }

.tpl-row { display: flex; align-items: stretch; border-radius: 8px; }
.tpl-row:hover { background: #f8f9fa; }

.tpl-row-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 9px 10px;
  border: none;
  background: none;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
}

.tpl-row-main:disabled { cursor: default; opacity: 0.6; }

.tpl-row-name {
  font-size: 13.5px;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tpl-row-meta { font-size: 11.5px; color: #868e96; }

.tpl-row-del {
  width: 34px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  border-radius: 8px;
  color: #ced4da;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.tpl-row:hover .tpl-row-del { opacity: 1; }
.tpl-row-del:focus-visible { opacity: 1; }
.tpl-row-del:hover { color: #e03131; background: rgba(224, 49, 49, 0.08); }
.tpl-row-del svg { width: 14px; height: 14px; }
`, "",{"version":3,"sources":["webpack://./src/styles/reports.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,iFAAiF;IACjF,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qEAAqE;IACrE,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb;;;iFAG6E;IAC7E,0CAA0C;AAC9C;;AAEA;IACI,WAAW,mCAAmC,EAAE;IAChD,MAAM,2CAA2C,EAAE;AACvD;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,QAAQ;IACR,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,QAAQ;IACR,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW,mCAAmC,EAAE;IAChD,MAAM,4CAA4C,EAAE;IACpD,MAAM,4CAA4C,EAAE;AACxD;;AAEA,WAAW;AACX;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uDAAuD;IACvD,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;;AAEnD;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,cAAc;IACd,oBAAoB;IACpB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oFAAoF;IACpF,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,SAAO;IACP,YAAY,IAAI;8FAC0E;IAC1F,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,8CAA8C;IAC9C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,+EAA+E;AAC/E;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,+CAA+C;AACnD;AACA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;AACA,eAAe,WAAW,EAAE;AAC5B;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;AACd;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;uDAEuD;AACvD;gFACgF;AAChF;IACI,6BAA6B;IAC7B;;;;qFAIiF;IACjF,oBAAoB;IACpB;;;+DAG2D;IAC3D;;;;;;;;qEAQiE;IACjE,6CAA6C;IAC7C;;mEAE+D;IAC/D,wBAAwB;IACxB,yBAAyB;AAC7B;AACA,sEAAsE;AACtE,6DAA6D,cAAc,EAAE;AAC7E;+EAC+E;AAC/E;;IAEI,gBAAgB;IAChB,uCAAuC;AAC3C;AACA,kFAAkF;AAClF,kDAAkD,yBAAyB,EAAE;;AAE7E,+EAA+E;AAC/E;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;oEACgE;IAChE,mBAAmB;IACnB,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;AACA,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtE,0FAA0F;AAC1F,qBAAqB,YAAY,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;AAC/E,wFAAwF;AACxF,aAAa,kBAAkB,EAAE,oBAAoB,EAAE;AACvD,yBAAyB,WAAW,EAAE,qBAAqB,EAAE;AAC7D;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW;EAC1C,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,mBAAmB,EAAE,WAAW;EAChC,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB;EACxE,0BAA0B;AAC5B;AACA;IACI,WAAW,EAAE,YAAY;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;IACzC,qDAAqD;IACrD,cAAc;AAClB;AACA,mBAAmB,2BAA2B,EAAE,0CAA0C,EAAE;AAC5F,oBAAoB,gBAAgB,EAAE,yBAAyB,EAAE;AACjE,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,kEAAkE,EAAE;AACxF,YAAY,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACvD,eAAe,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC/E,iCAAiC,eAAe,EAAE;AAClD,oEAAoE;AACpE,uBAAuB,gBAAgB,EAAE,cAAc,EAAE;;AAEzD,wEAAwE;AACxE,gBAAgB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAExF;oFACoF;AACpF,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,qBAAqB,EAAE;AAC7F,cAAc,SAAW,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1F,eAAe,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,yBAAyB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACxI,aAAa,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACrF,mBAAmB,cAAc,EAAE;AACnC,oBAAoB,qBAAqB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,4CAA4C,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClK,iCAAiC,cAAc,EAAE;AACjD,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAElF;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,oBAAoB;IACpB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,YAAY;QACZ,oCAAoC;IACxC;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,kCAAkC;AAClC;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4FAA4F;IAC5F,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;AACtC;;AAEA,wDAAwD;AACxD;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;8EAC0E;IAC1E,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4FAA4F;IAC5F,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;IACzC;AACJ;;;;AAIA,iCAAiC;AACjC;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,uDAAuD;AACvD;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAA6Q;IAC7Q,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uFAAuF;IACvF,kBAAkB;IAClB,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;;AAGA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;8EAC0E;IAC1E,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,YAAY;AACZ;IACI,aAAa;IACb;;;;;+EAK2E;IAC3E,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,YAAY,IAAI,uCAAuC;AAC3D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA,UAAU;AACV;mDACmD;AACnD;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;6EAC6E;AAC7E;;IAEI,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;6CAE6C;;AAE7C,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,4CAA4C;IAC5C,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;6CAE6C;AAC7C;IACI,8BAA8B;IAC9B;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA,kBAAkB;IAClB;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA,YAAY;IACZ;QACI,cAAc;QACd,YAAY;IAChB;;IAEA,sBAAsB;IACtB;QACI,eAAe;QACf,OAAO;QACP,MAAM;QACN,aAAa;QACb,YAAY;QACZ,4BAA4B;QAC5B,+BAA+B;QAC/B,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA,iDAAiD;IACjD;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,4BAA4B;QAC5B,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,qCAAqC;IACzC;;IAEA,iBAAiB;IACjB;QACI,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA,qCAAqC;IACrC;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA,wCAAwC;IACxC;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;;6CAG6C;AAC7C;IACI,kEAAkE;IAClE;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,qBAAqB;IACzB;;IAEA,qCAAqC;IACrC;;QAEI,WAAW;QACX,gBAAgB;IACpB;;IAEA,oDAAoD;IACpD;QACI,YAAyB;QAAzB,cAAyB;QAAzB,2BAAyB;QACzB,0BAA0B;QAC1B,0BAA0B;QAC1B,2BAA2B;QAC3B,wBAAwB;IAC5B;;IAEA,uCAAuC;IACvC;QACI,cAAc;QACd,eAAe;QACf,eAAe;IACnB;;IAEA,mDAAmD;IACnD;;;;QAII,WAAW;QACX,gBAAgB;IACpB;;IAEA,4CAA4C;IAC5C;QACI,8BAA8B;IAClC;AACJ;;AAEA;;6CAE6C;AAC7C;IACI,iBAAiB;IACjB;QACI,4BAA4B;QAC5B,eAAe;QACf,sBAAsB;IAC1B;;IAEA,gBAAgB;IAChB;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA,uBAAuB;IACvB;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,mBAAmB;IACnB;QACI,SAAS;IACb;;IAEA,+BAA+B;IAC/B;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA,4CAA4C;IAC5C;QACI,qCAAqC;QACrC,YAAY;QACZ,QAAQ;QACR,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,QAAQ;QACR,kBAAkB;QAClB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,qCAAqC;IACzC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA,2BAA2B;IAC3B;QACI,qCAAqC;QACrC,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA,2BAA2B;IAC3B;QACI,QAAQ;QACR,aAAa;QACb,mBAAmB;IACvB;;IAEA;;QAEI,SAAO;QACP,kBAAkB;QAClB,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA,uCAAuC;IACvC;QACI,gDAAgD;QAChD,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,kBAAkB;IAClB;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA,yCAAyC;IACzC;QACI,WAAW;QACX,aAAa;QACb,qCAAqC;QACrC,QAAQ;QACR,8BAA8B;QAC9B,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,gBAAgB;QAChB,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA,mCAAmC;IACnC;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA,mCAAmC;IACnC;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA,kCAAkC;IAClC;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,6DAA6D;IACjE;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,mBAAmB;QACnB,qBAAqB;QACrB,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,mBAAmB;IACvB;;IAEA,yCAAyC;IACzC;QACI,4BAA4B;IAChC;;IAEA;QACI,oCAAoC;IACxC;;IAEA,mCAAmC;IACnC;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA,gCAAgC;IAChC;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA,eAAe;IACf;QACI,iCAAiC;QACjC,oBAAoB;QACpB,8BAA8B;IAClC;AACJ;;AAEA;;6CAE6C;AAC7C;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,6BAA6B;IAC7B;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA,4CAA4C;IAC5C;QACI,qCAAqC;QACrC,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA,mBAAmB;IACnB;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA,4BAA4B;IAC5B;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA,WAAW;IACX;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA,YAAY;IACZ;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,aAAa;IACjB;;IAEA,mCAAmC;IACnC;QACI,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,uCAAuC;IACvC;QACI,qCAAqC;QACrC,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;;QAGI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA,2BAA2B;IAC3B;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,uBAAuB;IACvB;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;;6CAE6C;;AAE7C;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;6CAE6C;;AAE7C,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,2BAA2B;AAC3B;IACI,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,qFAAwN;IACxN,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,yDAA6Q;IAC7Q,4BAA4B;IAC5B,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA,yBAAyB;AACzB;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;IACrC,8EAA8E;AAClF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;IACpB,qEAAqE;IACrE,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB;;8DAE0D;IAC1D,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kEAAkE;IAClE,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,8CAA8C;IAC9C,WAAW;IACX,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;IAGI,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;IACP,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,4DAA4D;AAChE;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,qDAAqD;IACrD,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,0BAA0B;AAC9B;;AAEA;;IAEI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,6DAA6D;IAC7D,+CAA+C;IAC/C,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,6DAA6D;IAC7D,+CAA+C;IAC/C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,qDAAqD;IACrD,oBAAoB;IACpB,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,oBAAoB,EAAE;;AAEvD;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB;;;qCAGiC;IACjC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,QAAQ;IACR,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,+EAA+E;IAC/E,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;AACnD;;AAEA,eAAe;AACf;IACI,aAAa;IACb,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,kEAAkE;AAClE;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,sFAAsF;IACtF,yCAAyC;AAC7C;;AAEA;IACI,sFAAsF;IACtF,yCAAyC;AAC7C;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,uFAAuF;IACvF,6CAA6C;IAC7C,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,uFAAuF;IACvF,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,sFAAsF;AAC1F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qFAAqF;IACrF,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,sFAAsF;IACtF,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;mCACmC,UAAU,EAAE,EAAE,aAAa;AAC9D;mCACmC,UAAU,EAAE,EAAE,WAAW;AAC5D;mCACmC,UAAU,EAAE,EAAE,UAAU;AAC3D;mCACmC,UAAU,EAAE,EAAE,YAAY;AAC7D;mCACmC,SAAS,EAAE,EAAE,QAAQ;AACxD;mCACmC,SAAS,EAAE,EAAE,QAAQ;AACxD;mCACmC,UAAU,EAAE,EAAE,WAAW;AAC5D;mCACmC,SAAS,EAAE,EAAE,YAAY;;AAE5D;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,2CAA2C;IAC3C,uCAAuC;AAC3C;;AAEA;IACI;QACI,UAAU;QACV,kCAAkC;IACtC;IACA;QACI,YAAY;QACZ,uCAAuC;IAC3C;AACJ;;AAEA,eAAe;AACf;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA,mBAAmB;AACnB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,2BAA2B;QAC3B,gBAAgB;QAChB,iCAAiC;QACjC,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4DAA4D;QAC5D,SAAS;IACb;;IAEA,oBAAoB;IACpB;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;QAClB,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA,6BAA6B;IAC7B;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,QAAQ;QACR,SAAO;QACP,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,6BAA6B;IAC7B;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,mCAAmC;IACnC;QACI,eAAe;QACf,aAAa;QACb,YAAY;IAChB;;IAEA,qDAAqD;;IAErD,qCAAqC;IACrC;QACI,qCAAqC;QACrC,QAAQ;QACR,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,sCAAsC;IAC1C;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA,6BAA6B;IAC7B;QACI,cAAc;QACd,cAAc;QACd,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA,0BAA0B;IAC1B;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA,qBAAqB;IACrB;QACI,SAAS;QACT,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,iCAAiC;IACjC;QACI,kBAAkB;QAClB,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,+BAA+B;QAC/B,QAAQ;QACR,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,qBAAqB;QACrB,4BAA4B;QAC5B,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA,+BAA+B;IAC/B;QACI,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,uCAAuC;QACvC,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,aAAa;QACb,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,WAAW;QACX,kBAAkB;IACtB;;IAEA,uCAAuC;IACvC;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA,kCAAkC;IAClC;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA,wCAAwC;IACxC;QACI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,eAAe;IACnB;;IAEA,uEAAuE;IACvE;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,oDAAoD;AACpD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;IAC1B,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,2CAA2C;IAC3C,2BAA2B;IAC3B,wDAAwD;AAC5D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sDAAsD;IACtD,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,iDAAiD;;AAEjD,cAAc;AACd;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,0BAA0B;AAC1B;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;;IAEI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,sCAAsC;AACtC;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,uCAAuC;AACvC;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,yDAA4L;IAC5L,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+FAA+F;IAC/F,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY,IAAI,6DAA6D;AACjF;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,kCAAkC;IACtC;IACA;QACI,YAAY;QACZ,uCAAuC;IAC3C;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,+EAA+E;IAC/E,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,iFAAiF;IACjF,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,iFAAiF;IACjF,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iFAAiF;IACjF,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,6FAA6F;AAC7F,kBAAkB,gBAAgB,EAAE;AACpC,+BAA+B,YAAY,EAAE,eAAe,EAAE;;AAE9D,gCAAgC;AAChC;IACI,SAAO;IACP,YAAY,SAAS,qEAAqE;IAC1F,gBAAgB,KAAK,gFAAgF;IACrG,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,kFAAkF;IAClF,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,WAAW;IACX,oBAAoB,IAAI,sDAAsD;IAC9E,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,6FAA6F;IAC7F,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,8BAA8B;IAC9B,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,+FAA+F;IAC/F,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA,wDAAwD;AACxD;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA,0EAA0E;AAC1E;IACI,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,2DAA2D;AAC3D;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,yDAAyD;AACzD;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,4EAA4E;IAC5E,YAAY;AAChB;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,4EAA4E;IAC5E,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;;IAEI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,+DAA+D;AAC/D;IACI,eAAe;AACnB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA,cAAc;AACd;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,sCAAsC;IACtC,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4EAA4E;IAC5E,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,4EAA4E;IAC5E,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uFAAuF;IACvF,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,sCAAsC;IACtC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,4BAA4B;IAC5B,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,sFAAsF;AAC1F;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,4EAA4E;IAC5E,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,yEAAyE;AAC7E;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,4EAA4E;IAC5E,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,4EAA4E;IAC5E,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,4EAA4E;IAC5E,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;AACxB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;IAC1C,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,4EAA4E;IAC5E,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,6FAA6F;IAC7F,2BAA2B;AAC/B;;AAEA;IACI,+FAA+F;IAC/F,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,8FAA8F;IAC9F,8CAA8C;AAClD;;AAEA;IACI,WAAW,mBAAmB,EAAE,UAAU,EAAE;IAC5C,MAAM,sBAAsB,EAAE,YAAY,EAAE;AAChD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,6CAA6C;AACjD;;AAEA;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,4EAA4E;IAC5E,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,4EAA4E;IAC5E,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;IAC3B,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,yEAAyE;AACzE;;IAEI,uBAAuB;IACvB,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;IAC7D,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,2CAA2C;IAC3C,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,uBAAuB;IACvB,iDAAiD;AACrD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,sBAAsB;IACtB,WAAW;AACf;;AAEA;;;;IAII,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,sBAAsB;IACtB,WAAW;AACf;;AAEA;;;;IAII,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,0DAA0D;AAC9D;;AAEA;IACI,KAAK,mBAAmB,EAAE,UAAU,EAAE;IACtC,MAAM,qBAAqB,EAAE;IAC7B,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,8DAA8D;;AAE9D;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,+BAA+B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,8BAA8B;IAC9B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,SAAO;IACP,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,4EAA4E;IAC5E,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,wBAAwB;AAC5B;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,uEAAuE;AAC3E;;AAEA,iEAAiE;AACjE;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;IACI,qBAAqB;IACrB;QACI,sBAAsB;QACtB,SAAS;QACT,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA,mBAAmB;IACnB;QACI,WAAW;QACX,eAAe;QACf,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA,mBAAmB;IACnB;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA,mCAAmC;IACnC;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA,cAAc;IACd;;QAEI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,UAAU;IACd;;IAEA,sCAAsC;IACtC;;QAEI,aAAa;QACb,QAAQ;QACR,WAAW;IACf;;IAEA;;QAEI,SAAO;QACP,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA,sCAAsC;IACtC;QACI,aAAa;QACb,iBAAiB;QACjB,QAAQ;QACR,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,SAAO;QACP,eAAe;IACnB;;IAEA,sDAAsD;IACtD;;QAEI,aAAa;QACb,WAAW;QACX,qCAAqC;QACrC,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;;QAEI,uBAAuB;QACvB,gBAAgB;QAChB,SAAO;QACP,YAAY;IAChB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,cAAc;IAClB;;IAEA,mBAAmB;IACnB;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,aAAa;QACb,eAAe;QACf,QAAQ;QACR,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA,mBAAmB;IACnB;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,cAAc;IACd;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;IACtB;;IAEA,WAAW;IACX;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,cAAc;IACd;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;IACjB;;IAEA,QAAQ;IACR;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;QACP,iBAAiB;QACjB,eAAe;IACnB;;IAEA,cAAc;IACd;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA,mCAAmC;IACnC;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;QACjC,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,eAAe;QACf,eAAe;IACnB;;IAEA,gBAAgB;IAChB;QACI,eAAe;IACnB;;IAEA,aAAa;IACb;QACI,iBAAiB;IACrB;;IAEA,cAAc;IACd;QACI,2DAA2D;QAC3D,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;;iDAEiD;;AAEjD;IACI,kCAAkC;IAClC,+FAA+F;AACnG;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oFAAoF;IACpF,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yEAAyE;IACzE,aAAa;IACb,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,6DAA6D;IAC7D,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+FAA+F;AACnG;;AAEA;IACI,8FAA8F;AAClG;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oFAAoF;IACpF,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA,kBAAkB;AAClB;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,eAAe;AACnB;;AAEA;IACI,8FAA8F;AAClG;;AAEA;IACI,8FAA8F;AAClG;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,sCAAsC;IACtC,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,8FAA8F;IAC9F,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;;iDAEiD;;AAEjD;IACI,kCAAkC;IAClC,+FAA+F;AACnG;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oFAAoF;IACpF,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yEAAyE;IACzE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6DAA6D;IAC7D,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+FAA+F;AACnG;;AAEA;IACI,8FAA8F;AAClG;;AAEA,aAAa;AACb;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oFAAoF;IACpF,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,8FAA8F;IAC9F,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,+CAA+C;IAC/C,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,wDAAwD;AAC5D;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,8BAA8B;AAC9B;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,mCAAmC;AACvC;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,mCAAmC;AACvC;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,mCAAmC;AACvC;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;AACA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,uFAAuF;IACvF,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,SAAS;AACT;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uFAAuF;IACvF,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;iDAEiD;;AAEjD,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qFAAqF;IACrF,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,UAAU;IACV,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;AACjC;;AAEA,qCAAqC;AACrC;IACI,qFAAqF;IACrF,4CAA4C;AAChD;;AAEA,yCAAyC;AACzC;IACI,sFAAsF;IACtF,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6DAA6D;IAC7D,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,UAAU,EAAE;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,uFAAuF;IACvF,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,uFAAuF;IACvF,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,uFAAuF;IACvF,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,6DAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,kDAAkD;AAClD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,uFAAuF;IACvF,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;iDAEiD;;AAEjD,kDAAkD;AAClD;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kCAAkC;IAClC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qFAAqF;IACrF,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,uFAAuF;IACvF,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;AACJ;;AAEA;;iDAEiD;;AAEjD;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;mCACmC,WAAW,EAAE,EAAE,aAAa;AAC/D;mCACmC,WAAW,EAAE,EAAE,YAAY;AAC9D;mCACmC,WAAW,EAAE,EAAE,oBAAoB;AACtE;mCACmC,YAAY,EAAE,EAAE,SAAS;AAC5D;mCACmC,YAAY,EAAE,EAAE,SAAS;AAC5D;mCACmC,YAAY,EAAE,gBAAgB,EAAE,EAAE,WAAW;AAChF;mCACmC,WAAW,EAAE,EAAE,OAAO;AACzD;mCACmC,WAAW,EAAE,EAAE,YAAY;AAC9D;mCACmC,WAAW,EAAE,EAAE,YAAY;;AAE9D;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA,YAAY;AACZ;IACI,oDAAoD;IACpD,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,eAAe;IACf,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA,gCAAgC;AAChC;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,UAAU,EAAE;AACtB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;AAC5B;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,uFAAuF;AAC3F;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;IACI;;QAEI,aAAa,EAAE,mBAAmB;IACtC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yEAAyE;IACzE,gBAAgB;IAChB,oBAAoB;IACpB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;;;IAGI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+FAA+F;AACnG;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,6FAA6F;IAC7F,cAAc;AAClB;;AAEA;IACI,6FAA6F;IAC7F,cAAc;AAClB;;AAEA;IACI,2FAA2F;IAC3F,cAAc;AAClB;;AAEA,sDAAsD;;AAEtD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;;AAGA;;sEAEsE;AACtE;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,2DAA2D;AAC7D;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;2DAC2D;AAC3D;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,8EAA8E;AAChF;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY,eAAe,EAAE;EAC7B,iBAAiB,cAAc,EAAE,uBAAuB,EAAE;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oFAAoF;EACpF,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,QAAQ;AACR;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,mDAAmD;AACnD,sBAAsB,eAAe,EAAE,QAAQ,EAAE,+BAA+B,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,aAAa,EAAE;AAC7K,cAAc,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,WAAW,EAAE,uBAAuB,EAAE,2CAA2C,EAAE;AAC1J,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF,mBAAmB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxF,0BAA0B,cAAc,EAAE;AAC1C,sBAAsB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE;;AAE3E,iEAAiE;AACjE,kBAAkB,WAAW,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACvL,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClJ,YAAY,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACjH,UAAU,YAAY,EAAE,cAAc,EAAE,0BAA0B,EAAE;AACpE,aAAa,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC9E,UAAU,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,YAAY,EAAE;AACzF,UAAU,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACvE,eAAe,cAAc,EAAE,gBAAgB,EAAE;AACjD,cAAc,cAAc,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;AACpF,cAAc,cAAc,EAAE,kCAAkC,EAAE;AAClE,eAAe,gBAAgB,EAAE,iBAAiB,EAAE,8BAA8B,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACnJ,eAAe,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE,YAAY,EAAE;AACrI,iCAAiC,YAAY,EAAE,uBAAuB,EAAE,IAAI,gDAAgD;AAC5H,eAAe,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE;AAClH,sBAAsB,cAAc,EAAE;;AAEtC,gGAAgG;AAChG,iBAAiB,kBAAkB,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC9G,yBAAyB,2BAA2B,EAAE;AACtD,qCAAqC,gBAAgB,EAAE,IAAI,yCAAyC;AACpG,qCAAqC,2BAA2B,EAAE,8BAA8B,EAAE;AAClG,oCAAoC,4BAA4B,EAAE,+BAA+B,EAAE;AACnG,aAAa,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,YAAY,EAAE,gCAAgC;EACpG,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,UAAU,EAAE,kBAAkB,EAAE;AAClH,kBAAkB,UAAU,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAC9E,sEAAsE,EAAE,qDAAqD,EAAE;AACjI,iEAAiE,uBAAuB,EAAE,qEAAqE,EAAE;AACjK,YAAY,gBAAgB,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe;EACvF,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrD,kBAAkB,0BAA0B,EAAE;;AAE9C;kGACkG;AAClG;;;;;;EAME,6BAA6B;EAC7B,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;AACA;;8CAE8C,6BAA6B,EAAE;AAC7E,yBAAyB,KAAK,2BAA2B,EAAE,EAAE,OAAO,wBAAwB,EAAE,EAAE;;AAEhG;gFACgF;AAChF,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AACxF,qCAAqC,eAAe,EAAE;AACtD,kCAAkC,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnF,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC/D,aAAa,cAAc,EAAE;;;AAG7B;;;gFAGgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzD,cAAc,kBAAkB,EAAE;;AAElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,4EAA4E;AAC9E;;AAEA,gCAAgC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5F,oBAAoB,aAAa,EAAE,eAAe,EAAE;AACpD,eAAe,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAC1D,wBAAwB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAEtE,qEAAqE;AACrE,gBAAgB,eAAe,EAAE,QAAQ,EAAE,WAAW,EAAE;;AAExD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,sCAAsC,0BAA0B,EAAE;AAClE,0BAA0B,aAAa,EAAE,eAAe,EAAE;;AAE1D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAE/D,WAAW,aAAa,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;AACpE,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,yBAAyB,eAAe,EAAE,YAAY,EAAE;;AAExD;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB,iBAAiB,EAAE,cAAc,EAAE;;AAEnD;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,uEAAuE;AACzE;;AAEA,8BAA8B,UAAU,EAAE;AAC1C,6BAA6B,UAAU,EAAE;AACzC,qBAAqB,cAAc,EAAE,mCAAmC,EAAE;AAC1E,mBAAmB,WAAW,EAAE,YAAY,EAAE","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n:root {\n    --bg-primary: #f8f9fa;\n    --bg-secondary: #ffffff;\n    --bg-tertiary: #f1f3f5;\n    --bg-card: #ffffff;\n    --accent-orange: #FF6B4A;\n    --accent-red: #E94B6C;\n    --accent-purple: #8E3A9A;\n    --accent-gradient: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n    --text-primary: #1a1a1a;\n    --text-secondary: #6c757d;\n    --text-tertiary: #adb5bd;\n    --border-color: rgba(0, 0, 0, 0.08);\n    --success: #2ecc71;\n    --warning: #f39c12;\n    --danger: #e74c3c;\n}\n\nbody {\n    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    overflow-x: hidden;\n}\n\n/* Enhanced Background with Brand Colors */\n.bg-gradient {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    opacity: 0.05;\n    background: \n        radial-gradient(circle at 20% 30%, var(--accent-orange) 0%, transparent 50%),\n        radial-gradient(circle at 80% 70%, var(--accent-purple) 0%, transparent 50%),\n        radial-gradient(circle at 50% 50%, var(--accent-red) 0%, transparent 60%);\n    animation: gradientShift 20s ease infinite;\n}\n\n@keyframes gradientShift {\n    0%, 100% { transform: translate(0, 0) scale(1); }\n    50% { transform: translate(50px, 30px) scale(1.1); }\n}\n\n/* Decorative Elements */\n.bg-orbs {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    pointer-events: none;\n    overflow: hidden;\n}\n\n.orb {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(60px);\n    opacity: 0.08;\n    animation: floatOrb 20s ease-in-out infinite;\n}\n\n.orb-1 {\n    width: 300px;\n    height: 300px;\n    background: var(--accent-orange);\n    top: 10%;\n    left: 5%;\n    animation-delay: 0s;\n}\n\n.orb-2 {\n    width: 400px;\n    height: 400px;\n    background: var(--accent-purple);\n    bottom: 10%;\n    right: 10%;\n    animation-delay: 5s;\n}\n\n.orb-3 {\n    width: 250px;\n    height: 250px;\n    background: var(--accent-red);\n    top: 50%;\n    right: 20%;\n    animation-delay: 10s;\n}\n\n@keyframes floatOrb {\n    0%, 100% { transform: translate(0, 0) scale(1); }\n    33% { transform: translate(50px, -30px) scale(1.1); }\n    66% { transform: translate(-30px, 50px) scale(0.9); }\n}\n\n/* Layout */\n.app-container {\n    display: flex;\n    min-height: 100vh;\n    position: relative;\n    z-index: 1;\n}\n\n/* Sidebar with Brand Accent */\n.sidebar {\n    width: 280px;\n    background: #fafbfc;\n    border-right: 1px solid var(--border-color);\n    padding: 28px 24px 0;\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    height: 100vh;\n    overflow: hidden;\n    z-index: 100;\n}\n\n.sidebar-nav-scroll {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    margin-right: -24px;\n    padding-right: 24px;\n    padding-bottom: 8px;\n    position: relative;\n    z-index: 1;\n}\n\n.sidebar::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0.6;\n}\n\n.logo {\n    margin-bottom: 32px;\n    animation: fadeInDown 0.6s ease;\n    position: relative;\n}\n\n.logo img {\n    width: 200px;\n    height: auto;\n    filter: drop-shadow(0 8px 24px rgba(255, 107, 74, 0.4));\n    transition: transform 0.3s ease;\n}\n\n.logo:hover img {\n    transform: scale(1.05);\n}\n\n.nav-section {\n    margin-bottom: 32px;\n    animation: fadeInLeft 0.6s ease;\n    animation-fill-mode: both;\n}\n\n.nav-section:nth-child(2) { animation-delay: 0.1s; }\n.nav-section:nth-child(3) { animation-delay: 0.2s; }\n.nav-section:nth-child(4) { animation-delay: 0.3s; }\n\n.nav-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    color: var(--text-tertiary);\n    margin-bottom: 12px;\n    padding-left: 16px;\n}\n\n.nav-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n    color: var(--text-secondary);\n    text-decoration: none;\n    border-radius: 10px;\n    transition: all 0.3s ease;\n    font-size: 14px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n}\n\n.nav-item::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 3px;\n    background: var(--accent-gradient);\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n}\n\n.nav-item::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.nav-item:hover::after {\n    opacity: 0.05;\n}\n\n.nav-item:hover,\n.nav-item.active {\n    background: #f8f9fa;\n    color: var(--text-primary);\n}\n\n.nav-item.active::before {\n    transform: translateX(0);\n}\n\n.nav-item-icon {\n    width: 20px;\n    height: 20px;\n    opacity: 0.7;\n    position: relative;\n    z-index: 1;\n}\n\n.nav-item.active .nav-item-icon {\n    opacity: 1;\n}\n\n.nav-item span {\n    position: relative;\n    z-index: 1;\n}\n\n/* Sidebar User Menu */\n.sidebar-user {\n    flex-shrink: 0;\n    padding: 20px 0 24px;\n    border-top: 1px solid var(--border-color);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.sidebar-user-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n}\n\n.sidebar-user-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    flex-shrink: 0;\n}\n\n.sidebar-user-details {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.sidebar-user-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sidebar-user-email {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sidebar-logout-btn {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.sidebar-logout-btn svg {\n    width: 18px;\n    height: 18px;\n    stroke: var(--text-tertiary);\n    transition: stroke 0.2s ease;\n}\n\n.sidebar-logout-btn:hover {\n    background: var(--bg-tertiary);\n}\n\n.sidebar-logout-btn:hover svg {\n    stroke: var(--accent-red);\n}\n\n/* Main Content */\n.main-content {\n    flex: 1;\n    min-width: 0;   /* flex item must shrink to the viewport, not grow to its widest child\n                       (without this ANY wide content horizontally overflows the whole page) */\n    margin-left: 280px;\n    padding: 32px 48px;\n}\n\n/* Header with Gradient Accent */\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 36px;\n    animation: fadeInDown 0.6s ease;\n    position: relative;\n    padding-bottom: 24px;\n}\n\n.header::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 120px;\n    height: 3px;\n    background: var(--accent-gradient);\n    border-radius: 2px;\n}\n\n.header-title h1 {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 36px;\n    font-weight: 700;\n    margin-bottom: 8px;\n    letter-spacing: -0.5px;\n    color: var(--text-primary);\n}\n\n.header-subtitle {\n    color: var(--text-secondary);\n    font-size: 15px;\n}\n\n.header-actions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.btn {\n    padding: 14px 28px;\n    border: none;\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n    overflow: hidden;\n}\n\n.btn::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.2);\n    transform: translate(-50%, -50%);\n    transition: width 0.6s, height 0.6s;\n}\n\n.btn:hover::before {\n    width: 300px;\n    height: 300px;\n}\n\n.btn-primary {\n    background: var(--accent-gradient);\n    color: white;\n    box-shadow: 0 8px 24px rgba(255, 107, 74, 0.4);\n    position: relative;\n    z-index: 1;\n}\n\n.btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 32px rgba(255, 107, 74, 0.5);\n}\n\n.btn-secondary {\n    background: var(--bg-card);\n    color: var(--text-primary);\n    border: 1px solid #e9ecef;\n}\n\n.btn-secondary:hover {\n    background: #f8f9fa;\n    border-color: var(--accent-orange);\n}\n\n/* Sense Max — premium dark sibling of New Campaign, with a gradient MAX pill */\n.btn-max {\n    background: #1b1430;\n    color: #fff;\n    position: relative;\n    z-index: 1;\n    box-shadow: 0 8px 24px rgba(142, 58, 154, 0.35);\n}\n.btn-max:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 32px rgba(142, 58, 154, 0.5);\n}\n.btn-max svg { color: #fff; }\n.btn-max-badge {\n    font-size: 10px;\n    font-weight: 800;\n    letter-spacing: 0.5px;\n    line-height: 1;\n    padding: 3px 6px;\n    border-radius: 6px;\n    background: var(--accent-gradient);\n    color: #fff;\n    margin-left: 4px;\n}\n\n/* Stats Grid with Brand Accents */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    margin-bottom: 36px;\n    animation: fadeInUp 0.6s ease 0.2s;\n    animation-fill-mode: both;\n}\n\n.stat-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    padding: 28px;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.3s ease;\n}\n\n.stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.stat-card::after {\n    content: '';\n    position: absolute;\n    top: -100%;\n    right: -50px;\n    width: 200px;\n    height: 200px;\n    background: radial-gradient(circle, rgba(255, 107, 74, 0.15) 0%, transparent 70%);\n    border-radius: 50%;\n    transition: top 0.6s ease;\n}\n\n.stat-card:hover {\n    transform: translateY(-6px);\n    border-color: rgba(255, 107, 74, 0.3);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card:hover::before {\n    opacity: 1;\n}\n\n.stat-card:hover::after {\n    top: -50px;\n}\n\n.stat-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.stat-label {\n    font-size: 13px;\n    color: var(--text-secondary);\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.stat-badge {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.stat-badge.positive {\n    background: rgba(46, 204, 113, 0.15);\n    color: var(--success);\n}\n\n.stat-badge.negative {\n    background: rgba(231, 76, 60, 0.15);\n    color: var(--danger);\n}\n\n.stat-value {\n    font-size: 40px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    line-height: 1;\n    color: var(--text-primary);\n    position: relative;\n    z-index: 1;\n}\n\n.stat-comparison {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    position: relative;\n    z-index: 1;\n}\n\n/* Campaign Cards with Enhanced Styling */\n.campaigns-section {\n    margin-bottom: 48px;\n    animation: fadeInUp 0.6s ease 0.3s;\n    animation-fill-mode: both;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 28px;\n}\n\n.section-title {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 28px;\n    font-weight: 700;\n    position: relative;\n    display: inline-block;\n}\n\n.section-title::after {\n    content: '';\n    position: absolute;\n    bottom: -8px;\n    left: 0;\n    width: 60px;\n    height: 3px;\n    background: var(--accent-gradient);\n    border-radius: 2px;\n}\n\n.campaign-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n.campaign-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    padding: 32px;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Sense Max (cross-platform) campaign — strongly distinct: 2px brand-gradient border,\n   a bright gradient wash, a heavier shadow, and a big faint brand triangle watermark in\n   the bottom-right. No element sits ABOVE the title. */\n/* NOTE: must out-specify `.campaigns-cards .campaign-card` (background:white)\n   which is declared later in this file — hence the `.campaigns-cards` prefix. */\n.campaigns-cards .campaign-card.sense-max {\n    border: 2px solid transparent;\n    /* Normal cards end with the pacing (card-ai) block, which the grid stretches\n       to give the bottom breathing room. Max cards end with the thin \"Running on\"\n       row instead, so when a Max card is ALONE (grid row not stretched by a taller\n       sibling) that row jams against the bottom edge and looks cut off. Reserve the\n       bottom room explicitly so it reads the same whether alone or in a full grid. */\n    padding-bottom: 40px;\n    /* Signature: a large brand-gradient triangle wedge bleeding off the\n       bottom-right corner, a soft gradient tint, and the gradient border.\n       All are background layers, so the card's rounded corners clip them\n       automatically (no pseudo-element cutting the corners). */\n    background:\n        /* The real Sense logo (public/sense-triangle-bg.png, pre-faded to ~8%\n           alpha) as a LARGE brand watermark bleeding off the bottom-right corner.\n           A background layer, so the card's rounded corners clip it automatically. */\n        url(\"./sense-triangle-bg.png\") no-repeat right -60px bottom -170px / 150% auto,\n        /* OPAQUE, near-white tint — keeps the interior light so all the text and\n           metric boxes stay fully readable; brand colour lives in the border only */\n        linear-gradient(155deg, #FFFBFA 0%, #FEF7F9 55%, #FCF9FD 100%) padding-box,\n        linear-gradient(120deg, #FF6B4A, #E94B6C, #8E3A9A) border-box;\n    box-shadow: 0 10px 30px rgba(142,58,154,0.14);\n    /* Darken the muted text tiers (default tertiary #adb5bd is too light to read\n       over the tinted/watermarked bg). Descendants using these vars — metric &\n       cost labels, subtitle, \"No data\" — all get darker at once. */\n    --text-tertiary: #6b6b77;\n    --text-secondary: #4c4c58;\n}\n/* KZT/currency prefix is styled in another file; darken it here too */\n.campaigns-cards .campaign-card.sense-max .currency-symbol { color: #7a7a86; }\n/* Solid white metric/cost boxes on Max cards — the default #f8f9fa is nearly the\n   same value as the tinted card, so boxes must go white to read as distinct. */\n.campaigns-cards .campaign-card.sense-max .metric-box,\n.campaigns-cards .campaign-card.sense-max .cost-box {\n    background: #fff;\n    border: 1px solid rgba(142,58,154,0.10);\n}\n/* keep the gradient border crisp on hover (base card sets a solid border-color) */\n.campaigns-cards .campaign-card.sense-max:hover { border-color: transparent; }\n\n/* Max identity chip — same shape/slot as the type-indicator on regular cards */\n.type-indicator.sense-max-m {\n    background: #17171d;\n    color: #fff;\n    font-weight: 800;\n    font-size: 15px;\n    line-height: 1;\n    letter-spacing: -0.5px;\n}\n\n/* \"Running on <platform logos>\" block — replaces the pacing block on Max cards */\n.card-platforms {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    /* inset 20px each side so \"Running on\" + the divider line up with the\n       card body text (metrics/budget sit at card-padding 32 + 20) */\n    margin: 16px 20px 0;\n    padding-top: 15px;\n    border-top: 1px solid rgba(142,58,154,0.12);\n    position: relative;\n    z-index: 1;\n}\n.card-platforms-label {\n    font-size: 10.5px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    color: #a29aad;\n}\n.card-platforms-logos { display: flex; align-items: center; gap: 8px; }\n/* Launched on a now-disconnected cabinet — greyed (still runs there, can't be managed). */\n.plat-disconnected { opacity: .32; filter: grayscale(1); display: inline-flex; }\n/* Partial launch: a platform whose tool FAILED to launch — red \"!\" badge on its logo. */\n.card-plat { position: relative; display: inline-flex; }\n.card-plat.plat-failed { opacity: .5; filter: grayscale(.6); }\n.plat-failed-mark {\n  position: absolute; top: -5px; right: -6px;\n  width: 15px; height: 15px; border-radius: 50%;\n  background: #e5484d; color: #fff;\n  font-size: 10px; font-weight: 800; line-height: 15px; text-align: center;\n  box-shadow: 0 0 0 2px #fff;\n}\n.plat-tile {\n    width: 30px; height: 30px;\n    border-radius: 9px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 6px rgba(20,10,40,0.10);\n    transition: transform .15s ease, box-shadow .15s ease;\n    flex: 0 0 auto;\n}\n.plat-tile:hover { transform: translateY(-2px); box-shadow: 0 6px 15px rgba(20,10,40,0.20); }\n.plat-tile-white  { background: #fff; border: 1px solid #ececf2; }\n.plat-tile-yandex { background: #FC3F1D; }\n.plat-tile-sense  { background: linear-gradient(135deg, #FF6B4A, #E94B6C 55%, #8E3A9A); }\n.plat-svg { width: 18px; height: 18px; display: block; }\n.plat-letter { color: #fff; font-weight: 800; font-size: 15px; line-height: 1; }\n.plat-tile-yandex .plat-letter { font-size: 16px; }\n/* platform count in the subtitle (replaces \"N ad groups\" for Max) */\n.sense-max-platforms { font-weight: 600; color: #8E3A9A; }\n\n/* full precision, compact only when it would overflow (measured live) */\n.fit-currency { display: block; max-width: 100%; overflow: hidden; white-space: nowrap; }\n\n/* Max card budget — one compact row (Sense / Commission / External / From balance),\n   aligned to the metric boxes (20px insets); external muted when it's stats-only. */\n.sm-budget-strip { display: flex; align-items: flex-start; gap: 10px; padding: 6px 20px 4px; }\n.sm-bs-item { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 3px; }\n.sm-bs-label { font-size: 10px; font-weight: 700; letter-spacing: .3px; text-transform: uppercase; color: #a09aac; white-space: nowrap; }\n.sm-bs-val { font-size: 14px; font-weight: 700; color: #22222c; white-space: nowrap; }\n.sm-bs-val.muted { color: #b0b0ba; }\n.sm-bs-item.total { align-items: flex-end; text-align: right; padding-left: 12px; border-left: 1px solid rgba(142,58,154,0.16); flex: 0 0 auto; min-width: 120px; }\n.sm-bs-item.total .sm-bs-label { color: #8E3A9A; }\n.sm-bs-item.total .sm-bs-val { font-size: 15px; font-weight: 800; color: #1a1a22; }\n\n.campaign-card::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 250px;\n    height: 250px;\n    background: radial-gradient(circle, rgba(142, 58, 154, 0.12) 0%, transparent 70%);\n    pointer-events: none;\n    transform: translate(50%, -50%);\n    transition: all 0.4s ease;\n}\n\n.campaign-card:hover {\n    transform: translateY(-6px);\n    border-color: rgba(142, 58, 154, 0.3);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.campaign-card:hover::after {\n    transform: translate(40%, -40%) scale(1.2);\n}\n\n.campaign-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 28px;\n    position: relative;\n    z-index: 1;\n}\n\n.campaign-info h3 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    color: var(--text-primary);\n}\n\n.campaign-status {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    animation: pulse 2s ease infinite;\n    box-shadow: 0 0 0 0 currentColor;\n}\n\n.status-dot.live {\n    background: var(--success);\n    box-shadow: 0 0 12px var(--success);\n}\n\n.status-dot.paused {\n    background: var(--warning);\n    box-shadow: 0 0 8px var(--warning);\n}\n\n.status-dot.ended {\n    background: var(--text-tertiary);\n}\n\n@keyframes pulse {\n    0%, 100% { \n        opacity: 1;\n        box-shadow: 0 0 0 0 currentColor;\n    }\n    50% { \n        opacity: 0.7;\n        box-shadow: 0 0 12px 4px transparent;\n    }\n}\n\n.campaign-budget {\n    text-align: right;\n    position: relative;\n    z-index: 1;\n}\n\n.budget-label {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    margin-bottom: 6px;\n}\n\n.budget-value {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.budget-bar {\n    width: 100px;\n    height: 6px;\n    background: #f8f9fa;\n    border-radius: 3px;\n    margin-top: 10px;\n    overflow: hidden;\n    margin-left: auto;\n}\n\n.budget-fill {\n    height: 100%;\n    background: var(--accent-gradient);\n    border-radius: 3px;\n    transition: width 0.8s ease;\n    box-shadow: 0 0 12px rgba(255, 107, 74, 0.6);\n}\n\n.campaign-metrics {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n    position: relative;\n    z-index: 1;\n}\n\n.metric {\n    text-align: center;\n}\n\n.metric-value {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: var(--text-primary);\n}\n\n.metric-label {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Analytics Chart with Gradient */\n.analytics-section {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    padding: 36px;\n    margin-bottom: 48px;\n    animation: fadeInUp 0.6s ease 0.4s;\n    animation-fill-mode: both;\n    position: relative;\n    overflow: visible;\n}\n\n.analytics-section::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(circle at 80% 20%, rgba(255, 107, 74, 0.05) 0%, transparent 50%);\n    pointer-events: none;\n    border-radius: 16px;\n}\n\n.analytics-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 36px;\n    position: relative;\n    z-index: 1;\n}\n\n.chart-tabs {\n    display: flex;\n    gap: 12px;\n}\n\n.chart-tab {\n    padding: 10px 20px;\n    background: transparent;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    color: var(--text-secondary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.chart-tab::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.chart-tab:hover::before {\n    opacity: 0.1;\n}\n\n.chart-tab.active {\n    background: #f8f9fa;\n    border-color: transparent;\n    color: var(--text-primary);\n    position: relative;\n}\n\n.chart-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: var(--accent-gradient);\n}\n\n/* Chart tab labels - full on desktop, short on mobile */\n.chart-tab-full {\n    display: inline;\n}\n\n.chart-tab-short {\n    display: none;\n}\n\n.chart-container {\n    height: 320px;\n    position: relative;\n    background: \n        linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n#reportChart {\n    width: 100%;\n    height: 100%;\n}\n\n.chart-tooltip {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.9);\n    color: white;\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-size: 13px;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.2s;\n    z-index: 10;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n}\n\n.chart-tooltip.show {\n    opacity: 1;\n}\n\n.tooltip-date {\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: #FF6B4A;\n}\n\n.tooltip-value {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 4px;\n}\n\n.tooltip-label {\n    font-size: 11px;\n    color: #aaa;\n}\n\n/* Audience Intelligence */\n.audience-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 24px;\n    animation: fadeInUp 0.6s ease 0.5s;\n    animation-fill-mode: both;\n}\n\n.audience-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    padding: 32px;\n    position: relative;\n    overflow: hidden;\n}\n\n.audience-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(circle at 90% 10%, rgba(233, 75, 108, 0.05) 0%, transparent 60%);\n    pointer-events: none;\n}\n\n.audience-card h3 {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 20px;\n    margin-bottom: 28px;\n    position: relative;\n    display: inline-block;\n}\n\n.audience-card h3::after {\n    content: '';\n    position: absolute;\n    bottom: -8px;\n    left: 0;\n    width: 50px;\n    height: 2px;\n    background: var(--accent-gradient);\n    border-radius: 1px;\n}\n\n.segment-list {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    position: relative;\n    z-index: 1;\n}\n\n.segment-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 18px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    border: 1px solid transparent;\n}\n\n.segment-item:hover {\n    background: #fafbfc;\n    transform: translateX(6px);\n    border-color: rgba(255, 107, 74, 0.2);\n}\n\n.segment-info {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.segment-icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 10px;\n    background: var(--accent-gradient);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.segment-details h4 {\n    font-size: 15px;\n    font-weight: 700;\n    margin-bottom: 6px;\n}\n\n.segment-details p {\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n.segment-count {\n    text-align: right;\n}\n\n.segment-count-value {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 4px;\n    color: var(--text-primary);\n}\n\n.segment-count-label {\n    font-size: 11px;\n    color: var(--text-tertiary);\n}\n\n/* Top Creatives */\n.creative-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    position: relative;\n    z-index: 1;\n}\n\n.creative-item {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 18px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    border: 1px solid transparent;\n}\n\n.creative-item:hover {\n    background: #fafbfc;\n    border-color: rgba(142, 58, 154, 0.2);\n}\n\n.creative-rank {\n    font-size: 20px;\n    font-weight: 700;\n    width: 40px;\n    text-align: center;\n    color: var(--text-primary);\n}\n\n.creative-preview {\n    width: 64px;\n    height: 64px;\n    border-radius: 10px;\n    background: var(--accent-gradient);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    box-shadow: 0 4px 12px rgba(142, 58, 154, 0.3);\n}\n\n.creative-details {\n    flex: 1;\n}\n\n.creative-details h4 {\n    font-size: 15px;\n    font-weight: 700;\n    margin-bottom: 8px;\n}\n\n.creative-stats {\n    display: flex;\n    gap: 16px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n.creative-ctr {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--success);\n}\n\n/* Animations */\n@keyframes fadeInDown {\n    from {\n        opacity: 0;\n        transform: translateY(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n/* Responsive */\n@media (max-width: 1400px) {\n    .stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .campaign-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 1024px) {\n    .sidebar {\n        width: 240px;\n    }\n    \n    .main-content {\n        margin-left: 240px;\n        padding: 24px 32px;\n    }\n\n    .audience-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .sidebar {\n        transform: translateX(-100%);\n    }\n    \n    .main-content {\n        margin-left: 0;\n        padding: 16px;\n    }\n\n    .stats-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .campaign-metrics {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n    \n\n\n/* Variant 6: Segmented Control */\n.type-segmented {\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 4px;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 4px;\n}\n\n.type-segment {\n    padding: 12px 8px;\n    background: transparent;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    position: relative;\n}\n\n.type-segment svg {\n    width: 20px;\n    height: 20px;\n    color: var(--text-secondary);\n    transition: all 0.3s ease;\n}\n\n.type-segment-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    transition: all 0.3s ease;\n}\n\n.type-segment:hover {\n    background: rgba(255, 107, 74, 0.08);\n}\n\n.type-segment:hover svg,\n.type-segment:hover .type-segment-label {\n    color: var(--accent-orange);\n}\n\n.type-segment.active {\n    background: white;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.type-segment.active svg,\n.type-segment.active .type-segment-label {\n    color: var(--accent-orange);\n}\n\n/* Reports Layout */\n.reports-layout {\n    display: grid;\n    grid-template-columns: 380px minmax(0, 1fr);\n    gap: 24px;\n    align-items: start;\n}\n\n/* Filters Panel */\n.filters-panel {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 28px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n    position: sticky;\n    top: 24px;\n}\n\n.filter-section {\n    margin-bottom: 36px;\n}\n\n.filter-section:last-child {\n    margin-bottom: 0;\n}\n\n/* Section Headings - same as dashboard section-title */\n.section-heading {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 20px;\n    display: block;\n}\n\n/* Type Buttons - same as chart-tab */\n.type-buttons {\n    display: grid;\n    gap: 10px;\n}\n\n.type-button {\n    padding: 12px 16px;\n    background: transparent;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.type-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.type-button:hover::before {\n    opacity: 0.1;\n}\n\n.type-button.active {\n    background: #f8f9fa;\n    border-color: transparent;\n    color: var(--text-primary);\n}\n\n.type-button.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: var(--accent-gradient);\n}\n\n.type-button svg {\n    width: 18px;\n    height: 18px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Form Fields */\n.form-field {\n    margin-bottom: 16px;\n}\n\n.field-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 8px;\n}\n\n.field-select {\n    width: 100%;\n    padding: 13px 40px 13px 16px;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 500;\n    font-family: inherit;\n    background: white;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.2s;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236c757d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 16px center;\n}\n\n.field-select:hover {\n    border-color: #adb5bd;\n}\n\n.field-select:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);\n}\n\n/* Campaign Info */\n.info-box {\n    padding: 16px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.06), rgba(233, 75, 108, 0.06));\n    border-radius: 8px;\n    border-left: 3px solid var(--accent-orange);\n    font-size: 14px;\n    line-height: 1.7;\n    color: #495057;\n}\n\n.info-box div {\n    margin-bottom: 4px;\n}\n\n.info-box div:last-child {\n    margin-bottom: 0;\n}\n\n.info-box strong {\n    color: var(--text-primary);\n    font-weight: 600;\n}\n\n/* Period Buttons */\n.period-buttons {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n.period-button {\n    padding: 12px;\n    background: white;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #495057;\n    cursor: pointer;\n    transition: all 0.2s;\n    text-align: center;\n}\n\n.period-button:hover {\n    border-color: #adb5bd;\n}\n\n.period-button.active {\n    background: var(--accent-gradient);\n    border-color: transparent;\n    color: white;\n}\n\n/* Date Inputs */\n.date-fields {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.date-input {\n    width: 100%;\n    padding: 12px 14px;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    font-size: 14px;\n    font-family: inherit;\n    color: var(--text-primary);\n    transition: all 0.2s;\n}\n\n.date-input:hover {\n    border-color: #adb5bd;\n}\n\n.date-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.06);\n}\n\n/* Action Buttons (Reports page specific) */\n.action-buttons {\n    display: grid;\n    gap: 10px;\n}\n\n.action-buttons .btn-primary {\n    width: 100%;\n    padding: 15px 24px;\n    background: var(--accent-gradient);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.action-buttons .btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(255, 107, 74, 0.4);\n}\n\n.action-buttons .btn-secondary {\n    width: 100%;\n    padding: 15px 24px;\n    background: white;\n    color: #495057;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.action-buttons .btn-secondary:hover {\n    border-color: #adb5bd;\n    background: #f8f9fa;\n}\n\n.action-buttons .btn-primary svg,\n.action-buttons .btn-secondary svg {\n    width: 18px;\n    height: 18px;\n}\n\n\n/* Chart Section */\n.chart-section {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 28px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n    margin-bottom: 24px;\n}\n\n.chart-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.chart-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.chart-tabs {\n    display: flex;\n    gap: 12px;\n}\n\n.chart-tab {\n    padding: 10px 20px;\n    background: transparent;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    color: var(--text-secondary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.chart-tab::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.chart-tab:hover::before {\n    opacity: 0.1;\n}\n\n.chart-tab.active {\n    background: #f8f9fa;\n    border-color: transparent;\n    color: var(--text-primary);\n    position: relative;\n}\n\n.chart-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: var(--accent-gradient);\n}\n\n.chart-container {\n    height: 320px;\n    position: relative;\n    background: \n        linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n#reportChart {\n    width: 100%;\n    height: 100%;\n}\n\n.chart-tooltip {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.9);\n    color: white;\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-size: 13px;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.2s;\n    z-index: 10;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n}\n\n.chart-tooltip.show {\n    opacity: 1;\n}\n\n.tooltip-date {\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: #FF6B4A;\n}\n\n.tooltip-value {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 4px;\n}\n\n.tooltip-label {\n    font-size: 11px;\n    color: #aaa;\n}\n\n/* Results */\n.results-area {\n    display: none;\n    /* Grid item, so min-width defaults to auto and it takes its content's width,\n       overflowing its own track — minmax(0, 1fr) on .reports-layout sizes the\n       TRACK but does not make the item shrink. Without this the summary grid\n       claimed the width it wanted and pushed the whole document sideways\n       (measured 1719px against a 1250px viewport), which no overflow container\n       further down can undo: nothing is ever too narrow, so nothing scrolls. */\n    min-width: 0;\n}\n\n.results-area.visible {\n    display: block;\n}\n\n/* Report Card */\n.report-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 32px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n    min-width: 0;   /* same reason as .results-area above */\n}\n\n.report-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 28px;\n}\n\n.report-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--text-primary);\n    position: relative;\n    padding-bottom: 12px;\n}\n\n.report-title::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 60px;\n    height: 3px;\n    background: var(--accent-gradient);\n    border-radius: 2px;\n}\n\n.report-period {\n    font-size: 14px;\n    color: var(--text-secondary);\n}\n\n/* Table */\n/* The money columns pushed the table past its card. It scrolls sideways inside\n   its own box now rather than widening the page. */\n.report-table-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.report-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n/* A figure like \"₸ 1 293,81\" was breaking after the symbol once the column got\n   tight — with the scroll in place the cells can keep their natural width. */\n.report-table th,\n.report-table td {\n    white-space: nowrap;\n}\n\n/* The one column that may be long and IS safe to clip: it sets its own width. */\n.report-table td.val-wrap {\n    white-space: normal;\n}\n\n.report-table thead {\n    background: #f8f9fa;\n}\n\n.report-table th {\n    padding: 18px;\n    text-align: left;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    border-bottom: 2px solid #e9ecef;\n}\n\n.report-table td {\n    padding: 20px 18px;\n    font-size: 16px;\n    color: #495057;\n    border-bottom: 1px solid #f1f3f5;\n}\n\n.report-table tbody tr:hover {\n    background: #f8f9fa;\n}\n\n.report-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.val-big {\n    font-weight: 600;\n    color: var(--text-primary);\n    font-size: 17px;\n}\n\n.val-positive {\n    color: var(--success);\n    font-weight: 600;\n}\n\n.val-negative {\n    color: var(--danger);\n    font-weight: 600;\n}\n\n@media (max-width: 1200px) {\n    .reports-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .filters-panel {\n        position: static;\n    }\n}\n\n/* Pagination Arrows */\n.pagination-arrow {\n    position: relative;\n    overflow: hidden;\n}\n\n.pagination-arrow::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.pagination-arrow:not(:disabled):hover {\n    border-color: var(--accent-orange) !important;\n    transform: scale(1.05);\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.2);\n}\n\n.pagination-arrow:not(:disabled):hover::before {\n    opacity: 0.1;\n}\n\n.pagination-arrow:not(:disabled):hover svg {\n    stroke: var(--accent-purple) !important;\n}\n\n.pagination-arrow:not(:disabled):active {\n    transform: scale(0.95);\n}\n\n/* Sortable Table Headers */\n.report-table th[style*=\"cursor: pointer\"] {\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n.report-table th[style*=\"cursor: pointer\"]:hover {\n    color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.05);\n}\n\n.report-table th[style*=\"cursor: pointer\"]:hover span {\n    opacity: 1 !important;\n    color: var(--accent-orange);\n}\n\n/* ========================================\n   MOBILE RESPONSIVE STYLES\n   ======================================== */\n\n/* Mobile Header */\n.mobile-header {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 60px;\n    background: var(--bg-card);\n    border-bottom: 1px solid var(--border-color);\n    z-index: 100;\n    padding: 0 16px;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.mobile-header-logo {\n    display: flex;\n    align-items: center;\n}\n\n.mobile-header-logo img {\n    height: 32px;\n    width: auto;\n}\n\n.mobile-header-logo .mobile-logo-icon {\n    height: 36px;\n    width: 36px;\n    border-radius: 8px;\n}\n\n/* Mobile Menu Button */\n.mobile-menu-btn {\n    display: none;\n    width: 40px;\n    height: 40px;\n    background: transparent;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s;\n}\n\n.mobile-menu-btn:hover {\n    background: var(--bg-tertiary);\n}\n\n.mobile-menu-btn svg {\n    width: 22px;\n    height: 22px;\n    color: var(--text-primary);\n}\n\n/* Sidebar Overlay */\n.sidebar-overlay {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.sidebar-overlay.visible {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* ========================================\n   TABLET (iPad) - 768px to 1024px\n   ======================================== */\n@media (max-width: 1024px) {\n    /* Prevent horizontal scroll */\n    html, body {\n        overflow-x: hidden;\n        max-width: 100vw;\n    }\n\n    /* Mobile header */\n    .mobile-header {\n        display: flex;\n        z-index: 101;\n    }\n\n    .mobile-menu-btn {\n        display: flex;\n    }\n\n    /* Overlay */\n    .sidebar-overlay {\n        display: block;\n        z-index: 100;\n    }\n\n    /* Sidebar as drawer */\n    .sidebar {\n        position: fixed;\n        left: 0;\n        top: 0;\n        height: 100vh;\n        width: 280px;\n        transform: translateX(-100%);\n        transition: transform 0.3s ease;\n        z-index: 102;\n        background: #fafbfc;\n        padding-top: 70px;\n    }\n\n    /* Скрыть логотип в сайдбаре - он есть в хедере */\n    .sidebar .logo {\n        display: none;\n    }\n\n    .sidebar.open {\n        transform: translateX(0);\n    }\n\n    .main-content {\n        margin-left: 0;\n        padding: 76px 20px 20px 20px;\n        max-width: 100%;\n        box-sizing: border-box;\n    }\n\n    .reports-layout {\n        grid-template-columns: 1fr;\n        gap: 20px;\n        max-width: 100%;\n    }\n\n    .filters-panel {\n        position: static;\n        padding: 20px;\n        max-width: 100%;\n        box-sizing: border-box;\n    }\n\n    .type-segmented {\n        grid-template-columns: repeat(5, 1fr);\n    }\n\n    /* Results area */\n    .results-area {\n        max-width: 100%;\n    }\n\n    /* Report card */\n    .report-card {\n        max-width: 100%;\n        box-sizing: border-box;\n    }\n\n    /* Таблица - скролл внутри карточки */\n    .report-table {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    /* Таблицы на планшете - на всю ширину */\n    .report-card {\n        width: 100%;\n    }\n\n    .report-table {\n        width: 100% !important;\n        min-width: 100%;\n        display: table;\n    }\n\n    .report-table th {\n        padding: 16px 14px;\n        font-size: 13px;\n    }\n\n    .report-table td {\n        padding: 18px 14px;\n        font-size: 17px;\n    }\n\n    .val-big {\n        font-size: 18px;\n    }\n\n    .val-big {\n        font-size: 15px;\n    }\n}\n\n/* ========================================\n   TABLET ONLY - 769px to 1024px\n   Form fields in 2 columns\n   ======================================== */\n@media (min-width: 769px) and (max-width: 1024px) {\n    /* All filter sections use flexbox for potential 2-column layout */\n    .filter-section {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 12px;\n        align-items: flex-end;\n    }\n\n    /* Section headings take full width */\n    .filter-section > .section-heading,\n    .filter-section > h3 {\n        width: 100%;\n        flex-basis: 100%;\n    }\n\n    /* Form fields - 2 per row when there are multiple */\n    .filter-section > .form-field {\n        flex: 1 1 calc(50% - 6px);\n        min-width: calc(50% - 6px);\n        max-width: calc(50% - 6px);\n        margin-bottom: 0 !important;\n        margin-top: 0 !important;\n    }\n\n    /* Single form-field takes full width */\n    .filter-section > .form-field:only-of-type {\n        flex: 1 1 100%;\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n    /* Period buttons and date fields take full width */\n    .filter-section > .period-buttons,\n    .filter-section > .date-fields,\n    .filter-section > .type-segmented,\n    .filter-section > .action-buttons {\n        width: 100%;\n        flex-basis: 100%;\n    }\n\n    /* Date fields - ensure they stay in a row */\n    .date-fields {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n/* ========================================\n   MOBILE - max 768px\n   ======================================== */\n@media (max-width: 768px) {\n    /* Main content */\n    .main-content {\n        padding: 72px 12px 12px 12px;\n        max-width: 100%;\n        box-sizing: border-box;\n    }\n\n    /* Report card */\n    .report-card {\n        max-width: 100%;\n        box-sizing: border-box;\n    }\n\n    /* Header adjustments */\n    .header {\n        margin-bottom: 16px;\n        padding-bottom: 12px;\n    }\n\n    .header-title h1 {\n        font-size: 22px;\n    }\n\n    .header-subtitle {\n        font-size: 13px;\n    }\n\n    /* Reports layout */\n    .reports-layout {\n        gap: 16px;\n    }\n\n    /* Filters panel - компактнее */\n    .filters-panel {\n        padding: 16px;\n        border-radius: 10px;\n    }\n\n    .filter-section {\n        margin-bottom: 20px;\n    }\n\n    .section-heading {\n        font-size: 11px;\n        margin-bottom: 12px;\n    }\n\n    /* Type segmented - компактный с подписями */\n    .type-segmented {\n        grid-template-columns: repeat(5, 1fr);\n        padding: 4px;\n        gap: 4px;\n        background: var(--bg-tertiary);\n        border-radius: 10px;\n    }\n\n    .type-segment {\n        padding: 10px 4px;\n        gap: 4px;\n        border-radius: 8px;\n        background: transparent;\n        border: none;\n    }\n\n    .type-segment.active {\n        background: white;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    }\n\n    .type-segment svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .type-segment-label {\n        font-size: 9px;\n    }\n\n    /* Period buttons - в ряд */\n    .period-buttons {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 6px;\n    }\n\n    .period-button {\n        padding: 10px 8px;\n        font-size: 12px;\n    }\n\n    /* Date fields */\n    .date-fields {\n        gap: 8px;\n    }\n\n    .date-input {\n        padding: 10px 12px;\n        font-size: 14px;\n    }\n\n    .field-select {\n        padding: 10px 32px 10px 12px;\n        font-size: 14px;\n    }\n\n    .field-label {\n        font-size: 12px;\n        margin-bottom: 6px;\n    }\n\n    /* Action buttons - в ряд */\n    .action-buttons {\n        gap: 8px;\n        display: flex;\n        flex-direction: row;\n    }\n\n    .action-buttons .btn-primary,\n    .action-buttons .btn-secondary {\n        flex: 1;\n        padding: 12px 10px;\n        font-size: 13px;\n    }\n\n    /* Report card */\n    .report-card {\n        padding: 16px;\n        border-radius: 10px;\n    }\n\n    .report-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n        margin-bottom: 16px;\n    }\n\n    .report-title {\n        font-size: 18px;\n        padding-bottom: 8px;\n    }\n\n    .report-period {\n        font-size: 13px;\n    }\n\n    /* Summary stats - компактные 3 в ряд */\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] {\n        grid-template-columns: repeat(3, 1fr) !important;\n        gap: 6px !important;\n        margin-bottom: 14px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div {\n        padding: 10px 6px !important;\n        border-radius: 8px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div > div:first-child {\n        font-size: 16px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div > div:last-child {\n        font-size: 9px !important;\n    }\n\n    /* Chart section */\n    .chart-section {\n        padding: 12px;\n        margin-bottom: 16px;\n    }\n\n    .chart-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        margin-bottom: 16px;\n    }\n\n    .chart-title {\n        font-size: 15px;\n    }\n\n    /* Chart tabs - segmented control стиль */\n    .chart-tabs {\n        width: 100%;\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        gap: 4px;\n        background: var(--bg-tertiary);\n        border-radius: 8px;\n        padding: 4px;\n    }\n\n    .chart-tab {\n        padding: 10px 8px;\n        font-size: 12px;\n        text-align: center;\n        border: none;\n        background: transparent;\n        border-radius: 6px;\n        color: var(--text-secondary);\n    }\n\n    .chart-tab::before,\n    .chart-tab::after {\n        display: none !important;\n    }\n\n    .chart-tab.active {\n        background: white;\n        color: var(--accent-orange);\n        font-weight: 600;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    }\n\n    .chart-tab.active::after {\n        display: none !important;\n    }\n\n    /* Короткие названия на мобильных */\n    .chart-tab-full {\n        display: none;\n    }\n\n    .chart-tab-short {\n        display: inline;\n    }\n\n    .chart-container {\n        height: 160px;\n        padding: 4px;\n    }\n\n    /* Report card - contain overflow */\n    .report-card {\n        max-width: 100%;\n        overflow: hidden;\n    }\n\n    /* Table - компактная и читаемая */\n    .report-table {\n        display: table;\n        width: 100%;\n        border-radius: 8px;\n        overflow: hidden;\n    }\n\n    .report-table thead {\n        background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%);\n    }\n\n    .report-table th {\n        padding: 10px 6px;\n        font-size: 9px;\n        white-space: nowrap;\n        letter-spacing: 0.5px;\n        border-bottom: 2px solid #e9ecef;\n    }\n\n    .report-table td {\n        padding: 12px 6px;\n        font-size: 13px;\n        white-space: nowrap;\n    }\n\n    /* Zebra striping для лучшей читаемости */\n    .report-table tbody tr:nth-child(even) {\n        background: rgba(0,0,0,0.02);\n    }\n\n    .report-table tbody tr:hover {\n        background: rgba(255, 107, 74, 0.05);\n    }\n\n    /* Первая колонка (дата) - акцент */\n    .report-table td:first-child {\n        font-weight: 600;\n        color: #2c3e50;\n    }\n\n    .val-big {\n        font-size: 13px;\n        font-weight: 600;\n    }\n\n    /* CTR положительный - зелёный */\n    .val-positive {\n        color: #27ae60;\n        font-weight: 600;\n    }\n\n    /* Pagination */\n    .report-card > div[style*=\"justify-content: space-between\"] {\n        flex-direction: column !important;\n        gap: 12px !important;\n        align-items: center !important;\n    }\n}\n\n/* ========================================\n   SMALL MOBILE - max 480px\n   ======================================== */\n@media (max-width: 480px) {\n    .main-content {\n        padding: 70px 12px 12px 12px;\n    }\n\n    .header-title h1 {\n        font-size: 20px;\n    }\n\n    .header-subtitle {\n        font-size: 12px;\n    }\n\n    /* Filters более компактные */\n    .filters-panel {\n        padding: 12px;\n    }\n\n    .filter-section {\n        margin-bottom: 16px;\n    }\n\n    /* Type segmented - компактный с подписями */\n    .type-segmented {\n        grid-template-columns: repeat(5, 1fr);\n        gap: 3px;\n        padding: 3px;\n    }\n\n    .type-segment {\n        padding: 8px 2px;\n        gap: 3px;\n    }\n\n    .type-segment svg {\n        width: 14px;\n        height: 14px;\n    }\n\n    .type-segment-label {\n        font-size: 8px;\n    }\n\n    /* Period buttons */\n    .period-buttons {\n        gap: 4px;\n    }\n\n    .period-button {\n        padding: 8px 6px;\n        font-size: 11px;\n    }\n\n    /* Date fields - в колонку */\n    .date-fields {\n        grid-template-columns: 1fr;\n        gap: 8px;\n    }\n\n    /* Inputs */\n    .field-select,\n    .date-input {\n        padding: 10px 12px;\n        font-size: 14px;\n    }\n\n    /* Buttons */\n    .btn-primary,\n    .btn-secondary {\n        padding: 10px 14px;\n        font-size: 13px;\n    }\n\n    /* Report card */\n    .report-card {\n        padding: 12px;\n    }\n\n    /* Summary stats - ещё компактнее */\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] {\n        gap: 4px !important;\n        margin-bottom: 12px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div {\n        padding: 8px 4px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div > div:first-child {\n        font-size: 14px !important;\n    }\n\n    .report-card > div[style*=\"grid-template-columns: repeat(3\"] > div > div:last-child {\n        font-size: 8px !important;\n    }\n\n    /* Chart - segmented control на 480px */\n    .chart-tabs {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 3px;\n        padding: 3px;\n    }\n\n    .chart-tab {\n        padding: 8px 4px;\n        font-size: 10px;\n    }\n\n    .chart-tab::before,\n    .chart-tab::after,\n    .chart-tab.active::after {\n        display: none !important;\n    }\n\n    .chart-container {\n        height: 140px;\n    }\n\n    /* Table - ещё компактнее */\n    .report-table th {\n        padding: 8px 3px;\n        font-size: 8px;\n    }\n\n    .report-table td {\n        padding: 10px 3px;\n        font-size: 12px;\n    }\n\n    .val-big {\n        font-size: 12px;\n    }\n\n    /* Pagination buttons */\n    .pagination-arrow,\n    .report-card button[style*=\"width: 36px\"] {\n        width: 34px !important;\n        height: 34px !important;\n    }\n}\n\n/* ========================================\n   CAMPAIGN SEARCH AUTOCOMPLETE\n   ======================================== */\n\n.campaign-search-container {\n    position: relative;\n    width: 100%;\n}\n\n.campaign-search-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.campaign-search-input-wrapper .search-icon {\n    position: absolute;\n    left: 14px;\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n    pointer-events: none;\n    transition: color 0.2s;\n}\n\n.campaign-search-input {\n    width: 100%;\n    padding: 13px 40px 13px 42px;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 500;\n    font-family: inherit;\n    background: white;\n    color: var(--text-primary);\n    transition: all 0.2s;\n}\n\n.campaign-search-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.campaign-search-input:hover {\n    border-color: #adb5bd;\n}\n\n.campaign-search-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);\n}\n\n.campaign-search-input:focus + .search-icon,\n.campaign-search-input-wrapper:focus-within .search-icon {\n    color: var(--accent-orange);\n}\n\n/* Loading spinner */\n.search-spinner {\n    position: absolute;\n    right: 14px;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #e9ecef;\n    border-top-color: var(--accent-orange);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Clear button */\n.search-clear-btn {\n    position: absolute;\n    right: 10px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f1f3f5;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    padding: 0;\n    transition: all 0.2s;\n}\n\n.search-clear-btn:hover {\n    background: #e9ecef;\n}\n\n.search-clear-btn svg {\n    width: 14px;\n    height: 14px;\n    color: var(--text-secondary);\n}\n\n.search-clear-btn:hover svg {\n    color: var(--text-primary);\n}\n\n/* Dropdown */\n.campaign-search-dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    max-height: 320px;\n    overflow-y: auto;\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    z-index: 1000;\n    animation: dropdownSlide 0.2s ease;\n}\n\n@keyframes dropdownSlide {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Dropdown items */\n.campaign-search-item {\n    padding: 14px 16px;\n    cursor: pointer;\n    transition: background 0.15s;\n    border-bottom: 1px solid #f1f3f5;\n}\n\n.campaign-search-item:last-child {\n    border-bottom: none;\n}\n\n.campaign-search-item:hover {\n    background: #f8f9fa;\n}\n\n.campaign-search-item.selected {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.08));\n}\n\n.campaign-search-item.selected:hover {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12), rgba(233, 75, 108, 0.12));\n}\n\n.campaign-search-item-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 4px;\n    line-height: 1.3;\n}\n\n.archived-label {\n    font-size: 12px;\n    font-weight: 400;\n    color: #9ca3af;\n    margin-left: 6px;\n}\n\n.campaign-search-item-advertiser {\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n/* Empty state */\n.campaign-search-empty {\n    padding: 20px 16px;\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 14px;\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n    .campaign-search-input {\n        padding: 10px 36px 10px 38px;\n        font-size: 14px;\n    }\n\n    .campaign-search-input-wrapper .search-icon {\n        left: 12px;\n        width: 16px;\n        height: 16px;\n    }\n\n    .search-clear-btn {\n        right: 8px;\n        width: 22px;\n        height: 22px;\n    }\n\n    .search-clear-btn svg {\n        width: 12px;\n        height: 12px;\n    }\n\n    .campaign-search-dropdown {\n        max-height: 280px;\n    }\n\n    .campaign-search-item {\n        padding: 12px 14px;\n    }\n\n    .campaign-search-item-name {\n        font-size: 14px;\n    }\n\n    .campaign-search-item-advertiser {\n        font-size: 12px;\n    }\n}\n\n/* ========================================\n   CAMPAIGNS PAGE STYLES\n   ======================================== */\n\n/* Filters Bar */\n.filters-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    gap: 20px;\n}\n\n.filters-left {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.filters-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Status Filter Dropdown */\n.status-filter-select {\n    height: 40px;\n    padding: 0 32px 0 14px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: white url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='%236b7280'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\") no-repeat right 10px center;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    min-width: 140px;\n}\n\n.status-filter-select:hover {\n    border-color: #d1d5db;\n}\n\n.status-filter-select:focus {\n    outline: none;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n/* Status Segmented Control */\n.status-segmented {\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 4px;\n    display: inline-flex;\n    gap: 4px;\n}\n\n.status-segment {\n    padding: 10px 20px;\n    background: transparent;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    font-family: inherit;\n}\n\n.status-segment:hover {\n    background: rgba(255, 107, 74, 0.08);\n}\n\n.status-segment.active {\n    background: white;\n    color: var(--text-primary);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.segment-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 6px;\n    background: rgba(0, 0, 0, 0.06);\n    border-radius: 11px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.status-segment.active .segment-count {\n    background: var(--accent-gradient);\n    color: white;\n}\n\n/* View Toggle */\n.view-toggle {\n    display: flex;\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 4px;\n}\n\n.view-btn {\n    padding: 8px 12px;\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.view-btn svg {\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n}\n\n.view-btn:hover svg {\n    color: var(--text-secondary);\n}\n\n.view-btn.active {\n    background: white;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.08);\n}\n\n.view-btn.active svg {\n    color: var(--accent-orange);\n}\n\n/* Search Box */\n.search-box {\n    position: relative;\n    width: 280px;\n}\n\n.search-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n    pointer-events: none;\n}\n\n.search-input {\n    width: 100%;\n    padding: 12px 14px 12px 44px;\n    border: 1px solid #dee2e6;\n    border-radius: 10px;\n    font-size: 14px;\n    font-family: inherit;\n    color: var(--text-primary);\n    background: white;\n    transition: all 0.2s;\n}\n\n.search-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);\n}\n\n/* Period Select */\n.period-select {\n    padding: 10px 36px 10px 14px;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: inherit;\n    background: white;\n    color: var(--text-primary);\n    cursor: pointer;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236c757d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    transition: all 0.2s;\n}\n\n.period-select:hover {\n    border-color: #adb5bd;\n}\n\n.period-select:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);\n}\n\n/* Campaigns Table Card */\n.campaigns-table-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    overflow: visible;\n    animation: fadeInUp 0.4s ease;\n}\n\n@keyframes fadeInUp {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n/* ============ CARD VIEW ============ */\n.campaigns-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n    gap: 24px;\n    animation: fadeInUp 0.4s ease;\n}\n\n.campaigns-cards .campaign-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 10px;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n}\n\n.campaigns-cards .campaign-card .card-ai {\n    margin-top: auto;\n}\n\n.campaigns-cards .campaign-card::after {\n    display: none;\n}\n\n.campaigns-cards .campaign-card:hover,\n.campaigns-cards .campaign-card.menu-active {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\n}\n\n/* Card with unpublished changes */\n.campaigns-cards .campaign-card.has-unpublished {\n    overflow: hidden;\n    border-color: rgba(255, 107, 74, 0.5);\n    box-shadow: 0 0 0 1px rgba(255, 107, 74, 0.2);\n}\n\n.campaigns-cards .campaign-card.has-unpublished:hover {\n    border-color: rgba(255, 107, 74, 0.7);\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(255, 107, 74, 0.3);\n}\n\n.campaigns-cards .campaign-card:hover::after {\n    display: none;\n}\n\n.campaigns-cards .campaign-card.action-loading {\n    pointer-events: none;\n}\n\n.card-loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.9);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    z-index: 100;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary);\n}\n\n.card-loading-spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid #f1f3f5;\n    border-top-color: var(--brand-orange);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 12px 12px 0;\n    /* keeps a long campaign name from butting against the status badge */\n    gap: 10px;\n}\n\n.campaign-name-card {\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n    /* Campaign names are often long underscore-joined strings with no break\n       opportunity. Without min-width:0 the flex item refuses to shrink below\n       its content and the name runs under the status badge. */\n    flex: 1;\n    min-width: 0;\n}\n\n.campaign-name-card .campaign-name-text {\n    min-width: 0;\n}\n\n.card-title {\n    font-size: 15px;\n    font-weight: 800;\n    color: var(--text-primary);\n    margin-bottom: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.card-subtitle {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.card-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    position: relative;\n    z-index: 10;\n    /* the badge and the menu keep their size; only the name shrinks */\n    flex-shrink: 0;\n}\n\n.card-actions .actions-dropdown {\n    position: relative;\n}\n\n.card-actions .actions-btn {\n    pointer-events: auto;\n}\n\n/* Status Badge */\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.status-badge.live {\n    background: rgba(46, 204, 113, 0.1);\n    color: var(--success);\n}\n\n.status-badge.paused {\n    background: rgba(108, 117, 125, 0.1);\n    color: var(--text-secondary);\n}\n\n.status-badge-icon {\n    width: 12px;\n    height: 12px;\n}\n\n.status-badge.ended {\n    background: rgba(108, 117, 125, 0.1);\n    color: var(--text-secondary);\n}\n\n.status-badge .status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.status-badge .status-dot.live {\n    background: var(--success);\n    box-shadow: 0 0 8px var(--success);\n    animation: statusPulse 2s ease infinite;\n}\n\n/* Corner Ribbon for Unpublished Changes */\n.corner-ribbon {\n    position: absolute;\n    top: 18px;\n    left: -40px;\n    width: 150px;\n    padding: 5px 0;\n    background: linear-gradient(135deg, #ff6b4a 0%, #e94b6c 100%);\n    color: white;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    text-align: center;\n    transform: rotate(-45deg);\n    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.35);\n    z-index: 15;\n    pointer-events: none;\n}\n\n/* Card Dates Row */\n.card-dates-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 12px 8px;\n}\n\n.card-dates {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.card-dates svg {\n    color: var(--text-tertiary);\n}\n\n/* Demographics Link */\n.demographics-link {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.demographics-link:hover {\n    color: var(--text-primary);\n    background: var(--bg-tertiary);\n}\n\n.demographics-link svg {\n    color: inherit;\n}\n\n/* Demographics Content */\n.demographics-content {\n    padding: 8px 20px 0;\n    min-height: 320px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.demographics-loading,\n.demographics-empty,\n.demographics-no-data {\n    text-align: center;\n    color: var(--text-secondary);\n    padding: 40px 20px;\n    font-size: 13px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.demographics-no-data-small {\n    text-align: center;\n    color: var(--text-secondary);\n    padding: 20px 10px;\n    font-size: 12px;\n    opacity: 0.7;\n}\n\n.demographics-charts {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: flex-end;\n}\n\n.demographics-chart-section {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1;\n    align-self: flex-start;\n    position: relative;\n}\n\n.demographics-chart-title.age-title {\n    position: absolute;\n    top: 0;\n    left: 130px;\n    transform: translateX(-50%);\n}\n\n.demographics-chart-section.gender-section {\n    flex: 0 0 auto;\n    align-items: center;\n}\n\n.demographics-chart-title {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    flex-shrink: 0;\n}\n\n.demographics-bars {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.demographics-bar-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.demographics-bar-label {\n    width: 70px;\n    font-size: 12px;\n    color: var(--text-secondary);\n    flex-shrink: 0;\n}\n\n.demographics-bar-track {\n    flex: 1;\n    height: 20px;\n    background: var(--bg-tertiary);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.demographics-bar-fill {\n    height: 100%;\n    border-radius: 4px;\n    transition: width 0.3s ease;\n}\n\n.demographics-bar-fill.age {\n    background: linear-gradient(90deg, #FF6B4A 0%, #E94B6C 100%);\n}\n\n.demographics-bar-fill.gender {\n    background: linear-gradient(90deg, #8E3A9A 0%, #6B5CE7 100%);\n}\n\n/* Age Pie Chart */\n.age-pie-container {\n    position: relative;\n    height: 290px;\n    margin-top: 22px;\n}\n\n.age-pie-chart {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.age-pie-tooltip {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.85);\n    color: white;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    pointer-events: none;\n    z-index: 100;\n    transform: translate(-50%, -100%);\n}\n\n.age-pie-segment {\n    transition: opacity 0.2s ease;\n    cursor: pointer;\n}\n\n.age-pie-segment:hover {\n    opacity: 0.8;\n}\n\n.age-pie-label {\n    font-size: 14px;\n    font-weight: 600;\n    fill: white;\n    pointer-events: none;\n}\n\n.age-pie-legend {\n    position: absolute;\n    bottom: 10px;\n    left: 250px;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.age-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n}\n\n.age-legend-color {\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n    flex-shrink: 0;\n}\n\n.age-legend-label {\n    color: var(--text-secondary);\n}\n\n/* Gender Single Bar */\n.gender-single-bar {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 4px;\n}\n\n.gender-label {\n    font-size: 12px;\n    color: var(--text-secondary);\n    flex-shrink: 0;\n}\n\n.gender-bar-track {\n    flex: 1;\n    height: 32px;\n    background: var(--bg-tertiary);\n    border-radius: 4px;\n    display: flex;\n    position: relative;\n}\n\n.gender-bar-female {\n    height: 100%;\n    background: linear-gradient(90deg, #E94B6C 0%, #FFAA80 100%);\n    transition: width 0.3s ease;\n    border-right: 2px solid white;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-left: 8px;\n    cursor: pointer;\n    border-radius: 4px 0 0 4px;\n}\n\n.gender-bar-male {\n    height: 100%;\n    background: linear-gradient(90deg, #C77DFF 0%, #6B2D78 100%);\n    transition: width 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding-right: 8px;\n    cursor: pointer;\n    border-radius: 0 4px 4px 0;\n}\n\n.gender-bar-tooltip {\n    position: absolute;\n    bottom: calc(100% + 8px);\n    background: rgba(0, 0, 0, 0.85);\n    color: white;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.15s ease, visibility 0.15s ease;\n    pointer-events: none;\n    z-index: 100;\n}\n\n.gender-bar-tooltip::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 0, 0, 0.85);\n}\n\n.gender-bar-tooltip.female-tooltip {\n    left: 25%;\n    transform: translateX(-50%);\n}\n\n.gender-bar-tooltip.male-tooltip {\n    right: 25%;\n    left: auto;\n    transform: translateX(50%);\n}\n\n.gender-bar-female:hover ~ .gender-bar-tooltip.female-tooltip,\n.gender-bar-male:hover ~ .gender-bar-tooltip.male-tooltip {\n    opacity: 1;\n    visibility: visible;\n}\n\n.gender-bar-text {\n    font-size: 11px;\n    font-weight: 600;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0,0,0,0.3);\n    white-space: nowrap;\n}\n\n/* Gender Vertical Bar */\n.gender-vertical-bar {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.gender-bar-track-vertical {\n    width: 44px;\n    height: 265px;\n    background: var(--bg-tertiary);\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n}\n\n.gender-bar-female-v {\n    width: 100%;\n    background: linear-gradient(180deg, #E94B6C 0%, #FFAA80 100%);\n    transition: height 0.3s ease, opacity 0.2s ease;\n    border-bottom: 2px solid white;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding-top: 25%;\n    cursor: pointer;\n    border-radius: 4px 4px 0 0;\n    position: relative;\n}\n\n.gender-bar-male-v {\n    width: 100%;\n    background: linear-gradient(180deg, #C77DFF 0%, #6B2D78 100%);\n    transition: height 0.3s ease, opacity 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n    padding-bottom: 25%;\n    cursor: pointer;\n    border-radius: 0 0 4px 4px;\n    position: relative;\n}\n\n.gender-bar-text-v {\n    font-size: 11px;\n    font-weight: 600;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0,0,0,0.3);\n}\n\n.gender-bar-tooltip-v {\n    position: absolute;\n    right: calc(100% + 8px);\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(0, 0, 0, 0.85);\n    color: white;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.15s ease, visibility 0.15s ease;\n    pointer-events: none;\n    z-index: 100;\n}\n\n.gender-bar-female-v:hover,\n.gender-bar-male-v:hover {\n    opacity: 0.8;\n}\n\n.gender-bar-female-v:hover .gender-bar-tooltip-v,\n.gender-bar-male-v:hover .gender-bar-tooltip-v {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* When only one gender is shown - full rounded corners */\n.gender-bar-only {\n    border-radius: 4px !important;\n}\n\n.gender-label-v {\n    font-size: 11px;\n    color: var(--text-secondary);\n    text-align: center;\n}\n\n.demographics-bar-value {\n    width: 50px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-primary);\n    text-align: right;\n    flex-shrink: 0;\n}\n\n.demographics-total {\n    margin-top: 8px;\n    padding-top: 12px;\n    border-top: 1px solid var(--border-color);\n    font-size: 12px;\n    color: var(--text-secondary);\n    text-align: center;\n}\n\n/* Card Chart */\n.card-chart {\n    padding: 0 20px;\n    margin: 8px 0;\n    position: relative;\n    height: 100px;\n    overflow: visible;\n}\n\n.card-chart-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    cursor: crosshair;\n}\n\n.card-sparkline-svg {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n    display: block;\n}\n\n/* Chart dots (HTML elements for campaign cards) */\n.card-chart-wrapper .chart-dot {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    z-index: 5;\n}\n\n.card-chart-wrapper .chart-dot.hover-dot {\n    width: 14px;\n    height: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.card-chart-wrapper .chart-dot-inner {\n    width: 8px;\n    height: 8px;\n    background: white;\n    border-radius: 50%;\n}\n\n.card-chart-wrapper .chart-dot.end-dot {\n    width: 10px;\n    height: 10px;\n}\n\n/* Chart Tooltip */\n.chart-tooltip {\n    position: absolute;\n    background: rgba(26, 26, 26, 0.95);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 11px;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.15s;\n    z-index: 100;\n    white-space: nowrap;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n    transform: translateX(-50%);\n}\n\n.chart-tooltip.show {\n    opacity: 1;\n}\n\n.chart-tooltip-date {\n    font-weight: 700;\n    color: #FF6B4A;\n    margin-bottom: 4px;\n}\n\n.chart-tooltip-value {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.chart-tooltip-change {\n    font-size: 10px;\n    margin-top: 2px;\n}\n\n.chart-tooltip-change.positive { color: var(--success); }\n.chart-tooltip-change.negative { color: var(--danger); }\n\n.card-chart-empty {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n    font-size: 13px;\n}\n\n/* Card Metrics Grid */\n.card-metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n    padding: 16px 20px;\n}\n\n.metric-box {\n    text-align: center;\n    padding: 12px 8px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    /* Grid items default to min-width:auto, so a long conversion-goal name would\n       blow the track out and distort the whole 4-column metrics grid (squishing\n       Impressions/Clicks/Spend). Pin to 0 so every track keeps its 1fr share and\n       the name ellipsizes instead. */\n    min-width: 0;\n}\n\n.metric-box .metric-label {\n    font-size: 10px;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 6px;\n}\n\n.metric-big {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 4px;\n}\n\n/* Top-2 conversion goals under the Conversions metric */\n.metric-top-conv {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin-top: 4px;\n}\n.top-conv-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 8px;\n    font-size: 11px;\n}\n.top-conv-name {\n    color: var(--text-secondary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    /* Allow the flex item to shrink below its content width so ellipsis engages. */\n    min-width: 0;\n}\n.top-conv-count {\n    font-weight: 700;\n    color: var(--text-primary);\n    flex-shrink: 0;\n    font-variant-numeric: tabular-nums;\n}\n\n.metric-change {\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.metric-change.positive {\n    color: var(--success);\n}\n\n.metric-change.negative {\n    color: var(--danger);\n}\n\n.metric-change.neutral {\n    color: #6c757d;\n}\n\n.metric-box.clickable {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.metric-box.clickable:hover {\n    background: #eef0f2;\n}\n\n.metric-box.clickable.selected {\n    box-shadow: inset 0 -2px 0 var(--accent-orange);\n}\n\n/* Card Costs */\n.card-costs {\n    display: flex;\n    gap: 8px;\n    padding: 0 20px 16px;\n}\n\n.cost-box {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    font-size: 12px;\n}\n\n.cost-box .cost-label {\n    color: var(--text-tertiary);\n}\n\n.cost-box .cost-value {\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n/* CPC/CPM drive the card chart, same as the metric boxes above. */\n.cost-box.clickable {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.cost-box.clickable:hover {\n    background: #eef0f2;\n}\n\n.cost-box.clickable.selected {\n    box-shadow: inset 0 -2px 0 var(--accent-orange);\n}\n\n.cost-box.highlight {\n    background: linear-gradient(135deg, rgba(46, 204, 113, 0.1), rgba(46, 204, 113, 0.05));\n    border: 1px solid rgba(46, 204, 113, 0.2);\n}\n\n.cost-box.highlight.warning {\n    background: linear-gradient(135deg, rgba(243, 156, 18, 0.1), rgba(243, 156, 18, 0.05));\n    border: 1px solid rgba(243, 156, 18, 0.2);\n}\n\n/* Card Budget */\n.card-budget {\n    padding: 0 20px 16px;\n}\n\n.card-budget .budget-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2px;\n    font-size: 13px;\n}\n\n.card-budget .budget-label {\n    color: var(--text-secondary);\n}\n\n.card-budget .budget-amount {\n    font-weight: 600;\n}\n\n.card-budget .budget-bar {\n    width: 100%;\n    height: 6px;\n    background: #f1f3f5;\n    border-radius: 3px;\n    overflow: hidden;\n    margin-top: 0;\n}\n\n.card-budget .budget-progress {\n    height: 100%;\n    background: var(--accent-gradient);\n    border-radius: 3px;\n}\n\n.card-budget .budget-progress.warning {\n    background: var(--danger);\n}\n\n/* Card AI - Pacing Alerts */\n.card-ai {\n    padding: 16px 30px;\n    background: linear-gradient(135deg, rgba(142, 58, 154, 0.06), rgba(142, 58, 154, 0.02));\n    border-top: 1px solid rgba(142, 58, 154, 0.1);\n    border-radius: 0 0 12px 12px;\n    margin: 0 -10px -10px -10px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.card-ai.warning {\n    background: linear-gradient(135deg, rgba(243, 156, 18, 0.08), rgba(243, 156, 18, 0.02));\n    border-top-color: rgba(243, 156, 18, 0.15);\n}\n\n.ai-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--accent-purple);\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.card-ai.warning .ai-badge {\n    color: var(--warning);\n}\n\n.ai-badge svg {\n    flex-shrink: 0;\n}\n\n.ai-recommendation {\n    font-size: 13px;\n    line-height: 1.5;\n    color: var(--text-secondary);\n    margin: 0;\n}\n\n.card-ai:hover {\n    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));\n}\n\n.card-ai.warning:hover {\n    background: linear-gradient(135deg, rgba(243, 156, 18, 0.12), rgba(243, 156, 18, 0.04));\n}\n\n.ai-action {\n    display: inline-block;\n    margin-left: 8px;\n    color: var(--accent-purple);\n    font-weight: 600;\n}\n\n.card-ai.warning .ai-action {\n    color: var(--warning);\n}\n\n.card-ai.danger {\n    background: linear-gradient(135deg, rgba(231, 76, 60, 0.15), rgba(192, 57, 43, 0.08));\n    border-top: 2px solid rgba(231, 76, 60, 0.5);\n}\n\n.card-ai.danger .ai-badge {\n    color: #c0392b;\n    font-weight: 600;\n    background: #fff;\n    padding: 4px 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.card-ai.danger:hover {\n    background: linear-gradient(135deg, rgba(231, 76, 60, 0.2), rgba(192, 57, 43, 0.12));\n}\n\n.card-ai.danger .ai-action {\n    color: #c0392b;\n    font-weight: 600;\n}\n\n.card-ai.danger .ai-recommendation {\n    color: #1a1a1a;\n}\n\n/* Paused style - purple/neutral */\n.card-ai.paused {\n    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));\n    border-top: 2px solid rgba(142, 58, 154, 0.3);\n}\n\n.card-ai.paused .ai-badge {\n    color: #8E3A9A;\n    font-weight: 600;\n    background: #fff;\n    padding: 4px 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.card-ai.paused:hover {\n    background: linear-gradient(135deg, rgba(142, 58, 154, 0.15), rgba(142, 58, 154, 0.08));\n}\n\n.card-ai.paused .ai-action {\n    color: #8E3A9A;\n    font-weight: 600;\n}\n\n.card-ai.paused .ai-recommendation {\n    color: #1a1a1a;\n}\n\n/* OK style - neutral gray */\n.card-ai.ok {\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n}\n\n.card-ai.ok .ai-badge {\n    color: #6c757d;\n    font-weight: 600;\n    background: #fff;\n    padding: 4px 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.card-ai.ok:hover {\n    background: #f1f3f5;\n}\n\n.card-ai.ok .ai-recommendation {\n    color: #495057;\n}\n\n.card-ai.ok .ai-action {\n    display: none;\n}\n\n/* Campaigns Table */\n.campaigns-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-radius: 16px;\n    overflow: hidden;\n    table-layout: fixed;\n}\n\n/* Fixed column widths */\n.campaigns-table th:nth-child(1),\n.campaigns-table td:nth-child(1) { width: 28%; } /* Campaign */\n.campaigns-table th:nth-child(2),\n.campaigns-table td:nth-child(2) { width: 10%; } /* Period */\n.campaigns-table th:nth-child(3),\n.campaigns-table td:nth-child(3) { width: 12%; } /* Trend */\n.campaigns-table th:nth-child(4),\n.campaigns-table td:nth-child(4) { width: 14%; } /* Metrics */\n.campaigns-table th:nth-child(5),\n.campaigns-table td:nth-child(5) { width: 8%; } /* CPM */\n.campaigns-table th:nth-child(6),\n.campaigns-table td:nth-child(6) { width: 8%; } /* CPC */\n.campaigns-table th:nth-child(7),\n.campaigns-table td:nth-child(7) { width: 14%; } /* Budget */\n.campaigns-table th:nth-child(8),\n.campaigns-table td:nth-child(8) { width: 6%; } /* Actions */\n\n.campaigns-table thead {\n    background: #f8f9fa;\n}\n\n.campaigns-table thead tr:first-child th:first-child {\n    border-top-left-radius: 16px;\n}\n\n.campaigns-table thead tr:first-child th:last-child {\n    border-top-right-radius: 16px;\n}\n\n.campaigns-table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 16px;\n}\n\n.campaigns-table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 16px;\n}\n\n.campaigns-table th {\n    padding: 14px 12px;\n    text-align: left;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    border-bottom: 1px solid #e9ecef;\n    white-space: nowrap;\n}\n\n.campaigns-table td {\n    padding: 12px;\n    border-bottom: 1px solid #f1f3f5;\n    vertical-align: middle;\n}\n\n.campaigns-table tbody tr {\n    transition: background 0.2s;\n}\n\n.campaigns-table tbody tr:hover {\n    background: #fafbfc;\n}\n\n.campaigns-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.campaigns-table tbody tr.row-loading {\n    opacity: 0.5;\n    pointer-events: none;\n    position: relative;\n}\n\n.campaigns-table tbody tr.row-loading td:first-child::before {\n    content: '';\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    border: 2px solid #f1f3f5;\n    border-top-color: var(--brand-orange);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n/* Campaign Name Cell */\n.campaign-name-cell {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    min-width: 250px;\n}\n\n.campaign-name-cell .status-dot {\n    margin-right: -2px;\n}\n\n.campaign-name-cell .campaign-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.campaign-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.campaign-subtitle {\n    font-size: 11px;\n    color: var(--text-tertiary);\n}\n\n/* Status Indicator (Table view) */\n.status-indicator {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n}\n\n.status-indicator .status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n}\n\n.status-indicator .status-dot.live {\n    background: var(--success, #2ecc71);\n    box-shadow: 0 0 8px var(--success, #2ecc71);\n    animation: statusPulse 2s ease infinite;\n}\n\n@keyframes statusPulse {\n    0%, 100% {\n        opacity: 1;\n        box-shadow: 0 0 8px var(--success);\n    }\n    50% {\n        opacity: 0.6;\n        box-shadow: 0 0 12px 2px var(--success);\n    }\n}\n\n/* Pause Icon */\n.status-pause-icon {\n    width: 14px;\n    height: 14px;\n    color: var(--text-tertiary, #adb5bd);\n}\n\n/* Ended Icon (hourglass) */\n.status-ended-icon {\n    width: 14px;\n    height: 14px;\n    color: var(--text-tertiary, #adb5bd);\n}\n\n/* Type Indicator */\n.type-indicator {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    flex-shrink: 0;\n}\n\n.type-indicator svg {\n    width: 14px;\n    height: 14px;\n}\n\n.type-indicator.display {\n    background: rgba(52, 152, 219, 0.1);\n    color: #3498db;\n}\n\n.type-indicator.video {\n    background: rgba(155, 89, 182, 0.1);\n    color: #9b59b6;\n}\n\n.type-indicator.audio {\n    background: rgba(39, 174, 96, 0.1);\n    color: #27ae60;\n}\n\n/* Date Range */\n.date-range {\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.date-start {\n    color: var(--text-primary);\n    font-weight: 600;\n    margin-bottom: 2px;\n}\n\n.date-end {\n    color: var(--text-tertiary);\n}\n\n/* Chart Cell (Sparkline) */\n.chart-cell {\n    position: relative;\n    width: 120px;\n    height: 40px;\n}\n\n.chart-cell.empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n    font-size: 12px;\n}\n\n.mini-chart {\n    width: 100%;\n    height: 100%;\n    cursor: crosshair;\n}\n\n.chart-tooltip {\n    position: absolute;\n    background: rgba(26, 26, 26, 0.95);\n    color: white;\n    padding: 6px 10px;\n    border-radius: 6px;\n    font-size: 11px;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.15s;\n    z-index: 100;\n    white-space: nowrap;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    transform: translateX(-50%);\n}\n\n.chart-tooltip.show {\n    opacity: 1;\n}\n\n.chart-tooltip-date {\n    font-weight: 700;\n    color: var(--accent-orange);\n    margin-bottom: 2px;\n}\n\n.chart-tooltip-value {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.chart-tooltip-change {\n    font-size: 10px;\n    margin-top: 2px;\n}\n\n.chart-tooltip-change.positive {\n    color: #2ecc71;\n}\n\n.chart-tooltip-change.negative {\n    color: #e74c3c;\n}\n\n/* Metrics Cell - Campaigns Table */\n.metrics-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    width: 90px;\n}\n\n.metrics-cell .metric-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    line-height: 1.3;\n}\n\n.metrics-cell .metric-label {\n    font-size: 10px;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.metrics-cell .metric-value {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-primary);\n    text-align: right;\n}\n\n/* CPA/CPM/CPC Cell */\n.campaigns-table th:nth-child(5),\n.campaigns-table th:nth-child(6) {\n    text-align: center;\n}\n\n.cpa-cell {\n    text-align: center;\n}\n\n.cpa-value {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.cpa-trend {\n    font-size: 11px;\n    font-weight: 600;\n    margin-top: 2px;\n}\n\n.cpa-trend.positive {\n    color: var(--success);\n}\n\n.cpa-trend.negative {\n    color: var(--danger);\n}\n\n/* Budget Info (Table view) */\n.budget-info {\n    min-width: 130px;\n}\n\n.budget-info .budget-values {\n    display: flex;\n    gap: 4px;\n    font-size: 12px;\n    margin-bottom: 6px;\n}\n\n.budget-info .budget-spent {\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.budget-info .budget-total {\n    color: var(--text-tertiary);\n}\n\n.budget-info .budget-bar {\n    width: 100%;\n    height: 5px;\n    background: #f1f3f5;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.budget-info .budget-progress {\n    height: 100%;\n    background: var(--accent-gradient);\n    border-radius: 3px;\n}\n\n.budget-info .budget-progress.warning {\n    background: var(--danger);\n}\n\n.budget-warning-icon {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 4px;\n    color: var(--danger);\n}\n\n.budget-warning-icon svg {\n    width: 14px;\n    height: 14px;\n}\n\n.card-budget .budget-warning-icon {\n    margin-left: 0;\n    margin-right: 6px;\n    vertical-align: middle;\n    position: relative;\n    top: -1px;\n}\n\n.budget-info.warning .budget-spent {\n    color: var(--danger);\n}\n\n/* Performance Metrics */\n.perf-metrics {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.perf-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n}\n\n.perf-label {\n    color: var(--text-tertiary);\n    font-size: 10px;\n    text-transform: uppercase;\n}\n\n.perf-value {\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n/* Spend Cell */\n.spend-cell {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n/* Actions Dropdown */\n.actions-dropdown {\n    position: relative;\n}\n\n.actions-btn {\n    width: 32px;\n    height: 32px;\n    border: 1px solid transparent;\n    background: transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.actions-btn svg {\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n}\n\n.actions-btn:hover {\n    background: #f8f9fa;\n    border-color: #e9ecef;\n}\n\n.actions-btn:hover svg {\n    color: var(--text-secondary);\n}\n\n.actions-menu {\n    position: absolute;\n    right: 0;\n    top: 100%;\n    margin-top: 4px;\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 10px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n    min-width: 180px;\n    z-index: 100;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-8px);\n    transition: all 0.2s ease;\n}\n\n.actions-dropdown.open .actions-menu {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    z-index: 1000;\n}\n\n.action-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 10px 14px;\n    border: none;\n    background: none;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: background 0.15s;\n    text-align: left;\n}\n\n.action-item:first-child {\n    border-radius: 10px 10px 0 0;\n}\n\n.action-item:last-child {\n    border-radius: 0 0 10px 10px;\n}\n\n.action-item:hover {\n    background: #f8f9fa;\n}\n\n.action-item svg {\n    width: 16px;\n    height: 16px;\n    color: var(--text-secondary);\n}\n\n.action-item.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.action-item.disabled:hover {\n    background: none;\n}\n\n.action-item.danger {\n    color: var(--danger);\n}\n\n.action-item.danger svg {\n    color: var(--danger);\n}\n\n.action-item.resume svg {\n    color: var(--success);\n}\n\n.action-item.publish {\n    background: linear-gradient(135deg, #ff6b4a 0%, #e94b6c 100%);\n    color: #ffffff;\n    font-weight: 500;\n}\n\n.action-item.publish svg {\n    color: #ffffff;\n}\n\n.action-item.publish:hover {\n    background: linear-gradient(135deg, #ff5a3a 0%, #d83a5c 100%);\n}\n\n.action-item.delete {\n    color: #dc3545;\n}\n\n.action-item.delete svg {\n    color: #dc3545;\n}\n\n.action-item.loading {\n    opacity: 0.7;\n    cursor: wait;\n}\n\n.action-item.loading:hover {\n    background: none;\n}\n\n.action-divider {\n    height: 1px;\n    background: #f1f3f5;\n    margin: 4px 0;\n}\n\n/* Campaign Dates */\n.campaign-dates {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.date-separator {\n    color: #dee2e6;\n}\n\n/* Metric Cell */\n.metric-cell {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.metric-cell.spend {\n    color: var(--accent-purple);\n}\n\n/* Campaign Action Button */\n.campaign-action-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    color: var(--text-secondary);\n    background: transparent;\n    border: 1px solid transparent;\n    transition: all 0.2s;\n}\n\n.campaign-action-btn:hover {\n    background: #f8f9fa;\n    border-color: #e9ecef;\n    color: var(--accent-orange);\n}\n\n/* Loading & Error States */\n.loading-state,\n.error-message,\n.empty-state {\n    padding: 48px 24px;\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 15px;\n}\n\n.error-message {\n    background: rgba(231, 76, 60, 0.08);\n    color: #c0392b;\n    border-radius: 8px;\n    margin-bottom: 24px;\n}\n\n.empty-state {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n}\n\n/* Mobile Responsive for Campaigns */\n@media (max-width: 1024px) {\n    .filters-bar {\n        flex-direction: column;\n        gap: 12px;\n        align-items: stretch;\n    }\n\n    .filters-left {\n        width: 100%;\n    }\n\n    .filters-right {\n        width: 100%;\n    }\n\n    .status-segmented {\n        width: 100%;\n        justify-content: flex-start;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: none;\n    }\n\n    .status-segmented::-webkit-scrollbar {\n        display: none;\n    }\n\n    .search-box {\n        width: 100%;\n    }\n\n    .period-select {\n        width: 100%;\n    }\n\n    .campaigns-table-card {\n        overflow-x: auto;\n    }\n\n    .campaigns-table {\n        min-width: 700px;\n    }\n\n    .campaigns-cards {\n        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n        gap: 12px;\n    }\n\n    /* Modal on tablet */\n    .modal-container {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 0;\n    }\n}\n\n@media (max-width: 768px) {\n    /* Filters Bar - compact */\n    .filters-bar {\n        gap: 10px;\n        padding: 12px 0;\n    }\n\n    .status-segmented {\n        background: var(--bg-tertiary);\n        border-radius: 8px;\n        padding: 4px;\n        gap: 4px;\n    }\n\n    .status-segment {\n        padding: 10px 12px;\n        font-size: 12px;\n        border-radius: 6px;\n        white-space: nowrap;\n        flex-shrink: 0;\n        border: none;\n        background: transparent;\n    }\n\n    .status-segment.active {\n        background: white;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    }\n\n    .segment-count {\n        min-width: 18px;\n        height: 18px;\n        font-size: 10px;\n    }\n\n    .search-box {\n        height: 44px;\n    }\n\n    .search-input {\n        font-size: 14px;\n    }\n\n    /* Campaign Cards - compact */\n    .campaigns-cards {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .campaigns-cards .campaign-card {\n        padding: 0;\n        border-radius: 10px;\n    }\n\n    .card-header {\n        padding: 12px 12px 0;\n    }\n\n    .campaign-name-card {\n        gap: 8px;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .type-indicator {\n        width: 28px;\n        height: 28px;\n        flex-shrink: 0;\n    }\n\n    .type-indicator svg {\n        width: 14px;\n        height: 14px;\n    }\n\n    .card-title {\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 180px;\n    }\n\n    .card-subtitle {\n        font-size: 11px;\n    }\n\n    .card-actions {\n        gap: 6px;\n    }\n\n    .status-badge {\n        padding: 4px 8px;\n        font-size: 10px;\n        gap: 4px;\n    }\n\n    .status-badge-icon {\n        width: 10px;\n        height: 10px;\n    }\n\n    .actions-btn {\n        width: 32px;\n        height: 32px;\n    }\n\n    /* Card Dates Row - compact */\n    .card-dates-row {\n        padding: 10px 12px 6px;\n    }\n\n    .card-dates {\n        font-size: 11px;\n        gap: 4px;\n    }\n\n    .card-dates svg {\n        width: 12px;\n        height: 12px;\n    }\n\n    .demographics-link {\n        font-size: 11px;\n        padding: 4px 8px;\n    }\n\n    .demographics-link svg {\n        width: 12px;\n        height: 12px;\n    }\n\n    /* Card Chart - smaller on mobile */\n    .card-chart {\n        padding: 0 12px;\n        margin: 4px 0;\n        height: 60px;\n    }\n\n    /* wrapper and svg inherit height: 100% from parent */\n\n    /* Metrics Grid - 4 in row, compact */\n    .card-metrics-grid {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 4px;\n        margin: 8px 12px;\n        padding: 10px;\n        background: var(--bg-tertiary);\n        border-radius: 8px;\n    }\n\n    .metric-box {\n        padding: 0;\n        text-align: center;\n        background: transparent;\n        border: none;\n    }\n\n    .metric-box.clickable {\n        border-radius: 6px;\n        padding: 6px 4px;\n    }\n\n    .metric-box.clickable.selected {\n        background: white;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n    }\n\n    .metric-label {\n        font-size: 9px;\n        margin-bottom: 2px;\n    }\n\n    .metric-big {\n        font-size: 13px;\n    }\n\n    .metric-change {\n        font-size: 9px;\n        padding: 1px 4px;\n        margin-top: 2px;\n    }\n\n    /* Card Costs - compact row */\n    .card-costs {\n        margin: 0 12px;\n        padding: 8px 0;\n        gap: 6px;\n        flex-wrap: nowrap;\n    }\n\n    .cost-box {\n        flex: 1;\n        padding: 6px 8px;\n        min-width: 0;\n    }\n\n    .cost-label {\n        font-size: 9px;\n    }\n\n    .cost-value {\n        font-size: 12px;\n    }\n\n    /* Card Budget - compact */\n    .card-budget {\n        margin: 0 12px 12px;\n        padding: 10px;\n    }\n\n    .card-budget .budget-header {\n        margin-bottom: 6px;\n    }\n\n    .card-budget .budget-label {\n        font-size: 10px;\n    }\n\n    .card-budget .budget-amount {\n        font-size: 11px;\n    }\n\n    .card-budget .budget-bar {\n        height: 4px;\n    }\n\n    /* Card AI - mobile */\n    .card-ai {\n        margin: 0;\n        padding: 12px;\n        border-radius: 0 0 10px 10px;\n    }\n\n    .card-ai .ai-badge {\n        font-size: 10px;\n    }\n\n    .card-ai .ai-recommendation {\n        font-size: 12px;\n    }\n\n    /* Demographics - mobile layout */\n    .demographics-content {\n        padding: 10px 12px;\n        min-height: unset;\n        justify-content: flex-start;\n    }\n\n    .demographics-charts {\n        display: grid;\n        grid-template-columns: 1fr 70px;\n        gap: 8px;\n        align-items: start;\n    }\n\n    .demographics-chart-section {\n        min-width: 0;\n    }\n\n    .demographics-chart-section.gender-section {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .demographics-chart-title {\n        font-size: 10px;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        color: var(--text-secondary);\n        margin-bottom: 8px;\n        text-align: center;\n    }\n\n    /* Age chart - compact mobile */\n    .age-pie-container {\n        position: relative;\n        height: 200px;\n        margin-top: 0;\n        overflow: visible;\n    }\n\n    .age-pie-chart {\n        position: absolute;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%) scale(0.68);\n        transform-origin: top center;\n    }\n\n    .age-pie-legend {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: 3px 10px;\n        justify-content: center;\n        padding: 0 4px;\n    }\n\n    .age-legend-item {\n        font-size: 9px;\n        gap: 3px;\n    }\n\n    .age-legend-color {\n        width: 7px;\n        height: 7px;\n        border-radius: 1px;\n    }\n\n    /* Gender - fixed height, no overflow */\n    .demographics-chart-section.gender-section {\n        max-height: 200px;\n        overflow: hidden;\n    }\n\n    .gender-vertical-bar {\n        height: auto;\n        max-height: 170px;\n        min-height: unset;\n    }\n\n    .gender-bar-track-vertical {\n        height: 100px !important;\n        flex-shrink: 0;\n        border-radius: 6px;\n    }\n\n    .gender-bar-text-v {\n        font-size: 10px;\n    }\n\n    .gender-label-v {\n        font-size: 9px;\n        margin: 2px 0;\n    }\n\n    /* Modal - full screen on mobile */\n    .modal-container {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 0;\n    }\n\n    .modal-header {\n        padding: 16px;\n    }\n\n    .modal-title {\n        font-size: 18px;\n    }\n\n    .modal-subtitle {\n        font-size: 12px;\n    }\n\n    .modal-content {\n        padding: 0;\n    }\n\n    /* Ad Groups Table - horizontal scroll */\n    .ad-groups-table {\n        font-size: 12px;\n    }\n\n    .ad-groups-table th,\n    .ad-groups-table td {\n        padding: 10px 8px;\n    }\n\n    .ad-group-title {\n        font-size: 13px;\n    }\n\n    .ad-group-subtitle {\n        font-size: 10px;\n    }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n    .card-title {\n        font-size: 13px;\n        max-width: 140px;\n    }\n\n    .card-subtitle {\n        font-size: 10px;\n    }\n\n    .type-indicator {\n        width: 24px;\n        height: 24px;\n    }\n\n    .type-indicator svg {\n        width: 12px;\n        height: 12px;\n    }\n\n    .status-badge {\n        padding: 3px 6px;\n        font-size: 9px;\n    }\n\n    .card-dates {\n        font-size: 10px;\n    }\n\n    .card-chart {\n        height: 50px;\n    }\n\n    .card-metrics-grid {\n        padding: 8px;\n    }\n\n    .metric-label {\n        font-size: 8px;\n    }\n\n    .metric-big {\n        font-size: 11px;\n    }\n\n    .metric-change {\n        font-size: 8px;\n    }\n\n    .cost-label {\n        font-size: 8px;\n    }\n\n    .cost-value {\n        font-size: 11px;\n    }\n\n    .card-budget {\n        padding: 8px;\n    }\n\n    .card-budget .budget-label,\n    .card-budget .budget-amount {\n        font-size: 10px;\n    }\n\n    /* Hide demographics pie chart on very small screens, show simplified */\n    .age-pie-container {\n        transform: scale(0.7);\n    }\n\n    .modal-header {\n        padding: 12px;\n    }\n\n    .modal-close {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n/* ============ AD GROUPS SLIDE PANEL ============ */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(2px);\n    z-index: 10000;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n}\n\n.modal-overlay.active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.modal-container {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    background: white;\n    border-radius: 20px 0 0 20px;\n    width: 1000px;\n    max-width: 90%;\n    overflow: hidden;\n    box-shadow: -8px 0 40px rgba(0, 0, 0, 0.15);\n    transform: translateX(100%);\n    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.modal-overlay.active .modal-container {\n    transform: translateX(0);\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 32px;\n    border-bottom: 1px solid var(--border-color);\n    background: #fafbfc;\n}\n\n.modal-title-section {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.modal-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.modal-subtitle {\n    font-size: 14px;\n    color: var(--text-secondary);\n}\n\n.modal-close {\n    width: 40px;\n    height: 40px;\n    border: none;\n    background: transparent;\n    border-radius: 10px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.modal-close svg {\n    width: 24px;\n    height: 24px;\n    color: var(--text-tertiary);\n}\n\n.modal-close:hover {\n    background: #f1f3f5;\n}\n\n.modal-close:hover svg {\n    color: var(--text-primary);\n}\n\n.modal-content {\n    padding: 24px 32px;\n    overflow-y: auto;\n    height: calc(100vh - 90px);\n    position: relative;\n}\n\n.modal-loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.modal-loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f1f3f5;\n    border-top-color: var(--brand-gradient-start, #FF6B4A);\n    border-radius: 50%;\n    animation: modal-spin 0.8s linear infinite;\n}\n\n@keyframes modal-spin {\n    to { transform: rotate(360deg); }\n}\n\n/* Ad Groups Table */\n.ad-groups-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.ad-groups-table thead {\n    background: #f8f9fa;\n}\n\n.ad-groups-table th {\n    padding: 14px 16px;\n    text-align: left;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    border-bottom: 1px solid #e9ecef;\n    white-space: nowrap;\n}\n\n.ad-groups-table td {\n    padding: 16px;\n    border-bottom: 1px solid #f1f3f5;\n    vertical-align: middle;\n}\n\n.ad-groups-table tbody tr {\n    transition: background 0.2s;\n}\n\n.ad-groups-table tbody tr:hover {\n    background: #fafbfc;\n}\n\n.ad-groups-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.ad-groups-table tbody tr.inactive > td:not(:last-child) {\n    opacity: 0.5;\n}\n\n.ad-groups-table tbody tr.inactive > td:last-child {\n    opacity: 1;\n}\n\n/* Ad Group Name Cell */\n.ad-group-name-cell {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    min-width: 220px;\n}\n\n.ad-group-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.ad-group-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ad-group-subtitle {\n    font-size: 11px;\n    color: var(--text-tertiary);\n}\n\n/* Ad Groups Loading/Empty States */\n.ad-groups-loading,\n.ad-groups-empty {\n    padding: 60px 20px;\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 14px;\n}\n\n/* Metric Cell */\n.ad-groups-table .metric-cell {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    white-space: nowrap;\n}\n\n/* Metrics Cell (combined Impr, Clicks, CTR) */\n.metrics-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    width: 80px;\n}\n\n.metrics-cell .metric-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    line-height: 1.4;\n}\n\n.metrics-cell .metric-label {\n    font-size: 10px;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.metrics-cell .metric-value {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 0;\n}\n\n/* No Budget */\n.no-budget {\n    color: var(--text-tertiary);\n}\n\n/* Clickable Subtitle */\n.clickable-subtitle {\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.clickable-subtitle:hover {\n    color: var(--accent-orange);\n}\n\n/* Status Indicator for Ad Groups */\n.ad-group-name-cell .status-indicator {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n.ad-group-name-cell .status-indicator .status-dot {\n    width: 8px;\n    height: 8px;\n}\n\n.ad-group-name-cell .status-icon {\n    width: 16px;\n    height: 16px;\n}\n\n.ad-group-name-cell .status-icon.paused {\n    color: var(--text-tertiary);\n}\n\n.ad-group-name-cell .status-icon.ended {\n    color: var(--text-tertiary);\n}\n\n.ad-group-name-cell .status-icon.scheduled {\n    color: #f59e0b;\n}\n\n/* ============ EDIT CAMPAIGN PAGE ============ */\n\n/* Back Link */\n.back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--text-tertiary);\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 500;\n    transition: color 0.2s;\n    margin-bottom: 8px;\n}\n\n.back-link svg {\n    width: 18px;\n    height: 18px;\n}\n\n.back-link:hover {\n    color: var(--accent-orange);\n}\n\n/* Edit Header */\n.edit-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 36px;\n    position: relative;\n    padding-bottom: 24px;\n}\n\n.edit-header::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 120px;\n    height: 3px;\n    background: var(--accent-gradient);\n    border-radius: 2px;\n}\n\n.edit-header .header-title h1 {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 36px;\n    font-weight: 700;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.5px;\n    color: var(--text-primary);\n}\n\n.edit-header .header-subtitle {\n    color: var(--text-secondary);\n    font-size: 15px;\n    margin: 0;\n}\n\n/* Edit Layout */\n.edit-layout {\n    display: flex;\n    gap: 24px;\n    align-items: flex-start;\n    --text-primary: #111111;\n    --text-secondary: #555555;\n    --text-tertiary: #888888;\n}\n\n/* Left Panel - Campaign */\n.campaign-panel {\n    width: 340px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.panel-section {\n    background: white;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.section-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 20px;\n}\n\n.section-header .section-title {\n    margin-bottom: 0;\n}\n\n/* Form Fields */\n.form-field {\n    margin-bottom: 16px;\n}\n\n.form-field:last-child {\n    margin-bottom: 0;\n}\n\n.field-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.field-input {\n    width: 100%;\n    padding: 12px 14px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-size: 14px;\n    font-family: inherit;\n    color: var(--text-primary);\n    background: white;\n    transition: all 0.2s;\n    box-sizing: border-box;\n}\n\n.field-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.field-input:disabled,\n.field-input.disabled {\n    background: #f5f5f7;\n    color: var(--text-tertiary);\n    cursor: not-allowed;\n    border-color: #e5e5e8;\n}\n\n/* Required empty field - red border */\n.field-input.required-empty,\n.field-select.required-empty {\n    border-color: #e53935;\n}\n\n.field-input.required-empty:focus {\n    border-color: #e53935;\n    box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);\n}\n\n/* Input with prefix - required empty */\n.input-with-prefix:has(.field-input.required-empty) {\n    border-color: #e53935;\n}\n\n.input-wrapper {\n    display: block;\n    width: 100%;\n}\n\n.field-select {\n    width: 100%;\n    padding: 12px 14px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-size: 14px;\n    font-family: inherit;\n    color: var(--text-primary);\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%238888a4'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    padding-right: 36px;\n}\n\n.field-select:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.form-row.form-row-3 {\n    grid-template-columns: 1fr 1.5fr 1fr;\n}\n\n/* Conversion Goals Selector for CPA optimization */\n.conversion-goals-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);\n    border-radius: 10px;\n    border: 1px solid rgba(255, 107, 74, 0.12);\n    margin-bottom: 16px;\n    position: relative;\n}\n\n.conversion-goals-row .goals-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #666;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n}\n\n.conversion-goals-row .goals-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    flex: 1;\n}\n\n.conversion-goals-row .goal-chip {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 20px;\n    font-size: 13px;\n    color: #444;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    user-select: none;\n}\n\n.conversion-goals-row .goal-chip:hover {\n    border-color: #FF6B4A;\n    background: rgba(255, 107, 74, 0.05);\n}\n\n.conversion-goals-row .goal-chip.selected {\n    background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n    border-color: transparent;\n    color: #fff;\n    font-weight: 500;\n}\n\n.conversion-goals-row .goal-chip .goal-check {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 1.5px solid currentColor;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.conversion-goals-row .goal-chip.selected .goal-check {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.6);\n}\n\n.conversion-goals-row .goal-chip.selected .goal-check::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    background: #fff;\n    border-radius: 50%;\n}\n\n.conversion-goals-row.error {\n    border: 2px solid #d32f2f;\n    background: #fff5f5;\n    box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.15);\n}\n\n.conversion-goals-row.error .goals-label {\n    color: #d32f2f;\n    font-weight: 700;\n}\n\n.conversion-goals-row.error .goals-label::before {\n    content: '⚠ ';\n}\n\n.conversion-goals-row.error::after {\n    content: 'Select at least one goal';\n    position: absolute;\n    right: 16px;\n    font-size: 12px;\n    color: #d32f2f;\n    font-weight: 500;\n}\n\n.form-row-flex {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 16px;\n    align-items: flex-end;\n}\n\n.form-row-flex .form-field {\n    margin-bottom: 0;\n}\n\n.form-field-auto {\n    flex-shrink: 0;\n}\n\n.form-field-grow {\n    flex: 1;\n    min-width: 0;\n}\n\n.form-row .form-field {\n    margin-bottom: 0;\n    min-width: 0;   /* grid items must shrink to fit the panel, not overflow it */\n}\n\n/* Frequency Input */\n.frequency-input {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.frequency-count {\n    width: 70px;\n    text-align: center;\n}\n\n.frequency-text {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    white-space: nowrap;\n}\n\n.frequency-period {\n    width: auto;\n    min-width: 100px;\n}\n\n/* Status Dots in Edit Page */\n.edit-layout .status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.edit-layout .status-dot.live {\n    background: var(--success);\n    box-shadow: 0 0 8px var(--success);\n    animation: editStatusPulse 2s ease infinite;\n}\n\n@keyframes editStatusPulse {\n    0%, 100% {\n        opacity: 1;\n        box-shadow: 0 0 8px var(--success);\n    }\n    50% {\n        opacity: 0.6;\n        box-shadow: 0 0 12px 2px var(--success);\n    }\n}\n\n.edit-layout .status-dot.paused {\n    background: var(--warning);\n}\n\n/* Status Toggle */\n.status-toggle {\n    display: flex;\n    gap: 8px;\n}\n\n.status-btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 16px;\n    background: white;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.status-btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n.status-btn:hover {\n    border-color: var(--text-tertiary);\n}\n\n.status-btn.active {\n    background: linear-gradient(135deg, rgba(255,107,74,0.1), rgba(233,75,108,0.1));\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n}\n\n.status-btn.ended {\n    background: var(--bg-secondary);\n    border-color: var(--border-color);\n    color: var(--text-tertiary);\n    cursor: default;\n}\n\n.status-btn.ended:hover {\n    border-color: var(--border-color);\n}\n\n/* Line Item Type Toggle */\n.line-item-type-toggle {\n    display: flex;\n    gap: 8px;\n}\n\n.line-item-type-btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: white;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.line-item-type-btn svg {\n    width: 20px;\n    height: 20px;\n}\n\n.line-item-type-btn:hover {\n    border-color: var(--text-tertiary);\n    background: var(--bg-secondary);\n}\n\n.line-item-type-btn.active {\n    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));\n    border-color: var(--accent-orange);\n    color: var(--accent-red);\n}\n\n.line-item-type-btn.active svg {\n    stroke: var(--accent-orange);\n}\n\n.line-item-type-toggle.disabled .line-item-type-btn {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.line-item-type-toggle.disabled .line-item-type-btn.active {\n    opacity: 1;\n}\n\n.line-item-type-toggle.disabled .line-item-type-btn:hover {\n    border-color: var(--border-color);\n    background: white;\n}\n\n.line-item-type-toggle.disabled .line-item-type-btn.active:hover {\n    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));\n    border-color: var(--accent-orange);\n}\n\n.line-item-type-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    background: linear-gradient(135deg, rgba(255,107,74,0.08), rgba(233,75,108,0.08));\n    border: 1px solid rgba(255,107,74,0.2);\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n.line-item-type-badge svg {\n    width: 18px;\n    height: 18px;\n    stroke: var(--accent-orange);\n}\n\n/* Ad Groups List in Edit Page */\n.edit-layout .ad-groups-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    overflow-y: auto;\n    max-height: 470px;\n}\n\n.edit-layout .ad-group-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n    background: #fafbfc;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.edit-layout .ad-group-item:hover {\n    background: #f5f5fa;\n}\n\n.edit-layout .ad-group-item.active {\n    background: white;\n    border-color: var(--accent-orange);\n    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.1);\n}\n\n.edit-layout .ad-group-item.paused {\n    opacity: 0.6;\n}\n\n.edit-layout .ad-group-item.ended {\n    opacity: 0.5;\n}\n\n.edit-layout .ad-group-item.scheduled {\n    background: rgba(245, 158, 11, 0.05);\n    border-color: rgba(245, 158, 11, 0.2);\n}\n\n.edit-layout .ad-group-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.edit-layout .ad-group-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.edit-layout .ad-group-meta {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    margin-top: 2px;\n}\n\n.edit-layout .chevron {\n    width: 20px;\n    height: 20px;\n    color: var(--text-tertiary);\n    flex-shrink: 0;\n    transition: transform 0.2s;\n}\n\n.edit-layout .ad-group-item.active .chevron {\n    color: var(--accent-orange);\n}\n\n.edit-layout .status-icon {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n}\n\n.edit-layout .status-icon.paused {\n    color: var(--text-secondary);\n}\n\n.edit-layout .status-icon.ended {\n    color: var(--text-tertiary);\n}\n\n.edit-layout .status-icon.scheduled {\n    color: #f59e0b;\n}\n\n/* Sense Max constructor — the page itself never scrolls horizontally (top-level guarantee) */\n.sense-max-page { overflow-x: clip; }\n.sense-max-page .edit-layout { min-width: 0; max-width: 100%; }\n\n/* Right Panel - Ad Group Form */\n.adgroup-panel {\n    flex: 1;\n    min-width: 0;        /* shrink below content's intrinsic width (flexbox default is auto) */\n    overflow-x: clip;    /* hard guarantee vs horizontal page-break; keeps dropdowns (vertical) visible */\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.adgroup-form {\n    padding: 24px;\n    min-width: 0;\n}\n\n.form-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.form-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.edit-layout .form-actions {\n    display: flex;\n    gap: 8px;\n}\n\n/* Form Sections */\n.form-section {\n    margin-bottom: 28px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.form-section:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n.form-section-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 16px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Collapsible form section */\n.form-section-collapsible {\n    padding-top: 0;\n}\n\n.form-section-collapsible .form-section-title {\n    margin-bottom: 0;\n}\n\n.form-section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0;\n    padding-bottom: 16px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.form-section-header:hover .form-section-title {\n    color: var(--brand-orange);\n}\n\n.form-section-chevron {\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n    transition: transform 0.2s ease;\n}\n\n.form-section-chevron.expanded {\n    transform: rotate(180deg);\n}\n\n/* Inventory Section Styles */\n.inventory-columns {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-top: 8px;\n}\n\n.inventory-column {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.inventory-column-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-secondary);\n}\n\n.inventory-icon {\n    width: 18px;\n    height: 18px;\n}\n\n.inventory-icon-whitelist {\n    color: #22c55e;\n}\n\n.inventory-icon-blacklist {\n    color: #ef4444;\n}\n\n.inventory-list-selector {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.inventory-list-selector select {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    background: white;\n    font-size: 13px;\n    color: var(--text-secondary);\n    cursor: pointer;\n}\n\n.inventory-list-selector select:focus {\n    outline: none;\n    border-color: var(--brand-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.btn-new-list {\n    padding: 8px 12px;\n    background: linear-gradient(135deg, var(--brand-orange) 0%, var(--brand-red) 100%);\n    border: none;\n    border-radius: 6px;\n    color: white;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all 0.2s ease;\n}\n\n.btn-new-list:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(255, 107, 74, 0.3);\n}\n\n.inventory-urls-container {\n    position: relative;\n}\n\n.inventory-urls-input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    font-size: 12px;\n    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n    line-height: 1.5;\n    resize: vertical;\n    min-height: 120px;\n    background: white;\n    color: var(--text-primary);\n}\n\n.inventory-urls-input:focus {\n    outline: none;\n    border-color: var(--brand-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.inventory-urls-input::placeholder {\n    color: var(--text-tertiary);\n    font-style: italic;\n}\n\n.inventory-urls-count {\n    position: absolute;\n    bottom: 8px;\n    right: 8px;\n    font-size: 11px;\n    color: var(--text-tertiary);\n    background: rgba(255, 255, 255, 0.9);\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n/* Inventory chips (like Proximity) */\n.inventory-saved-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 12px;\n}\n\n.inventory-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 5px 10px;\n    border-radius: 16px;\n    font-size: 12px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.inventory-chip-whitelist {\n    background: rgba(34, 197, 94, 0.1);\n    color: #15803d;\n}\n\n.inventory-chip-whitelist:hover,\n.inventory-chip-whitelist.active {\n    background: rgba(34, 197, 94, 0.25);\n}\n\n.inventory-chip-blacklist {\n    background: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n}\n\n.inventory-chip-blacklist:hover,\n.inventory-chip-blacklist.active {\n    background: rgba(239, 68, 68, 0.25);\n}\n\n.inventory-chip-new {\n    background: rgba(255, 107, 74, 0.1);\n    color: var(--brand-orange);\n}\n\n.inventory-chip-new:hover {\n    background: rgba(255, 107, 74, 0.2);\n}\n\n.inventory-chip-count {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 8px;\n    font-weight: 600;\n}\n\n.inventory-chip-whitelist .inventory-chip-count {\n    background: rgba(34, 197, 94, 0.2);\n}\n\n.inventory-chip-blacklist .inventory-chip-count {\n    background: rgba(239, 68, 68, 0.2);\n}\n\n.inventory-chip-remove {\n    font-size: 14px;\n    line-height: 1;\n    opacity: 0.5;\n    margin-left: 2px;\n}\n\n.inventory-chip-remove:hover {\n    opacity: 1;\n}\n\n/* Inventory editor */\n.inventory-editor {\n    margin-top: 8px;\n}\n\n.inventory-textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    font-size: 12px;\n    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n    line-height: 1.5;\n    resize: vertical;\n    min-height: 100px;\n    background: white;\n    color: var(--text-primary);\n    margin-top: 6px;\n}\n\n.inventory-textarea:focus {\n    outline: none;\n    border-color: var(--brand-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.inventory-textarea::placeholder {\n    color: var(--text-tertiary);\n}\n\n.inventory-hint {\n    display: block;\n    font-size: 11px;\n    color: var(--text-tertiary);\n    margin-top: 4px;\n}\n\n.form-placeholder {\n    color: var(--text-tertiary);\n    font-size: 14px;\n    font-style: italic;\n}\n\n/* Targeting Styles */\n.targeting-group {\n    margin-bottom: 16px;\n}\n\n.targeting-group:last-child {\n    margin-bottom: 0;\n}\n\n.targeting-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 10px;\n}\n\n.targeting-row:last-child {\n    margin-bottom: 0;\n}\n\n.targeting-row-separated {\n    margin-top: 20px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-light);\n}\n\n.targeting-label {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    min-width: 70px;\n    padding-top: 4px;\n}\n\n.sm-blacklist {\n    flex: 1;\n    min-height: 62px;\n    padding: 8px 10px;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 13px;\n    line-height: 1.4;\n    resize: vertical;\n}\n\n.targeting-hint {\n    font-size: 12px;\n    line-height: 1.45;\n    color: var(--text-secondary);\n    opacity: .8;\n    margin: 6px 0 0 78px;   /* clears the label column so it reads as a footnote */\n    max-width: 560px;\n}\n\n.targeting-expand-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 10px;\n    background: transparent;\n    border: 1px dashed var(--border-color);\n    border-radius: 12px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n}\n\n.targeting-expand-btn:hover {\n    color: var(--text-secondary);\n    border-color: var(--text-tertiary);\n    background: var(--bg-tertiary);\n}\n\n.targeting-expand-btn.active {\n    color: var(--text-tertiary);\n    border-color: var(--border-color);\n    background: transparent;\n}\n\n.targeting-expand-btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n.targeting-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    flex: 1;\n}\n\n.targeting-tags-wrap {\n    max-height: 120px;\n    overflow-y: auto;\n}\n\n.targeting-tag {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.1) 100%);\n    border: 1px solid rgba(255, 107, 74, 0.2);\n    border-radius: 12px;\n    font-size: 12px;\n    color: var(--text-primary);\n    white-space: nowrap;\n}\n\n.targeting-tag-more {\n    background: var(--bg-tertiary);\n    border-color: var(--border-color);\n    color: var(--text-secondary);\n    cursor: pointer;\n}\n\n.targeting-tag-more:hover {\n    background: var(--bg-hover);\n}\n\n.targeting-empty {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    font-style: italic;\n}\n\n/* Toggle tags (Age, Gender, Devices) */\n.targeting-tag-toggle {\n    cursor: pointer;\n    background: var(--bg-tertiary);\n    border-color: var(--border-color);\n    color: var(--text-tertiary);\n    transition: all 0.15s ease;\n}\n\n.targeting-tag-toggle:hover {\n    background: var(--bg-hover);\n    color: var(--text-secondary);\n}\n\n.targeting-tag-toggle.active {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.15) 0%, rgba(233, 75, 108, 0.15) 100%);\n    border-color: rgba(255, 107, 74, 0.3);\n    color: var(--text-primary);\n}\n\n/* Exclude tags (Content Labels, Sensitive Categories) */\n.targeting-tag-exclude {\n    background: var(--bg-tertiary);\n    border-color: var(--border-color);\n    color: var(--text-tertiary);\n}\n\n.targeting-tag-exclude.excluded {\n    background: rgba(220, 53, 69, 0.1);\n    border-color: rgba(220, 53, 69, 0.3);\n    color: #dc3545;\n}\n\n.targeting-tag-exclude:hover {\n    background: rgba(220, 53, 69, 0.05);\n    border-color: rgba(220, 53, 69, 0.2);\n    color: var(--text-secondary);\n}\n\n/* Exclude tag active state (uses .active not .excluded for consistency) */\n.targeting-tag-exclude.active {\n    background: rgba(220, 53, 69, 0.12);\n    border-color: rgba(220, 53, 69, 0.4);\n    color: #dc3545;\n}\n\n/* Disabled tag (when included can't exclude, vice versa) */\n.targeting-tag.disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n/* Inventory column header with toggle */\n.inventory-column-header-with-toggle {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.inventory-column-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Align remarketing columns - both headers same height */\n.inventory-columns .inventory-column-header {\n    min-height: 32px;\n    display: flex;\n    align-items: center;\n}\n\n/* Remarketing OR/AND toggle switch */\n.remarketing-toggle {\n    display: inline-flex;\n    background: var(--bg-tertiary);\n    border-radius: 6px;\n    padding: 2px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.remarketing-toggle-option {\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-tertiary);\n    border-radius: 4px;\n    transition: all 0.15s ease;\n}\n\n.remarketing-toggle-option.active {\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n}\n\n/* Look-Alike (Optimized Targeting) section */\n.lookalike-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-light);\n}\n\n.lookalike-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.lookalike-toggle {\n    display: inline-flex;\n    background: var(--bg-tertiary);\n    border-radius: 6px;\n    padding: 2px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.lookalike-toggle-option {\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-tertiary);\n    border-radius: 4px;\n    transition: all 0.15s ease;\n}\n\n.lookalike-toggle-option.active-off {\n    background: var(--bg-secondary);\n    color: var(--text-secondary);\n}\n\n.lookalike-toggle-option.active-on {\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n}\n\n.lookalike-hint {\n    margin: 8px 0 0 0;\n    font-size: 11px;\n    color: var(--text-tertiary);\n    line-height: 1.4;\n}\n\n/* Unavailable state */\n.lookalike-unavailable .lookalike-row,\n.lookalike-unavailable .lookalike-hint {\n    opacity: 0.4;\n    pointer-events: none;\n}\n\n.lookalike-warning {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.lookalike-warning-icon {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    color: var(--accent-orange);\n}\n\n.lookalike-warning span {\n    font-size: 12px;\n    line-height: 1.5;\n    color: var(--text-secondary);\n}\n\n.lookalike-warning-highlight {\n    color: var(--accent-orange);\n    font-weight: 600;\n}\n\n/* Exclude chip styles */\n.proximity-chip-exclude:hover {\n    border-color: #dc3545;\n    background: rgba(220, 53, 69, 0.04);\n}\n\n.proximity-chip-exclude.selected {\n    border-color: #dc3545;\n    background: linear-gradient(135deg, #dc3545, #b33d4a);\n    color: white;\n}\n\n.chip-checkbox-exclude:hover {\n    border-color: #dc3545;\n}\n\n.chip-checkbox-exclude.checked {\n    background: #dc3545;\n    border-color: #dc3545;\n    color: white;\n}\n\n/* Clickable chip (for remarketing - whole area is clickable) */\n.proximity-chip-clickable {\n    cursor: pointer;\n}\n\n/* Disabled chip (already selected in other column) */\n.disabled-chip {\n    opacity: 0.35;\n    pointer-events: none;\n}\n\n/* Targeting empty state */\n.targeting-empty {\n    padding: 20px;\n    text-align: center;\n    color: var(--text-tertiary);\n    font-size: 13px;\n}\n\n/* Removable tags (Locations) */\n.targeting-tag-removable {\n    padding-right: 6px;\n    gap: 4px;\n}\n\n.targeting-tag-remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border: none;\n    background: transparent;\n    color: var(--text-tertiary);\n    font-size: 14px;\n    line-height: 1;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.15s ease;\n}\n\n.targeting-tag-remove:hover {\n    background: rgba(220, 53, 69, 0.15);\n    color: #dc3545;\n}\n\n/* Language dropdown */\n.targeting-dropdown-container {\n    position: relative;\n    flex: 1;\n}\n\n.targeting-row:has(.targeting-dropdown-container) {\n    align-items: center;\n}\n\n.targeting-dropdown-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 280px;\n    padding: 8px 12px;\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.targeting-dropdown-trigger:hover {\n    border-color: var(--accent-orange);\n}\n\n.dropdown-trigger-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.dropdown-chevron {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n}\n\n.dropdown-chevron.expanded {\n    transform: rotate(180deg);\n}\n\n.targeting-dropdown-panel {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    max-width: 280px;\n    margin-top: 4px;\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    z-index: 100;\n    overflow: hidden;\n}\n\n.dropdown-search-wrapper {\n    padding: 8px;\n    border-bottom: 1px solid var(--border-light);\n}\n\n.dropdown-search-input {\n    width: 100%;\n    padding: 8px 10px;\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    font-size: 13px;\n    color: var(--text-primary);\n    outline: none;\n}\n\n.dropdown-search-input:focus {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 2px rgba(255, 107, 74, 0.15);\n}\n\n.dropdown-search-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.dropdown-options-list {\n    max-height: 240px;\n    overflow-y: auto;\n    padding: 4px 0;\n}\n\n.dropdown-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background 0.1s ease;\n}\n\n.dropdown-option:hover {\n    background: var(--bg-hover);\n}\n\n.dropdown-option input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--accent-orange);\n    cursor: pointer;\n}\n\n.dropdown-option .option-label {\n    font-size: 13px;\n    color: var(--text-primary);\n}\n\n.dropdown-no-results {\n    padding: 16px;\n    text-align: center;\n    font-size: 13px;\n    color: var(--text-tertiary);\n}\n\n.targeting-selected-tags {\n    margin-top: 8px;\n}\n\n.tag-remove-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    padding: 0;\n    margin-left: 2px;\n    border: none;\n    background: transparent;\n    color: var(--text-tertiary);\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.15s ease;\n}\n\n.tag-remove-btn svg {\n    width: 10px;\n    height: 10px;\n}\n\n.tag-remove-btn:hover {\n    background: rgba(220, 53, 69, 0.15);\n    color: #dc3545;\n}\n\n/* Add button */\n.targeting-add-btn {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    background: transparent;\n    border: 1px dashed var(--border-color);\n    border-radius: 12px;\n    font-size: 12px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.targeting-add-btn:hover {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.05);\n}\n\n/* Geo input */\n.targeting-input-wrapper {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.targeting-input {\n    padding: 4px 8px;\n    border: 1px solid var(--accent-orange);\n    border-radius: 8px;\n    font-size: 12px;\n    width: 180px;\n    outline: none;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n}\n\n.targeting-input:focus {\n    box-shadow: 0 0 0 2px rgba(255, 107, 74, 0.2);\n}\n\n.targeting-input-cancel {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border: none;\n    background: var(--bg-tertiary);\n    color: var(--text-secondary);\n    font-size: 14px;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.15s ease;\n}\n\n.targeting-input-cancel:hover {\n    background: rgba(220, 53, 69, 0.15);\n    color: #dc3545;\n}\n\n/* Geo autocomplete */\n.targeting-autocomplete-container {\n    position: relative;\n    display: inline-block;\n}\n\n.targeting-input-loading {\n    font-size: 12px;\n    color: var(--text-secondary);\n    animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n\n.targeting-autocomplete-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    margin-top: 4px;\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    max-height: 240px;\n    overflow-y: auto;\n    z-index: 100;\n    min-width: 250px;\n}\n\n.targeting-autocomplete-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 12px;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.targeting-autocomplete-item:hover {\n    background: rgba(255, 107, 74, 0.1);\n}\n\n.targeting-autocomplete-item:first-child {\n    border-radius: 8px 8px 0 0;\n}\n\n.targeting-autocomplete-item:last-child {\n    border-radius: 0 0 8px 8px;\n}\n\n.targeting-autocomplete-item:only-child {\n    border-radius: 8px;\n}\n\n.targeting-autocomplete-item .geo-name {\n    font-size: 13px;\n    color: var(--text-primary);\n}\n\n.targeting-autocomplete-item .geo-type {\n    font-size: 11px;\n    color: var(--text-secondary);\n    background: var(--bg-tertiary);\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n.targeting-autocomplete-empty {\n    padding: 12px;\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 12px;\n}\n\n/* Geo Grouped Display */\n.targeting-row-vertical {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n}\n\n.targeting-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.targeting-count {\n    font-size: 12px;\n    color: var(--text-secondary);\n}\n\n.geo-groups-container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    background: var(--bg-secondary);\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.geo-type-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.geo-type-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.geo-type-name {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--text-secondary);\n    letter-spacing: 0.5px;\n}\n\n.geo-type-count {\n    font-size: 11px;\n    color: var(--text-muted);\n}\n\n.geo-type-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.geo-list-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px 8px;\n    border-radius: 6px;\n    transition: background 0.15s ease;\n}\n\n.geo-list-item:hover {\n    background: var(--bg-primary);\n}\n\n.geo-item-name {\n    font-size: 13px;\n    color: var(--text-primary);\n}\n\n.geo-item-remove {\n    display: none;\n    width: 18px;\n    height: 18px;\n    border: none;\n    background: transparent;\n    color: var(--text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.15s ease;\n    align-items: center;\n    justify-content: center;\n}\n\n.geo-list-item:hover .geo-item-remove {\n    display: flex;\n}\n\n.geo-item-remove:hover {\n    background: rgba(220, 53, 69, 0.15);\n    color: #dc3545;\n}\n\n.geo-empty {\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 13px;\n    padding: 16px;\n}\n\n.geo-add-section {\n    padding-top: 8px;\n    border-top: 1px solid var(--border-color);\n}\n\n.geo-add-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 12px;\n    border: 1px dashed var(--border-color);\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 12px;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: all 0.15s ease;\n}\n\n.geo-add-btn:hover {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.05);\n}\n\n.geo-search-input {\n    width: 100%;\n    max-width: 300px;\n}\n\n/* Geo Two-Column Layout */\n.geo-columns {\n    display: flex;\n    gap: 24px;\n}\n\n.geo-column {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.geo-column .targeting-label {\n    margin-bottom: 0;\n}\n\n/* Geo Locations List */\n.geo-email-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.geo-email-list {\n    display: flex;\n    flex-direction: column;\n    max-height: 200px;\n    overflow-y: auto;\n    border-radius: 12px 12px 0 0;\n}\n\n.geo-email-item:first-child {\n    border-radius: 12px 12px 0 0;\n}\n\n.geo-email-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.geo-email-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.geo-email-list::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));\n    border-radius: 3px;\n}\n\n.geo-email-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n.geo-email-item::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.geo-email-item:hover::before {\n    opacity: 1;\n}\n\n.geo-email-item:last-child {\n    border-bottom: none;\n}\n\n.geo-email-item:hover {\n    background: linear-gradient(90deg, rgba(255, 107, 74, 0.04), transparent);\n}\n\n.geo-email-name {\n    font-size: 14px;\n    color: #212529;\n    flex: 1;\n    font-weight: 500;\n}\n\n.geo-name-secondary {\n    font-size: 12px;\n    color: #868e96;\n    font-weight: 400;\n}\n\n.geo-email-remove {\n    width: 24px;\n    height: 24px;\n    border: none;\n    background: transparent;\n    color: #adb5bd;\n    font-size: 20px;\n    font-weight: 300;\n    cursor: pointer;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.geo-email-item:hover .geo-email-remove {\n    opacity: 1;\n}\n\n.geo-email-remove:hover {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.15), rgba(233, 75, 108, 0.15));\n    color: var(--accent-red);\n}\n\n.geo-email-search {\n    position: relative;\n    padding: 8px 12px;\n}\n\n.geo-email-container > .geo-email-search:first-child {\n    padding-top: 12px;\n}\n\n.geo-email-search-wrapper {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 8px 12px;\n    background: white;\n    transition: border-color 0.2s;\n}\n\n.geo-email-search-wrapper:focus-within {\n    border-color: #999;\n}\n\n.geo-email-search-icon {\n    display: none;\n}\n\n.geo-email-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    font-size: 13px;\n    color: #212529;\n    outline: none;\n    font-family: inherit;\n}\n\n.geo-email-input::placeholder {\n    color: #aaa;\n}\n\n.geo-email-loading {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 107, 74, 0.2);\n    border-top-color: var(--accent-orange);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.geo-email-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border-radius: 0 0 12px 12px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    max-height: 240px;\n    overflow-y: auto;\n    z-index: 100;\n}\n\n.geo-email-dropdown-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    gap: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.geo-email-dropdown-item:last-child {\n    border-bottom: none;\n    border-radius: 0 0 12px 12px;\n}\n\n.geo-email-dropdown-item:hover {\n    background: linear-gradient(90deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.04));\n}\n\n.geo-dropdown-name {\n    font-size: 14px;\n    color: #212529;\n    flex: 1;\n    font-weight: 500;\n}\n\n.geo-dropdown-type {\n    font-size: 11px;\n    color: white;\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-weight: 600;\n    flex-shrink: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.geo-email-dropdown-empty {\n    padding: 20px;\n    text-align: center;\n    color: #868e96;\n    font-size: 13px;\n}\n\n/* Excluded Locations Styling */\n.targeting-label-excluded {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.excluded-icon {\n    width: 16px;\n    height: 16px;\n    stroke: var(--accent-red);\n}\n\n.geo-excluded-container .geo-email-item::before {\n    background: linear-gradient(180deg, var(--accent-orange), var(--accent-red));\n}\n\n.geo-excluded-container .geo-email-item:hover {\n    background: linear-gradient(90deg, rgba(255, 107, 74, 0.04), transparent);\n}\n\n/* Geo Mode Header */\n.geo-mode-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.geo-mode-header .targeting-label {\n    margin-bottom: 0;\n}\n\n/* Geo Mode Toggle */\n.geo-mode-toggle {\n    display: flex;\n    gap: 8px;\n}\n\n.geo-mode-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    background: white;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.geo-mode-btn svg {\n    width: 18px;\n    height: 18px;\n}\n\n.geo-mode-btn:hover {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n}\n\n.geo-mode-btn.active {\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    border-color: transparent;\n    color: white;\n}\n\n.geo-mode-btn.active svg {\n    stroke: white;\n}\n\n/* Proximity Container */\n.proximity-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* Proximity Saved Row - Chips */\n.proximity-saved-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.proximity-saved-label {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    margin-right: 4px;\n}\n\n.proximity-chip {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 20px;\n    background: white;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-chip:hover {\n    border-color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.04);\n}\n\n.proximity-chip.active {\n    border-color: var(--accent-orange);\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n}\n\n.proximity-chip-count {\n    background: rgba(0, 0, 0, 0.1);\n    padding: 2px 6px;\n    border-radius: 10px;\n    font-size: 11px;\n    margin-left: 6px;\n}\n\n.proximity-chip.active .proximity-chip-count {\n    background: rgba(255, 255, 255, 0.25);\n}\n\n.proximity-chip-new {\n    border-style: dashed;\n    color: var(--accent-orange);\n}\n\n.proximity-chip-new:hover {\n    background: rgba(255, 107, 74, 0.08);\n}\n\n/* Chip checkbox for multi-select */\n.chip-checkbox {\n    width: 16px;\n    height: 16px;\n    border: 1.5px solid var(--border-color);\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    color: transparent;\n    background: white;\n    transition: all 0.15s ease;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.chip-checkbox:hover {\n    border-color: var(--accent-orange);\n}\n\n.chip-checkbox.checked {\n    background: var(--accent-orange);\n    border-color: var(--accent-orange);\n    color: white;\n}\n\n.chip-label {\n    cursor: pointer;\n}\n\n.proximity-chip.selected {\n    border-color: var(--accent-orange);\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n}\n\n.proximity-chip.selected .chip-checkbox {\n    background: rgba(255, 255, 255, 0.25);\n    border-color: rgba(255, 255, 255, 0.5);\n    color: white;\n}\n\n.proximity-chip.selected .proximity-chip-count {\n    background: rgba(255, 255, 255, 0.25);\n}\n\n/* Editor Grid */\n.proximity-editor-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    align-items: stretch;\n}\n\n/* Proximity Editor */\n.proximity-editor {\n    background: white;\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.proximity-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.proximity-name-editable {\n    font-weight: 600;\n    font-size: 14px;\n    color: #1a1a2e;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 6px;\n    transition: background 0.15s;\n}\n\n.proximity-name-editable:hover {\n    background: #f0f0f5;\n}\n\n.proximity-name-input {\n    font-weight: 600;\n    font-size: 14px;\n    color: #1a1a2e;\n    padding: 4px 8px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    outline: none;\n    width: 200px;\n}\n\n.proximity-name-input:focus {\n    border-color: #FF6B4A;\n}\n\n.proximity-delete-btn {\n    background: none;\n    border: none;\n    color: #999;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: all 0.15s;\n}\n\n.proximity-delete-btn:hover {\n    background: #fee2e2;\n    color: #dc2626;\n}\n\n.proximity-editor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.proximity-editing-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.proximity-back-btn {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 6px;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-back-btn:hover {\n    background: #f0f0f0;\n    color: var(--text-primary);\n}\n\n.proximity-textarea {\n    width: 100%;\n    min-height: 140px;\n    padding: 14px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-family: 'SF Mono', Monaco, monospace;\n    font-size: 13px;\n    line-height: 1.6;\n    resize: vertical;\n    transition: all 0.2s ease;\n}\n\n.proximity-textarea:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.proximity-textarea::placeholder {\n    color: var(--text-tertiary);\n    font-family: 'SF Mono', Monaco, monospace;\n}\n\n.proximity-textarea.has-error {\n    border-color: #e53e3e;\n    background: rgba(229, 62, 62, 0.03);\n}\n\n.proximity-textarea.has-error:focus {\n    border-color: #e53e3e;\n    box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.15);\n}\n\n.proximity-validation-error {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-top: 8px;\n    padding: 10px 12px;\n    background: rgba(229, 62, 62, 0.08);\n    border: 1px solid rgba(229, 62, 62, 0.2);\n    border-radius: 8px;\n    color: #c53030;\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.proximity-validation-error svg {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 1px;\n    stroke: #c53030;\n}\n\n.proximity-options {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 16px;\n    gap: 16px;\n}\n\n.proximity-radius-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.proximity-radius-row > label {\n    font-size: 13px;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n.proximity-radius-control {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.proximity-radius-btn {\n    width: 32px;\n    height: 36px;\n    border: none;\n    background: var(--bg-secondary);\n    color: var(--text-secondary);\n    font-size: 18px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.proximity-radius-btn:hover {\n    background: var(--border-color);\n    color: var(--text-primary);\n}\n\n.proximity-radius-btn:active {\n    background: var(--accent-orange);\n    color: white;\n}\n\n.proximity-radius-input {\n    width: 60px;\n    padding: 8px 4px;\n    border: none;\n    border-left: 1px solid var(--border-color);\n    border-right: 1px solid var(--border-color);\n    font-size: 14px;\n    text-align: center;\n}\n\n.proximity-radius-input:focus {\n    outline: none;\n}\n\n/* Hide number input spinners */\n.proximity-radius-input::-webkit-outer-spin-button,\n.proximity-radius-input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n.proximity-radius-input[type=number] {\n    -moz-appearance: textfield;\n}\n\n.proximity-radius-unit {\n    font-size: 13px;\n    color: var(--text-tertiary);\n}\n\n.proximity-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color);\n}\n\n.proximity-save-btn {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 10px;\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-save-btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.proximity-save-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.proximity-save-btn.saving {\n    pointer-events: none;\n}\n\n/* Button spinner */\n.btn-spinner {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Name edit input for lists */\n.proximity-name-edit {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.proximity-name-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.proximity-name-edit-btn {\n    padding: 4px 8px;\n    border: none;\n    background: transparent;\n    color: var(--text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    opacity: 0.5;\n}\n\n.proximity-name-edit-btn:hover {\n    opacity: 1;\n    background: var(--bg-hover);\n    color: var(--accent-orange);\n}\n\n.proximity-delete-btn {\n    padding: 6px 12px;\n    border: 1px solid #dc3545;\n    background: transparent;\n    color: #dc3545;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    margin-left: auto;\n}\n\n.proximity-delete-btn:hover {\n    background: #dc3545;\n    color: white;\n}\n\n.proximity-delete-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Confirmation Modal */\n.modal-overlay:has(.confirm-modal) {\n    opacity: 1;\n    visibility: visible;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.confirm-modal {\n    background: white;\n    border-radius: 16px;\n    padding: 32px;\n    width: 100%;\n    max-width: 400px;\n    text-align: center;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.confirm-modal-icon {\n    font-size: 48px;\n    margin-bottom: 16px;\n}\n\n.confirm-modal h3 {\n    margin: 0 0 12px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.confirm-modal p {\n    margin: 0 0 24px 0;\n    font-size: 14px;\n    color: var(--text-secondary);\n    line-height: 1.5;\n}\n\n.confirm-modal p strong {\n    color: var(--text-primary);\n}\n\n.confirm-modal-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.confirm-modal-actions .btn-secondary {\n    padding: 10px 24px;\n    border: 1px solid var(--border-color);\n    background: white;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.confirm-modal-actions .btn-secondary:hover {\n    background: var(--bg-hover);\n}\n\n.confirm-modal-actions .btn-danger {\n    padding: 10px 24px;\n    border: none;\n    background: #dc3545;\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.confirm-modal-actions .btn-danger:hover {\n    background: #c82333;\n}\n\n.confirm-modal-actions .btn-danger:disabled,\n.confirm-modal-actions .btn-secondary:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Message Modal - Info/Notice variant */\n.message-modal {\n    background: white;\n    border-radius: 16px;\n    padding: 32px;\n    width: 100%;\n    max-width: 420px;\n    text-align: center;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n    animation: modalSlideIn 0.25s ease-out;\n}\n\n.message-modal-icon {\n    width: 56px;\n    height: 56px;\n    margin: 0 auto 20px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n}\n\n.message-modal-icon.info {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.1) 100%);\n    color: var(--accent-orange);\n}\n\n.message-modal-icon.error {\n    background: linear-gradient(135deg, rgba(251, 191, 36, 0.15) 0%, rgba(245, 158, 11, 0.15) 100%);\n    color: #d97706;\n    position: relative;\n}\n\n.message-modal-icon.error::before {\n    content: '';\n    position: absolute;\n    inset: -3px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%);\n    animation: error-pulse 2s ease-in-out infinite;\n}\n\n@keyframes error-pulse {\n    0%, 100% { transform: scale(1); opacity: 1; }\n    50% { transform: scale(1.08); opacity: 0.7; }\n}\n\n.message-modal h3 {\n    margin: 0 0 12px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.message-modal p {\n    margin: 0 0 24px 0;\n    font-size: 14px;\n    color: var(--text-secondary);\n    line-height: 1.6;\n}\n\n.message-modal-btn {\n    padding: 11px 32px;\n    border: none;\n    background: var(--accent-orange);\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.message-modal-btn:hover {\n    background: #e55a3a;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.message-modal-btn:active {\n    transform: translateY(0);\n    box-shadow: none;\n}\n\n.message-modal-btn.warning {\n    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n.message-modal-btn.warning:hover {\n    background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n    box-shadow: 0 4px 12px rgba(217, 119, 6, 0.3);\n}\n\n@keyframes modalSlideIn {\n    from {\n        opacity: 0;\n        transform: scale(0.95) translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1) translateY(0);\n    }\n}\n\n.message-modal-icon.delete {\n    background: rgba(220, 53, 69, 0.1);\n    color: #dc3545;\n}\n\n.message-modal-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.message-modal-btn-secondary {\n    padding: 11px 24px;\n    border: 1px solid var(--border-color);\n    background: white;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.message-modal-btn-secondary:hover {\n    background: var(--bg-hover);\n    border-color: #ccc;\n}\n\n.message-modal-btn-secondary:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.message-modal-btn-danger {\n    padding: 11px 24px;\n    border: none;\n    background: #dc3545;\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.message-modal-btn-danger:hover {\n    background: #c82333;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n}\n\n.message-modal-btn-danger:active {\n    transform: translateY(0);\n    box-shadow: none;\n}\n\n.message-modal-btn-danger:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.proximity-name-input {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    background: transparent;\n    transition: all 0.2s ease;\n}\n\n.proximity-name-input:hover {\n    background: var(--bg-hover);\n}\n\n.proximity-name-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    background: white;\n}\n\n.proximity-name-input:disabled {\n    opacity: 0.7;\n}\n\n.proximity-save-new-btn {\n    padding: 10px 20px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    background: white;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-save-new-btn:hover {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n}\n\n/* Proximity Modal */\n.proximity-modal {\n    background: white;\n    border-radius: 16px;\n    padding: 24px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.proximity-modal h3 {\n    margin: 0 0 20px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.proximity-modal-input {\n    width: 100%;\n    padding: 14px 16px;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-size: 14px;\n    transition: all 0.2s ease;\n}\n\n.proximity-modal-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.proximity-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.proximity-modal-cancel {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 10px;\n    background: #f0f0f0;\n    color: var(--text-secondary);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-modal-cancel:hover {\n    background: #e0e0e0;\n}\n\n.proximity-modal-save {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 10px;\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.proximity-modal-save:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.proximity-modal-save:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Proximity Hint */\n.proximity-hint {\n    display: block;\n    margin-top: 8px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n/* Proximity Inline Save */\n.proximity-inline-save {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.proximity-inline-input {\n    padding: 8px 12px;\n    border: 1px solid var(--accent-orange);\n    border-radius: 8px;\n    font-size: 14px;\n    width: 180px;\n    transition: all 0.2s ease;\n}\n\n.proximity-inline-input:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);\n}\n\n.proximity-inline-confirm {\n    width: 32px;\n    height: 32px;\n    border: none;\n    border-radius: 8px;\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    color: white;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.proximity-inline-confirm:hover:not(:disabled) {\n    transform: scale(1.05);\n}\n\n.proximity-inline-confirm:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.proximity-inline-cancel {\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    background: white;\n    color: var(--text-tertiary);\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.proximity-inline-cancel:hover {\n    border-color: var(--text-tertiary);\n    color: var(--text-secondary);\n}\n\n/* Proximity Map */\n.proximity-map {\n    position: relative;\n    background: #f8f9fa;\n    border-radius: 12px;\n    overflow: hidden;\n    min-height: 300px;\n    height: 100%;\n}\n\n.proximity-map-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    min-height: 300px;\n    color: var(--text-tertiary);\n    gap: 12px;\n}\n\n.proximity-map-empty svg {\n    width: 48px;\n    height: 48px;\n    opacity: 0.4;\n}\n\n.proximity-map-empty span {\n    font-size: 13px;\n}\n\n.proximity-map-container {\n    width: 100%;\n    height: 100%;\n    min-height: 300px;\n    border-radius: 12px;\n}\n\n.proximity-map-container .leaflet-control-attribution {\n    font-size: 10px;\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 4px 0 0 0;\n}\n\n.proximity-map-overlay {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: white;\n    padding: 6px 12px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n}\n\n.proximity-map-count {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-secondary);\n}\n\n/* Input with prefix */\n.input-with-prefix {\n    display: flex;\n    align-items: stretch;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    overflow: hidden;\n    transition: all 0.2s;\n}\n\n.input-with-prefix:focus-within {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.input-prefix {\n    padding: 12px 14px;\n    background: #f8f9fa;\n    color: var(--text-tertiary);\n    font-size: 14px;\n    font-weight: 500;\n    border-right: 1px solid var(--border-color);\n}\n\n.input-with-prefix .field-input {\n    border: none;\n    border-radius: 0;\n}\n\n.input-with-prefix .field-input:focus {\n    box-shadow: none;\n}\n\n/* Input with prefix - required empty state */\n.input-with-prefix.required-empty {\n    border-color: #e53935;\n}\n\n.input-with-prefix.required-empty:focus-within {\n    border-color: #e53935;\n    box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.15);\n}\n\n/* Input with suffix */\n.input-with-suffix {\n    display: flex;\n    align-items: stretch;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    overflow: hidden;\n    transition: all 0.2s;\n}\n\n.input-with-suffix:focus-within {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.input-suffix {\n    padding: 12px 14px;\n    background: #f8f9fa;\n    color: var(--text-tertiary);\n    font-size: 13px;\n    font-weight: 500;\n    border-left: 1px solid var(--border-color);\n    white-space: nowrap;\n}\n\n.input-with-suffix .field-input {\n    border: none;\n    border-radius: 0;\n    flex: 1;\n}\n\n.input-with-suffix .field-input:focus {\n    box-shadow: none;\n}\n\n/* Input with inline select */\n.input-with-select {\n    display: flex;\n    align-items: stretch;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    overflow: hidden;\n    transition: all 0.2s;\n}\n\n.input-with-select:focus-within {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.input-with-select .field-input {\n    border: none;\n    border-radius: 0;\n    flex: 1;\n}\n\n.input-with-select .field-input:focus {\n    box-shadow: none;\n}\n\n.input-with-select .field-select-inline {\n    border: none;\n    border-left: 1px solid var(--border-color);\n    border-radius: 0;\n    background: #f8f9fa;\n    padding: 12px 14px;\n    font-size: 13px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    flex-shrink: 0;\n    width: auto;\n}\n\n.input-with-select .field-select-inline:disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Creatives Grid */\n.creatives-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 12px;\n}\n\n.creative-thumb {\n    aspect-ratio: 1;\n    background: #f8f9fa;\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.creative-placeholder {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    font-weight: 500;\n}\n\n.creative-add {\n    aspect-ratio: 1;\n    background: transparent;\n    border: 2px dashed var(--border-color);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.creative-add svg {\n    width: 24px;\n    height: 24px;\n    color: var(--text-tertiary);\n}\n\n.creative-add span {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    font-weight: 500;\n}\n\n.creative-add:hover {\n    border-color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.02);\n}\n\n.creative-add:hover svg,\n.creative-add:hover span {\n    color: var(--accent-orange);\n}\n\n/* Buttons */\n.btn-add {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    background: transparent;\n    color: var(--accent-orange);\n    border: 1px dashed var(--accent-orange);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-add svg {\n    width: 16px;\n    height: 16px;\n}\n\n.btn-add:hover {\n    background: rgba(255, 107, 74, 0.05);\n}\n\n.btn-icon {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-icon svg {\n    width: 18px;\n    height: 18px;\n    color: var(--text-tertiary);\n}\n\n.btn-icon:hover {\n    background: #f5f5fa;\n}\n\n.btn-icon:hover svg {\n    color: var(--text-primary);\n}\n\n.btn-icon.danger:hover {\n    background: #fef2f2;\n    border-color: #fecaca;\n}\n\n.btn-icon.danger:hover svg {\n    color: var(--danger);\n}\n\n/* Publish All Button */\n.btn-publish-all {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    padding: 9px 14px;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);\n}\n\n.btn-publish-all svg {\n    width: 14px;\n    height: 14px;\n}\n\n.btn-publish-all:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);\n}\n\n.btn-publish-all:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.btn-publish-all .btn-loading {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n/* Publish buttons when campaign is not published - ghost outline style */\n.btn-publish.campaign-not-published,\n.btn-publish-all.campaign-not-published {\n    background: transparent;\n    color: #9ca3af;\n    border: 1.5px dashed #d1d5db;\n    box-shadow: none;\n    cursor: not-allowed;\n}\n\n.btn-publish.campaign-not-published svg,\n.btn-publish-all.campaign-not-published svg {\n    opacity: 0.5;\n}\n\n.btn-publish.campaign-not-published:hover,\n.btn-publish-all.campaign-not-published:hover {\n    transform: none;\n    box-shadow: none;\n    background: rgba(0, 0, 0, 0.02);\n}\n\n.btn-publish-all.fields-missing {\n    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n    box-shadow: none;\n}\n\n.btn-publish-all.fields-missing:hover {\n    transform: none;\n}\n\n/* Custom Tooltip */\n.tooltip-wrapper {\n    position: relative;\n    display: inline-flex;\n}\n\n.tooltip-wrapper.has-tooltip::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    bottom: calc(100% + 8px);\n    left: 50%;\n    transform: translateX(-50%) translateY(4px);\n    padding: 8px 12px;\n    background: #1f2937;\n    color: #f9fafb;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s ease;\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.tooltip-wrapper.has-tooltip::before {\n    content: '';\n    position: absolute;\n    bottom: calc(100% + 2px);\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: #1f2937;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s ease;\n    z-index: 1000;\n}\n\n.tooltip-wrapper.has-tooltip:hover::after {\n    opacity: 1;\n    visibility: visible;\n    transform: translateX(-50%) translateY(0);\n}\n\n.tooltip-wrapper.has-tooltip:hover::before {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* Form Actions Bottom */\n.form-actions-bottom {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 20px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color);\n}\n\n.form-actions-bottom .btn-secondary-sm {\n    padding: 9px 14px;\n}\n\n.form-actions-bottom .btn-primary-sm {\n    padding: 9px 16px;\n    min-width: auto;\n}\n\n.btn-primary-sm {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 18px;\n    background: var(--accent-gradient);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-primary-sm:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 107, 74, 0.3);\n}\n\n.btn-primary-sm:disabled {\n    opacity: 0.85;\n    cursor: default;\n    transform: none;\n}\n\n/* Save Campaign Button States */\n.save-campaign-btn {\n    justify-content: center;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.save-campaign-btn.saving {\n    background: linear-gradient(135deg, #a0a0a8 0%, #8888a4 100%);\n}\n\n.save-campaign-btn.saved {\n    background: linear-gradient(135deg, #34c759 0%, #30b350 100%);\n    box-shadow: 0 2px 8px rgba(52, 199, 89, 0.3);\n}\n\n.save-campaign-btn.inactive {\n    opacity: 0.45;\n    cursor: default;\n}\n\n.save-campaign-btn.inactive:hover {\n    transform: none;\n    box-shadow: none;\n}\n\n/* Campaign Details Section - Saving State */\n.campaign-details-section {\n    position: relative;\n    transition: opacity 0.2s;\n}\n\n.campaign-details-section.saving {\n    pointer-events: none;\n}\n\n.campaign-details-section.saving::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: inherit;\n    z-index: 10;\n}\n\n.campaign-details-section.saving .form-field,\n.campaign-details-section.saving .form-row,\n.campaign-details-section.saving .status-toggle,\n.campaign-details-section.saving .btn-secondary-sm {\n    opacity: 0.5;\n}\n\n/* Keep save button visible */\n.campaign-details-section.saving .save-campaign-btn {\n    opacity: 1;\n    position: relative;\n    z-index: 11;\n    pointer-events: auto;\n}\n\n/* Ad Group Form - Saving State */\n.adgroup-form {\n    position: relative;\n    transition: opacity 0.2s;\n}\n\n.adgroup-form.saving {\n    pointer-events: none;\n}\n\n.adgroup-form.saving::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: inherit;\n    z-index: 10;\n}\n\n.adgroup-form.saving .form-field,\n.adgroup-form.saving .form-row,\n.adgroup-form.saving .form-section,\n.adgroup-form.saving .btn-secondary-sm {\n    opacity: 0.5;\n}\n\n/* Keep save button visible */\n.adgroup-form.saving .save-campaign-btn {\n    opacity: 1;\n    position: relative;\n    z-index: 11;\n    pointer-events: auto;\n}\n\n.btn-spinner {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: btn-spin 0.8s linear infinite;\n}\n\n@keyframes btn-spin {\n    to { transform: rotate(360deg); }\n}\n\n.btn-check {\n    width: 16px;\n    height: 16px;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    animation: btn-check-pop 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes btn-check-pop {\n    0% { transform: scale(0); opacity: 0; }\n    50% { transform: scale(1.2); }\n    100% { transform: scale(1); opacity: 1; }\n}\n\n.btn-secondary-sm {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 18px;\n    background: white;\n    color: var(--text-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-secondary-sm:hover {\n    border-color: var(--text-tertiary);\n    color: var(--text-primary);\n}\n\n/* Empty State - Ad Group Panel */\n.adgroup-panel-empty {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    min-height: 400px;\n}\n\n.adgroup-panel-empty .empty-state {\n    text-align: center;\n    padding: 40px;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n}\n\n.adgroup-panel-empty .empty-state-icon {\n    width: 64px;\n    height: 64px;\n    margin: 0 auto 16px;\n    color: var(--text-tertiary);\n    opacity: 0.5;\n    display: block;\n}\n\n.adgroup-panel-empty .empty-state-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    margin-bottom: 8px;\n}\n\n.adgroup-panel-empty .empty-state-text {\n    font-size: 14px;\n    color: var(--text-tertiary);\n}\n\n/* Loading/Error States */\n.loading-state,\n.error-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    color: var(--text-secondary);\n    font-size: 14px;\n}\n\n.empty-list-message {\n    padding: 20px;\n    text-align: center;\n    color: var(--text-tertiary);\n    font-size: 14px;\n}\n\n/* ==================== Day & Time Grid ==================== */\n\n.day-time-section {\n    padding: 16px 0;\n}\n\n.day-time-header {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.day-time-timezone {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.day-time-timezone-label {\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.day-time-timezone-select {\n    padding: 6px 10px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    font-size: 13px;\n    color: var(--text-primary);\n    background: white;\n    cursor: pointer;\n}\n\n.day-time-timezone-select:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n}\n\n.day-time-actions {\n    display: flex;\n    gap: 16px;\n}\n\n.day-time-action-link {\n    font-size: 13px;\n    color: var(--text-secondary);\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px 8px;\n    margin: -4px -8px;\n    border-radius: 4px;\n    text-decoration: none;\n    transition: all 0.15s;\n}\n\n.day-time-action-link:hover {\n    color: var(--text-primary);\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.day-time-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    background: var(--border-color);\n    border-radius: 8px;\n    padding: 2px;\n    overflow: hidden;\n    user-select: none;\n}\n\n.day-time-row {\n    display: flex;\n    gap: 2px;\n}\n\n.day-time-header-row {\n    background: transparent;\n}\n\n.day-time-day-label {\n    width: 40px;\n    min-width: 40px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    background: var(--bg-tertiary);\n    cursor: pointer;\n    user-select: none;\n    transition: all 0.15s;\n}\n\n.day-time-day-label:hover {\n    background: var(--accent-orange);\n    color: white;\n}\n\n.day-time-header-row .day-time-day-label {\n    background: transparent;\n}\n\n.day-time-header-row .day-time-day-label:hover {\n    background: transparent;\n    color: var(--text-secondary);\n}\n\n.day-time-hour-label {\n    flex: 1;\n    min-width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    color: var(--text-tertiary);\n    cursor: pointer;\n    user-select: none;\n    transition: all 0.15s;\n}\n\n.day-time-hour-label:hover {\n    color: var(--accent-orange);\n    font-weight: 600;\n}\n\n.day-time-cell {\n    flex: 1;\n    min-width: 20px;\n    height: 24px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.1s;\n}\n\n.day-time-cell:hover {\n    background: rgba(255, 107, 74, 0.2);\n}\n\n.day-time-cell.selected {\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n}\n\n.day-time-cell.selected:hover {\n    background: linear-gradient(135deg, var(--accent-red), var(--accent-purple));\n}\n\n.day-time-legend {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid var(--border-color);\n}\n\n.day-time-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: var(--text-secondary);\n}\n\n.day-time-legend-box {\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n    background: white;\n    border: 1px solid var(--border-color);\n}\n\n.day-time-legend-box.selected {\n    background: linear-gradient(135deg, var(--accent-orange), var(--accent-red));\n    border: none;\n}\n\n.day-time-hint {\n    margin-left: auto;\n    font-size: 11px;\n    color: var(--text-tertiary);\n    font-style: italic;\n}\n\n/* Weekend styling for Day & Time grid */\n.day-time-row.weekend .day-time-day-label {\n    color: var(--accent-red);\n}\n\n.day-time-row.weekend .day-time-cell.selected {\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);\n}\n\n.day-time-row.weekend .day-time-cell.selected:hover {\n    background: linear-gradient(135deg, var(--accent-red) 0%, #6B2D7B 100%);\n}\n\n/* Inactive rows/columns (no cells selected) - only labels fade */\n.day-time-row.inactive .day-time-day-label {\n    opacity: 0.4;\n}\n\n.day-time-hour-label.inactive {\n    opacity: 0.4;\n}\n\n/* ========================================\n   Campaign Card Skeleton Loading Styles\n   ======================================== */\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.campaign-card.skeleton {\n  pointer-events: none;\n}\n\n.campaign-card.skeleton .skeleton-line {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite ease-in-out;\n  border-radius: 6px;\n}\n\n.campaign-card.skeleton .skeleton-type {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  margin-right: 12px;\n}\n\n.campaign-card.skeleton .skeleton-title {\n  width: 180px;\n  height: 18px;\n  margin-bottom: 6px;\n}\n\n.campaign-card.skeleton .skeleton-subtitle {\n  width: 120px;\n  height: 14px;\n}\n\n.campaign-card.skeleton .skeleton-badge {\n  width: 70px;\n  height: 28px;\n  border-radius: 20px;\n}\n\n.campaign-card.skeleton .skeleton-dates {\n  width: 200px;\n  height: 16px;\n  margin: 16px 0;\n}\n\n.campaign-card.skeleton .skeleton-chart {\n  width: 100%;\n  height: 80px;\n  margin-bottom: 16px;\n}\n\n.campaign-card.skeleton .metric-box {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.campaign-card.skeleton .skeleton-metric-label {\n  width: 70px;\n  height: 12px;\n}\n\n.campaign-card.skeleton .skeleton-metric-value {\n  width: 50px;\n  height: 24px;\n}\n\n.campaign-card.skeleton .skeleton-costs {\n  width: 100%;\n  height: 36px;\n  margin: 12px 0;\n}\n\n.campaign-card.skeleton .skeleton-budget {\n  width: 100%;\n  height: 48px;\n}\n\n/* ============================================\n   Edit Campaign Page - Mobile Responsive\n   ============================================ */\n\n@media (max-width: 768px) {\n    /* Prevent overflow */\n    .edit-layout {\n        flex-direction: column;\n        gap: 12px;\n        max-width: 100%;\n        overflow-x: hidden;\n    }\n\n    .edit-layout * {\n        box-sizing: border-box;\n    }\n\n    /* Campaign panel */\n    .campaign-panel {\n        width: 100%;\n        max-width: 100%;\n        gap: 12px;\n    }\n\n    .edit-layout .panel-section {\n        padding: 14px;\n        border-radius: 10px;\n        max-width: 100%;\n    }\n\n    .edit-layout .section-header {\n        margin-bottom: 12px;\n    }\n\n    .edit-layout .section-title {\n        font-size: 14px;\n        margin-bottom: 12px;\n    }\n\n    /* Ad group panel */\n    .adgroup-panel {\n        border-radius: 10px;\n        max-width: 100%;\n        overflow: hidden;\n    }\n\n    .adgroup-panel .adgroup-form {\n        padding: 14px;\n    }\n\n    .adgroup-panel .form-header {\n        margin-bottom: 14px;\n        padding-bottom: 14px;\n        gap: 8px;\n    }\n\n    .adgroup-panel .form-title {\n        font-size: 15px;\n    }\n\n    .adgroup-panel .form-section {\n        margin-bottom: 16px;\n        padding-bottom: 16px;\n    }\n\n    .adgroup-panel .form-section-title {\n        font-size: 11px;\n        margin-bottom: 10px;\n    }\n\n    /* Form fields - simpler approach */\n    .edit-layout .form-field {\n        margin-bottom: 14px;\n    }\n\n    .edit-layout .field-label {\n        font-size: 11px;\n        margin-bottom: 5px;\n    }\n\n    .edit-layout .field-input,\n    .edit-layout .field-select {\n        width: 100%;\n        padding: 10px 12px;\n        font-size: 15px;\n        border-radius: 8px;\n    }\n\n    /* Form rows */\n    .edit-layout .form-row,\n    .edit-layout .form-row-3 {\n        display: flex;\n        flex-direction: column;\n        gap: 14px;\n    }\n\n    .edit-layout .form-row .form-field,\n    .edit-layout .form-row-3 .form-field {\n        margin-bottom: 0;\n    }\n\n    .edit-layout .form-row-flex {\n        flex-direction: column;\n        gap: 14px;\n        align-items: stretch;\n    }\n\n    .edit-layout .form-row-flex .form-field {\n        width: 100%;\n        margin-bottom: 0 !important;\n    }\n\n    .edit-layout .form-row-flex .form-field .field-label {\n        text-align: left;\n    }\n\n    .edit-layout .form-field-auto,\n    .edit-layout .form-field-grow {\n        width: 100%;\n        flex: none;\n    }\n\n    /* Buttons - simple consistent style */\n    .edit-layout .status-toggle,\n    .edit-layout .line-item-type-toggle {\n        display: flex;\n        gap: 8px;\n        width: 100%;\n    }\n\n    .edit-layout .status-btn,\n    .edit-layout .line-item-type-btn {\n        flex: 1;\n        padding: 10px 12px;\n        font-size: 13px;\n        border-radius: 8px;\n    }\n\n    .edit-layout .status-btn svg,\n    .edit-layout .line-item-type-btn svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    /* Frequency - full width row layout */\n    .edit-layout .frequency-input {\n        display: flex;\n        flex-wrap: nowrap;\n        gap: 8px;\n        align-items: center;\n        width: 100%;\n    }\n\n    .edit-layout .frequency-count {\n        width: 70px !important;\n        min-width: 70px;\n        flex-shrink: 0;\n        text-align: center;\n    }\n\n    .edit-layout .frequency-text {\n        font-size: 12px;\n        white-space: nowrap;\n        flex-shrink: 0;\n    }\n\n    .edit-layout .frequency-period {\n        flex: 1;\n        min-width: 80px;\n    }\n\n    /* Input with prefix/suffix - proper border handling */\n    .edit-layout .input-with-prefix,\n    .edit-layout .input-with-suffix {\n        display: flex;\n        width: 100%;\n        border: 1px solid var(--border-color);\n        border-radius: 8px;\n        overflow: hidden;\n    }\n\n    .edit-layout .input-with-prefix .field-input,\n    .edit-layout .input-with-suffix .field-input {\n        border: none !important;\n        border-radius: 0;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .edit-layout .input-prefix,\n    .edit-layout .input-suffix {\n        font-size: 12px;\n        padding: 10px 10px;\n        white-space: nowrap;\n        background: #f8f9fa;\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n    }\n\n    /* Action buttons */\n    .edit-layout .btn-icon {\n        width: 36px;\n        height: 36px;\n        padding: 0;\n    }\n\n    .edit-layout .form-actions-bottom {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px;\n        margin-top: 16px;\n        justify-content: flex-end;\n    }\n\n    .edit-layout .form-actions-bottom .btn-secondary-sm {\n        padding: 10px 14px;\n        font-size: 13px;\n        margin-right: auto;\n    }\n\n    .edit-layout .form-actions-bottom .btn-primary-sm,\n    .edit-layout .form-actions-bottom .btn-publish {\n        padding: 10px 14px;\n        font-size: 13px;\n    }\n\n    /* Ad groups list */\n    .edit-layout .ad-groups-list {\n        gap: 6px;\n    }\n\n    .edit-layout .ad-group-item {\n        padding: 10px;\n        gap: 8px;\n        border-radius: 8px;\n    }\n\n    .edit-layout .ad-group-name {\n        font-size: 13px;\n    }\n\n    .edit-layout .ad-group-meta {\n        font-size: 11px;\n    }\n\n    .edit-layout .btn-add {\n        padding: 6px 10px;\n        font-size: 12px;\n    }\n\n    .edit-layout .btn-add svg {\n        width: 14px;\n        height: 14px;\n    }\n\n    /* Targeting */\n    .edit-layout .targeting-group {\n        margin-bottom: 14px;\n    }\n\n    .edit-layout .targeting-row {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .edit-layout .targeting-label {\n        font-size: 12px;\n        font-weight: 500;\n    }\n\n    .edit-layout .targeting-tags {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n    }\n\n    .edit-layout .targeting-tag {\n        padding: 8px 10px;\n        font-size: 12px;\n        border-radius: 6px;\n    }\n\n    /* Header */\n    .back-link {\n        font-size: 13px;\n        margin-bottom: 10px;\n    }\n\n    .edit-header {\n        margin-bottom: 12px;\n    }\n\n    .edit-header h1 {\n        font-size: 18px;\n    }\n\n    .edit-header .header-subtitle {\n        font-size: 13px;\n    }\n\n    /* Empty state */\n    .adgroup-panel-empty {\n        min-height: 150px;\n        border-radius: 10px;\n    }\n\n    .adgroup-panel-empty .empty-state {\n        padding: 16px;\n    }\n\n    .adgroup-panel-empty .empty-state-icon {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n/* Edit Campaign - Advanced Sections (768px) */\n@media (max-width: 768px) {\n    /* Inventory */\n    .inventory-columns {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .inventory-column-header {\n        font-size: 13px;\n    }\n\n    .inventory-list-selector {\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .inventory-list-selector select {\n        width: 100%;\n    }\n\n    .inventory-urls-input {\n        font-size: 13px;\n        min-height: 80px;\n        padding: 10px;\n    }\n\n    /* Geo */\n    .geo-columns {\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .geo-column {\n        width: 100%;\n    }\n\n    .geo-email-item {\n        padding: 10px;\n    }\n\n    .geo-email-name {\n        font-size: 13px;\n    }\n\n    .geo-email-input {\n        font-size: 15px;\n    }\n\n    .geo-mode-tabs {\n        width: 100%;\n    }\n\n    .geo-mode-tab {\n        flex: 1;\n        padding: 10px 6px;\n        font-size: 12px;\n    }\n\n    /* Proximity */\n    .proximity-editor-grid {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .proximity-saved-row {\n        flex-wrap: wrap;\n        gap: 6px;\n    }\n\n    .proximity-chip {\n        font-size: 12px;\n        padding: 6px 10px;\n    }\n\n    .proximity-textarea {\n        font-size: 13px;\n        min-height: 80px;\n    }\n\n    .proximity-actions {\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .proximity-actions button {\n        width: 100%;\n    }\n\n    .proximity-map,\n    .proximity-map-container {\n        min-height: 180px;\n    }\n\n    /* Day & Time - horizontal scroll */\n    .day-time-section {\n        padding: 12px 0;\n    }\n\n    .day-time-header {\n        flex-direction: column;\n        gap: 8px;\n        margin-bottom: 10px;\n    }\n\n    .day-time-actions {\n        display: flex;\n        gap: 10px;\n    }\n\n    .day-time-action-link {\n        font-size: 12px;\n    }\n\n    .day-time-grid {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        margin: 0 -14px;\n        padding: 0 14px 8px 14px;\n    }\n\n    .day-time-row {\n        min-width: 520px;\n    }\n\n    .day-time-day-label {\n        width: 36px;\n        min-width: 36px;\n        height: 26px;\n        font-size: 10px;\n    }\n\n    .day-time-hour-label {\n        min-width: 18px;\n        height: 20px;\n        font-size: 9px;\n    }\n\n    .day-time-cell {\n        min-width: 18px;\n        height: 26px;\n    }\n\n    .day-time-legend {\n        flex-wrap: wrap;\n        gap: 8px;\n        margin-top: 8px;\n        font-size: 11px;\n    }\n\n    /* Collapsible */\n    .form-section-header {\n        padding: 10px 0;\n    }\n\n    /* Language */\n    .language-dropdown {\n        max-height: 180px;\n    }\n\n    /* Creatives */\n    .creatives-grid {\n        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n        gap: 8px;\n    }\n\n    .creative-item {\n        padding: 8px;\n        font-size: 11px;\n    }\n}\n\n/* ============================================\n   Category Tree Styles - Refined Design\n   ============================================ */\n\n.category-trigger.has-selection {\n    border-color: var(--accent-orange);\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);\n}\n\n.category-trigger.active {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.category-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 10px;\n    margin-right: 6px;\n}\n\n.category-tree-panel {\n    min-width: 340px;\n    max-width: 420px;\n    border-radius: 12px;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);\n    z-index: 1000;\n    background: white;\n}\n\n/* Navigation Header */\n.category-nav-header {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 12px 14px;\n    background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.category-home-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    background: white;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 6px;\n    cursor: pointer;\n    color: var(--text-secondary);\n    transition: all 0.15s ease;\n}\n\n.category-home-btn:hover {\n    background: white;\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n    transform: scale(1.05);\n}\n\n.category-home-btn.current {\n    background: var(--accent-orange);\n    border-color: var(--accent-orange);\n    color: white;\n}\n\n.category-home-btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n.category-nav-chevron {\n    width: 14px;\n    height: 14px;\n    color: var(--text-tertiary);\n    flex-shrink: 0;\n}\n\n.category-nav-item {\n    background: none;\n    border: none;\n    padding: 4px 8px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n    max-width: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.category-nav-item:hover {\n    background: rgba(0, 0, 0, 0.05);\n    color: var(--text-primary);\n}\n\n.category-nav-item.current {\n    background: white;\n    color: var(--text-primary);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n/* Search */\n.category-search-wrapper {\n    position: relative;\n    padding: 10px 14px;\n    background: white;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.category-search-icon {\n    position: absolute;\n    left: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 16px;\n    height: 16px;\n    color: var(--text-tertiary);\n    pointer-events: none;\n}\n\n.category-search-input {\n    width: 100%;\n    padding: 10px 36px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    font-size: 13px;\n    background: var(--bg-primary);\n    transition: all 0.15s ease;\n}\n\n.category-search-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    background: white;\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.category-search-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.category-search-clear {\n    position: absolute;\n    right: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--text-tertiary);\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    color: white;\n    transition: all 0.15s ease;\n}\n\n.category-search-clear:hover {\n    background: var(--text-secondary);\n    transform: translateY(-50%) scale(1.1);\n}\n\n.category-search-clear svg {\n    width: 12px;\n    height: 12px;\n}\n\n/* Category List */\n.category-tree-list {\n    max-height: 320px;\n    overflow-y: auto;\n    padding: 6px 0;\n    background: white;\n}\n\n.category-tree-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    margin: 2px 8px;\n    border-radius: 8px;\n    cursor: default;\n    transition: all 0.15s ease;\n    animation: categoryFadeIn 0.2s ease forwards;\n    opacity: 0;\n}\n\n@keyframes categoryFadeIn {\n    from {\n        opacity: 0;\n        transform: translateX(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.category-tree-item:hover {\n    background: rgba(0, 0, 0, 0.03);\n}\n\n.category-tree-item.selected {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(233, 75, 108, 0.06) 100%);\n}\n\n.category-tree-item.selected:hover {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.1) 100%);\n}\n\n/* Custom Checkbox */\n.category-checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.category-checkbox-input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.category-checkbox-custom {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    background: white;\n    transition: all 0.15s ease;\n}\n\n.category-checkbox-custom svg {\n    width: 12px;\n    height: 12px;\n    color: white;\n    opacity: 0;\n    transform: scale(0.5);\n    transition: all 0.15s ease;\n}\n\n.category-checkbox-wrapper:hover .category-checkbox-custom {\n    border-color: var(--accent-orange);\n}\n\n.category-checkbox-input:checked + .category-checkbox-custom {\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n    border-color: transparent;\n}\n\n.category-checkbox-input:checked + .category-checkbox-custom svg {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.category-checkbox-input:focus + .category-checkbox-custom {\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.2);\n}\n\n/* Category Name */\n.category-tree-item .category-name {\n    flex: 1;\n    font-size: 13px;\n    font-weight: 450;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.category-tree-item.selected .category-name {\n    color: var(--accent-orange);\n    font-weight: 500;\n}\n\n/* Clickable row for categories with children */\n.category-tree-item.has-children {\n    cursor: pointer;\n}\n\n.category-tree-item.has-children:hover {\n    background: linear-gradient(90deg, rgba(255, 107, 74, 0.06) 0%, rgba(255, 107, 74, 0.02) 100%);\n}\n\n.category-tree-item.has-children.selected:hover {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.14) 0%, rgba(233, 75, 108, 0.1) 100%);\n}\n\n/* Drill Down Icon */\n.category-drill-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    color: var(--text-tertiary);\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.category-drill-icon svg {\n    width: 16px;\n    height: 16px;\n}\n\n.category-tree-item.has-children:hover .category-drill-icon {\n    color: var(--accent-orange);\n    transform: translateX(3px);\n}\n\n/* Empty State */\n.category-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 16px;\n    color: var(--text-tertiary);\n    gap: 8px;\n}\n\n.category-empty svg {\n    width: 32px;\n    height: 32px;\n    opacity: 0.5;\n}\n\n.category-empty span {\n    font-size: 13px;\n}\n\n/* Loading State */\n.category-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 16px;\n    gap: 12px;\n    color: var(--text-secondary);\n    font-size: 13px;\n}\n\n.category-loading-spinner {\n    width: 24px;\n    height: 24px;\n    border: 2px solid rgba(255, 107, 74, 0.2);\n    border-top-color: var(--accent-orange);\n    border-radius: 50%;\n    animation: categorySpinner 0.8s linear infinite;\n}\n\n@keyframes categorySpinner {\n    to { transform: rotate(360deg); }\n}\n\n/* Selected Tags */\n.category-selected-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n}\n\n.category-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 8px 6px 12px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.08) 100%);\n    border: 1px solid rgba(255, 107, 74, 0.2);\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--accent-orange);\n    animation: tagFadeIn 0.2s ease forwards;\n    opacity: 0;\n}\n\n@keyframes tagFadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.category-tag-text {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.category-tag-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: rgba(255, 107, 74, 0.15);\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    color: var(--accent-orange);\n    transition: all 0.15s ease;\n}\n\n.category-tag-remove:hover {\n    background: var(--accent-orange);\n    color: white;\n    transform: scale(1.1);\n}\n\n.category-tag-remove svg {\n    width: 10px;\n    height: 10px;\n}\n\n.category-clear-all {\n    padding: 6px 12px;\n    background: none;\n    border: 1px dashed rgba(0, 0, 0, 0.15);\n    border-radius: 20px;\n    font-size: 12px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.category-clear-all:hover {\n    border-color: var(--accent-red);\n    color: var(--accent-red);\n    background: rgba(233, 75, 108, 0.05);\n}\n\n/* ============================================\n   Language Dropdown Styles - Refined Design\n   ============================================ */\n\n.language-trigger.has-selection {\n    border-color: var(--accent-orange);\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(233, 75, 108, 0.04) 100%);\n}\n\n.language-trigger.active {\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.language-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 10px;\n    margin-right: 6px;\n}\n\n.language-panel {\n    min-width: 280px;\n    max-width: 320px;\n    border-radius: 12px;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);\n    z-index: 1000;\n    background: white;\n    overflow: hidden;\n}\n\n/* Search */\n.language-search-wrapper {\n    position: relative;\n    padding: 12px 14px;\n    background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.language-search-icon {\n    position: absolute;\n    left: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 16px;\n    height: 16px;\n    color: var(--text-tertiary);\n    pointer-events: none;\n}\n\n.language-search-input {\n    width: 100%;\n    padding: 10px 36px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    font-size: 13px;\n    background: white;\n    transition: all 0.15s ease;\n}\n\n.language-search-input:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.language-search-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.language-search-clear {\n    position: absolute;\n    right: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--text-tertiary);\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    color: white;\n    transition: all 0.15s ease;\n}\n\n.language-search-clear:hover {\n    background: var(--text-secondary);\n    transform: translateY(-50%) scale(1.1);\n}\n\n.language-search-clear svg {\n    width: 12px;\n    height: 12px;\n}\n\n/* Language List */\n.language-list {\n    max-height: 280px;\n    overflow-y: auto;\n    padding: 6px 0;\n    background: white;\n}\n\n.language-item {\n    display: flex;\n    align-items: center;\n    padding: 2px 8px;\n    margin: 0 6px;\n    border-radius: 6px;\n    transition: all 0.15s ease;\n    animation: languageFadeIn 0.2s ease forwards;\n    opacity: 0;\n}\n\n@keyframes languageFadeIn {\n    from {\n        opacity: 0;\n        transform: translateX(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.language-item:hover {\n    background: rgba(0, 0, 0, 0.03);\n}\n\n.language-item.selected {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(233, 75, 108, 0.06) 100%);\n}\n\n.language-item.selected:hover {\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.1) 100%);\n}\n\n/* Checkbox */\n.language-checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    padding: 8px 6px;\n    flex: 1;\n}\n\n.language-checkbox-input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.language-checkbox-custom {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    background: white;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n}\n\n.language-checkbox-custom svg {\n    width: 12px;\n    height: 12px;\n    color: white;\n    opacity: 0;\n    transform: scale(0.5);\n    transition: all 0.15s ease;\n}\n\n.language-checkbox-wrapper:hover .language-checkbox-custom {\n    border-color: var(--accent-orange);\n}\n\n.language-checkbox-input:checked + .language-checkbox-custom {\n    background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n    border-color: transparent;\n}\n\n.language-checkbox-input:checked + .language-checkbox-custom svg {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.language-name {\n    font-size: 13px;\n    font-weight: 450;\n    color: var(--text-primary);\n}\n\n.language-item.selected .language-name {\n    color: var(--accent-orange);\n    font-weight: 500;\n}\n\n/* Empty State */\n.language-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 16px;\n    color: var(--text-tertiary);\n    gap: 8px;\n}\n\n.language-empty svg {\n    width: 32px;\n    height: 32px;\n    opacity: 0.5;\n}\n\n.language-empty span {\n    font-size: 13px;\n}\n\n/* Selected Tags */\n.language-selected-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n}\n\n.language-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 8px 6px 12px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(233, 75, 108, 0.08) 100%);\n    border: 1px solid rgba(255, 107, 74, 0.2);\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--accent-orange);\n    animation: languageTagFadeIn 0.2s ease forwards;\n    opacity: 0;\n}\n\n@keyframes languageTagFadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.language-tag-text {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.language-tag-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: rgba(255, 107, 74, 0.15);\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    color: var(--accent-orange);\n    transition: all 0.15s ease;\n}\n\n.language-tag-remove:hover {\n    background: var(--accent-orange);\n    color: white;\n    transform: scale(1.1);\n}\n\n.language-tag-remove svg {\n    width: 10px;\n    height: 10px;\n}\n\n.language-clear-all {\n    padding: 6px 12px;\n    background: none;\n    border: 1px dashed rgba(0, 0, 0, 0.15);\n    border-radius: 20px;\n    font-size: 12px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.language-clear-all:hover {\n    border-color: var(--accent-red);\n    color: var(--accent-red);\n    background: rgba(233, 75, 108, 0.05);\n}\n\n/* ============================================================\n   Advanced Targeting Component - Clean 3-Column Layout\n   ============================================================ */\n\n.at-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    width: 100%;\n    padding: 16px 0;\n}\n\n@media (max-width: 1400px) {\n    .at-container {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 900px) {\n    .at-container {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Category Block */\n.at-category-block {\n    border: 1px solid #e8e8eb;\n    border-radius: 12px;\n    background: #fff;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    transition: box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.at-category-block:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n/* Category Color Variations */\n.at-category-demographics {\n    border-color: rgba(255, 107, 74, 0.2);\n}\n.at-category-demographics:hover {\n    border-color: rgba(255, 107, 74, 0.4);\n}\n.at-category-demographics .at-category-icon {\n    background: rgba(255, 107, 74, 0.1);\n}\n.at-category-demographics .at-category-icon svg {\n    stroke: #FF6B4A;\n}\n.at-category-demographics .at-category-count {\n    color: #FF6B4A;\n    background: rgba(255, 107, 74, 0.1);\n}\n.at-category-demographics .at-selector-trigger:hover,\n.at-category-demographics .at-selector-trigger.open {\n    border-color: #FF6B4A;\n}\n.at-category-demographics .at-selector-trigger:hover {\n    background: rgba(255, 107, 74, 0.03);\n    color: #FF6B4A;\n}\n.at-category-demographics .at-selector-trigger:hover .at-selector-chevron,\n.at-category-demographics .at-selector-trigger.open .at-selector-chevron {\n    color: #FF6B4A;\n}\n.at-category-demographics .at-breadcrumb-root {\n    color: #FF6B4A;\n}\n.at-category-demographics .at-breadcrumb-item:hover {\n    background: rgba(255, 107, 74, 0.1);\n    color: #FF6B4A;\n}\n.at-category-demographics .at-list-folder.has-selected {\n    background: rgba(255, 107, 74, 0.06);\n    border-left-color: #FF6B4A;\n}\n.at-category-demographics .at-list-folder.has-selected:hover {\n    background: rgba(255, 107, 74, 0.1);\n}\n.at-category-demographics .at-item-badge {\n    color: #FF6B4A;\n    background: rgba(255, 107, 74, 0.12);\n}\n.at-category-demographics .at-list-leaf.selected {\n    background: rgba(255, 107, 74, 0.08);\n}\n.at-category-demographics .at-list-leaf.selected:hover {\n    background: rgba(255, 107, 74, 0.12);\n}\n.at-category-demographics .at-list-leaf:hover .at-checkbox:not(.checked) {\n    border-color: #FF6B4A;\n}\n.at-category-demographics .at-checkbox.checked {\n    background: #FF6B4A;\n    border-color: #FF6B4A;\n}\n.at-category-demographics .at-list-folder:hover .at-item-arrow {\n    color: #FF6B4A;\n}\n.at-category-demographics .at-tag {\n    background: rgba(255, 107, 74, 0.08);\n    border-color: rgba(255, 107, 74, 0.2);\n}\n.at-category-demographics .at-tag-remove:hover {\n    background: #FF6B4A;\n}\n\n.at-category-intentions {\n    border-color: rgba(233, 75, 108, 0.2);\n}\n.at-category-intentions:hover {\n    border-color: rgba(233, 75, 108, 0.4);\n}\n.at-category-intentions .at-category-icon {\n    background: rgba(233, 75, 108, 0.1);\n}\n.at-category-intentions .at-category-icon svg {\n    stroke: #E94B6C;\n}\n.at-category-intentions .at-category-count {\n    color: #E94B6C;\n    background: rgba(233, 75, 108, 0.1);\n}\n.at-category-intentions .at-selector-trigger:hover,\n.at-category-intentions .at-selector-trigger.open {\n    border-color: #E94B6C;\n}\n.at-category-intentions .at-selector-trigger:hover {\n    background: rgba(233, 75, 108, 0.03);\n    color: #E94B6C;\n}\n.at-category-intentions .at-selector-trigger:hover .at-selector-chevron,\n.at-category-intentions .at-selector-trigger.open .at-selector-chevron {\n    color: #E94B6C;\n}\n.at-category-intentions .at-breadcrumb-root {\n    color: #E94B6C;\n}\n.at-category-intentions .at-breadcrumb-item:hover {\n    background: rgba(233, 75, 108, 0.1);\n    color: #E94B6C;\n}\n.at-category-intentions .at-list-folder.has-selected {\n    background: rgba(233, 75, 108, 0.06);\n    border-left-color: #E94B6C;\n}\n.at-category-intentions .at-list-folder.has-selected:hover {\n    background: rgba(233, 75, 108, 0.1);\n}\n.at-category-intentions .at-item-badge {\n    color: #E94B6C;\n    background: rgba(233, 75, 108, 0.12);\n}\n.at-category-intentions .at-list-leaf.selected {\n    background: rgba(233, 75, 108, 0.08);\n}\n.at-category-intentions .at-list-leaf.selected:hover {\n    background: rgba(233, 75, 108, 0.12);\n}\n.at-category-intentions .at-list-leaf:hover .at-checkbox:not(.checked) {\n    border-color: #E94B6C;\n}\n.at-category-intentions .at-checkbox.checked {\n    background: #E94B6C;\n    border-color: #E94B6C;\n}\n.at-category-intentions .at-list-folder:hover .at-item-arrow {\n    color: #E94B6C;\n}\n.at-category-intentions .at-tag {\n    background: rgba(233, 75, 108, 0.08);\n    border-color: rgba(233, 75, 108, 0.2);\n}\n.at-category-intentions .at-tag-remove:hover {\n    background: #E94B6C;\n}\n\n.at-category-preferences {\n    border-color: rgba(142, 58, 154, 0.2);\n}\n.at-category-preferences:hover {\n    border-color: rgba(142, 58, 154, 0.4);\n}\n.at-category-preferences .at-category-icon {\n    background: rgba(142, 58, 154, 0.1);\n}\n.at-category-preferences .at-category-icon svg {\n    stroke: #8E3A9A;\n}\n.at-category-preferences .at-category-count {\n    color: #8E3A9A;\n    background: rgba(142, 58, 154, 0.1);\n}\n.at-category-preferences .at-selector-trigger:hover,\n.at-category-preferences .at-selector-trigger.open {\n    border-color: #8E3A9A;\n}\n.at-category-preferences .at-selector-trigger:hover {\n    background: rgba(142, 58, 154, 0.03);\n    color: #8E3A9A;\n}\n.at-category-preferences .at-selector-trigger:hover .at-selector-chevron,\n.at-category-preferences .at-selector-trigger.open .at-selector-chevron {\n    color: #8E3A9A;\n}\n.at-category-preferences .at-breadcrumb-root {\n    color: #8E3A9A;\n}\n.at-category-preferences .at-breadcrumb-item:hover {\n    background: rgba(142, 58, 154, 0.1);\n    color: #8E3A9A;\n}\n.at-category-preferences .at-list-folder.has-selected {\n    background: rgba(142, 58, 154, 0.06);\n    border-left-color: #8E3A9A;\n}\n.at-category-preferences .at-list-folder.has-selected:hover {\n    background: rgba(142, 58, 154, 0.1);\n}\n.at-category-preferences .at-item-badge {\n    color: #8E3A9A;\n    background: rgba(142, 58, 154, 0.12);\n}\n.at-category-preferences .at-list-leaf.selected {\n    background: rgba(142, 58, 154, 0.08);\n}\n.at-category-preferences .at-list-leaf.selected:hover {\n    background: rgba(142, 58, 154, 0.12);\n}\n.at-category-preferences .at-list-leaf:hover .at-checkbox:not(.checked) {\n    border-color: #8E3A9A;\n}\n.at-category-preferences .at-checkbox.checked {\n    background: #8E3A9A;\n    border-color: #8E3A9A;\n}\n.at-category-preferences .at-list-folder:hover .at-item-arrow {\n    color: #8E3A9A;\n}\n.at-category-preferences .at-tag {\n    background: rgba(142, 58, 154, 0.08);\n    border-color: rgba(142, 58, 154, 0.2);\n}\n.at-category-preferences .at-tag-remove:hover {\n    background: #8E3A9A;\n}\n\n/* Category Header */\n.at-category-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.at-category-icon {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.at-category-icon svg {\n    width: 20px;\n    height: 20px;\n}\n\n.at-category-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.at-category-label {\n    display: block;\n    font-size: 15px;\n    font-weight: 600;\n    color: #1f2937;\n    line-height: 1.3;\n}\n\n.at-category-desc {\n    display: block;\n    font-size: 12px;\n    color: #9ca3af;\n    line-height: 1.3;\n    margin-top: 2px;\n}\n\n.at-category-count {\n    font-size: 12px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 12px;\n    flex-shrink: 0;\n}\n\n/* Selector */\n.at-selector-wrap {\n    position: relative;\n}\n\n.at-selector-trigger {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 14px;\n    border: 1px dashed #d1d5db;\n    border-radius: 8px;\n    background: #fafbfc;\n    font-size: 13px;\n    color: #6b7280;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.at-selector-trigger:hover {\n    border-color: #E94B6C;\n    border-style: solid;\n    background: rgba(233, 75, 108, 0.03);\n    color: #E94B6C;\n}\n\n.at-selector-trigger.open {\n    border-color: #E94B6C;\n    border-style: solid;\n    background: #fff;\n    color: #374151;\n}\n\n.at-selector-trigger:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.at-selector-chevron {\n    width: 16px;\n    height: 16px;\n    color: #9ca3af;\n    transition: transform 0.2s ease;\n}\n\n.at-selector-trigger:hover .at-selector-chevron {\n    color: #E94B6C;\n}\n\n.at-selector-trigger.open .at-selector-chevron {\n    transform: rotate(180deg);\n    color: #E94B6C;\n}\n\n/* Dropdown */\n.at-dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    background: #fff;\n    border: 1px solid #e8e8eb;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    z-index: 100;\n    max-height: 340px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* Breadcrumb */\n.at-breadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 10px 14px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.04), rgba(142, 58, 154, 0.04));\n    border-bottom: 1px solid #f0f0f2;\n    flex-wrap: wrap;\n    min-height: 40px;\n}\n\n.at-breadcrumb-item {\n    padding: 3px 8px;\n    border: none;\n    background: none;\n    font-size: 12px;\n    color: #6b7280;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n}\n\n.at-breadcrumb-item:hover {\n    background: rgba(233, 75, 108, 0.1);\n    color: #E94B6C;\n}\n\n.at-breadcrumb-item.current {\n    color: #1f2937;\n    font-weight: 500;\n}\n\n.at-breadcrumb-root {\n    font-weight: 500;\n    color: #E94B6C;\n}\n\n.at-breadcrumb-sep {\n    color: #d1d5db;\n    font-size: 11px;\n}\n\n/* Search */\n.at-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.at-search svg {\n    width: 14px;\n    height: 14px;\n    color: #9ca3af;\n    flex-shrink: 0;\n}\n\n.at-search input {\n    flex: 1;\n    border: none;\n    background: none;\n    font-size: 13px;\n    color: #374151;\n    outline: none;\n}\n\n.at-search input::placeholder {\n    color: #9ca3af;\n}\n\n.at-search-clear {\n    width: 18px;\n    height: 18px;\n    border: none;\n    background: #e5e7eb;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: all 0.15s ease;\n}\n\n.at-search-clear svg {\n    width: 10px;\n    height: 10px;\n    color: #6b7280;\n}\n\n.at-search-clear:hover {\n    background: #E94B6C;\n}\n\n.at-search-clear:hover svg {\n    color: #fff;\n}\n\n/* List */\n.at-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 6px 0;\n}\n\n.at-list-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.at-list-item:hover {\n    background: #f9fafb;\n}\n\n.at-list-folder {\n    color: #374151;\n}\n\n.at-list-folder.has-selected {\n    background: rgba(233, 75, 108, 0.06);\n    border-left: 3px solid #E94B6C;\n    padding-left: 11px;\n}\n\n.at-list-folder.has-selected:hover {\n    background: rgba(233, 75, 108, 0.1);\n}\n\n.at-list-leaf {\n    color: #374151;\n}\n\n.at-list-leaf.selected {\n    background: rgba(233, 75, 108, 0.08);\n}\n\n.at-list-leaf.selected:hover {\n    background: rgba(233, 75, 108, 0.12);\n}\n\n.at-item-name {\n    flex: 1;\n    font-size: 13px;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.at-item-path {\n    font-size: 11px;\n    color: #9ca3af;\n    margin-left: 8px;\n    flex-shrink: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 150px;\n}\n\n.at-item-badge {\n    font-size: 11px;\n    font-weight: 600;\n    color: #E94B6C;\n    background: rgba(233, 75, 108, 0.12);\n    padding: 2px 8px;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.at-item-total {\n    font-size: 11px;\n    color: #9ca3af;\n    flex-shrink: 0;\n}\n\n.at-item-arrow {\n    width: 14px;\n    height: 14px;\n    color: #d1d5db;\n    flex-shrink: 0;\n    transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.at-list-folder:hover .at-item-arrow {\n    transform: translateX(3px);\n    color: #E94B6C;\n}\n\n/* Checkbox */\n.at-checkbox {\n    width: 16px;\n    height: 16px;\n    border: 1.5px solid #d1d5db;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: #fff;\n    transition: all 0.15s ease;\n}\n\n.at-checkbox svg {\n    width: 10px;\n    height: 10px;\n    color: #fff;\n}\n\n.at-checkbox.checked {\n    background: linear-gradient(135deg, #FF6B4A, #E94B6C);\n    border-color: #E94B6C;\n}\n\n.at-list-leaf:hover .at-checkbox:not(.checked) {\n    border-color: #E94B6C;\n}\n\n/* Loading & Empty */\n.at-loading,\n.at-empty {\n    padding: 24px 12px;\n    text-align: center;\n    font-size: 13px;\n    color: #9ca3af;\n}\n\n/* Selected Tags */\n.at-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 4px;\n}\n\n.at-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.08), rgba(233, 75, 108, 0.08));\n    border: 1px solid rgba(233, 75, 108, 0.2);\n    border-radius: 6px;\n    font-size: 12px;\n    color: #374151;\n}\n\n.at-tag-text {\n    max-width: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.at-tag-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n}\n\n.at-tag-remove svg {\n    width: 10px;\n    height: 10px;\n    color: #9ca3af;\n}\n\n.at-tag-remove:hover {\n    background: #E94B6C;\n}\n\n.at-tag-remove:hover svg {\n    color: #fff;\n}\n\n.at-tag-remove:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n\n/* ============================================\n   Create Campaign & Groups Styles\n   ============================================ */\n\n/* Header Actions */\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Draft Badge */\n.draft-badge {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    padding: 3px 8px;\n    background: linear-gradient(135deg, rgba(255, 193, 7, 0.15), rgba(255, 152, 0, 0.15));\n    border: 1px solid rgba(255, 152, 0, 0.3);\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #f59e0b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Pacing Badge */\n.pacing-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 8px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: rgba(243, 156, 18, 0.15);\n    color: #f39c12;\n}\n\n.pacing-badge.paused {\n    background: rgba(142, 58, 154, 0.15);\n    color: var(--accent-purple, #8e3a9a);\n}\n\n.pacing-badge.warning {\n    background: rgba(243, 156, 18, 0.15);\n    color: #f39c12;\n}\n\n.pacing-badge.info {\n    background: rgba(59, 130, 246, 0.15);\n    color: #3b82f6;\n}\n\n/* Pacing Alert Row */\n.ad-groups-table tr.alert-row td {\n    padding: 0;\n    background: transparent !important;\n    border: none;\n}\n\n.ad-groups-table tr.alert-row:hover td {\n    background: transparent !important;\n}\n\n.ad-groups-table tr.has-alert td {\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n.pacing-alert-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 24px;\n    border-radius: 0;\n    border: none;\n    border-top: 1px solid #e9ecef;\n}\n\n/* Danger style - behind pace (red) */\n.pacing-alert-card.danger {\n    background: linear-gradient(135deg, rgba(231, 76, 60, 0.12), rgba(231, 76, 60, 0.06));\n    border-top: 2px solid rgba(231, 76, 60, 0.4);\n}\n\n/* Paused style - ahead/paused (purple) */\n.pacing-alert-card.paused {\n    background: linear-gradient(135deg, rgba(142, 58, 154, 0.1), rgba(142, 58, 154, 0.04));\n    border-top: 2px solid rgba(142, 58, 154, 0.3);\n}\n\n.pacing-alert-card .alert-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #6c757d;\n}\n\n.pacing-alert-card.danger .alert-icon {\n    color: #c0392b;\n}\n\n.pacing-alert-card.paused .alert-icon {\n    color: var(--accent-purple, #8e3a9a);\n}\n\n.pacing-alert-card .alert-content {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex: 1;\n}\n\n.pacing-alert-card .alert-message {\n    font-size: 13px;\n    color: #1a1a1a;\n    line-height: 1.4;\n}\n\n.pacing-alert-card.danger .alert-message {\n    color: #1a1a1a;\n}\n\n.pacing-alert-card.paused .alert-message {\n    color: #1a1a1a;\n}\n\n.pacing-alert-card .alert-action-btn {\n    padding: 6px 14px;\n    background: #c0392b;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.pacing-alert-card .alert-action-btn:hover:not(:disabled) {\n    background: #a93226;\n}\n\n.pacing-alert-card .alert-action-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Campaign Alert Badge */\n.campaign-alert-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background: rgba(59, 130, 246, 0.12);\n    color: #3b82f6;\n    border: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.campaign-alert-badge:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);\n}\n\n.campaign-alert-badge.warning {\n    background: rgba(243, 156, 18, 0.12);\n    color: #f39c12;\n    border-color: rgba(243, 156, 18, 0.25);\n}\n\n.campaign-alert-badge.warning:hover {\n    box-shadow: 0 2px 8px rgba(243, 156, 18, 0.2);\n}\n\n.campaign-alert-badge.paused {\n    background: rgba(142, 58, 154, 0.12);\n    color: var(--accent-purple, #8e3a9a);\n    border-color: rgba(142, 58, 154, 0.25);\n}\n\n.campaign-alert-badge.paused:hover {\n    box-shadow: 0 2px 8px rgba(142, 58, 154, 0.2);\n}\n\n.campaign-alert-badge.danger {\n    background: rgba(231, 76, 60, 0.12);\n    color: var(--danger, #e74c3c);\n    border-color: rgba(231, 76, 60, 0.25);\n}\n\n.campaign-alert-badge.danger:hover {\n    box-shadow: 0 2px 8px rgba(231, 76, 60, 0.2);\n}\n\n.campaign-alert-badge.throttle {\n    background: rgba(255, 159, 67, 0.12);\n    color: #ff9f43;\n    border-color: rgba(255, 159, 67, 0.25);\n    cursor: default;\n}\n\n.campaign-alert-badge.throttle:hover {\n    box-shadow: 0 2px 8px rgba(255, 159, 67, 0.2);\n    transform: none;\n}\n\n/* Publish Button - filled gradient style */\n.btn-publish {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    padding: 9px 14px;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);\n}\n\n.btn-publish:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);\n}\n\n.btn-publish:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.btn-publish.fields-missing {\n    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n    box-shadow: none;\n}\n\n.btn-publish.fields-missing:hover {\n    transform: none;\n}\n\n.btn-publish.publishing {\n    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);\n}\n\n.btn-publish.success {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n}\n\n.btn-publish svg {\n    width: 14px;\n    height: 14px;\n}\n\n/* Targeting Pending Indicator */\n.targeting-pending-indicator {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 10px;\n    background: #f3f4f6;\n    border-radius: 6px;\n    color: #9ca3af;\n}\n\n.targeting-pending-indicator .pending-clock-icon {\n    width: 16px;\n    height: 16px;\n    animation: pulse-pending 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-pending {\n    0%, 100% { opacity: 0.5; }\n    50% { opacity: 1; }\n}\n\n/* Create Mode Notice */\n.create-mode-notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.05), rgba(139, 92, 246, 0.05));\n    border: 1px solid rgba(99, 102, 241, 0.15);\n    border-radius: 8px;\n}\n\n.create-mode-notice .notice-icon {\n    width: 20px;\n    height: 20px;\n    color: #6366f1;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.create-mode-notice .notice-text {\n    flex: 1;\n}\n\n.create-mode-notice .notice-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 4px;\n}\n\n.create-mode-notice .notice-description {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* Create Group Notice */\n.create-group-notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px;\n    margin-top: 24px;\n    background: linear-gradient(135deg, rgba(245, 158, 11, 0.05), rgba(251, 191, 36, 0.05));\n    border: 1px solid rgba(245, 158, 11, 0.2);\n    border-radius: 8px;\n}\n\n.create-group-notice .notice-icon {\n    width: 18px;\n    height: 18px;\n    color: #f59e0b;\n    flex-shrink: 0;\n    margin-top: 1px;\n}\n\n.create-group-notice .notice-text {\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.5;\n}\n\n/* Draft Campaign Card */\n.draft-card-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 24px;\n    min-height: 200px;\n}\n\n.draft-notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 20px;\n    background: linear-gradient(135deg, rgba(245, 158, 11, 0.06), rgba(251, 191, 36, 0.06));\n    border: 1px solid rgba(245, 158, 11, 0.15);\n    border-radius: 12px;\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.draft-notice .draft-icon {\n    width: 24px;\n    height: 24px;\n    color: #f59e0b;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.draft-notice .draft-text {\n    flex: 1;\n}\n\n.draft-notice .draft-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #92400e;\n    margin-bottom: 4px;\n}\n\n.draft-notice .draft-description {\n    font-size: 13px;\n    color: #a16207;\n    line-height: 1.5;\n}\n\n.draft-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.btn-edit-draft {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 10px 18px;\n    background: #fff;\n    color: var(--text-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-edit-draft:hover {\n    border-color: var(--text-tertiary);\n    color: var(--text-primary);\n}\n\n.btn-edit-draft svg {\n    width: 14px;\n    height: 14px;\n}\n\n.btn-publish-draft {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 10px 18px;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);\n}\n\n.btn-publish-draft:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);\n}\n\n.btn-publish-draft:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.btn-publish-draft svg {\n    width: 14px;\n    height: 14px;\n}\n\n/* Draft badge - inline badge next to group name */\n.draft-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 6px;\n    margin-left: 8px;\n    border-radius: 4px;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(251, 191, 36, 0.15));\n    color: #b45309;\n    border: 1px solid rgba(245, 158, 11, 0.3);\n}\n\n.edit-layout .ad-group-name .draft-badge {\n    font-size: 9px;\n    padding: 1px 5px;\n    margin-left: 6px;\n}\n\n.field-label .draft-badge {\n    font-size: 9px;\n    padding: 2px 6px;\n    vertical-align: middle;\n}\n\n/* ============================================\n   CREATIVES PAGE STYLES\n   ============================================ */\n\n/* Header Select (for dropdowns in page headers) */\n.header-select {\n    padding: 10px 14px;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: inherit;\n    min-width: 180px;\n    background: white;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.2s;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\n\n.header-select:hover {\n    border-color: #adb5bd;\n}\n\n.header-select:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.08);\n}\n\n/* Creatives Grid */\n.creatives-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 24px;\n    animation: fadeInUp 0.5s ease;\n}\n\n/* Creative Card */\n.creative-card {\n    background: var(--bg-card);\n    border: 1px solid #e9ecef;\n    border-radius: 16px;\n    overflow: hidden;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n.creative-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: var(--accent-gradient);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.creative-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);\n    border-color: rgba(142, 58, 154, 0.2);\n}\n\n.creative-card:hover::before {\n    opacity: 1;\n}\n\n/* Creative Preview */\n.creative-preview {\n    height: 180px;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.creative-preview img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n}\n\n.creative-card:hover .creative-preview img {\n    transform: scale(1.05);\n}\n\n.creative-placeholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: var(--text-tertiary);\n}\n\n.creative-placeholder svg {\n    width: 48px;\n    height: 48px;\n    opacity: 0.5;\n}\n\n.creative-placeholder.video svg {\n    color: var(--accent-red);\n    opacity: 0.7;\n}\n\n.creative-placeholder.html5 svg {\n    color: var(--accent-purple);\n    opacity: 0.7;\n}\n\n.creative-placeholder span {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* Creative Content */\n.creative-content {\n    padding: 20px;\n}\n\n.creative-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 12px;\n}\n\n.creative-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 0;\n    line-height: 1.3;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-right: 8px;\n}\n\n.creative-actions-dropdown .actions-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    color: var(--text-tertiary);\n}\n\n.creative-actions-dropdown .actions-btn:hover {\n    background: var(--bg-tertiary);\n    color: var(--text-primary);\n}\n\n.creative-actions-dropdown .actions-btn svg {\n    width: 18px;\n    height: 18px;\n}\n\n/* Creative Badges */\n.creative-badges {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n}\n\n.creative-type-badge {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 4px 10px;\n    border-radius: 6px;\n    border: 1.5px solid currentColor;\n    background: transparent;\n}\n\n.creative-badge {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 6px;\n}\n\n.creative-badge.status-draft {\n    background: rgba(108, 117, 125, 0.1);\n    color: #6c757d;\n}\n\n.creative-badge.status-pending {\n    background: rgba(245, 158, 11, 0.1);\n    color: #d97706;\n}\n\n.creative-badge.status-approved {\n    background: rgba(16, 185, 129, 0.1);\n    color: #059669;\n}\n\n.creative-badge.status-rejected {\n    background: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n}\n\n.creative-badge.status-unknown {\n    background: rgba(107, 114, 128, 0.1);\n    color: #6b7280;\n}\n\n/* Creative Meta */\n.creative-meta {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.creative-meta .meta-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n.creative-meta .meta-item svg {\n    opacity: 0.6;\n}\n\n/* Creative Actions */\n.creative-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding-top: 16px;\n    border-top: 1px solid #f0f0f0;\n}\n\n.creative-actions .btn {\n    flex: 1;\n    min-width: 80px;\n}\n\n/* Empty State Card */\n.empty-state-card {\n    background: var(--bg-card);\n    border: 2px dashed #e0e0e0;\n    border-radius: 20px;\n    padding: 80px 40px;\n    text-align: center;\n    animation: fadeInUp 0.5s ease;\n}\n\n.empty-state-icon {\n    width: 80px;\n    height: 80px;\n    margin: 0 auto 24px;\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.1), rgba(142, 58, 154, 0.1));\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.empty-state-icon svg {\n    width: 40px;\n    height: 40px;\n    color: var(--accent-purple);\n}\n\n.empty-state-card h3 {\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 0 0 8px;\n}\n\n.empty-state-card p {\n    font-size: 14px;\n    color: var(--text-secondary);\n    margin: 0 0 24px;\n}\n\n/* Loading State */\n.loading-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 80px 20px;\n    text-align: center;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #e9ecef;\n    border-top-color: var(--accent-orange);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n.loading-state p {\n    color: var(--text-secondary);\n    font-size: 14px;\n    margin: 0;\n}\n\n/* Alert Banner */\n.alert {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 18px;\n    border-radius: 12px;\n    margin-bottom: 24px;\n    animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.alert-error {\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    color: #dc2626;\n}\n\n.alert-error svg {\n    flex-shrink: 0;\n}\n\n.alert span {\n    flex: 1;\n    font-size: 14px;\n}\n\n.alert-close {\n    width: 28px;\n    height: 28px;\n    border: none;\n    background: transparent;\n    color: currentColor;\n    font-size: 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: background 0.2s ease;\n    opacity: 0.6;\n}\n\n.alert-close:hover {\n    background: rgba(0, 0, 0, 0.1);\n    opacity: 1;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n.modal {\n    background: var(--bg-card);\n    border-radius: 20px;\n    width: 100%;\n    max-width: 520px;\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    animation: modalSlideUp 0.3s ease;\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n}\n\n@keyframes modalSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px) scale(0.95);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 28px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.modal-header h2 {\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.modal-close {\n    width: 36px;\n    height: 36px;\n    border: none;\n    background: var(--bg-tertiary);\n    border-radius: 10px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    color: var(--text-secondary);\n}\n\n.modal-close:hover {\n    background: #e9ecef;\n    color: var(--text-primary);\n}\n\n.modal-close svg {\n    width: 20px;\n    height: 20px;\n}\n\n.modal-body {\n    padding: 28px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 20px 28px;\n    border-top: 1px solid #f0f0f0;\n    background: #fafbfc;\n}\n\n/* Form Styles */\n.form-group {\n    margin-bottom: 24px;\n}\n\n.form-group:last-child {\n    margin-bottom: 0;\n}\n\n.form-group label {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 8px;\n}\n\n.form-group label .optional {\n    font-weight: 400;\n    color: var(--text-tertiary);\n}\n\n.form-input,\n.form-textarea {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1.5px solid #e9ecef;\n    border-radius: 10px;\n    font-size: 14px;\n    color: var(--text-primary);\n    background: var(--bg-card);\n    transition: all 0.2s ease;\n}\n\n.form-input:hover,\n.form-textarea:hover {\n    border-color: #d1d5db;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n    outline: none;\n    border-color: var(--accent-orange);\n    box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.form-input::placeholder,\n.form-textarea::placeholder {\n    color: var(--text-tertiary);\n}\n\n.form-textarea {\n    resize: vertical;\n    min-height: 100px;\n    font-family: inherit;\n}\n\n.form-hint {\n    display: block;\n    margin-top: 6px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n/* Type Selector */\n.type-selector {\n    display: flex;\n    gap: 12px;\n}\n\n.type-option {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 20px 16px;\n    border: 2px solid #e9ecef;\n    border-radius: 12px;\n    background: var(--bg-card);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: var(--text-secondary);\n}\n\n.type-option:hover {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n}\n\n.type-option.active {\n    border-color: var(--accent-orange);\n    background: linear-gradient(135deg, rgba(255, 107, 74, 0.05), rgba(142, 58, 154, 0.05));\n    color: var(--accent-red);\n}\n\n.type-option svg {\n    width: 28px;\n    height: 28px;\n}\n\n.type-option span {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n/* File Upload */\n.file-upload-area {\n    position: relative;\n}\n\n.file-upload-area input[type=\"file\"] {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 2;\n}\n\n.file-upload-label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px 24px;\n    border: 2px dashed #e0e0e0;\n    border-radius: 12px;\n    background: #fafbfc;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: center;\n}\n\n.file-upload-area:hover .file-upload-label {\n    border-color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.02);\n}\n\n.file-upload-label svg {\n    width: 32px;\n    height: 32px;\n    color: var(--text-tertiary);\n}\n\n.file-upload-label span {\n    font-size: 14px;\n    color: var(--text-secondary);\n}\n\n.file-upload-label small {\n    font-size: 12px;\n    color: var(--accent-purple);\n    font-weight: 500;\n}\n\n/* Button Variants for Creatives */\n.btn-ghost {\n    background: transparent;\n    border: none;\n}\n\n.btn-ghost:hover {\n    background: rgba(0, 0, 0, 0.05);\n}\n\n.btn-danger {\n    color: #dc2626;\n}\n\n.btn-danger:hover {\n    background: rgba(220, 38, 38, 0.1);\n    color: #dc2626;\n}\n\n/* Creatives Responsive */\n@media (max-width: 768px) {\n    .creatives-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .advertiser-dropdown {\n        width: 100%;\n        margin-right: 0;\n        margin-bottom: 12px;\n    }\n\n    .header-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .modal {\n        margin: 16px;\n        max-height: calc(100vh - 32px);\n    }\n\n    .type-selector {\n        flex-direction: column;\n    }\n\n    .type-option {\n        flex-direction: row;\n        padding: 16px;\n    }\n}\n\n/* ============================================\n   CREATIVES TABLE STYLES\n   ============================================ */\n\n.creatives-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-radius: 16px;\n    overflow: hidden;\n    table-layout: fixed;\n}\n\n/* Fixed column widths for creatives table */\n.creatives-table th:nth-child(1),\n.creatives-table td:nth-child(1) { width: 44px; } /* Checkbox */\n.creatives-table th:nth-child(2),\n.creatives-table td:nth-child(2) { width: 72px; } /* Preview */\n.creatives-table th:nth-child(3),\n.creatives-table td:nth-child(3) { width: auto; } /* Name - flexible */\n.creatives-table th:nth-child(4),\n.creatives-table td:nth-child(4) { width: 110px; } /* Type */\n.creatives-table th:nth-child(5),\n.creatives-table td:nth-child(5) { width: 100px; } /* Size */\n.creatives-table th:nth-child(6),\n.creatives-table td:nth-child(6) { width: 120px; text-align: left; } /* Status */\n.creatives-table th:nth-child(7),\n.creatives-table td:nth-child(7) { width: 55px; } /* ID */\n.creatives-table th:nth-child(8),\n.creatives-table td:nth-child(8) { width: 90px; } /* Created */\n.creatives-table th:nth-child(9),\n.creatives-table td:nth-child(9) { width: 80px; } /* Actions */\n\n.creatives-table thead {\n    background: #f8f9fa;\n}\n\n.creatives-table thead tr:first-child th:first-child {\n    border-top-left-radius: 16px;\n}\n\n.creatives-table thead tr:first-child th:last-child {\n    border-top-right-radius: 16px;\n}\n\n.creatives-table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 16px;\n}\n\n.creatives-table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 16px;\n}\n\n.creatives-table th {\n    padding: 14px 12px;\n    text-align: left;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    border-bottom: 1px solid #e9ecef;\n    white-space: nowrap;\n}\n\n.creatives-table td {\n    padding: 10px 12px;\n    border-bottom: 1px solid #f1f3f5;\n    vertical-align: middle;\n}\n\n.creatives-table tbody tr {\n    transition: background 0.2s;\n}\n\n.creatives-table tbody tr:hover {\n    background: #fafbfc;\n}\n\n.creatives-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* Preview Cell */\n.creative-preview-cell {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.creative-preview-cell:hover {\n    transform: scale(1.08);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.preview-thumb {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 8px;\n}\n\n.preview-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%);\n    border-radius: 8px;\n}\n\n.preview-placeholder svg {\n    width: 22px;\n    height: 22px;\n    color: var(--text-tertiary);\n    opacity: 0.6;\n}\n\n.preview-placeholder.video {\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(239, 68, 68, 0.15));\n}\n\n.preview-placeholder.video svg {\n    color: #ef4444;\n    opacity: 0.8;\n}\n\n.preview-placeholder.html5 {\n    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08), rgba(139, 92, 246, 0.15));\n}\n\n.preview-placeholder.html5 svg {\n    color: #8b5cf6;\n    opacity: 0.8;\n}\n\n/* Creative Name Cell */\n.creative-name-cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.creative-name-cell .name-text {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n/* Type Badge */\n.type-badge {\n    display: inline-flex;\n    align-items: center;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 4px 8px;\n    border-radius: 5px;\n    border: 1.5px solid currentColor;\n    background: transparent;\n}\n\n/* Dim Cell (secondary info) */\n.dim-cell {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    font-variant-numeric: tabular-nums;\n}\n\n/* ID Cell */\n.id-cell {\n    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;\n    font-size: 11px;\n    color: var(--text-tertiary);\n    letter-spacing: -0.2px;\n}\n\n/* Date Cell */\n.date-cell {\n    font-size: 13px;\n    color: var(--text-secondary);\n    font-variant-numeric: tabular-nums;\n}\n\n/* Status badges for creatives */\n.status-badge.active {\n    background: rgba(16, 185, 129, 0.1);\n    color: #059669;\n}\n\n.status-badge.pending {\n    background: rgba(245, 158, 11, 0.1);\n    color: #d97706;\n}\n\n/* Clock icon for uploading status */\n.upload-clock-icon {\n    width: 12px;\n    height: 12px;\n    margin-left: 4px;\n    opacity: 0.7;\n    animation: pulse-opacity 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-opacity {\n    0%, 100% { opacity: 0.5; }\n    50% { opacity: 1; }\n}\n\n.status-badge.rejected {\n    background: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n}\n\n.status-badge.partial {\n    background: rgba(139, 92, 246, 0.1);\n    color: #7c3aed;\n}\n\n/* Status badges container */\n.status-badges {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n}\n\n/* Platform upload status badges */\n.platform-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.platform-badge.failed {\n    background: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n}\n\n.platform-badge svg {\n    flex-shrink: 0;\n}\n\n/* Spin animation for loading indicators */\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spin {\n    animation: spin 1s linear infinite;\n}\n\n/* Actions Cell */\n.actions-cell {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.btn-icon {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n    transition: all 0.2s ease;\n}\n\n.btn-icon:hover {\n    background: rgba(0, 0, 0, 0.05);\n    color: var(--text-primary);\n}\n\n.btn-icon svg {\n    width: 18px;\n    height: 18px;\n}\n\n.btn-icon-danger:hover {\n    background: rgba(220, 38, 38, 0.1);\n    color: #dc2626;\n}\n\n/* Hidden utility */\n.hidden {\n    display: none !important;\n}\n\n/* Type Badge with Icon */\n.type-badge-new {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 5px 10px;\n    border-radius: 6px;\n    white-space: nowrap;\n}\n\n.type-badge-new svg {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n}\n\n/* Image placeholder */\n.preview-placeholder.image {\n    background: linear-gradient(135deg, rgba(14, 165, 233, 0.08), rgba(14, 165, 233, 0.15));\n}\n\n.preview-placeholder.image svg {\n    color: #0ea5e9;\n    opacity: 0.8;\n}\n\n/* Pagination */\n.pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    margin-top: 24px;\n    padding: 16px 0;\n}\n\n.pagination-btn {\n    min-width: 36px;\n    height: 36px;\n    border: 1px solid #e9ecef;\n    background: white;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    transition: all 0.2s ease;\n    padding: 0 12px;\n}\n\n.pagination-btn svg {\n    width: 18px;\n    height: 18px;\n}\n\n.pagination-btn:hover:not(:disabled) {\n    border-color: var(--accent-orange);\n    color: var(--accent-orange);\n    background: rgba(255, 107, 74, 0.05);\n}\n\n.pagination-btn.active {\n    background: var(--accent-gradient);\n    border-color: transparent;\n    color: white;\n}\n\n.pagination-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.pagination-ellipsis {\n    color: var(--text-tertiary);\n    padding: 0 4px;\n}\n\n.pagination-info {\n    margin-left: 16px;\n    font-size: 13px;\n    color: var(--text-tertiary);\n}\n\n/* Responsive for creatives table */\n@media (max-width: 1024px) {\n    .creatives-table th:nth-child(7),\n    .creatives-table td:nth-child(7) {\n        display: none; /* Hide ID column */\n    }\n}\n\n@media (max-width: 768px) {\n    .creatives-table {\n        min-width: 600px;\n    }\n\n    .creative-preview-cell {\n        width: 40px;\n        height: 40px;\n    }\n}\n\n/* Creative Preview Popup */\n.creative-preview-popup {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    pointer-events: none;\n    animation: previewFadeIn 0.15s ease-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n@keyframes previewFadeIn {\n    from {\n        opacity: 0;\n        transform: translateX(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.creative-preview-popup img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 12px;\n}\n\n/* Placeholder styles for Video/HTML5 in popup */\n.preview-video-placeholder,\n.preview-html5-placeholder,\n.preview-no-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 100%;\n    height: 100%;\n    padding: 24px;\n}\n\n.preview-video-placeholder {\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(239, 68, 68, 0.15) 100%);\n}\n\n.preview-video-placeholder svg {\n    width: 48px;\n    height: 48px;\n    color: #ef4444;\n    opacity: 0.8;\n}\n\n.preview-video-placeholder span {\n    font-size: 13px;\n    color: #ef4444;\n    font-weight: 500;\n}\n\n.preview-video-placeholder .duration {\n    font-size: 11px;\n    color: #ef4444;\n    opacity: 0.7;\n    background: rgba(239, 68, 68, 0.12);\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n.preview-html5-placeholder {\n    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(139, 92, 246, 0.15) 100%);\n}\n\n.preview-html5-placeholder svg {\n    width: 48px;\n    height: 48px;\n    color: #8b5cf6;\n    opacity: 0.8;\n}\n\n.preview-html5-placeholder span {\n    font-size: 13px;\n    color: #8b5cf6;\n    font-weight: 500;\n}\n\n.preview-no-preview {\n    background: linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%);\n}\n\n.preview-no-preview span {\n    font-size: 13px;\n    color: var(--text-tertiary);\n}\n\n/* Placeholder styles for popup */\n.preview-placeholder-popup {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n}\n\n.preview-placeholder-popup svg {\n    width: 48px;\n    height: 48px;\n    opacity: 0.7;\n}\n\n.preview-placeholder-popup .placeholder-label {\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.preview-placeholder-popup .placeholder-dims {\n    font-size: 12px;\n    opacity: 0.6;\n    font-variant-numeric: tabular-nums;\n}\n\n.preview-placeholder-popup.image {\n    background: linear-gradient(135deg, rgba(14, 165, 233, 0.1) 0%, rgba(14, 165, 233, 0.2) 100%);\n    color: #0369a1;\n}\n\n.preview-placeholder-popup.html5 {\n    background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.2) 100%);\n    color: #7c3aed;\n}\n\n.preview-placeholder-popup.video {\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.2) 100%);\n    color: #dc2626;\n}\n\n/* ===== Checkbox Selection for Creatives List ===== */\n\n.checkbox-cell {\n  width: 44px !important;\n  text-align: center;\n  padding: 0 !important;\n}\n\n.creative-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--primary);\n  border-radius: 4px;\n}\n\n.creatives-table tr.selected-row {\n  background: rgba(255, 107, 74, 0.06);\n}\n\n.creatives-table tr.selected-row:hover {\n  background: rgba(255, 107, 74, 0.1);\n}\n\n/* Selection count in header */\n.selection-count {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  padding: 8px 16px;\n  background: rgba(255, 107, 74, 0.08);\n  border-radius: 8px;\n}\n\n/* Danger outline button */\n.btn-danger-outline {\n  border-color: rgba(220, 38, 38, 0.3) !important;\n  color: #dc2626 !important;\n}\n\n.btn-danger-outline:hover {\n  background: rgba(220, 38, 38, 0.08) !important;\n  border-color: rgba(220, 38, 38, 0.5) !important;\n}\n\n/* ===== Planning Help Tooltip ===== */\n.planning-help-icon {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n}\n\n.planning-help-icon svg {\n  opacity: 0.5;\n  transition: opacity 0.2s;\n}\n\n.planning-help-icon:hover svg {\n  opacity: 0.8;\n}\n\n.planning-tooltip {\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 8px);\n  transform: translateX(-50%);\n  width: 280px;\n  padding: 12px 14px;\n  background: #1a1a2e;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s, visibility 0.2s;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.planning-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #1a1a2e;\n}\n\n.planning-help-icon:hover .planning-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.planning-tooltip-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.planning-tooltip-item + .planning-tooltip-item {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.planning-tooltip-item strong {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.planning-tooltip-item span {\n  font-size: 11px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* ============================================\n   User Dropdown Menu (Sidebar)\n   ============================================ */\n\n.sidebar-user {\n  position: relative;\n}\n\n.sidebar-user-dropdown {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  padding: 6px;\n  z-index: 100;\n  animation: dropdownFadeIn 0.15s ease;\n}\n\n@keyframes dropdownFadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.sidebar-user-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.sidebar-user-dropdown-item svg {\n  width: 16px;\n  height: 16px;\n  stroke: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.sidebar-user-dropdown-item:hover {\n  background: var(--bg-tertiary);\n}\n\n.sidebar-user-dropdown-item:hover svg {\n  stroke: var(--text-primary);\n}\n\n.sidebar-user-dropdown-logout:hover {\n  color: var(--accent-red);\n}\n\n.sidebar-user-dropdown-logout:hover svg {\n  stroke: var(--accent-red);\n}\n\n/* ============================================\n   Settings Page\n   ============================================ */\n\n.settings-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.settings-nav-item svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.settings-nav-item:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--text-primary);\n}\n\n.settings-nav-item.active {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1), rgba(142, 58, 154, 0.1));\n  color: var(--accent-orange);\n}\n\n.settings-nav-item.active svg {\n  stroke: var(--accent-orange);\n}\n\n.settings-content {\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n\n.settings-card {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  padding: 28px;\n}\n\n.settings-card-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 24px;\n}\n\n\n/* Interface language — a segmented control rather than a dropdown: with a\n   handful of languages the whole choice is visible at once, and it does not\n   stretch the width of the card the way a full-bleed <select> does. */\n.lang-seg {\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px;\n  background: #f1f3f5;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n}\n\n.lang-seg-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  padding: 9px 16px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n}\n\n.lang-seg-item:hover {\n  color: var(--text-primary);\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.lang-seg-item:focus-visible {\n  outline: 2px solid var(--accent-orange);\n  outline-offset: 2px;\n}\n\n/* The code carries the brand colour on the selected item, so the control reads\n   as chosen at a glance without painting the whole pill. */\n.lang-seg-item .lang-seg-code {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  padding: 3px 6px;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--text-tertiary);\n  transition: background 0.18s, color 0.18s;\n}\n\n.lang-seg-item.active {\n  background: #fff;\n  color: var(--text-primary);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 4px 12px -6px rgba(0, 0, 0, 0.18);\n}\n\n.lang-seg-item.active .lang-seg-code {\n  background: var(--accent-gradient);\n  color: #fff;\n}\n\n/* Fallback picker, once there are too many languages to lay out as pills. */\n.lang-select {\n  max-width: 280px;\n}\n\n@media (max-width: 560px) {\n  .lang-seg { flex-wrap: wrap; }\n  .lang-seg-item { flex: 1 1 auto; justify-content: center; }\n}\n\n.settings-profile-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.settings-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  font-weight: 600;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.settings-avatar-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.settings-avatar-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.settings-avatar-role {\n  font-size: 12px;\n  color: var(--text-tertiary);\n  text-transform: capitalize;\n}\n\n.settings-input {\n  width: 100%;\n  padding: 11px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  font-size: 14px;\n  color: var(--text-primary);\n  background: var(--bg-card);\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.settings-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.settings-input:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.settings-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.settings-form-group {\n  margin-bottom: 18px;\n}\n\n.settings-form-group .field-label {\n  margin-bottom: 6px;\n}\n\n.settings-message {\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.settings-message-success {\n  background: rgba(46, 204, 113, 0.1);\n  color: #27ae60;\n  border: 1px solid rgba(46, 204, 113, 0.2);\n}\n\n.settings-message-error {\n  background: rgba(231, 76, 60, 0.1);\n  color: #e74c3c;\n  border: 1px solid rgba(231, 76, 60, 0.2);\n}\n\n/* 2FA */\n.tfa-status-row {\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.tfa-status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.tfa-enabled {\n  background: rgba(46, 204, 113, 0.1);\n  color: #27ae60;\n  border: 1px solid rgba(46, 204, 113, 0.2);\n}\n\n.tfa-disabled {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--text-tertiary);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.tfa-description {\n  margin-top: 10px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.tfa-setup-block {\n  margin-top: 8px;\n}\n\n.tfa-instruction {\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n\n.tfa-qr-wrapper {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.tfa-qr-image {\n  width: 200px;\n  height: 200px;\n  border-radius: 4px;\n}\n\n.tfa-manual-key {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.tfa-manual-label {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n.tfa-secret-code {\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 14px;\n  color: var(--text-primary);\n  background: rgba(0, 0, 0, 0.04);\n  padding: 10px 14px;\n  border-radius: 8px;\n  letter-spacing: 2px;\n  word-break: break-all;\n  user-select: all;\n}\n\n.tfa-code-input {\n  max-width: 200px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 20px;\n  letter-spacing: 8px;\n  text-align: center;\n}\n\n.tfa-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.tfa-actions .add-list-btn {\n  width: auto;\n  flex: none;\n  padding: 10px 20px;\n}\n\n.tfa-disable-btn {\n  background: rgba(231, 76, 60, 0.08) !important;\n  color: #e74c3c !important;\n  border-color: rgba(231, 76, 60, 0.15) !important;\n}\n\n.tfa-disable-btn:hover {\n  background: rgba(231, 76, 60, 0.15) !important;\n}\n\n.tfa-cancel-btn {\n  background: rgba(0, 0, 0, 0.04) !important;\n  color: var(--text-secondary) !important;\n  border-color: rgba(0, 0, 0, 0.08) !important;\n}\n\n.tfa-cancel-btn:hover {\n  background: rgba(0, 0, 0, 0.08) !important;\n}\n\n/* Sense Max — Save-and-Launch confirmation modal */\n.sm-confirm-overlay { position: fixed; inset: 0; background: rgba(20,16,40,0.45); display: flex; align-items: center; justify-content: center; z-index: 3000; padding: 20px; }\n.sm-confirm { background: #fff; border-radius: 16px; max-width: 460px; width: 100%; padding: 26px 26px 22px; box-shadow: 0 24px 60px rgba(20,10,40,0.28); }\n.sm-confirm-title { margin: 0 0 10px; font-size: 20px; font-weight: 800; color: #17171d; }\n.sm-confirm-text { margin: 0 0 20px; font-size: 14px; line-height: 1.6; color: #5a5a66; }\n.sm-confirm-text strong { color: #17171d; }\n.sm-confirm-actions { display: flex; justify-content: flex-end; gap: 10px; }\n\n/* Sense Max — live budget split preview (stacked bar + legend) */\n.budget-preview { width: 100%; box-sizing: border-box; margin: 14px 0 28px; padding: 16px 18px; border: 1px solid #ececf2; border-radius: 12px; background: #fafafc; overflow: hidden; }\n.budget-preview-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #9a9aa6; margin-bottom: 10px; }\n.bp-stack { display: flex; width: 100%; height: 12px; border-radius: 6px; overflow: hidden; background: #ececf2; }\n.bp-seg { height: 100%; min-width: 2px; transition: width .3s ease; }\n.bp-legend { display: flex; flex-wrap: wrap; gap: 8px 18px; margin-top: 12px; }\n.bp-leg { display: flex; align-items: center; gap: 7px; font-size: 12.5px; min-width: 0; }\n.bp-dot { width: 9px; height: 9px; border-radius: 3px; flex: 0 0 auto; }\n.bp-leg-name { color: #3a3a44; font-weight: 600; }\n.bp-leg-pct { color: #3a3a44; font-weight: 700; font-variant-numeric: tabular-nums; }\n.bp-leg-amt { color: #9a9aa6; font-variant-numeric: tabular-nums; }\n.bp-excluded { margin-top: 12px; padding-top: 10px; border-top: 1px dashed #e3e3ea; display: flex; flex-direction: column; gap: 6px; min-width: 0; }\n.bp-excl-row { display: flex; align-items: flex-start; gap: 8px; font-size: 12.5px; color: #7a6a56; line-height: 1.45; min-width: 0; }\n.bp-excl-row > span:last-child { min-width: 0; overflow-wrap: anywhere; }   /* let the long reason WRAP, never force width */\n.bp-excl-dot { width: 7px; height: 7px; border-radius: 50%; background: #E9A23B; margin-top: 5px; flex: 0 0 auto; }\n.bp-excl-row strong { color: #b8791f; }\n\n/* Draggable split bar: boundaries between segments are grab handles that redistribute budget. */\n.bp-stack-drag { position: relative; height: 16px; border-radius: 8px; overflow: visible; touch-action: none; }\n.bp-stack-drag .bp-seg { transition: width .12s ease; }\n.bp-stack-drag.bp-dragging .bp-seg { transition: none; }   /* track the pointer 1:1 while dragging */\n.bp-stack-drag .bp-seg:first-child { border-top-left-radius: 8px; border-bottom-left-radius: 8px; }\n.bp-stack-drag .bp-seg:last-child { border-top-right-radius: 8px; border-bottom-right-radius: 8px; }\n.bp-handle { position: absolute; top: 50%; width: 18px; height: 26px; transform: translate(-50%, -50%);\n  display: flex; align-items: center; justify-content: center; cursor: ew-resize; z-index: 2; touch-action: none; }\n.bp-handle-grip { width: 4px; height: 22px; border-radius: 3px; background: #fff;\n  box-shadow: 0 0 0 1px rgba(20,20,30,.18), 0 2px 5px rgba(20,20,30,.22); transition: transform .12s ease, box-shadow .12s ease; }\n.bp-handle:hover .bp-handle-grip, .bp-dragging .bp-handle-grip { transform: scaleY(1.12); box-shadow: 0 0 0 1px rgba(20,20,30,.28), 0 3px 8px rgba(20,20,30,.3); }\n.bp-reset { margin-top: 12px; background: none; border: none; padding: 0; cursor: pointer;\n  font-size: 12px; font-weight: 600; color: #8E3A9A; }\n.bp-reset:hover { text-decoration: underline; }\n\n/* Sense Max card: while the budget breakdown loads, the summed metrics aren't known yet.\n   Skeleton the number elements so they don't flash the Sense-only value then jump to the total. */\n.campaign-card.metrics-loading .metric-big,\n.campaign-card.metrics-loading .cost-value,\n.campaign-card.metrics-loading .budget-amount,\n.campaign-card.metrics-loading .budget-spent,\n.campaign-card.metrics-loading .budget-total,\n.campaign-card.metrics-loading .sm-bs-val {\n  color: transparent !important;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #efedf3 25%, #e6e2ec 37%, #efedf3 63%);\n  background-size: 400% 100%;\n  animation: smx-shimmer 1.2s ease-in-out infinite;\n}\n.campaign-card.metrics-loading .metric-big *,\n.campaign-card.metrics-loading .cost-value *,\n.campaign-card.metrics-loading .sm-bs-val * { color: transparent !important; }\n@keyframes smx-shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }\n\n/* Sense Max — blacklist picker. Chips and the inline editor reuse the campaign\n   editor's classes so the two screens look the same; only the layout differs. */\n.sm-bl-picker { display: flex; flex-direction: column; gap: 8px; flex: 1; min-width: 0; }\n.sm-bl-picker .proximity-saved-row { flex-wrap: wrap; }\n.sm-bl-picker .proximity-editor { display: flex; flex-direction: column; gap: 8px; }\n.sm-bl-actions { display: flex; align-items: center; gap: 8px; }\n.sm-bl-err { color: #c0392b; }\n\n\n/* ---------------------------------------------------------------------------\n   Targeting templates — a saved arrangement of targeting, offered from the\n   Targeting header because it acts on the whole block.\n   --------------------------------------------------------------------------- */\n.form-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.tpl-bar { display: flex; align-items: center; gap: 8px; }\n.tpl-picker { position: relative; }\n\n.tpl-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 32px;\n  padding: 0 11px;\n  border: 1px solid #e5e8eb;\n  border-radius: 8px;\n  background: #fff;\n  color: #495057;\n  font-family: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.tpl-btn:hover:not(:disabled) { border-color: #ced4da; background: #fafbfc; color: #1a1a1a; }\n.tpl-btn:disabled { opacity: 0.55; cursor: default; }\n.tpl-btn svg { width: 14px; height: 14px; color: #adb5bd; }\n.tpl-btn .tpl-chevron { width: 13px; height: 13px; margin-left: -1px; }\n\n/* Click-away layer, so the menu closes on the next click anywhere. */\n.tpl-backdrop { position: fixed; inset: 0; z-index: 60; }\n\n.tpl-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 61;\n  width: 320px;\n  background: #fff;\n  border: 1px solid #e5e8eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 40px rgba(16, 24, 40, 0.14);\n  overflow: hidden;\n}\n\n.tpl-menu-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 11px 13px;\n  border-bottom: 1px solid #f1f3f5;\n  font-size: 12px;\n  color: #868e96;\n}\n\n.tpl-menu-save {\n  border: none;\n  background: none;\n  padding: 0;\n  color: #4c6ef5;\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.tpl-menu-save:hover:not(:disabled) { text-decoration: underline; }\n.tpl-menu-save:disabled { opacity: 0.55; cursor: default; }\n\n.tpl-empty {\n  padding: 18px 14px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #868e96;\n  text-align: center;\n}\n\n.tpl-list { max-height: 300px; overflow-y: auto; padding: 4px; }\n\n.tpl-row { display: flex; align-items: stretch; border-radius: 8px; }\n.tpl-row:hover { background: #f8f9fa; }\n\n.tpl-row-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 9px 10px;\n  border: none;\n  background: none;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.tpl-row-main:disabled { cursor: default; opacity: 0.6; }\n\n.tpl-row-name {\n  font-size: 13.5px;\n  color: #1a1a1a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tpl-row-meta { font-size: 11.5px; color: #868e96; }\n\n.tpl-row-del {\n  width: 34px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  border-radius: 8px;\n  color: #ced4da;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.tpl-row:hover .tpl-row-del { opacity: 1; }\n.tpl-row-del:focus-visible { opacity: 1; }\n.tpl-row-del:hover { color: #e03131; background: rgba(224, 49, 49, 0.08); }\n.tpl-row-del svg { width: 14px; height: 14px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
